
/* ==== js/modules/okx/dashboard.js ==== */
var _dashData = null;
var _mktFilters = { mktSide: 'all', maxPrice: '', paymentMethod: '', sortBy: 'price' };

async function renderDashboard(container) {
  const _pg = currentPage;
  try {
    if (currentUser && currentUser.role !== 'admin' && !currentUser.hasApiKeys) {
      if (currentPage !== _pg) return;
      container.innerHTML = '<div class="page-header"><div><h2>Merchant Dashboard</h2><div class="subtitle">P2P command center</div></div></div>' + noApiKeysDashboard();
      return;
    }
    if (currentUser && currentUser.approved === 0 && currentUser.hasApiKeys) {
      if (currentPage !== _pg) return;
      container.innerHTML = '<div class="page-header"><div><h2>Merchant Dashboard</h2><div class="subtitle">P2P command center</div></div></div>' + '<div class="card" style="border-color:rgba(255,145,0,0.3);margin-top:16px;text-align:center;padding:40px 20px;"><div style="font-size:48px;margin-bottom:16px;">🛂</div><h3 style="color:#ff9100;">Account Pending Approval</h3><p style="color:var(--text-tertiary);font-size:14px;max-width:400px;margin:12px auto;">Your API keys have been submitted for admin review. Please wait for approval to access P2P features.</p><p style="color:var(--text-quaternary);font-size:12px;">Contact admin: +254723472206 or moneyfestltd@gmail.com</p></div>';
      return;
    }
    const res = await checkKeys(container);
    if (!res) return;
    _dashData = res.data;
    buildDashboardHTML(container, _dashData);
    if (currentPage !== _pg) return;
    startPagePoll(container, () => pollDashboard(container), 120000);
    startPageCountdown(15);
  } catch (err) {
    if (currentPage !== _pg) return;
    if (err.message && err.message.includes('API keys')) {
      container.innerHTML = '<div class="page-header"><div><h2>Merchant Dashboard</h2><div class="subtitle">P2P command center</div></div></div>' + configKeysPrompt();
      startPagePoll(container, () => renderDashboard(container), 120000);
      startPageCountdown(15);
      return;
    }
    showError(container, err.message || 'Failed to load dashboard', () => renderDashboard(container));
  }
}

async function pollDashboard(container) {
  if (!_dashData) { renderDashboard(container); return; }
  try {
    var res = await API.get('/api/p2p/dashboard');
    if (!res || !res.data) return;
    _dashData = res.data;
    updateDashboardContent(container, _dashData);
  } catch (e) {}
}

function buildDashboardHTML(container, d) {
  var html = '<div class="page-header"><div><h2>Merchant Dashboard</h2><div class="subtitle">P2P command center · <span id="dash-last-updated" style="color:var(--text-quaternary);font-size:11px;">Updated ' + new Date().toLocaleTimeString() + '</span> <span id="page-countdown" style="color:var(--text-tertiary);font-size:11px;"></span></div></div></div>';

  html += '<div id="dash-stats">' + buildStatsRow(d) + '</div>';
  html += '<div id="dash-buy-card" class="card" style="border-color:rgba(68,138,255,0.2);margin-top:16px;"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;"><h3 style="margin:0;">📥 Recent Buy Orders</h3><a href="#" onclick="navigate(\'orders\');return false;" style="font-size:12px;color:var(--accent-blue);">View all →</a></div><div id="dash-buy-orders">' + buildOrderTable(d.orders || [], 'buy') + '</div></div>';

  html += '<div id="dash-sell-card" class="card" style="border-color:rgba(244,67,54,0.2);margin-top:16px;"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;"><h3 style="margin:0;">📤 Recent Sell Orders</h3><a href="#" onclick="navigate(\'orders\');return false;" style="font-size:12px;color:var(--accent-blue);">View all →</a></div><div id="dash-sell-orders">' + buildOrderTable(d.orders || [], 'sell') + '</div></div>';

  html += '<div id="dash-marketplace">' + buildMarketplaceContent(d) + '</div>';

  html += '<div id="dash-account-summary" class="card" style="margin-top:16px;"><h3>📋 Account Summary</h3>' + buildAccountSummary(d) + '</div>';

  container.innerHTML = html;
}

function buildStatsRow(d) {
  var ads = d.ads || [];
  var orders = d.orders || [];
  var completedCount = d.completedCount || orders.filter(function(o) { return isCompletedOrder(o); }).length;
  var totalVolume = d.totalVolume || 0;
  var completionRate = d.completionRate || (orders.length > 0 ? Math.round((completedCount / orders.length) * 100) : 0);
  var pendingOrders = orders.filter(function(o) { var s = orderState(o); return s !== 'completed' && s !== 'canceled' && s !== 'cancelled' && o.paymentStatus !== 'confirmed'; }).length;
  var activeAds = ads.filter(function(a) { return a.status === 'new' && !a.isHidden; }).length;
  var balData = d.okxBalance;
  var fundData = d.okxFundingBalance;
  // NOTE: P2P USDT lives in the funding wallet — the P2P user/balance endpoint
  // and the funding asset/balances endpoint report the SAME funds. Adding them
  // double-counts the balance. Funding wallet is the source of truth; fall back
  // to the P2P endpoint only if funding data is missing.
  var onHold = parseFloat(balData?.onHoldAmount || '0');
  var p2pAvail = parseFloat(balData?.availableAmount || '0');
  var p2pTotal = p2pAvail + onHold;
  var fundAvail = parseFloat(fundData?.availBal || '0');
  var fundFrozen = parseFloat(fundData?.frozenBal || '0');
  var hasFunding = fundData && fundData.availBal !== undefined;
  var available = hasFunding ? fundAvail + fundFrozen : p2pTotal;
  var totalBal = available;
  var opt = d.optimalPrice || {};
  var bestBuy = opt.currentHighestBuyAdPrice || '-';
  var bestSell = opt.currentLowestSellAdPrice || '-';

  function sCard(id, val, label, sub, extra) {
    var c = id === 'dash-balance' ? '#00c853' : id === 'dash-ads-count' ? 'var(--accent-blue)' : id === 'dash-pending' ? 'var(--accent-orange)' : '#00c853';
    return '<div class="stat-card" style="padding:14px 16px;cursor:pointer;' + (extra || '') + '" onclick="' + (id === 'dash-balance' ? 'showBalanceBreakdown(' + p2pAvail + ', ' + onHold + ', ' + totalBal + ', ' + fundAvail + ', ' + fundFrozen + ')' : id === 'dash-ads-count' ? 'navigate(\'ads\')' : id === 'dash-pending' ? 'navigate(\'orders\')' : '') + '">' +
      '<div style="font-size:11px;color:var(--text-quaternary);font-weight:600;text-transform:uppercase;letter-spacing:0.3px;margin-bottom:4px;">' + label + '</div>' +
      '<div style="font-size:24px;font-weight:800;color:' + c + ';" id="' + id + '">' + val + '</div>' +
      '<div style="font-size:11px;color:var(--text-disabled);margin-top:2px;">' + sub + '</div></div>';
  }

  return '<div style="display:flex;gap:8px;overflow-x:auto;padding-bottom:4px;">' +
    sCard('dash-balance', available.toFixed(2) + ' USDT', 'Total USDT (P2P+Funding)', (fundAvail > 0 ? fundAvail.toFixed(2) + ' funding avail, ' : '') + onHold.toFixed(2) + ' on hold', 'border-color:rgba(0,200,83,0.3);background:var(--stat-card-bg-green);min-width:180px;') +
    sCard('dash-ads-count', ads.length, 'Total P2P Ads', activeAds + ' active', 'border-color:rgba(68,138,255,0.2);background:var(--stat-card-bg-blue);min-width:120px;') +
    sCard('dash-pending', pendingOrders, 'Pending Orders', 'Click to view', 'border-color:rgba(255,145,0,0.2);background:var(--stat-card-bg-orange);min-width:120px;') +
    '<div class="stat-card" style="padding:14px 16px;min-width:130px;border-color:rgba(0,200,83,0.2);background:var(--stat-card-bg-green);"><div style="font-size:11px;color:var(--text-quaternary);font-weight:600;text-transform:uppercase;letter-spacing:0.3px;margin-bottom:4px;">Completed</div><div style="font-size:24px;font-weight:800;color:#00c853;" id="dash-completed">' + completedCount + '</div><div style="font-size:11px;color:var(--text-disabled);margin-top:2px;">' + completionRate.toFixed(1) + '% success</div></div>' +
    '<div class="stat-card" style="padding:14px 16px;min-width:150px;border-color:rgba(68,138,255,0.2);background:var(--stat-card-bg-volume);"><div style="font-size:11px;color:var(--text-quaternary);font-weight:600;text-transform:uppercase;letter-spacing:0.3px;margin-bottom:4px;">Total Volume</div><div style="font-size:24px;font-weight:800;color:var(--accent-blue);" id="dash-volume">' + formatFiat(totalVolume, 'KES') + '</div><div style="font-size:11px;color:var(--text-disabled);margin-top:2px;">' + completedCount + ' orders</div></div>' +
    '<div class="stat-card" style="padding:14px 16px;min-width:160px;border-color:rgba(255,145,0,0.2);background:var(--stat-card-bg-orange);"><div style="font-size:11px;color:var(--text-quaternary);font-weight:600;text-transform:uppercase;letter-spacing:0.3px;margin-bottom:4px;">Optimal Rate</div><div style="font-size:16px;font-weight:700;color:#ff9100;margin-bottom:2px;">Buy: <strong style="color:#00e676;">' + bestBuy + '</strong> &middot; Sell: <strong style="color:#ff9100;">' + bestSell + '</strong></div><div style="font-size:11px;color:var(--text-disabled);">USDT/KES rates</div></div>' +
    '</div>';
}

function applyMarketFilter(list, side) {
  var f = _mktFilters;
  if (f.mktSide !== 'all' && f.mktSide !== side) return [];
  return list.filter(function(a) {
    if (f.maxPrice) { var p = parseFloat(a.unitPrice || '0'); if (p > parseFloat(f.maxPrice)) return false; }
    if (f.paymentMethod && (!a.paymentMethods || a.paymentMethods.indexOf(f.paymentMethod) === -1)) return false;
    return true;
  });
}

function sortMarketAds(list, side) {
  var s = _mktFilters.sortBy || 'price';
  list.sort(function(a, b) {
    if (s === 'price') { var d = parseFloat(a.unitPrice || '0') - parseFloat(b.unitPrice || '0'); return side === 'sell' ? -d : d; }
    if (s === 'available') return parseFloat(b.availableAmount || '0') - parseFloat(a.availableAmount || '0');
    if (s === 'limit') return parseFloat(b.maxOrderSize || '0') - parseFloat(a.maxOrderSize || '0');
    return 0;
  });
}

function buildMarketplaceContent(d) {
  // Swap to match OKX marketplace layout:
  // "Buy USDT" tab = sell ads (people selling USDT to you), sorted cheapest first
  // "Sell USDT" tab = buy ads (people buying USDT from you), sorted highest first
  var mBuy = d.marketplaceSell || [];
  var mSell = d.marketplaceBuy || [];
  var rankings = d.myRanking || [];

  var filteredBuy = applyMarketFilter(mBuy, 'buy');
  var filteredSell = applyMarketFilter(mSell, 'sell');
  sortMarketAds(filteredBuy, 'buy');
  sortMarketAds(filteredSell, 'sell');

  var allPaymentMethods = [...new Set([...mBuy, ...mSell].flatMap(function(a) { return a.paymentMethods || []; }))];

  function typeBadge(t) {
    var colors = { certified: '#00c853', super: '#448aff', diamond: '#7c4dff' };
    var labels = { certified: 'Certified', super: 'Super', diamond: 'Diamond' };
    var c = colors[t] || '#8888a0';
    var l = labels[t] || t || 'Standard';
    return '<span style="font-size:10px;font-weight:600;padding:2px 6px;border-radius:4px;background:' + c + '22;color:' + c + ';border:1px solid ' + c + '44;">' + l + '</span>';
  }

  function statusDot(a) {
    var cr = a.creator || {};
    if (cr.isOnline === true || cr.isOnline === 'true' || cr.onlineStatus === 'online') {
      return '<span style="color:#00c853;">●</span> Online';
    }
    if (cr.isOnline === false || cr.isOnline === 'false' || cr.onlineStatus === 'offline') {
      return '<span style="color:#8888a0;">◌</span> Offline';
    }
    // Fallback based on completion rate
    var rate = parseFloat(cr.completionRate || '0');
    if (rate > 0.95) return '<span style="color:#00c853;">●</span> Online';
    if (rate > 0.5) return '<span style="color:#ff9800;">●</span> Active';
    return '<span style="color:#8888a0;">◌</span> Limited';
  }

  function marketRow(ad, i, side) {
    var isOwner = ad.isOwner === 'true';
    var t = ad.creator?.type || '';
    var priceColor = side === 'buy' ? '#00c853' : '#f44336';
    var actionLabel = side === 'buy' ? 'Buy' : 'Sell';
    var actionColor = side === 'buy' ? '#00c853' : '#f44336';
    var adId = ad.adId || ad.id || '';
    var price = ad.unitPrice || '0';
    var limit = (ad.minOrderSize && ad.maxOrderSize) ? 'KES ' + fmtN(ad.minOrderSize) + ' - KES ' + fmtN(ad.maxOrderSize) : (ad.minOrderSize || ad.maxOrderSize ? 'KES ' + fmtN(ad.minOrderSize || ad.maxOrderSize) : '-');
    var followBtn = '';
    if (!isOwner) {
      var merchId = ad.creator?.userId || ad.userId || '';
      var merchName = ad.creator?.nickName || ad.nickName || '';
      followBtn = ' <button onclick="toggleFollowMerchant(\'' + esc(merchId) + '\',\'' + esc(merchName) + '\',this)" style="font-size:10px;padding:1px 6px;border-radius:4px;border:1px solid #4488ff44;background:transparent;color:#4488ff;cursor:pointer;" title="Follow merchant">+Follow</button>';
    }
    var cloneBtn = isOwner ? '' : ' <button onclick="cloneMarketplaceAd(' + JSON.stringify(ad).replace(/"/g,'&quot;') + ')" style="font-size:10px;padding:1px 6px;border-radius:4px;border:1px solid #8888a044;background:transparent;color:#8888a0;cursor:pointer;" title="Clone ad">Clone</button>';
    var btn = isOwner ? '<span style="font-size:10px;color:var(--text-quaternary);">—</span>' : '<button onclick="showOrderModal(\'' + adId + '\',\'' + side + '\',\'' + price + '\',\'' + (ad.minOrderSize||'0') + '\',\'' + (ad.maxOrderSize||'0') + '\',\'' + esc(ad.creator?.nickName || ad.nickName || '') + '\',\'' + esc(ad.creator?.userId || ad.userId || '') + '\')" style="padding:4px 12px;border:none;border-radius:6px;background:' + actionColor + ';color:#fff;font-size:11px;font-weight:600;cursor:pointer;">' + actionLabel + '</button>';
    var rowStyle = isOwner ? 'outline:2px solid ' + priceColor + ';outline-offset:-2px;background:rgba(' + (side === 'buy' ? '0,200,83' : '244,67,54') + ',0.08);' : '';
    return '<tr' + (rowStyle ? ' style="' + rowStyle + '"' : '') + '>' +
      '<td style="color:var(--text-quaternary);font-size:12px;">' + (i + 1) + '</td>' +
      '<td style="font-weight:700;color:' + priceColor + ';">' + price + '</td>' +
      '<td>' + fmtN(ad.availableAmount) + '</td>' +
      '<td style="font-size:11px;color:var(--text-secondary);">' + limit + '</td>' +
      '<td style="font-size:12px;">' + esc(ad.creator?.nickName || ad.nickName || '—') + (isOwner ? ' <span style="color:' + priceColor + ';">(You)</span>' : '') + followBtn + '</td>' +
      '<td>' + typeBadge(t) + '</td>' +
      '<td style="font-size:11px;">' + statusDot(ad) + '</td>' +
      '<td>' + cloneBtn + ' ' + btn + '</td></tr>';
  }

  var head = '<thead><tr><th>#</th><th>Price</th><th>Available</th><th>Limits (KES)</th><th>Merchant</th><th>Type</th><th>Status</th><th>Action</th></tr></thead>';

  // Filters bar
  var html = '<div class="card" style="margin-top:16px;padding:16px 20px;background:linear-gradient(135deg,#0c1220,#0e0e18);border-color:rgba(68,138,255,0.15);"><div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;"><span style="font-size:13px;color:#8888a0;font-weight:600;letter-spacing:0.5px;text-transform:uppercase;">Filters</span>' +
    '<div class="filter-group" style="display:flex;align-items:center;gap:4px;padding:3px;background:var(--bg-primary);border-radius:10px;border:1px solid var(--border-primary);">' +
    '<button class="btn btn-sm ' + (!_mktFilters.mktSide || _mktFilters.mktSide === 'all' ? 'btn-primary' : 'btn-secondary') + '" style="border-radius:8px;padding:5px 14px;font-size:12px;" onclick="setMktFilter(\'mktSide\',\'all\')">All</button>' +
    '<button class="btn btn-sm ' + (_mktFilters.mktSide === 'buy' ? 'btn-primary' : 'btn-secondary') + '" style="border-radius:8px;padding:5px 14px;font-size:12px;' + (_mktFilters.mktSide === 'buy' ? 'background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);' : 'background:transparent;color:var(--text-quaternary);border:none;') + '" onclick="setMktFilter(\'mktSide\',\'buy\')">Buy</button>' +
    '<button class="btn btn-sm ' + (_mktFilters.mktSide === 'sell' ? 'btn-primary' : 'btn-secondary') + '" style="border-radius:8px;padding:5px 14px;font-size:12px;' + (_mktFilters.mktSide === 'sell' ? 'background:linear-gradient(135deg,#f44336,#ef5350);color:#fff;' : 'background:transparent;color:var(--text-quaternary);border:none;') + '" onclick="setMktFilter(\'mktSide\',\'sell\')">Sell</button>' +
    '</div>' +
    '<div style="display:flex;align-items:center;gap:6px;"><span style="font-size:12px;color:var(--text-quaternary);">USDT</span><span style="font-size:14px;color:#33334a;">→</span><span style="font-size:12px;color:var(--text-quaternary);">KES</span></div>' +
    '<div class="filter-input" style="position:relative;"><input type="number" id="mkt-max-price" placeholder="0.00" value="' + (_mktFilters.maxPrice || '') + '" style="width:90px;padding:7px 10px 7px 20px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;" onkeydown="if(event.key===\'Enter\')applyMktFilter()"><span style="position:absolute;left:8px;top:50%;transform:translateY(-50%);font-size:11px;color:var(--text-quaternary);">≤</span></div>' +
    '<select id="mkt-payment" onchange="setMktFilter(\'paymentMethod\',this.value)" style="padding:7px 10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;max-width:150px;"><option value="">All payments</option>' +
    allPaymentMethods.map(function(m) { return '<option value="' + esc(m) + '" ' + (_mktFilters.paymentMethod === m ? 'selected' : '') + '>' + esc(m) + '</option>'; }).join('') +
    '</select>' +
    '<select id="mkt-sort" onchange="setMktFilter(\'sortBy\',this.value)" style="padding:7px 10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;"><option value="price" ' + ((_mktFilters.sortBy||'price') === 'price' ? 'selected' : '') + '>Sort: Price</option><option value="available" ' + (_mktFilters.sortBy === 'available' ? 'selected' : '') + '>Sort: Available</option><option value="limit" ' + (_mktFilters.sortBy === 'limit' ? 'selected' : '') + '>Sort: Max Limit</option></select>' +
    '<div style="display:flex;gap:6px;"><button class="btn btn-sm btn-primary" onclick="applyMktFilter()" style="padding:7px 16px;font-size:12px;">Apply</button>' +
    (_mktFilters.maxPrice || _mktFilters.paymentMethod || _mktFilters.sortBy !== 'price' || _mktFilters.mktSide !== 'all' ? '<button class="btn btn-sm btn-outline" onclick="clearMktFilter()" style="padding:7px 12px;font-size:11px;">Reset</button>' : '') +
    '</div></div></div>';

  // Buy ads table
  html += '<div class="card" style="border-color:rgba(0,200,83,0.2);margin-top:16px;"><h3>📈 Buy USDT (' + filteredBuy.length + ')</h3><div class="table-container"><table>' + head + '<tbody>' +
    (filteredBuy.length === 0 ? '<tr><td colspan="8"><div class="empty-state" style="padding:20px;"><p style="color:var(--text-quaternary);">No buy ads</p></div></td></tr>' : filteredBuy.slice(0, 30).map(function(ad, i) { return marketRow(ad, i, 'buy'); }).join('')) +
    '</tbody></table></div></div>';

  // Sell ads table
  html += '<div class="card" style="border-color:rgba(244,67,54,0.2);margin-top:16px;"><h3>📉 Sell USDT (' + filteredSell.length + ')</h3><div class="table-container"><table>' + head + '<tbody>' +
    (filteredSell.length === 0 ? '<tr><td colspan="8"><div class="empty-state" style="padding:20px;"><p style="color:var(--text-quaternary);">No sell ads</p></div></td></tr>' : filteredSell.slice(0, 30).map(function(ad, i) { return marketRow(ad, i, 'sell'); }).join('')) +
    '</tbody></table></div></div>';

  // My Rankings
  if (rankings.length > 0) {
    html += '<div class="card" style="margin-top:16px;"><h3>📊 My Ad Price Rankings</h3><div class="table-container"><table><thead><tr><th>Ad ID</th><th>Side</th><th>My Price</th><th>Rank</th><th>Best Price</th><th>Worst Price</th></tr></thead><tbody>';
    rankings.forEach(function(r) {
      var pct = (parseFloat(r.unitPrice||'0') && parseFloat(r.bestPrice||'0')) ? ((parseFloat(r.unitPrice) - parseFloat(r.bestPrice)) / parseFloat(r.bestPrice) * 100).toFixed(2) : '0';
      html += '<tr><td><code style="font-size:11px;">' + esc(r.adId || '').slice(0,10) + '</code></td>' +
        '<td><span class="badge badge-' + (r.side === 'sell' ? 'sell' : 'buy') + '">' + (r.side || '-') + '</span></td>' +
        '<td><strong>' + (r.unitPrice || '-') + '</strong></td>' +
        '<td><span class="badge badge-' + (r.priceRank <= 3 ? 'completed' : 'pending') + '">#' + (r.priceRank || '-') + '/' + (r.totalMarketAds || '-') + '</span></td>' +
        '<td>' + (r.bestPrice || '-') + '</td><td>' + (r.worstPrice || '-') + '</td></tr>';
    });
    html += '</tbody></table></div></div>';
  }

  return html;
}

function fmtN(v) { return v ? Number(v).toLocaleString() : ''; }

window.setMktFilter = function(key, val) { _mktFilters[key] = val; applyMktFilter(); };
window.applyMktFilter = function() {
  _mktFilters.maxPrice = document.getElementById('mkt-max-price') ? document.getElementById('mkt-max-price').value : '';
  _mktFilters.paymentMethod = document.getElementById('mkt-payment') ? document.getElementById('mkt-payment').value : '';
  _mktFilters.sortBy = document.getElementById('mkt-sort') ? document.getElementById('mkt-sort').value : 'price';
  if (_dashData) {
    var el = document.getElementById('dash-marketplace');
    if (el) el.innerHTML = buildMarketplaceContent(_dashData);
  }
};
window.clearMktFilter = function() { _mktFilters = { mktSide: 'all', maxPrice: '', paymentMethod: '', sortBy: 'price' }; applyMktFilter(); };

function buildAccountSummary(d) {
  var orders = d.orders || [];
  var stats = d.stats || {};
  var userInfo = d.userInfo || {};

  // Recent 30-day orders
  var cutoff30 = Date.now() - 30 * 86400000;
  var recentOrders = orders.filter(function(o) {
    var ts = parseFloat(o.createdTimestamp || o.createdDate || '0');
    return ts >= cutoff30 && ts > 0;
  });
  var recentBuy = recentOrders.filter(function(o) { return o.side !== 'sell'; });
  var recentSell = recentOrders.filter(function(o) { return o.side === 'sell'; });

  // Completion rate from OKX API (already normalized to 0-100 scale)
  var rateDisplay = d.completionRate != null ? d.completionRate.toFixed(2) + '%' : (userInfo.completionRate || stats.completionRate ? (parseFloat(userInfo.completionRate || stats.completionRate) * 100).toFixed(2) + '%' : '-');

  // Reviews from OKX merchant profile (section 6.4)
  var mp = d.merchantProfile || {};
  var posCount = mp.positiveReviews || stats.positiveReviews || userInfo.positiveReviews || '';
  var negCount = mp.negativeReviews || stats.negativeReviews || userInfo.negativeReviews || '';
  var posPct = mp.positiveReviewPercentage || '';
  var posReviews = posPct ? (posCount ? posCount + ' (' + posPct + '%)' : posPct + '%') : posCount || '0';
  var negPct = posPct && posPct !== '100.00' ? (100 - parseFloat(posPct)).toFixed(2) + '%' : '';
  var negReviews = negPct ? (negCount ? negCount + ' (' + negPct + ')' : negPct) : negCount || '0';

  function fmtTime(s) {
    if (s == null || s === '') return '-';
    var sec = parseInt(s);
    if (!sec) return '-';
    var m = Math.floor(sec / 60);
    var r = sec % 60;
    if (m > 0 && r > 0) return m + ' min ' + r + ' sec';
    if (m > 0) return m + ' min';
    return r + ' sec';
  }
  var avgPayTime = fmtTime(mp.avgPaymentTimeInSeconds || userInfo.avgPaymentTimeInSeconds || stats.avgPaymentTimeInSeconds || mp.avgPaymentTime);
  var avgCompTime = d.avgReleaseTime ? fmtTime(d.avgReleaseTime) : (function() {
    var completedOrders = d.completedOrdersList || d.orders || [];
    var times = [];
    completedOrders.forEach(function(o) {
      if (isCompletedOrder(o) && o.side === 'sell') {
        var start = parseFloat(o.createdTimestamp || o.createdDate || '0');
        var end = parseFloat(o.completedTimestamp || o.completionTimestamp || o.updatedTimestamp || '0');
        if (start > 0 && end > start) times.push((end - start) / 1000);
      }
    });
    return times.length > 0 ? fmtTime(Math.round(times.reduce(function(a, b) { return a + b; }, 0) / times.length)) : '-';
  })();

  return '<div class="table-container"><table><thead><tr><th>Metric</th><th>Value (OKX Stats)</th></tr></thead><tbody>' +
    '<tr><td>Recent Orders (30d)</td><td>' + recentOrders.length + ' (' + recentBuy.length + ' buy / ' + recentSell.length + ' sell)</td></tr>' +
    '<tr><td>Total Completed</td><td>' + (userInfo.completedOrders || stats.completedOrders || d.completedCount || '0') + '</td></tr>' +
    '<tr><td>Cancelled Orders</td><td>' + (userInfo.cancelledOrders || stats.cancelledOrders || '0') + '</td></tr>' +
    '<tr><td>Completion Rate</td><td>' + rateDisplay + '</td></tr>' +
    '<tr><td>Total Volume</td><td>' + formatFiat(d.totalVolume || 0, 'KES') + '</td></tr>' +
    '<tr><td>Avg Order Value</td><td>' + (d.completedCount > 0 ? formatFiat((d.totalVolume || 0) / d.completedCount, 'KES') : '-') + '</td></tr>' +
    '<tr><td>Positive Reviews</td><td>' + posReviews + '</td></tr>' +
    '<tr><td>Negative Reviews</td><td>' + negReviews + '</td></tr>' +
    '<tr><td>Avg Payment Time</td><td>' + avgPayTime + '</td></tr>' +
    '<tr><td>Avg Completion Time</td><td>' + avgCompTime + '</td></tr>' +
    '<tr><td>KYC Level</td><td>' + (userInfo.kycLevel || stats.kycLevel || '-') + '</td></tr>' +
    '<tr><td>User Type</td><td>' + (userInfo.type || stats.type || '-') + '</td></tr>' +
    '</tbody></table></div>';
}

function updateDashboardContent(container, d) {
  var orders = d.orders || [];
  var completedCount = d.completedCount || orders.filter(function(o) { return isCompletedOrder(o); }).length;
  var totalVolume = d.totalVolume || 0;
  var completionRate = d.completionRate || (orders.length > 0 ? Math.round((completedCount / orders.length) * 100) : 0);
  var pendingOrders = orders.filter(function(o) { var s = orderState(o); return s !== 'completed' && s !== 'canceled' && s !== 'cancelled' && o.paymentStatus !== 'confirmed'; }).length;
  var ads = d.ads || [];
  var activeAds = ads.filter(function(a) { return a.status === 'new' && !a.isHidden; }).length;
  var balData = d.okxBalance;
  var fundData = d.okxFundingBalance;
  var onHold = parseFloat(balData?.onHoldAmount || '0');
  var p2pAvail = parseFloat(balData?.availableAmount || '0');
  var p2pTotal = p2pAvail + onHold;
  var fundAvail = parseFloat(fundData?.availBal || '0');
  var fundFrozen = parseFloat(fundData?.frozenBal || '0');
  var hasFunding = fundData && fundData.availBal !== undefined;
  var available = hasFunding ? fundAvail + fundFrozen : p2pTotal;
  var opt = d.optimalPrice || {};
  var bestBuy = opt.currentHighestBuyAdPrice || null;
  var bestSell = opt.currentLowestSellAdPrice || null;

  if (!window._ordersMap) window._ordersMap = {};
  orders.forEach(function(o) { if (o.orderId) window._ordersMap[o.orderId] = o; });

  function setText(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }

  setText('dash-last-updated', 'Updated ' + new Date().toLocaleTimeString());
  setText('dash-balance', available.toFixed(2) + ' USDT');
  setText('dash-ads-count', ads.length);
  setText('dash-pending', pendingOrders);
  setText('dash-completed', completedCount);
  setText('dash-volume', formatFiat(totalVolume, 'KES'));

  function updateSub(cardId, txt) {
    var el = document.getElementById(cardId);
    if (el && el.parentNode && el.parentNode.lastElementChild) {
      el.parentNode.lastElementChild.textContent = txt;
    }
  }
  updateSub('dash-completed', completionRate.toFixed(2) + '% success');
  updateSub('dash-volume', completedCount + ' orders');
  updateSub('dash-ads-count', activeAds + ' active');

  var optCard = document.querySelector('#dash-stats .stat-card:last-child');
  if (optCard && bestBuy !== null) {
    function escHtml(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    var optInner = optCard.lastElementChild;
    if (optInner) optInner.innerHTML = 'Buy: <strong style="color:#00e676;">' + escHtml(bestBuy) + '</strong> · Sell: <strong style="color:#ff9100;">' + escHtml(bestSell) + '</strong><br><span style="color:var(--text-quaternary);font-size:9px;">USDT/KES rates</span>';
  }

  // Update order tables (skip if hash unchanged — no flash)
  var buyOrders = orders.filter(function(o) { return o.side !== 'sell'; });
  var sellOrders = orders.filter(function(o) { return o.side === 'sell'; });
  var buyHash = buyOrders.map(function(o) { return o.orderId + '|' + (o.state || o.completionStatus || '') + '|' + (o.paymentStatus || ''); }).join(',');
  var sellHash = sellOrders.map(function(o) { return o.orderId + '|' + (o.state || o.completionStatus || '') + '|' + (o.paymentStatus || ''); }).join(',');
  var buyEl = document.getElementById('dash-buy-orders');
  if (buyEl && buyHash !== buyEl._dashHash) { buyEl._dashHash = buyHash; buyEl.innerHTML = buildOrderTable(orders, 'buy'); }
  var sellEl = document.getElementById('dash-sell-orders');
  if (sellEl && sellHash !== sellEl._dashHash) { sellEl._dashHash = sellHash; sellEl.innerHTML = buildOrderTable(orders, 'sell'); }

  // Update marketplace content (skip if hash unchanged)
  var mktEl = document.getElementById('dash-marketplace');
  var mktHtml = buildMarketplaceContent(d);
  if (mktEl && mktHtml !== mktEl._dashMktHash) { mktEl._dashMktHash = mktHtml; mktEl.innerHTML = mktHtml; }

  // Update account summary (skip if hash unchanged)
  var summaryEl = document.getElementById('dash-account-summary');
  var summaryHtml = '<h3>📋 Account Summary</h3>' + buildAccountSummary(d);
  if (summaryEl && summaryHtml !== summaryEl._dashSummaryHash) { summaryEl._dashSummaryHash = summaryHtml; summaryEl.innerHTML = summaryHtml; }
}

function buildOrderTable(orders, side) {
  var filtered = orders.filter(function(o) {
    if (side === 'sell') return o.side === 'sell';
    return o.side !== 'sell';
  });
  filtered.sort(function(a, b) {
    var aDone = orderState(a) === 'completed' || orderState(a) === 'canceled' || orderState(a) === 'cancelled';
    var bDone = orderState(b) === 'completed' || orderState(b) === 'canceled' || orderState(b) === 'cancelled';
    if (aDone !== bDone) return aDone ? 1 : -1;
    return (parseFloat(b.createdTimestamp || '0') - parseFloat(a.createdTimestamp || '0'));
  });
  var recent = filtered.slice(0, 5);
  if (recent.length === 0) return '<div style="text-align:center;padding:20px;background:var(--bg-primary);border-radius:10px;"><span style="color:var(--text-quaternary);font-size:13px;">No ' + side + ' orders</span></div>';

  var html = '<div class="table-container"><table style="font-size:12px;"><thead><tr><th>Order ID</th><th>Customer</th><th>Account</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Status</th><th></th></tr></thead><tbody>';
  recent.forEach(function(o) {
    var os = orderState(o);
    var cp = getCounterpartyInfo(o);
    var isPaid = orderIsPaid(o) || os === 'completed';
    var isUnpaid = o.paymentStatus === 'unpaid' || (os !== 'completed' && os !== 'canceled' && os !== 'cancelled' && !isPaid);
    var isCompleted = os === 'completed';
    var oid = esc(o.orderId || '');
    var shortId = (o.orderId || '').slice(0, 12);

    var actions = '';
    if (side !== 'sell' && isUnpaid && !isCompleted) {
      actions += '<button class="btn btn-sm btn-primary" onclick="markBuyOrderPaid(\'' + oid + '\')" style="font-size:10px;padding:4px 10px;background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);font-weight:600;margin-right:4px;">Pay</button>';
    }
    if (side === 'sell' && isPaid && !isCompleted && !(window.isAppealedOrder && window.isAppealedOrder(o))) {
      actions += '<button class="btn btn-sm btn-primary" onclick="releaseSingleOrder(\'' + oid + '\')" style="font-size:10px;padding:4px 10px;background:linear-gradient(135deg,#ff9100,#ffab00);color:var(--text-on-accent);font-weight:600;margin-right:4px;">Release</button>';
    }
    if (side === 'sell' && window.isAppealedOrder && window.isAppealedOrder(o)) {
      actions += '<span style="font-size:10px;padding:4px 8px;border-radius:4px;background:rgba(244,67,54,0.12);border:1px solid rgba(244,67,54,0.35);color:var(--accent-red);font-weight:700;white-space:nowrap;margin-right:4px;">⚖️ Under Appeal</span>';
    }
    actions += '<button class="btn btn-sm btn-outline" onclick="showOrderDetail(\'' + oid + '\')" style="font-size:10px;padding:4px 8px;">Detail</button>';

    html += '<tr>'
      + '<td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" onclick="copyText(\'' + shortId + '\')">' + shortId + '</span></td>'
      + '<td style="font-size:11px;">' + cp.name + tradedBadge(o) + '</td>'
      + '<td style="font-size:11px;">' + renderPaymentInfo(o) + '</td>'
      + '<td>' + (o.cryptoAmount || '-') + ' ' + (o.cryptoCurrency || 'USDT') + '</td>'
      + '<td>' + formatFiat(o.fiatAmount, o.fiatCurrency) + '</td>'
      + '<td>' + (o.unitPrice || '-') + '</td>'
      + '<td><span class="badge badge-' + (isCompleted ? 'completed' : isPaid ? 'paid' : 'pending') + '">' + (isCompleted ? 'Completed' : isPaid ? 'Paid' : 'Unpaid') + '</span></td>'
      + '<td>' + actions + '</td>'
      + '</tr>';
  });
  html += '</tbody></table></div>';
  return html;
}

function showError(container, msg, retryFn) {
  // retryFn may close over locals (e.g. `container`) — stringifying it into an
  // onclick attribute breaks those references. Keep the real fn in a registry
  // and invoke through a global trampoline.
  var btn = '';
  if (retryFn) {
    window.__errRetryFn = retryFn;
    btn = '<button onclick="__errRetryClick()" style="padding:10px 24px;border-radius:10px;border:none;background:var(--accent-blue);color:#fff;font-weight:600;cursor:pointer;">Retry</button>';
  }
  container.innerHTML = '<div style="text-align:center;padding:40px 20px;"><p style="color:var(--accent-red);margin-bottom:16px;font-size:14px;">' + esc(msg) + '</p>' + btn + '</div>';
}
window.__errRetryClick = function() {
  var f = window.__errRetryFn;
  window.__errRetryFn = null;
  if (typeof f === 'function') f();
};

function showBalanceBreakdown(p2pAvail, onHold, total, fundAvail, fundFrozen) {
  // P2P wallet == funding wallet (same funds). Show one combined breakdown,
  // never sum the two wallets together.
  var effectiveTotal = total;
  var overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = [
    '<div class="modal-content" style="max-width:380px;">',
    '<h3 style="margin-bottom:20px;">USDT Balance Breakdown</h3>',
    '<div style="font-size:12px;color:var(--text-quaternary);margin-bottom:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Funding Wallet (P2P + Funding)</div>',
    '<div style="display:flex;flex-direction:column;gap:8px;margin-bottom:16px;">',
    '<div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;background:var(--bg-primary);border-radius:10px;border:1px solid #1a1a28;"><div style="font-weight:500;color:#aaaabc;">Available</div><div style="font-size:18px;font-weight:700;color:var(--accent-green);">' + (fundAvail || 0).toFixed(2) + ' USDT</div></div>',
    '<div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;background:var(--bg-primary);border-radius:10px;border:1px solid #1a1a28;"><div style="font-weight:500;color:#aaaabc;">On Hold (P2P escrow)</div><div style="font-size:18px;font-weight:700;color:#ff9100;">' + onHold.toFixed(2) + ' USDT</div></div>',
    '<div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;background:var(--bg-primary);border-radius:10px;border:1px solid #1a1a28;"><div style="font-weight:500;color:#aaaabc;">Frozen (Funding)</div><div style="font-size:18px;font-weight:700;color:#ff9100;">' + (fundFrozen || 0).toFixed(2) + ' USDT</div></div>',
    '</div>',
    '<div style="display:flex;justify-content:space-between;align-items:center;padding:16px;background:#0c1a14;border-radius:12px;border:1px solid rgba(0,200,83,0.2);"><div><div style="font-weight:600;color:var(--text-primary);">Grand Total</div><div style="font-size:12px;color:var(--text-quaternary);">Funding wallet — P2P and funding share the same funds</div></div><div style="font-size:24px;font-weight:800;color:#fff;">' + effectiveTotal.toFixed(2) + ' USDT</div></div>',
    '<button class="btn btn-secondary" style="width:100%;margin-top:20px;" onclick="this.closest(\'.modal-overlay\').remove()">Close</button>',
    '</div>'
  ].join('');
  document.body.appendChild(overlay);
}

async function checkKeys(container) {
  try {
    const res = await API.get('/api/p2p/dashboard');
    return res;
  } catch (err) {
    if (err.message && err.message.includes('API keys')) {
      const el = document.getElementById('page-content');
      if (el) el.innerHTML = [
        '<div class="page-header"><div><h2>Merchant Dashboard</h2><div class="subtitle">P2P command center</div></div></div>',
        configKeysPrompt()
      ].join('');
      return null;
    }
    throw err;
  }
}

function noApiKeysDashboard() {
  return '<div class="card" style="text-align:center;padding:48px;border-color:#ff980033;"><div style="font-size:48px;margin-bottom:16px;opacity:0.5;">🔑</div><h3 style="color:var(--accent-orange);text-transform:none;letter-spacing:0;font-size:18px;margin-bottom:8px;">Set Your Own OKX API Keys</h3><p style="color:var(--text-tertiary);margin-bottom:16px;max-width:440px;margin-left:auto;margin-right:auto;line-height:1.6;">You need to configure your own OKX API keys to access P2P data and balances. Go to <strong>Settings → API Config</strong> to add your keys.</p><button class="btn btn-primary" onclick="navigate(\'settings\')">Go to Settings</button></div>';
}

function configKeysPrompt() {
  return '<div class="card" style="text-align:center;padding:48px;border-color:#ff980033;"><div style="font-size:48px;margin-bottom:16px;opacity:0.5;">🔑</div><h3 style="color:var(--accent-orange);text-transform:none;letter-spacing:0;font-size:18px;margin-bottom:8px;">OKX API Keys Required</h3><p style="color:var(--text-tertiary);margin-bottom:16px;max-width:440px;margin-left:auto;margin-right:auto;line-height:1.6;">Set your OKX API keys in <code style="background:#1a1a28;padding:2px 8px;border-radius:4px;">.env</code> to connect to the OKX P2P API. You need <strong>Super or Diamond Merchant</strong> status on OKX.</p><div style="display:inline-block;text-align:left;background:var(--bg-primary);border:1px solid #1a1a28;border-radius:12px;padding:20px 24px;margin-bottom:16px;"><div style="color:var(--text-quaternary);font-size:12px;margin-bottom:8px;">Required .env variables:</div><code style="display:block;color:var(--text-primary);font-size:13px;line-height:1.8;">OKX_API_KEY=your-api-key<br>OKX_SECRET_KEY=your-secret-key<br>OKX_PASSPHRASE=your-passphrase</code></div><p style="color:var(--text-quaternary);font-size:12px;">Apply for P2P API access at <a href="https://www.okx.com/p2p/api" target="_blank" style="color:var(--accent-green);">okx.com/p2p/api</a></p></div>';
}

// Listen for order-update to refresh dashboard order tables (no full poll — avoids 10-API-call flood)
document.addEventListener('order-update', function(e) {
  if (currentPage !== 'dashboard') return;
  var data = e.detail;
  if (!data || !Array.isArray(data.orders) || !data.orders.length) return;
  var buyHash = data.orders.filter(function(o) { return o.side !== 'sell'; }).map(function(o) { return o.orderId + '|' + (o.state || o.completionStatus || '') + '|' + (o.paymentStatus || ''); }).join(',');
  var sellHash = data.orders.filter(function(o) { return o.side === 'sell'; }).map(function(o) { return o.orderId + '|' + (o.state || o.completionStatus || '') + '|' + (o.paymentStatus || ''); }).join(',');
  var buyEl = document.getElementById('dash-buy-orders');
  if (buyEl && buyHash !== buyEl._dashHash) { buyEl._dashHash = buyHash; buyEl.innerHTML = buildOrderTable(data.orders, 'buy'); }
  var sellEl = document.getElementById('dash-sell-orders');
  if (sellEl && sellHash !== sellEl._dashHash) { sellEl._dashHash = sellHash; sellEl.innerHTML = buildOrderTable(data.orders, 'sell'); }
});

// ===== Marketplace Order Modal =====
window.showOrderModal = function(adId, side, price, minOrder, maxOrder, merchantName, merchantId) {
  var modal = document.createElement('div');
  modal.className = 'modal-overlay';
  modal.innerHTML = '<div class="modal-content" style="max-width:400px;"><h3>' + (side === 'buy' ? 'Buy' : 'Sell') + ' USDT</h3>' +
    '<div style="padding:12px;background:var(--bg-primary);border-radius:8px;margin-bottom:12px;">' +
    '<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;"><span>Price</span><span style="color:var(--text-primary);font-weight:600;">KES ' + price + '</span></div>' +
    (merchantName ? '<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;"><span>Merchant</span><span style="color:var(--text-primary);">' + esc(merchantName) + '</span></div>' : '') +
    '<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;"><span>Limits</span><span style="color:var(--text-primary);">KES ' + fmtN(minOrder) + ' - KES ' + fmtN(maxOrder) + '</span></div>' +
    '</div>' +
    '<div class="form-group"><label>Amount (USDT)</label>' +
    '<input class="form-input" id="order-amount-input" type="number" step="any" placeholder="0.00" style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-input);color:var(--text-primary);font-size:14px;" oninput="updateOrderTotal(this.value,' + price + ')"></div>' +
    '<div class="form-group"><label>Total (KES)</label>' +
    '<input class="form-input" id="order-total-input" type="number" step="any" placeholder="0.00" style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-input);color:var(--text-primary);font-size:14px;" oninput="updateOrderAmount(this.value,' + price + ')"></div>' +
    '<div id="order-limits-hint" style="font-size:11px;color:var(--text-quaternary);margin-bottom:12px;">Min: KES ' + fmtN(minOrder) + ' | Max: KES ' + fmtN(maxOrder) + '</div>' +
    '<button class="btn btn-primary" style="width:100%;background:' + (side === 'buy' ? 'linear-gradient(135deg,#00c853,#00e676)' : 'linear-gradient(135deg,#f44336,#ef5350)') + ';color:#fff;font-weight:600;" onclick="placeMarketOrder(\'' + adId + '\',\'' + side + '\',this)">Place ' + (side === 'buy' ? 'Buy' : 'Sell') + ' Order</button>' +
    '<button class="btn btn-secondary" style="width:100%;margin-top:6px;" onclick="this.closest(\'.modal-overlay\').remove()">Cancel</button>' +
    '</div></div>';
  document.body.appendChild(modal);
  document.getElementById('order-amount-input').focus();
};

window.updateOrderTotal = function(amount, price) {
  var totalEl = document.getElementById('order-total-input');
  if (totalEl) totalEl.value = (parseFloat(amount || 0) * parseFloat(price)).toFixed(2);
};

window.updateOrderAmount = function(total, price) {
  var amtEl = document.getElementById('order-amount-input');
  if (amtEl && price > 0) amtEl.value = (parseFloat(total || 0) / parseFloat(price)).toFixed(6);
};

window.placeMarketOrder = async function(adId, side, btn) {
  var amt = document.getElementById('order-amount-input');
  var total = document.getElementById('order-total-input');
  if (!amt || !total || !parseFloat(amt.value)) { showToast('Enter a valid amount', 'error'); return; }
  btn.disabled = true;
  btn.textContent = 'Processing...';
  try {
    var res = await API.post('/api/p2p/orders', {
      adId: adId,
      side: side.toUpperCase(),
      cryptoAmount: amt.value,
      fiatAmount: total.value
    });
    showToast('Order placed: ' + (res.data.orderId || res.data.data?.orderId || 'success'), 'success');
    btn.closest('.modal-overlay').remove();
  } catch (err) {
    showToast('Order failed: ' + err.message, 'error');
    btn.disabled = false;
    btn.textContent = 'Place ' + (side === 'buy' ? 'Buy' : 'Sell') + ' Order';
  }
};

// ===== Toggle Follow Merchant =====
window.toggleFollowMerchant = async function(merchantId, merchantName, btn) {
  if (!merchantId) { showToast('Unknown merchant', 'error'); return; }
  var isFollowing = btn && (btn.textContent.trim() === 'Unfollow' || btn.dataset.following === 'true');
  try {
    if (isFollowing) {
      await API.post('/api/p2p/merchant/unfollow', { merchantId: merchantId });
      if (btn) { btn.textContent = '+Follow'; btn.dataset.following = 'false'; btn.style.borderColor = '#4488ff44'; btn.style.color = '#4488ff'; }
      showToast('Unfollowed ' + (merchantName || merchantId), 'info');
    } else {
      await API.post('/api/p2p/merchant/follow', { merchantId: merchantId });
      if (btn) { btn.textContent = 'Unfollow'; btn.dataset.following = 'true'; btn.style.borderColor = '#f4433644'; btn.style.color = '#f44336'; }
      showToast('Following ' + (merchantName || merchantId), 'success');
    }
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Price Explorer Page =====
function extractFirst(arr) {
  return Array.isArray(arr) && arr.length > 0 ? arr[0] : (arr && typeof arr === 'object' ? arr : null);
}
window.renderPriceExplorer = async function(container) {
  container.innerHTML = '<div class="page-header"><div><h2>Price Explorer</h2><div class="subtitle">OKX P2P USDT/KES price analysis</div></div></div><div style="margin-top:16px;display:grid;gap:16px;" id="price-explorer-content"><div style="text-align:center;padding:40px;color:var(--text-quaternary);"><div class="spinner"></div><span>Loading price data...</span></div></div>';
  try {
    var results = await Promise.allSettled([
      API.get('/api/p2p/ticker/estimated-price?cryptoCurrency=USDT&fiatCurrency=KES'),
      API.get('/api/p2p/dashboard'),
      API.get('/api/p2p/ticker/swap?cryptoCurrency=USDT&fiatCurrency=KES&usdtAmount=200')
    ]);
    var estRaw = results[0].status === 'fulfilled' ? results[0].value?.data : null;
    var dashData = results[1].status === 'fulfilled' ? results[1].value?.data : null;
    var swapRaw = results[2].status === 'fulfilled' ? results[2].value?.data : null;

    var est = extractFirst(estRaw);
    var swap = extractFirst(swapRaw);

    // Extract prices from marketplace data (most reliable)
    var mBuy = dashData?.marketplaceSell || [];
    var mSell = dashData?.marketplaceBuy || [];
    var allBuyPrices = mBuy.map(function(a) { return parseFloat(a.unitPrice); }).filter(function(p) { return p > 0; });
    var allSellPrices = mSell.map(function(a) { return parseFloat(a.unitPrice); }).filter(function(p) { return p > 0; });
    var allPrices = allBuyPrices.concat(allSellPrices);

    var bestBuyPrice = allBuyPrices.length > 0 ? Math.min.apply(null, allBuyPrices).toFixed(2) : '—';
    var bestSellPrice = allSellPrices.length > 0 ? Math.max.apply(null, allSellPrices).toFixed(2) : '—';

    // Current price: try estimated API, then swap, then average of marketplace
    var curPrice = est?.estimatedPrice || est?.price || swap?.price || swap?.estimatedPrice || '';
    if (!curPrice && allPrices.length > 0) {
      var sorted = allPrices.slice().sort(function(a,b) { return a - b; });
      var mid = Math.floor(sorted.length / 2);
      curPrice = sorted.length % 2 ? sorted[mid] : ((sorted[mid-1] + sorted[mid]) / 2).toFixed(2);
    }
    if (!curPrice) curPrice = '—';
    else if (typeof curPrice === 'number') curPrice = curPrice.toFixed(2);

    var spread = (bestBuyPrice !== '—' && bestSellPrice !== '—') ? ((parseFloat(bestSellPrice) - parseFloat(bestBuyPrice)) / parseFloat(bestBuyPrice) * 100).toFixed(2) + '%' : '—';

    var html = '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:12px;">';

    // Current Price Card
    html += '<div class="card" style="border-color:rgba(68,138,255,0.2);"><h3 style="font-size:14px;margin:0 0 8px;">Current Price (USDT/KES)</h3>' +
      '<div style="font-size:28px;font-weight:800;color:var(--text-primary);">KES ' + curPrice + '</div>' +
      '<div style="display:flex;gap:16px;margin-top:8px;font-size:12px;">' +
      '<span>Buy: <strong style="color:#00c853;">' + bestBuyPrice + '</strong></span>' +
      '<span>Sell: <strong style="color:#f44336;">' + bestSellPrice + '</strong></span>' +
      '<span>Spread: <strong style="color:#ff9800;">' + spread + '</strong></span></div></div>';

    // Statistics Card
    var avgPrice = allPrices.length > 0 ? (allPrices.reduce(function(a,b) { return a + b; }, 0) / allPrices.length).toFixed(2) : '—';
    var midPrice = allPrices.length > 0 ? (function(p) { var s = p.slice().sort(function(a,b) { return a - b; }); var m = Math.floor(s.length/2); return s.length % 2 ? s[m].toFixed(2) : ((s[m-1] + s[m])/2).toFixed(2); })(allPrices) : '—';
    var minP = allPrices.length > 0 ? Math.min.apply(null, allPrices).toFixed(2) : '—';
    var maxP = allPrices.length > 0 ? Math.max.apply(null, allPrices).toFixed(2) : '—';
    html += '<div class="card" style="border-color:rgba(255,145,0,0.2);"><h3 style="font-size:14px;margin:0 0 8px;">Price Statistics</h3>' +
      '<div style="font-size:12px;color:var(--text-tertiary);"><div>Average: <strong style="color:var(--text-primary);">KES ' + avgPrice + '</strong></div>' +
      '<div>Median: <strong style="color:var(--text-primary);">KES ' + midPrice + '</strong></div>' +
      '<div>Min: <strong style="color:#00c853;">KES ' + minP + '</strong></div>' +
      '<div>Max: <strong style="color:#f44336;">KES ' + maxP + '</strong></div></div></div>';

    // Market Overview Card
    var totalVol = 0;
    mBuy.concat(mSell).forEach(function(a) { totalVol += parseFloat(a.availableAmount || 0); });
    html += '<div class="card" style="border-color:rgba(0,200,83,0.2);"><h3 style="font-size:14px;margin:0 0 8px;">Market Overview</h3>' +
      '<div style="font-size:12px;color:var(--text-tertiary);"><div>Buy Ads (cheapest): <strong style="color:var(--text-primary);">' + mBuy.length + '</strong></div>' +
      '<div>Sell Ads (highest): <strong style="color:var(--text-primary);">' + mSell.length + '</strong></div>' +
      '<div>Total Liquidity: <strong style="color:var(--text-primary);">' + totalVol.toFixed(2) + ' USDT</strong></div></div></div>';

    html += '</div>';

    // Price distribution chart
    html += '<div class="card" style="margin-top:16px;"><h3 style="font-size:14px;margin:0 0 12px;">Price Distribution</h3>';
    html += '<div style="display:flex;align-items:flex-end;height:140px;gap:2px;padding:8px 0;" id="price-dist-bars">';
    if (allPrices.length > 1) {
      var minPrice = Math.min.apply(null, allPrices);
      var maxPrice = Math.max.apply(null, allPrices);
      var range = maxPrice - minPrice || 1;
      var bins = Math.min(20, allPrices.length);
      var step = range / bins;
      var histogram = new Array(bins).fill(0);
      allPrices.forEach(function(p) { var idx = Math.min(bins - 1, Math.floor((p - minPrice) / step)); histogram[idx]++; });
      var maxBin = Math.max.apply(null, histogram) || 1;
      histogram.forEach(function(count, idx) {
        var pct = (count / maxBin) * 100;
        var priceLabel = (minPrice + idx * step).toFixed(1);
        var isBuy = allBuyPrices.some(function(p) { return p >= (minPrice + idx * step) && p < (minPrice + (idx + 1) * step); });
        html += '<div style="flex:1;display:flex;flex-direction:column;align-items:center;"><div style="width:100%;background:' + (isBuy ? 'rgba(0,200,83,0.6)' : 'rgba(244,67,54,0.6)') + ';height:' + pct + '%;border-radius:2px 2px 0 0;min-height:2px;transition:height 0.3s;" title="' + priceLabel + ': ' + count + ' ads"></div><span style="font-size:8px;color:var(--text-quaternary);margin-top:2px;">' + priceLabel + '</span></div>';
      });
    } else {
      html += '<div style="width:100%;text-align:center;color:var(--text-quaternary);font-size:12px;">Not enough price data</div>';
    }
    html += '</div></div>';

    // Price Alerts quick link
    html += '<div class="card" style="margin-top:16px;border-color:rgba(68,138,255,0.15);display:flex;align-items:center;justify-content:space-between;">' +
      '<div><h3 style="font-size:14px;margin:0 0 4px;">Price Alerts</h3><p style="font-size:12px;color:var(--text-tertiary);margin:0;">Get notified when USDT/KES price crosses your target</p></div>' +
      '<button class="btn btn-primary" onclick="navigate(\'settings-price-alerts\')" style="white-space:nowrap;">Manage Alerts</button></div>';

    var contentEl = container.querySelector('#price-explorer-content');
    if (contentEl) contentEl.innerHTML = html;
    else container.innerHTML += html;
  } catch (err) {
    var el = container.querySelector('#price-explorer-content');
    if (el) el.innerHTML = '<div class="card" style="text-align:center;padding:40px;color:#f44336;">Failed to load price data: ' + esc(err.message) + '</div>';
  }
};

/* ==== js/modules/okx/ads.js ==== */
var _adsTab = 'manage';
var _adsPairFilter = {};
var _trailingLogTimer = null;

// SSE-first: refresh ads page when server pushes an ad change event
document.addEventListener('sse_ads_update', function() {
  if (currentPage === 'ads') {
    var c = document.getElementById('content');
    if (c && typeof renderAds === 'function') renderAds(c);
  }
});

window.renderAds = async function renderAds(container) {
  if (currentUser && currentUser.role !== 'admin' && !currentUser.hasApiKeys) {
    container.innerHTML = '<div class="page-header"><div><h2>P2P Ads</h2></div></div>' + noApiKeysDashboard();
    return;
  }
  if (currentUser && currentUser.approved === 0 && currentUser.hasApiKeys) {
    container.innerHTML = '<div class="page-header"><div><h2>P2P Ads</h2></div></div><div class="card" style="border-color:rgba(255,145,0,0.3);margin-top:16px;text-align:center;padding:40px 20px;"><div style="font-size:48px;margin-bottom:16px;">🛂</div><h3 style="color:#ff9100;">Account Pending Approval</h3><p style="color:var(--text-tertiary);font-size:14px;max-width:400px;margin:12px auto;">Your API keys have been submitted for admin review.</p><p style="color:var(--text-quaternary);font-size:12px;">Contact admin: +254723472206</p></div>';
    return;
  }
  var tabsHtml = '<div class="page-header"><div><h2>Ads</h2><div class="subtitle">Manage your P2P advertisements</div></div></div><div style="display:flex;gap:0;margin-bottom:16px;border-bottom:1px solid #1e1e2e;"><button class="btn btn-sm ' + (_adsTab === 'manage' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchAdsTab(\'manage\')">Ad Management</button><button class="btn btn-sm ' + (_adsTab === 'myads' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchAdsTab(\'myads\')">My Ads</button><button class="btn btn-sm ' + (_adsTab === 'settings' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchAdsTab(\'settings\')">Settings</button><button class="btn btn-sm ' + (_adsTab === 'presence' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchAdsTab(\'presence\')">🛰️ Presence</button><button class="btn btn-sm ' + (_adsTab === 'advanced' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchAdsTab(\'advanced\')">Advanced</button><button class="btn btn-sm ' + (_adsTab === 'proofs' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchAdsTab(\'proofs\')">💬 SMS Proofs</button></div><div id="ads-tab-content"></div>';
  container.innerHTML = tabsHtml;
  if (_adsTab === 'manage') await renderAdManagement(container);
  else if (_adsTab === 'myads') await renderMyAds(container);
  else if (_adsTab === 'settings') await renderAdSettings(container);
  else if (_adsTab === 'presence') await renderOkxPresenceTab(container);
  else if (_adsTab === 'proofs') await renderSmsProofs(container);
  else await renderAdAdvanced(container);
}

window.switchAdsTab = async function(tab) {
  _adsTab = tab;
  var container = document.getElementById('page-content');
  if (container) await renderAds(container);
};

window.applyAdPairFilter = function() {
  var cryptoEl = document.getElementById('ads-pair-crypto');
  var fiatEl = document.getElementById('ads-pair-fiat');
  _adsPairFilter = { crypto: cryptoEl ? cryptoEl.value : '', fiat: fiatEl ? fiatEl.value : '' };
  navigate('ads');
};

function startTrailingLogPoll() {
  if (_trailingLogTimer) clearInterval(_trailingLogTimer);
  var _lastTrailingTs = 0;
  var _busy = false;
  _trailingLogTimer = setInterval(async function() {
    if (document.hidden) return;
    if (_busy) return;
    var logEl = document.getElementById('trailing-log');
    if (!logEl) { clearInterval(_trailingLogTimer); _trailingLogTimer = null; return; }
    _busy = true;
    try {
      var res = await API.get('/api/okx/p2p/trailing/log');
      var logs = Array.isArray(res.data) ? res.data : [];
      if (logs.length === 0) return;
      var latestTs = logs[0].ts || 0;
      if (latestTs === _lastTrailingTs) return;
      _lastTrailingTs = latestTs;
      logEl.innerHTML = logs.map(function(l) { return '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; }).join('');
    } catch {}
    finally { _busy = false; }
  }, 10000);
  window._trailingLogTimer = _trailingLogTimer;
}

var _autoAdLogTimer = null;

// ===== Auto-Message dashboard (runs independently of trailing) =====
var _amLogTimer = null;

function renderAutoMsgDashboard(cfg) {
  var el = document.getElementById('auto-msg-dashboard');
  if (!el) return;
  var buyCfg = (cfg.buy && cfg.buy.coins && cfg.buy.coins[cfg.buy.activeCoin || 'USDT']) || {};
  var sellCfg = (cfg.sell && cfg.sell.coins && cfg.sell.coins[cfg.sell.activeCoin || 'USDT']) || {};
  function block(side, label, coinCfg, accent) {
    var on = !!coinCfg.autoMessageEnabled;
    var text = coinCfg.autoMessageText || '';
    return '<div style="flex:1;min-width:280px;background:var(--bg-primary);border-radius:8px;padding:10px;border:1px solid ' + accent + ';">'
      + '<div style="font-size:12px;font-weight:600;color:var(--text-secondary);margin-bottom:8px;">' + label + ' <span style="font-weight:400;color:var(--text-quaternary);font-size:11px;">(' + (on ? 'ON' : 'OFF') + ')</span></div>'
      + '<label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:6px;margin-bottom:6px;cursor:pointer;"><input type="checkbox" class="am-enable-' + side + '" ' + (on ? 'checked' : '') + '> Enable for new ' + side + ' orders</label>'
      + '<textarea class="am-text-' + side + '" rows="3" style="width:100%;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:6px;color:var(--text-primary);font-size:11px;padding:6px;" placeholder="Hello, welcome to my ad. Kindly complete payment within the time limit.">' + esc(text) + '</textarea></div>';
  }
  el.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:10px;margin-bottom:10px;">'
    + block('buy', '📥 Buy ads', buyCfg, 'rgba(76,175,80,0.35)')
    + block('sell', '📤 Sell ads', sellCfg, 'rgba(156,39,176,0.35)')
    + '</div>'
    + '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-bottom:10px;"><button class="btn btn-sm btn-success" data-on-click="saveAutoMsgDashboard()">💾 Save messages</button>'
    + '<span style="font-size:11px;color:var(--text-quaternary);">Sent the moment a new order lands — server-side, trailing not required. Saved under each side\'s active coin.</span></div>'
    + '<div style="font-size:12px;color:var(--text-tertiary);margin-bottom:6px;">📨 Messages sent <span style="color:var(--text-quaternary);font-weight:400;">(order / chat id)</span></div>'
    + '<div id="am-sent-log" style="background:var(--bg-primary);border-radius:6px;padding:8px;max-height:220px;overflow-y:auto;font-size:11px;font-family:monospace;"><div style="color:var(--text-quaternary);">Loading log...</div></div>';
  loadAutoMsgSentLog();
}

window.saveAutoMsgDashboard = async function() {
  try {
    var cfgRes = await API.get('/api/okx/p2p/trailing/config');
    var cfg = cfgRes.data || {};
    if (!cfg.buy) cfg.buy = { activeCoin: 'USDT', coins: {} };
    if (!cfg.sell) cfg.sell = { activeCoin: 'USDT', coins: {} };
    ['buy', 'sell'].forEach(function(side) {
      if (!cfg[side].coins) cfg[side].coins = {};
      if (!cfg[side].activeCoin) cfg[side].activeCoin = 'USDT';
      var coin = cfg[side].activeCoin;
      if (!cfg[side].coins[coin]) cfg[side].coins[coin] = {};
      var en = document.querySelector('.am-enable-' + side);
      var tx = document.querySelector('.am-text-' + side);
      cfg[side].coins[coin].autoMessageEnabled = !!(en && en.checked);
      cfg[side].coins[coin].autoMessageText = tx ? tx.value : '';
    });
    await API.post('/api/okx/p2p/trailing/config', { buy: cfg.buy, sell: cfg.sell });
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    showToast('Welcome Message saved — sent the moment an order is created', 'success');
    loadTrailingConfig();
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Completed Order Thank You Notice dashboard =====
// Named "Completed Order ... Notice" rather than "Thank You" because the WELCOME
// message also ends with "thank you for trading with me". The two are sent at
// opposite ends of the trade (order created vs order completed) and must never be
// confused with each other.
var _DEFAULT_TY_TEMPLATES = {
  enabled: true,
  completed: '{greeting}, {name}! 👋\n\nThank you for trading with me! I hope you enjoyed our experience. Your order #{orderId} has been completed successfully.\n\nYou\'re always welcome back for more trades. Have a wonderful {time}! 😊',
  cancelledSell: '{greeting}, {name}! 👋\n\nThank you for considering me for this trade. Unfortunately, order #{orderId} has been cancelled.\n\nIf you encountered any challenges during payment, please don\'t hesitate to reach out on the chat — I\'m here to help. You\'re always welcome to try again. Have a great {time}! 🙏',
  cancelledBuy: '{greeting}, {name}! 👋\n\nThank you for your patience with this trade. Unfortunately, due to a technical difficulty on our end, payment could not be processed for order #{orderId}.\n\nWe sincerely apologize for the inconvenience. Please try again at a later time as we work to resolve this. Have a wonderful {time}! 🙏'
};

function _loadTYConfig() {
  try { return JSON.parse(localStorage.getItem('thankYouNotes') || 'null') || JSON.parse(JSON.stringify(_DEFAULT_TY_TEMPLATES)); } catch (e) { return JSON.parse(JSON.stringify(_DEFAULT_TY_TEMPLATES)); }
}
function _saveTYConfig(cfg) { localStorage.setItem('thankYouNotes', JSON.stringify(cfg)); }
window._loadTYConfig = _loadTYConfig;

function renderThankYouNotes() {
  var el = document.getElementById('thankyou-notes-dashboard');
  if (!el) return;
  var cfg = _loadTYConfig();
  window._syncThankYouConfig(cfg);
  var placeholders = [
    ['{name}', 'Counterparty name'],
    ['{orderId}', 'Order ID (first 8 chars)'],
    ['{side}', 'buy / sell'],
    ['{greeting}', 'Good morning/afternoon/evening/night'],
    ['{time}', 'morning / afternoon / evening / night']
  ];
  function block(key, label, color) {
    return '<div style="background:var(--bg-primary);border-radius:8px;padding:12px;border:1px solid ' + color + ';margin-bottom:10px;">'
      + '<div style="font-size:12px;font-weight:600;color:var(--text-secondary);margin-bottom:8px;">' + label + '</div>'
      + '<textarea id="ty-tpl-' + key + '" rows="4" style="width:100%;background:var(--bg-tertiary);border:1px solid var(--border-primary);border-radius:6px;color:var(--text-primary);font-size:11px;padding:8px;resize:vertical;font-family:inherit;">' + esc(cfg[key] || '') + '</textarea>'
      + '</div>';
  }
  el.innerHTML = '<label style="display:flex;align-items:center;gap:8px;margin-bottom:12px;cursor:pointer;font-size:12px;color:var(--text-secondary);">'
    + '<input type="checkbox" id="ty-enabled" ' + (cfg.enabled !== false ? 'checked' : '') + ' style="accent-color:var(--accent-green);">'
    + '<strong>Auto-send the Completed Order Thank You Notice after the order actually completes, or a cancellation notice if it is cancelled</strong></label>'
    + block('completed', '✅ Completed Trade (after release)', 'rgba(0,200,83,0.3)')
    + block('cancelledSell', '📤 Cancelled — Sell Side (you cancelled, buyer couldn\'t pay)', 'rgba(156,39,176,0.3)')
    + block('cancelledBuy', '📥 Cancelled — Buy Side (you cancelled, API/technical issue)', 'rgba(255,152,0,0.3)')
    + '<div style="background:var(--bg-primary);border-radius:8px;padding:10px;margin-bottom:10px;border:1px solid var(--border-tertiary);">'
    + '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:6px;">Available placeholders:</div>'
    + '<div style="display:flex;flex-wrap:wrap;gap:4px;">'
    + placeholders.map(function(p) { return '<span style="display:inline-block;padding:2px 8px;background:var(--bg-secondary);border:1px solid var(--border-secondary);border-radius:4px;font-size:10px;font-family:monospace;color:var(--accent-green);">' + esc(p[0]) + ' <span style="color:var(--text-quaternary);font-family:sans-serif;">' + esc(p[1]) + '</span></span>'; }).join('')
    + '</div></div>'
    + '<div style="display:flex;gap:6px;align-items:center;">'
    + '<button class="btn btn-sm btn-success" data-on-click="saveThankYouNotes()">💾 Save</button>'
    + '<button class="btn btn-sm btn-outline" data-on-click="resetThankYouNotes()">↺ Reset defaults</button>'
    + '<span id="ty-save-status" style="font-size:11px;color:var(--text-quaternary);"></span>'
    + '</div>';
}

window.saveThankYouNotes = function() {
  var cfg = {
    enabled: !!(document.getElementById('ty-enabled') || {}).checked,
    completed: (document.getElementById('ty-tpl-completed') || {}).value || _DEFAULT_TY_TEMPLATES.completed,
    cancelledSell: (document.getElementById('ty-tpl-cancelledSell') || {}).value || _DEFAULT_TY_TEMPLATES.cancelledSell,
    cancelledBuy: (document.getElementById('ty-tpl-cancelledBuy') || {}).value || _DEFAULT_TY_TEMPLATES.cancelledBuy
  };
  _saveTYConfig(cfg);
  window._syncThankYouConfig(cfg);
  var s = document.getElementById('ty-save-status');
  if (s) { s.textContent = '✓ Saved'; setTimeout(function() { s.textContent = ''; }, 2000); }
  showToast('Thank-you note templates saved', 'success');
};

// Fire-and-forget sync to the server. The SERVER-SIDE completion sender
// (services/completedThankYouService) posts the notice even when no browser/APK
// is active at completion, so it must know the exact templates (and whether the
// feature is disabled). Called on save and whenever the editor is opened; POST
// failures are silently ignored — the server just falls back to its defaults.
window._syncThankYouConfig = function(cfg) {
  try {
    var c = cfg || _loadTYConfig();
    var payload = {
      enabled: c.enabled !== false,
      completed: c.completed || _DEFAULT_TY_TEMPLATES.completed,
      cancelledSell: c.cancelledSell || _DEFAULT_TY_TEMPLATES.cancelledSell,
      cancelledBuy: c.cancelledBuy || _DEFAULT_TY_TEMPLATES.cancelledBuy
    };
    if (window.API && API.post) API.post('/api/okx/p2p/thankyou-config', payload).catch(function() {});
  } catch (e) { /* never break the UI over a config sync */ }
};

window.resetThankYouNotes = function() {
  _saveTYConfig(JSON.parse(JSON.stringify(_DEFAULT_TY_TEMPLATES)));
  renderThankYouNotes();
  showToast('Templates reset to defaults', 'info');
};

async function loadAutoMsgSentLog() {
  var el = document.getElementById('am-sent-log');
  if (!el) return;
  try {
    var res = await API.get('/api/okx/p2p/trailing/auto-message-log?limit=50');
    var rows = Array.isArray(res.data) ? res.data : [];
    if (!rows.length) { el.innerHTML = '<div style="color:var(--text-quaternary);">No auto-messages sent yet — configure buy/sell messages above and save.</div>'; return; }
    el.innerHTML = rows.map(function(r) {
      var side = (r.side || '').toLowerCase();
      var color = side === 'buy' ? '#4caf50' : '#9c27b0';
      var st = r.status || 'sent';
      var stColor = st === 'sent' ? '#4caf50' : (st === 'retry' ? '#ffb74d' : '#ef5350');
      var ts = r.created_at ? fmtTimeAgo(new Date(r.created_at).getTime()) : '';
      var txt = String(r.text || '').replace(/\s+/g, ' ').trim();
      return '<div style="padding:3px 0;border-bottom:1px solid #14141e;color:#90a4ae;">'
        + '<span style="color:' + color + ';font-weight:600;">' + (side === 'buy' ? 'Buy' : 'Sell') + '</span> '
        + '<span style="color:#e0e0e0;">' + esc(r.order_id || '?') + '</span>'
        + ' <span style="color:var(--text-quaternary);">-</span> <span>' + esc(txt.slice(0, 90)) + '</span>'
        + ' <span style="color:var(--text-quaternary);">-</span>'
        + ' <span style="color:' + stColor + ';">' + esc(st) + '</span>'
        + (r.detail ? ' <span style="color:var(--text-quaternary);cursor:help;" title="' + esc(r.detail).replace(/"/g, '&quot;') + '">i</span>' : '')
        + ' <span style="color:var(--text-quaternary);float:right;">' + ts + '</span></div>';
    }).join('');
  } catch (e) { el.innerHTML = '<div style="color:#ef5350;">Failed to load log: ' + esc((e && e.message) || e) + '</div>'; }
}

function startAutoMsgLogPoll() {
  if (_amLogTimer) clearInterval(_amLogTimer);
  _amLogTimer = setInterval(function() {
    if (document.hidden) return;
    var el = document.getElementById('am-sent-log');
    if (!el) { clearInterval(_amLogTimer); _amLogTimer = null; return; }
    loadAutoMsgSentLog();
  }, 10000);
  window._amLogTimer = _amLogTimer;
}

// ===== Release Reminder dashboard (buy side: nudge seller to release) =====
var _rrTimer = null;

function _rrStageBadge(stage) {
  var map = {
    'new': 'chip-amber|● Waiting',
    'reminder1_sent': 'chip-blue|1️⃣ 1st reminder sent',
    'reminder2_sent': 'chip-amber|2️⃣ 2nd reminder sent',
    'appealed': 'chip-red|⚖️ Appealed',
    'closed': 'chip-green|✓ Done'
  };
  var p = (map[stage] || 'chip-gray|' + esc(stage || '-')).split('|');
  return '<span class="chip ' + p[0] + '" style="font-size:10px;">' + p[1] + '</span>';
}

async function loadReleaseReminderLog() {
  var el = document.getElementById('rr-active');
  var lg = document.getElementById('rr-log');
  if (!el && !lg) return;
  try {
    if (el) {
      var aRes = await API.get('/api/okx/p2p/release-reminder/all');
      var rows = Array.isArray(aRes.data) ? aRes.data : [];
      var open = rows.filter(function(r) { return r.stage !== 'closed' && r.stage !== 'appealed'; });
      var done = rows.filter(function(r) { return r.stage === 'closed' || r.stage === 'appealed'; }).slice(0, 8);
      function row(r) {
        var mins = r.marked_paid_at ? Math.max(0, Math.round((Date.now() - Number(r.marked_paid_at)) / 60000)) : 0;
        return '<div style="display:flex;align-items:center;gap:8px;padding:4px 0;border-bottom:1px solid #14141e;font-size:11px;">'
          + '<span style="color:#e0e0e0;font-family:monospace;">' + esc(String(r.order_id || '').slice(-10)) + '</span>'
          + _rrStageBadge(r.stage)
          + '<span style="color:var(--text-quaternary);">' + mins + 'm ago</span>'
          + (r.stage !== 'closed' && r.stage !== 'appealed' ? '<button class="btn btn-sm btn-outline" style="margin-left:auto;font-size:10px;padding:2px 8px;" data-on-click="stopReleaseReminder(\'' + esc(r.order_id) + '\')">Stop</button>' : '')
          + '</div>';
      }
      var html = '';
      if (open.length) html += '<div style="font-size:11px;color:var(--text-tertiary);margin-bottom:4px;">🟢 Watching ' + open.length + ' paid order' + (open.length === 1 ? '' : 's') + '</div>' + open.map(row).join('');
      else html += '<div style="font-size:11px;color:var(--text-quaternary);">No paid buy orders being watched right now. Reminders start automatically the moment you mark one paid.</div>';
      if (done.length) html += '<div style="font-size:11px;color:var(--text-quaternary);margin:8px 0 4px;">Recently finished</div>' + done.map(row).join('');
      el.innerHTML = html;
    }
    if (lg) {
      var lRes = await API.get('/api/okx/p2p/release-reminder/log?limit=30');
      var logs = Array.isArray(lRes.data) ? lRes.data : [];
      if (!logs.length) { lg.innerHTML = '<div style="color:var(--text-quaternary);">Nothing yet — reminders will appear here as they fire.</div>'; }
      else {
        lg.innerHTML = logs.map(function(l) {
          var col = l.action === 'filed' ? '#ef5350' : (l.action === 'skipped' || l.action === 'due-manual' ? '#ffb74d' : '#4caf50');
          return '<div style="padding:3px 0;border-bottom:1px solid #14141e;color:#90a4ae;">'
            + '<span style="color:var(--text-quaternary);">' + (l.ts ? fmtTimeAgo(Number(l.ts)) : '') + '</span> '
            + '<span style="color:#e0e0e0;font-family:monospace;">' + esc(String(l.order_id || '').slice(-10)) + '</span> '
            + '<span style="color:' + col + ';font-weight:600;">' + esc(l.stage || '') + '</span> '
            + '<span>' + esc(l.msg || '') + '</span></div>';
        }).join('');
      }
    }
  } catch (e) {
    if (el) el.innerHTML = '<div style="color:#ef5350;font-size:11px;">Failed to load: ' + esc(e.message || e) + '</div>';
  }
}

window.stopReleaseReminder = async function(orderId) {
  try {
    await API.post('/api/okx/p2p/release-reminder/stop', { orderId: orderId });
    showToast('Reminders stopped for this order', 'info');
    loadReleaseReminderLog();
  } catch (err) { showToast(err.message, 'error'); }
};

window.saveReleaseReminders = async function() {
  try {
    var body = {
      enabled: !!(document.getElementById('rr-enabled') || {}).checked,
      autoAppeal: !!(document.getElementById('rr-autoappeal') || {}).checked,
      reminder1Min: parseInt((document.getElementById('rr-min1') || {}).value, 10),
      reminder2Min: parseInt((document.getElementById('rr-min2') || {}).value, 10),
      appealMin: parseInt((document.getElementById('rr-min3') || {}).value, 10),
      message1: (document.getElementById('rr-msg1') || {}).value || '',
      message2: (document.getElementById('rr-msg2') || {}).value || '',
      appealMessage: (document.getElementById('rr-appealmsg') || {}).value || ''
    };
    await API.post('/api/okx/p2p/release-reminder/config', body);
    showToast('Release reminder saved', 'success');
    renderReleaseRemindersRoot();
  } catch (err) { showToast(err.message, 'error'); }
};

window.renderReleaseRemindersRoot = async function() {
  var el = document.getElementById('release-reminder-dashboard');
  if (!el) return;
  var cfg = null;
  try {
    var res = await API.get('/api/okx/p2p/release-reminder/config');
    cfg = res.data || {};
  } catch (e) {
    el.innerHTML = '<div style="color:#ef5350;font-size:12px;">Failed to load config: ' + esc(e.message || e) + '</div>';
    return;
  }
  if (!document.body.contains(el)) return;
  var inp = 'width:64px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:6px;color:var(--text-primary);font-size:12px;padding:4px 6px;';
  var ta = 'width:100%;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:6px;color:var(--text-primary);font-size:11px;padding:6px;';
  el.innerHTML = ''
    + '<label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:6px;margin-bottom:10px;cursor:pointer;"><input type="checkbox" id="rr-enabled" ' + (cfg.enabled !== false ? 'checked' : '') + '> <strong style="color:var(--text-secondary);">Enable release reminders</strong> for paid buy orders</label>'
    + '<div style="display:flex;flex-wrap:wrap;gap:14px;align-items:center;margin-bottom:10px;font-size:12px;color:var(--text-tertiary);">'
    + '<span>1st reminder at <input id="rr-min1" type="number" min="1" max="120" value="' + (cfg.reminder1Min || 10) + '" style="' + inp + '"> min</span>'
    + '<span>2nd reminder at <input id="rr-min2" type="number" min="1" max="120" value="' + (cfg.reminder2Min || 20) + '" style="' + inp + '"> min</span>'
    + '<span>appeal at <input id="rr-min3" type="number" min="1" max="120" value="' + (cfg.appealMin || 30) + '" style="' + inp + '"> min</span>'
    + '<label style="display:flex;align-items:center;gap:6px;cursor:pointer;"><input type="checkbox" id="rr-autoappeal" ' + (cfg.autoAppeal === true ? 'checked' : '') + '> Auto-file OKX appeal at the 3rd mark (off = you get a push to appeal manually)</label>'
    + '</div>'
    + '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:4px;">Reminder #1 (friendly) — placeholders: <code>{name}</code> <code>{crypto}</code> <code>{fiat}</code> <code>{order}</code></div>'
    + '<textarea id="rr-msg1" rows="3" style="' + ta + '">' + esc(cfg.message1 || '') + '</textarea>'
    + '<div style="font-size:11px;color:var(--text-quaternary);margin:8px 0 4px;">Reminder #2 (firm, mentions appeal) — also <code>{elapsed}</code></div>'
    + '<textarea id="rr-msg2" rows="3" style="' + ta + '">' + esc(cfg.message2 || '') + '</textarea>'
    + '<div style="font-size:11px;color:var(--text-quaternary);margin:8px 0 4px;">Appeal note (sent to OKX support if auto-appeal fires)</div>'
    + '<textarea id="rr-appealmsg" rows="2" style="' + ta + '">' + esc(cfg.appealMessage || '') + '</textarea>'
    + '<div style="display:flex;gap:8px;align-items:center;margin:10px 0;flex-wrap:wrap;">'
    + '<button class="btn btn-sm btn-success" data-on-click="saveReleaseReminders()">💾 Save</button>'
    + '<span style="font-size:11px;color:var(--text-quaternary);">Timers run server-side every 30s and survive restarts.</span></div>'
    + '<div style="font-size:12px;color:var(--text-tertiary);margin-bottom:6px;">👀 Active reminders</div>'
    + '<div id="rr-active" style="background:var(--bg-primary);border-radius:6px;padding:8px;margin-bottom:10px;max-height:180px;overflow-y:auto;"><div style="color:var(--text-quaternary);font-size:11px;">Loading...</div></div>'
    + '<div style="font-size:12px;color:var(--text-tertiary);margin-bottom:6px;">📨 Reminder log</div>'
    + '<div id="rr-log" style="background:var(--bg-primary);border-radius:6px;padding:8px;max-height:200px;overflow-y:auto;font-size:11px;font-family:monospace;"><div style="color:var(--text-quaternary);">Loading...</div></div>';
  loadReleaseReminderLog();
  startReleaseReminderPoll();
};

function startReleaseReminderPoll() {
  if (_rrTimer) clearInterval(_rrTimer);
  _rrTimer = setInterval(function() {
    if (document.hidden) return;
    if (!document.getElementById('rr-active')) { clearInterval(_rrTimer); _rrTimer = null; return; }
    loadReleaseReminderLog();
  }, 15000);
  window._rrTimer = _rrTimer;
}

function startAutoAdLogPoll() {
  if (_autoAdLogTimer) clearInterval(_autoAdLogTimer);
  var _lastAutoAdTs = 0;
  var _busy = false;
  _autoAdLogTimer = setInterval(async function() {
    if (document.hidden) return;
    if (_busy) return;
    var logEl = document.getElementById('autoads-log');
    if (!logEl) { clearInterval(_autoAdLogTimer); _autoAdLogTimer = null; return; }
    _busy = true;
    try {
      var res = await API.get('/api/okx/p2p/auto-ads/log');
      var logs = Array.isArray(res.data) ? res.data : [];
      if (logs.length === 0) return;
      var latestTs = logs[0].ts || 0;
      if (latestTs === _lastAutoAdTs) return;
      _lastAutoAdTs = latestTs;
      logEl.innerHTML = logs.map(function(l) { return '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; }).join('');
    } catch {}
    finally { _busy = false; }
  }, 15000);
  window._autoAdLogTimer = _autoAdLogTimer;
}

// Lock strip: groups THIS user's own pending orders per ad (OKX rejects
// pending-order queries for own ads with 55740, so we derive it from the
// already-warm order-list cache instead of extra OKX round-trips).
function adLockStrip(adId) {
  var m = (window._adLockMap || {})[adId];
  if (!m || !m.n) return '';
  var parts = [];
  if (m.unpaid) parts.push(m.unpaid + ' awaiting payment');
  if (m.paid) parts.push(m.paid + ' awaiting release');
  return '<div style="margin-top:8px;padding:6px 10px;border-radius:6px;background:rgba(255,179,0,0.08);border:1px solid rgba(255,179,0,0.25);font-size:11px;display:flex;align-items:center;gap:6px;flex-wrap:wrap;"><span style="color:#ffb300;">🔒 <strong>' + m.n + ' active order' + (m.n === 1 ? '' : 's') + ' locked on this ad</strong></span><span style="color:var(--text-tertiary);">(' + parts.join(' · ') + (m.amt > 0 ? ' · ' + m.cur + ' ' + m.amt.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' total' : '') + ')</span></div>';
}

async function renderAdList(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  var _lu = new Date().toLocaleTimeString();
  var html = '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;"><span style="font-size:12px;color:var(--text-quaternary);" id="ads-list-info">Loading...</span><button class="btn btn-primary btn-sm" data-on-click="showCreateAdModal()">+ New Ad</button></div>';
  try {
    var [res, pendRes] = await Promise.all([
      API.get('/api/p2p/ads/mine'),
      API.get('/api/okx/p2p/order-list?completionStatus=pending&pageSize=100&pageIndex=1').catch(function() { return { data: [] }; })
    ]);
    if (!document.body.contains(content)) return;
    var ads = res.data || [];
    var lockMap = {};
    (Array.isArray(pendRes.data) ? pendRes.data : []).forEach(function(o) {
      if (!o || !o.adId) return;
      var st = String(o.orderStatus || o.state || o.completionStatus || '').toLowerCase();
      if (st === 'completed' || st === 'canceled' || st === 'cancelled') return;
      var e = lockMap[o.adId] = lockMap[o.adId] || { n: 0, unpaid: 0, paid: 0, amt: 0, cur: (o.fiatCurrency || 'KES').toUpperCase() };
      e.n++;
      var ps = String(o.paymentStatus || '').toLowerCase();
      if (ps === 'paid' || ps === 'confirmed') e.paid++; else e.unpaid++;
      e.amt += parseFloat(o.fiatAmount || '0') || 0;
    });
    window._adLockMap = lockMap;
    if (ads.length === 0) {
      html += '<div class="card"><div class="empty-state"><div class="icon">📢</div><h4>No P2P ads on OKX</h4><p style="color:var(--text-quaternary);">Create your first ad or check your OKX merchant account</p><button class="btn btn-primary btn-sm" data-on-click="showCreateAdModal()" style="margin-top:12px;">+ New Ad</button></div></div>';
      content.innerHTML = html;
      startPageCountdown(15);
      startPagePoll(content, function() { renderAdList(container); }, 30000);
      return;
    }
    var onlineCount = ads.filter(function(a) { return a.status === 'new' && !a.isHidden; }).length;
    html = '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;"><span style="font-size:12px;color:var(--text-quaternary);">' + ads.length + ' ads (' + onlineCount + ' online)</span><div style="display:flex;gap:6px;"><button class="btn btn-sm btn-secondary" data-on-click="stopAllAds()">Stop All</button><button class="btn btn-sm btn-primary" data-on-click="startAllAds()">Start All</button><button class="btn btn-primary btn-sm" data-on-click="showCreateAdModal()">+ New</button></div></div>';
    ads.forEach(function(ad) {
      var isOnline = ad.status === 'new' && !ad.isHidden;
      var ccy = (ad.cryptoCurrency || '').toUpperCase();
      var priceType = ad.type === 'floating_market' ? 'Floating' : ad.unitPrice || '-';
      html += '<div class="card" style="margin-bottom:8px;padding:12px 16px;"><div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:8px;"><div style="flex:1;"><div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:6px;"><span class="badge badge-' + (ad.side === 'sell' ? 'sell' : 'buy') + '">' + (ad.side || '').toUpperCase() + '</span><strong style="font-size:15px;color:#fff;">' + ccy + '</strong><span style="color:var(--text-quaternary);font-size:12px;">/ ' + (ad.fiatCurrency || 'KES').toUpperCase() + '</span><span class="badge badge-' + (isOnline ? 'active' : 'cancelled') + '">' + (isOnline ? 'Online' : 'Offline') + '</span>' + (ad.type === 'floating_market' ? '<span class="badge" style="background:rgba(68,138,255,0.15);color:#448aff;font-size:10px;">FLOATING</span>' : '') + '<span class="badge" style="background:rgba(144,164,174,0.15);color:#90a4ae;font-size:10px;">' + (ad.targetGroup || 'all').toUpperCase() + '</span>' + '</div><div style="display:flex;gap:16px;flex-wrap:wrap;font-size:12px;"><div><span style="color:var(--text-quaternary);">Price:</span> <span style="font-weight:600;color:var(--text-primary);">' + priceType + '</span></div><div><span style="color:var(--text-quaternary);">Available:</span> <span style="font-weight:600;color:var(--text-primary);">' + (ad.availableAmount || '-') + ' ' + ccy + '</span></div><div><span style="color:var(--text-quaternary);">Limits:</span> <span style="font-weight:600;color:var(--text-primary);">' + (ad.minOrderSize || '-') + ' - ' + (ad.maxOrderSize || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Orders:</span> <span style="font-weight:600;color:var(--text-primary);">' + (ad.completedOrderCryptoAmount || '0') + '</span></div></div>' + adLockStrip(ad.adId || ad.ad_id) + '</div><div style="display:flex;gap:4px;"><button class="btn btn-sm btn-outline" data-on-click="editAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Edit</button><button class="btn btn-sm btn-outline" data-on-click="cloneAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Clone</button><button class="btn btn-sm ' + (isOnline ? 'btn-secondary' : 'btn-primary') + '" data-on-click="toggleAdStatus(\'' + esc(ad.adId || ad.ad_id) + '\', \'' + (isOnline ? 'inactive' : 'active') + '\')">' + (isOnline ? 'Pause' : 'Activate') + '</button><button class="btn btn-sm btn-danger" data-on-click="cancelAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Delete</button></div></div></div>';
    });
    content.innerHTML = html;
    startPageCountdown(15);
    startPagePoll(content, function() { renderAdList(container); }, 10000);
  } catch (err) {
    if (err.message && err.message.includes('API keys')) {
      content.innerHTML = html + configKeysPrompt();
      startPageCountdown(15);
      startPagePoll(content, function() { renderAdList(container); }, 30000);
      return;
    }
    retryError(content, function() { renderAdList(container); }, err);
  }
}

function setMpFilter(key, val) {
  var f = window._mpFilters || {};
  if (val) f[key] = val; else delete f[key];
  window._mpFilters = f;
  navigate('dashboard');
}
function applyMpFilter() {
  var f = window._mpFilters || {};
  f.maxPrice = document.getElementById('mp-max-price').value || null;
  window._mpFilters = f;
  navigate('dashboard');
}
function clearMpFilter() {
  window._mpFilters = {};
  navigate('dashboard');
}

// ========== Ad Management Sub-Tab ==========

async function renderAdManagement(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  try {
    var html = '<div class="card" style="margin-bottom:12px;"><h4 style="margin-bottom:12px;">Trailing Ads <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— auto-adjusts prices to track market</span></h4><div id="trailing-section"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    html += '<div class="card" style="margin-top:8px;"><h4 style="margin-bottom:12px;">💬 Welcome Message <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— sent the moment an order is created. NOT the Completed Order Thank You Notice below.</span></h4><div id="auto-msg-dashboard"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    html += '<div class="card" style="margin-top:8px;"><h4 style="margin-bottom:12px;">💌 Completed Order Thank You Notice <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— sent ONLY once the order has genuinely completed. Distinct from the Welcome Message, which is sent when the order is created. Uses EAT timezone greetings.</span></h4><div id="thankyou-notes-dashboard"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    html += '<div class="card" style="margin-top:8px;"><h4 style="margin-bottom:12px;">⏰ Release Reminder <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— after you mark a BUY order paid, nudge the seller to release your crypto at +10 &amp; +20 min, and auto-appeal at +30 min if they ignore you. Runs on the server.</span></h4><div id="release-reminder-dashboard"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    html += '<div class="card" style="margin-top:8px;"><h4 style="margin-bottom:12px;">🤖 AI Responder <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— answers sell-order chat messages (greetings, "can I proceed"...), learns from your replies, flags anything it won&#39;t auto-answer. </span><span id="ai-chat-pending-badge" style="display:none;"></span></h4><div id="ai-chat-dashboard"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    html += '<div class="card" style="margin-top:8px;"><h4 style="margin-bottom:12px;">🛡 Fraud Shield <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— risk-scores buyers (blacklist, first order, velocity, disputes, shared pay number, missed SMS) and blocks risky auto-releases.</span></h4><div id="fraud-shield-dashboard"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    html += '<div class="card" style="margin-top:8px;"><h4 style="margin-bottom:12px;">Auto-Ads <span style="font-size:11px;color:var(--text-quaternary);font-weight:400;">— automatically create & maintain ads</span></h4><div id="autoads-section"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div></div>';
    content.innerHTML = html;
    startTrailingLogPoll();
    startAutoAdLogPoll();
    loadTrailingConfig();
    loadAutoAdRules();
    renderReleaseRemindersRoot();
    renderAiChatRoot();
    renderFraudShieldRoot();
    renderThankYouNotes();
  } catch (err) {
    content.innerHTML = '<div class="card"><p style="color:#f44336;">Failed to load ad management: ' + esc(err.message) + '</p></div>';
  }
}

// ========== My Ads Sub-Tab ==========

async function renderMyAds(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  try {
    var res = await API.get('/api/p2p/ads/mine');
    if (!document.body.contains(content)) return;
    var ads = res.data || [];
    var cryptoCurrencies = ['USDT','BTC','ETH','SOL','XRP','USDC','TON','TRX'];
    var fiatCurrencies = ['KES','USD','NGN','GHS','ZAR','EUR','GBP','TZS','UGX','XAF','XOF'];
    var selCrypto = _adsPairFilter?.crypto || '';
    var selFiat = _adsPairFilter?.fiat || '';
    var html = '<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px;margin-bottom:12px;">';
    html += '<div style="display:flex;gap:6px;align-items:center;"><span style="font-size:13px;font-weight:600;color:var(--text-primary);">Your Ads</span>';
    html += '<label style="font-size:11px;color:var(--text-tertiary);">Crypto: <select id="ads-pair-crypto" data-on-change="applyAdPairFilter()">';
    html += '<option value="">All</option>';
    cryptoCurrencies.forEach(function(cc) { html += '<option value="' + cc + '" ' + (selCrypto === cc ? 'selected' : '') + '>' + cc + '</option>'; });
    html += '</select></label>';
    html += '<label style="font-size:11px;color:var(--text-tertiary);">Fiat: <select id="ads-pair-fiat" data-on-change="applyAdPairFilter()">';
    html += '<option value="">All</option>';
    fiatCurrencies.forEach(function(fc) { html += '<option value="' + fc + '" ' + (selFiat === fc ? 'selected' : '') + '>' + fc + '</option>'; });
    html += '</select></label></div>';
    html += '<div style="display:flex;gap:6px;"><button class="btn btn-sm btn-secondary" data-on-click="stopAllAds()">Stop All</button><button class="btn btn-sm btn-primary" data-on-click="startAllAds()">Start All</button><button class="btn btn-primary btn-sm" data-on-click="showCreateAdModal()">+ New</button></div></div>';
    html += '<div id="ads-pulse" style="margin-bottom:10px;"></div>';
    var filtered = ads;
    if (selCrypto) filtered = filtered.filter(function(a) { return (a.cryptoCurrency || '').toUpperCase() === selCrypto; });
    if (selFiat) filtered = filtered.filter(function(a) { return (a.fiatCurrency || '').toUpperCase() === selFiat; });
    var onlineCount = filtered.filter(function(a) { return a.status === 'new' && !a.isHidden; }).length;
    html += '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:8px;">' + filtered.length + ' ads' + (filtered.length !== ads.length ? ' (filtered from ' + ads.length + ')' : '') + (onlineCount > 0 ? ', ' + onlineCount + ' online' : '') + '</div>';
    if (filtered.length === 0) {
      html += '<div class="card" style="text-align:center;padding:40px;"><div style="font-size:40px;margin-bottom:12px;">📋</div><p style="color:var(--text-tertiary);font-size:14px;">' + (ads.length === 0 ? 'No ads yet. Create your first P2P ad.' : 'No ads match the selected pair.') + '</p></div>';
    } else {
      filtered.forEach(function(ad) {
        var isOnline = ad.status === 'new' && !ad.isHidden;
        var ccy = (ad.cryptoCurrency || '').toUpperCase();
        var priceType = ad.type === 'floating_market' ? 'Floating' : ad.unitPrice || '-';
        html += '<div class="card" style="margin-bottom:8px;">';
        html += '<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:8px;padding:12px 16px;">';
        html += '<div style="flex:1;"><div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:6px;">';
        html += '<span class="badge badge-' + (ad.side === 'sell' ? 'sell' : 'buy') + '">' + (ad.side || '').toUpperCase() + '</span><strong style="font-size:15px;color:#fff;">' + ccy + '</strong><span style="color:var(--text-quaternary);font-size:12px;">/ ' + (ad.fiatCurrency || 'KES').toUpperCase() + '</span>';
        html += '<span class="badge badge-' + (isOnline ? 'active' : 'cancelled') + '">' + (isOnline ? 'Online' : 'Offline') + '</span>';
        html += (ad.type === 'floating_market' ? '<span class="badge" style="background:rgba(68,138,255,0.15);color:#448aff;font-size:10px;">FLOATING</span>' : '');
        html += '<span class="badge" style="background:rgba(144,164,174,0.15);color:#90a4ae;font-size:10px;">' + (ad.targetGroup || 'all').toUpperCase() + '</span></div>';
        html += '<div style="display:flex;gap:16px;flex-wrap:wrap;font-size:12px;"><div><span style="color:var(--text-quaternary);">Price:</span> <span style="font-weight:600;color:var(--text-primary);">' + priceType + '</span></div>';
        html += '<div><span style="color:var(--text-quaternary);">Available:</span> <span style="font-weight:600;color:var(--text-primary);">' + (ad.availableAmount || '-') + ' ' + ccy + '</span></div>';
        html += '<div><span style="color:var(--text-quaternary);">Limits:</span> <span style="font-weight:600;color:var(--text-primary);">' + (ad.minOrderSize || '-') + ' - ' + (ad.maxOrderSize || '-') + '</span></div>';
        html += '<div><span style="color:var(--text-quaternary);">Orders:</span> <span style="font-weight:600;color:var(--text-primary);">' + (ad.completedOrderCryptoAmount || '0') + '</span></div></div></div>';
        html += '<div style="display:flex;gap:4px;"><button class="btn btn-sm btn-outline" data-on-click="editAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Edit</button>';
        html += '<button class="btn btn-sm btn-outline" data-on-click="cloneAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Clone</button>';
        html += '<button class="btn btn-sm ' + (isOnline ? 'btn-secondary' : 'btn-primary') + '" data-on-click="toggleAdStatus(\'' + esc(ad.adId || ad.ad_id) + '\', \'' + (isOnline ? 'inactive' : 'active') + '\')">' + (isOnline ? 'Pause' : 'Activate') + '</button>';
        html += '<button class="btn btn-sm btn-outline" data-on-click="toggleAdDetail(\'' + esc(ad.adId || ad.ad_id) + '\')">🔍 Diagnose</button>';
        html += '<button class="btn btn-sm btn-outline" data-on-click="shareAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Share</button><button class="btn btn-sm btn-danger" data-on-click="cancelAd(\'' + esc(ad.adId || ad.ad_id) + '\')">Delete</button></div></div>';
        html += '<div id="ad-detail-' + esc(ad.adId || ad.ad_id) + '" style="display:none;padding:12px 16px;border-top:1px solid #1e1e2e;"></div></div>';
      });
    }
    content.innerHTML = html;
    startPagePoll(content, function() { renderMyAds(container); }, 30000);
    window._lastAdsPulse = ads;
    loadAdsPulse();
  } catch (err) {
    content.innerHTML = '<div class="card"><p style="color:#f44336;">Failed to load ads: ' + esc(err.message) + '</p></div>';
  }
}

window.toggleAdDetail = async function(adId) {
  var el = document.getElementById('ad-detail-' + adId);
  if (!el) return;
  if (el.style.display !== 'none' && el.innerHTML) {
    el.style.display = el.style.display === 'none' ? 'block' : 'none';
    return;
  }
  try {
    var res = await API.get('/api/okx/p2p/ads/' + adId);
    var ad = Array.isArray(res.data) ? res.data[0] : res.data || {};
    el.style.display = 'block';
    var creator = ad.creator || {};
    var methods = (ad.configuredPaymentMethodDetails || []).map(function(m) { return m.paymentMethod || ''; }).filter(Boolean).join(', ');
    var verif = ad.verificationType === '1' ? 'Required' : 'None';
    el.innerHTML = '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;font-size:12px;"><div><span style="color:var(--text-quaternary);">Ad ID:</span><br><span style="color:var(--text-primary);font-family:monospace;font-size:11px;">' + esc(ad.adId) + '</span></div><div><span style="color:var(--text-quaternary);">Status:</span><br><span style="color:var(--text-primary);">' + esc(ad.status || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Price Type:</span><br><span style="color:var(--text-primary);">' + esc(ad.type || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Price:</span><br><span style="color:var(--text-primary);">' + esc(ad.unitPrice || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Available:</span><br><span style="color:var(--text-primary);">' + esc(ad.availableAmount || '0') + '</span></div><div><span style="color:var(--text-quaternary);">On Hold:</span><br><span style="color:var(--text-primary);">' + esc(ad.onHoldAmount || '0') + '</span></div><div><span style="color:var(--text-quaternary);">Min/Max Order:</span><br><span style="color:var(--text-primary);">' + esc(ad.minOrderSize || '-') + ' / ' + esc(ad.maxOrderSize || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Payment Duration:</span><br><span style="color:var(--text-primary);">' + esc(ad.maxPaymentDurationInMinutes || '-') + ' min</span></div><div><span style="color:var(--text-quaternary);">Target Group:</span><br><span style="color:var(--text-primary);">' + esc(ad.targetGroup || 'all') + '</span></div><div><span style="color:var(--text-quaternary);">KYC Level:</span><br><span style="color:var(--text-primary);">' + esc(ad.minKycLevel || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Min Orders:</span><br><span style="color:var(--text-primary);">' + esc(ad.minCompletedOrders || '0') + '</span></div><div><span style="color:var(--text-quaternary);">Min Completion Rate:</span><br><span style="color:var(--text-primary);">' + esc(ad.minCompletionRate || '-') + '</span></div><div><span style="color:var(--text-quaternary);">Min Account Age:</span><br><span style="color:var(--text-primary);">' + esc(ad.minAccountAge || '-') + ' days</span></div><div><span style="color:var(--text-quaternary);">Verification:</span><br><span style="color:var(--text-primary);">' + verif + '</span></div><div><span style="color:var(--text-quaternary);">Fiat Completed:</span><br><span style="color:var(--text-primary);">' + esc(ad.completedOrderFiatAmount || '0') + '</span></div><div><span style="color:var(--text-quaternary);">Crypto Completed:</span><br><span style="color:var(--text-primary);">' + esc(ad.completedOrderCryptoAmount || '0') + '</span></div><div style="grid-column:1/3;"><span style="color:var(--text-quaternary);">Remark:</span><br><span style="color:var(--text-primary);">' + esc(ad.remark || '-') + '</span></div><div style="grid-column:1/3;"><span style="color:var(--text-quaternary);">Payment Methods:</span><br><span style="color:var(--text-primary);">' + (methods || esc(ad.paymentMethods ? ad.paymentMethods.join(', ') : '-')) + '</span></div><div style="grid-column:1/3;"><span style="color:var(--text-quaternary);">Creator:</span><br><span style="color:var(--text-primary);">' + esc(creator.nickName || '') + ' (' + esc(creator.type || '') + ') · Orders: ' + esc(creator.completedOrders || '0') + ' · Rate: ' + esc(creator.completionRate || '-') + ' · KYC: ' + esc(creator.kycLevel || '-') + '</span></div></div><div style="display:flex;gap:6px;margin-top:10px;padding-top:10px;border-top:1px solid #1e1e2e;"><button class="btn btn-sm btn-outline" data-on-click="editAd(\'' + esc(adId) + '\')">Edit</button><button class="btn btn-sm ' + (isOnline(ad) ? 'btn-secondary' : 'btn-primary') + '" data-on-click="toggleAdStatus(\'' + esc(adId) + '\', \'' + (isOnline(ad) ? 'inactive' : 'active') + '\')">' + (isOnline(ad) ? 'Pause' : 'Activate') + '</button><button class="btn btn-sm btn-danger" data-on-click="cancelAd(\'' + esc(adId) + '\')">Delete</button></div>';
  } catch (err) {
    el.innerHTML = '<p style="color:#f44336;font-size:12px;">Failed to load details: ' + esc(err.message) + '</p>';
  }
};

function isOnline(ad) {
  return ad.status === 'new' && !ad.isHidden;
}

// Enriched Diagnose modal (overrides the lightweight original)
window.toggleAdDetail = async function(adId) {
  var el = document.getElementById('ad-detail-' + adId);
  if (!el) return;
  if (el.style.display !== 'none' && el.innerHTML) {
    el.style.display = el.style.display === 'none' ? 'block' : 'none';
    return;
  }
  try {
    var res = await API.get('/api/okx/p2p/ads/' + adId);
    var ad = Array.isArray(res.data) ? res.data[0] : res.data || {};
    el.style.display = 'block';
    var creator = ad.creator || {};
    var methods = (ad.configuredPaymentMethodDetails || []).map(function(m) { return m.paymentMethod || ''; }).filter(Boolean).join(', ');
    var verif = ad.verificationType === '1' ? 'Required' : 'None';
    var hcat = String(ad.hiddenCategory !== undefined ? ad.hiddenCategory : ad.hiddenType);
    var hiddenCatTxt = hcat === '0' ? 'In market' : (hcat === '1' ? 'Hidden manually' : (hcat === '3' ? 'Out of stock / unavailable' : (hcat === 'null' || hcat === 'undefined' ? '' : hcat)));
    var blockedList = (ad.blockedReasons || ad.blockedReasonList || []).filter(Boolean);
    var isListed = ad.isListedOnMarketplace !== false;
    var alerts = [];
    if (!isListed) alerts.push('NOT listed on marketplace');
    if (hcat && hcat !== '0' && hcat !== 'null' && hcat !== 'undefined') alerts.push('Hidden category: ' + hiddenCatTxt);
    if (ad.hiddenReason) alerts.push('Hidden reason: ' + ad.hiddenReason);
    if (blockedList.length) alerts.push('Blocked reasons: ' + blockedList.join('; '));
    if (ad.blacklistStatus === 'BLACKED' || ad.blacklistStatus === 'BLACK_EACH_OTHER') alerts.push('Blacklist status: ' + ad.blacklistStatus);
    var html = '';
    if (alerts.length) {
      html += '<div style="background:rgba(244,67,54,0.12);border:1px solid rgba(244,67,54,0.3);border-radius:6px;padding:8px 10px;margin-bottom:10px;font-size:12px;color:#f44336;"><strong>⚠️ Diagnostic</strong><br>' + alerts.map(function(a) { return esc(a); }).join('<br>') + '</div>';
    }
    function row(label, val, color) {
      return '<div style="min-width:0;"><span style="color:var(--text-quaternary);font-size:11px;">' + esc(label) + ':</span><br><span style="color:' + (color || '#e4e4ec') + ';font-size:12px;word-break:break-all;">' + esc(val || '-') + '</span></div>';
    }
    html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;font-size:12px;">';
    html += row('Status', ad.status || '-', ad.status === 'new' ? '#4caf50' : '#f44336');
    html += row('Listed', isListed ? 'Yes' : 'No', isListed ? '#4caf50' : '#f44336');
    html += row('Hidden category', hiddenCatTxt, hcat === '0' ? '#4caf50' : (hcat === '1' || hcat === '3' ? '#ff9800' : ''));
    html += row('On Hold', ad.onHoldAmount || '0');
    html += row('Commission', ad.platformCommissionRate || '-');
    html += row('Blacklist', ad.blacklistStatus || '-');
    html += row('Max order (fiat)', ad.realFiatMaxAmountPerOrder || '-');
    html += row('Ad ID', ad.adId, '#78788a');
    html += row('Price Type', ad.type || '-');
    html += row('Price', ad.unitPrice || '-');
    html += row('Min / Max Order', (ad.minOrderSize || '-') + ' / ' + (ad.maxOrderSize || '-'));
    html += row('Payment Duration', (ad.maxPaymentDurationInMinutes || '-') + ' min');
    html += row('Target Group', ad.targetGroup || 'all');
    html += row('KYC Level', ad.minKycLevel || '-');
    html += row('Min Orders', ad.minCompletedOrders || '0');
    html += row('Min Completion', ad.minCompletionRate || '-');
    html += row('Account Age', (ad.minAccountAge || '-') + ' days');
    html += row('Verification', verif);
    html += row('Payments', methods || '-');
    html += row('Creator', creator.nickName || '-');
    html += '</div>';
    el.innerHTML = html;
  } catch (err) {
    el.innerHTML = '<p style="color:#f44336;font-size:12px;">Failed to load details: ' + esc(err.message) + '</p>';
  }
};

async function loadAdsPulse() {
  var el = document.getElementById('ads-pulse');
  if (!el) return;
  el.innerHTML = '<div style="font-size:11px;color:var(--text-quaternary);">Loading market prices…</div>';
  var ads = Array.isArray(window._lastAdsPulse) ? window._lastAdsPulse : [];
  var coins = [];
  var fiat = 'KES';
  ads.forEach(function(a) {
    var c = (a.cryptoCurrency || '').toUpperCase();
    if (c && coins.indexOf(c) === -1) coins.push(c);
    var f = (a.fiatCurrency || '').toUpperCase();
    if (f) fiat = f;
  });
  if (coins.length === 0) coins = ['USDT'];
  coins = coins.slice(0, 4);
  var rows = [];
  for (var i = 0; i < coins.length; i++) {
    var c = coins[i];
    try {
      var oRes = await API.get('/api/okx/p2p/optimal-price?cryptoCurrency=' + c + '&fiatCurrency=' + fiat);
      var oD = (Array.isArray(oRes.data) ? oRes.data[0] : oRes.data) || {};
      var eRes = await API.get('/api/p2p/ticker/estimated-price?cryptoCurrency=' + c + '&fiatCurrency=' + fiat).catch(function() { return { data: {} }; });
      var eD = eRes.data || {};
      rows.push({ coin: c, buy: oD.currentHighestBuyAdPrice, sell: oD.currentLowestSellAdPrice, est: eD.price || eD.estimatedPrice || '' });
    } catch (e) {}
  }
  if (rows.length === 0) { el.innerHTML = ''; return; }
  var chip = function(r) {
    return '<div class="card" style="padding:10px 12px;"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;"><strong style="color:var(--text-primary);">' + esc(r.coin) + '</strong>' +
      (r.est ? '<span style="color:var(--text-quaternary);font-size:10px;">est ' + esc(r.est) + '</span>' : '') + '</div>' +
      '<div style="display:flex;gap:14px;font-size:11px;"><div><span style="color:var(--text-quaternary);">Highest Buy</span><br><span style="color:#4caf50;font-weight:600;font-size:13px;">' + esc(r.buy || '-') + '</span></div>' +
      '<div><span style="color:var(--text-quaternary);">Lowest Sell</span><br><span style="color:#ff9100;font-weight:600;font-size:13px;">' + esc(r.sell || '-') + '</span></div></div></div>';
  };
  el.innerHTML = '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:6px;">📊 Market pulse (' + esc(fiat) + '):</div><div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(230px,1fr));gap:8px;">' + rows.map(chip).join('') + '</div>';
}

window.cancelAd = async function(adId) {
  if (!confirm('Are you sure you want to cancel this ad?')) return;
  try {
    await API.post('/api/okx/p2p/ads/' + adId + '/cancel', {});
    showToast('Ad cancelled', 'success');
    navigate('ads');
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Share Ad =====
window.shareAd = async function(adId) {
  try {
    var res = await API.get('/api/p2p/ads/' + adId + '/share');
    var data = Array.isArray(res.data) ? res.data[0] : res.data || {};
    var shareUrl = data.shareUrl || data.shareLink || data.url || '';
    var shareCode = data.shareCode || '';
    var html = '<div class="modal-overlay"><div class="modal-content" style="max-width:420px;"><h3>Share Ad</h3>';
    html += '<div style="padding:16px;background:var(--bg-primary);border-radius:8px;margin-bottom:12px;text-align:center;">';
    if (data.qr) html += '<img src="' + data.qr + '" alt="QR" style="width:160px;height:160px;border-radius:8px;background:#fff;padding:8px;margin:0 auto 10px;display:block;">';
    if (shareUrl) html += '<div class="form-group" style="text-align:left;"><label>Share Link</label><input class="form-input" id="share-url-copy" value="' + esc(shareUrl) + '" readonly style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-input);color:var(--text-primary);font-size:12px;" onclick="this.select();copyText(this.value)"></div>';
    if (shareCode) html += '<div style="font-size:12px;color:var(--text-tertiary);margin-top:8px;">Share Code: <strong style="color:var(--text-primary);">' + esc(shareCode) + '</strong></div>';
    if (data.nickName) html += '<div style="font-size:12px;color:var(--text-tertiary);margin-top:4px;">Merchant: <strong style="color:var(--text-primary);">' + esc(data.nickName) + '</strong></div>';
    if (data.unitPrice) html += '<div style="font-size:12px;color:var(--text-tertiary);margin-top:4px;">Price: <strong style="color:var(--text-primary);">' + esc(data.unitPrice) + '</strong></div>';
    html += '</div>';
    html += '<button class="btn btn-primary" style="width:100%;" onclick="var i=document.getElementById(\'share-url-copy\');if(i){i.select();copyText(i.value);showToast(\'Link copied\',\'success\')}">Copy Link</button>';
    html += '<button class="btn btn-secondary" style="width:100%;margin-top:6px;" onclick="this.closest(\'.modal-overlay\').remove()">Close</button>';
    html += '</div></div>';
    var temp = document.createElement('div');
    temp.innerHTML = html;
    document.body.appendChild(temp.firstElementChild);
  } catch (err) { showToast('Failed to load share info: ' + err.message, 'error'); }
};

// ===== Ad Clone from Marketplace =====
window.cloneMarketplaceAd = async function(ad) {
  window._cloneAdData = {
    side: String(ad.side || 'BUY').toLowerCase(),
    cryptoCurrency: ad.cryptoCurrency || 'USDT',
    fiatCurrency: ad.fiatCurrency || 'KES',
    unitPrice: ad.unitPrice || '',
    type: ad.type === 'floating_market' || ad.type === 'floating' ? 'floating_market' : 'limit',
    priceMargin: ad.priceMargin || '',
    cryptoAmount: ad.cryptoAmount || '',
    minOrderLimit: ad.minOrderSize || '',
    maxOrderLimit: ad.maxOrderSize || '',
    maxPaymentDuration: ad.maxPaymentDurationInMinutes || '15',
    targetGroup: ad.targetGroup || 'all',
    minKycLevel: ad.minKycLevel || '0',
    minCompletedOrders: ad.minCompletedOrders || '0',
    minCompletionRate: ad.minCompletionRate || '',
    minAccountAge: ad.minAccountAge || '0',
    verificationType: ad.verificationType || '0',
    paymentMethod: (ad.configuredPaymentMethodDetails || []).map(function(m) { return m.paymentMethodId || m.paymentMethod; }).join(','),
    paymentMethodDetails: ad.configuredPaymentMethodDetails || []
  };
  showCreateAdModal();
};

// ===== Load Currency Pairs for Dynamic Forms =====
window._loadedFiatCurrencies = null;
window._loadedCurrencyPairs = {};
window.loadFiatCurrencies = async function(selectEl) {
  if (!selectEl) return;
  try {
    if (!window._loadedFiatCurrencies) {
      var res = await API.get('/api/p2p/currencies/fiat');
      window._loadedFiatCurrencies = res.data || [];
    }
    selectEl.innerHTML = '<option value="">Select fiat...</option>';
    (window._loadedFiatCurrencies).forEach(function(c) {
      var code = c.fiatCurrency || c.currency || c.code || '';
      if (code) selectEl.innerHTML += '<option value="' + esc(code) + '">' + esc(code) + '</option>';
    });
  } catch (e) { console.warn('Failed to load fiat currencies:', e.message); }
};
window.loadCurrencyPairs = async function(fiatCurrency, selectEl) {
  if (!selectEl || !fiatCurrency) return;
  try {
    var key = fiatCurrency;
    if (!window._loadedCurrencyPairs[key]) {
      var res = await API.get('/api/p2p/currencies/pairs?fiatCurrency=' + fiatCurrency);
      window._loadedCurrencyPairs[key] = res.data || [];
    }
    selectEl.innerHTML = '<option value="">Select crypto...</option>';
    (window._loadedCurrencyPairs[key]).forEach(function(p) {
      var code = p.cryptoCurrency || p.crypto || p.code || '';
      if (code) selectEl.innerHTML += '<option value="' + esc(code) + '">' + esc(code) + '</option>';
    });
  } catch (e) { console.warn('Failed to load currency pairs:', e.message); }
};

window.loadAdConfig = async function() {
  try {
    var res = await API.get('/api/okx/p2p/ad-config?side=buy&cryptoCurrency=USDT&fiatCurrency=KES');
    showToast('Config loaded (console)', 'info');
  } catch (err) { showToast(err.message, 'error'); }
};

window.fillMaxAmount = async function(mode) {
  var side = document.getElementById(mode + '-ad-side');
  if (!side || side.value !== 'sell') { showToast('Max only available for sell ads', 'warning'); return; }
  var ccy = document.getElementById(mode + '-ad-ccy');
  var target = document.getElementById(mode + '-ad-total');
  if (!target) return;
  try {
    var res = await API.getFundingBalance(ccy ? ccy.value.trim() || 'USDT' : 'USDT');
    var data = Array.isArray(res.data) ? res.data : (res.data && res.data.data ? res.data.data : []);
    if (!data.length) { showToast('No balance data returned', 'error'); return; }
    var bal = data[0];
    var avail = bal.availBal || bal.avail || bal.bal || '0';
    target.value = avail;
    showToast('Set to available ' + (ccy ? ccy.value.trim() || 'USDT' : 'USDT') + ': ' + avail, 'success');
  } catch (err) { showToast('Failed to fetch balance: ' + err.message, 'error'); }
};

window.fillMaxOrderCrypto = async function(mode) {
  var side = document.getElementById(mode + '-ad-side');
  var target = document.getElementById(mode + '-ad-max-crypto');
  if (!side || !target) return;
  if (side.value === 'sell') {
    var ccy = document.getElementById(mode + '-ad-ccy');
    try {
      var res = await API.getFundingBalance(ccy ? ccy.value.trim() || 'USDT' : 'USDT');
      var data = Array.isArray(res.data) ? res.data : (res.data && res.data.data ? res.data.data : []);
      if (!data.length) { showToast('No balance data returned', 'error'); return; }
      var bal = data[0];
      var avail = bal.availBal || bal.avail || bal.bal || '0';
      target.value = avail;
      calcFiatMax(mode);
      showToast('Set to available ' + (ccy ? ccy.value.trim() || 'USDT' : 'USDT') + ': ' + avail, 'success');
    } catch (err) { showToast('Failed to fetch balance: ' + err.message, 'error'); }
  } else {
    var total = document.getElementById(mode + '-ad-total');
    if (total && total.value) {
      target.value = total.value;
      calcFiatMax(mode);
    }
  }
};

// ========== Create Ad (full spec) ==========

async function showCreateAdModal() {
  var config = {};
  try {
    var res = await API.get('/api/okx/p2p/ad-config?side=SELL&cryptoCurrency=USDT&fiatCurrency=KES');
    config = res.data || {};
  } catch (e) { /* config fetch is optional */ }
  var cloneData = window._cloneAdData || {};
  delete window._cloneAdData;
  var overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  var title = cloneData.unitPrice ? 'Clone P2P Ad' : 'Create P2P Ad';
  overlay.innerHTML = '<div class="modal-content" style="max-width:560px;max-height:90vh;overflow-y:auto;"><h3>' + title + '</h3><p style="color:var(--text-tertiary);font-size:12px;margin-bottom:12px;">All fields matching P2P API spec</p><form id="ad-create-form" data-on-submit="createAd(event)">' + adFormFields('create', cloneData, config) + '<div class="form-actions"><button type="button" class="btn btn-secondary" data-on-click="this.closest(\'.modal-overlay\').remove()">Cancel</button><button type="submit" class="btn btn-primary">Create on OKX</button></div></form></div>';
  document.body.appendChild(overlay);
}

function adFormFields(mode, ad, config) {
  config = config || {};
  var s = function(id) { return ad[id] || ''; };
  var sel = function(id, val) { return s(id) === val ? 'selected' : ''; };
  var chk = function(id) { var v = ad[id]; return v === true || v === 'true' || v === 1 || v === '1' ? 'checked' : ''; };
  var fiats = config.tradableFiatCurrencies || [];
  var fiatOpts = '';
  fiats.forEach(function(f) {
    var code = typeof f === 'object' ? (f.code || f.currency || '') : f;
    fiatOpts += '<option value="'+code+'" '+sel('fiatCurrency',code)+'>'+code+'</option>';
  });
  var durs = config.maxPaymentDurationAllowedValues || [5, 10, 15, 30, 60, 120];
  // Generate all options; script will filter by side on change
  var durOptsBuy = '';
  var durOptsSell = '';
  durs.forEach(function(d) {
    durOptsBuy += '<option value="'+d+'" '+sel('maxPaymentDurationInMinutes',d)+'>'+d+' min</option>';
    if (d >= 30) durOptsSell += '<option value="'+d+'" '+sel('maxPaymentDurationInMinutes',d)+'>'+d+' min</option>';
  });
  var optimalPrice = config.optimalPrice || '';
  var orderMin = config.orderLimits && config.orderLimits.min || '';
  var orderMax = config.orderLimits && config.orderLimits.max || '';
  var h = '';
  h += '<div class="form-row"><div class="form-group"><label>Side *</label><select id="' + mode + '-ad-side" required onchange="updatePayDurOptions(\'' + mode + '\')"><option value="buy" ' + sel('side', 'buy') + '>Buy (want crypto)</option><option value="sell" ' + sel('side', 'sell') + '>Sell (have crypto)</option></select></div><div class="form-group"><label>Target Group *</label><select id="' + mode + '-ad-target" required><option value="all" ' + sel('targetGroup', 'all') + '>All</option><option value="common" ' + sel('targetGroup', 'common') + '>Common</option><option value="certified" ' + sel('targetGroup', 'certified') + '>Certified</option><option value="diamond" ' + sel('targetGroup', 'diamond') + '>Diamond</option></select></div></div>';
  h += '<div class="form-row"><div class="form-group"><label>Asset *</label><input id="' + mode + '-ad-ccy" value="' + esc(s('cryptoCurrency')) + '" placeholder="USDT" required></div><div class="form-group"><label>Fiat *</label>' + (fiatOpts ? '<select id="' + mode + '-ad-fiat" required>' + fiatOpts + '</select>' : '<input id="' + mode + '-ad-fiat" value="' + esc(s('fiatCurrency')) + '" placeholder="KES" required>') + '</div></div>';
  h += '<div class="form-row"><div class="form-group"><label>Price Type *</label><select id="' + mode + '-ad-type" required onchange="togglePriceType(\'' + mode + '\')"><option value="limit" ' + sel('type', 'limit') + '>Fixed Price</option><option value="floating_market" ' + sel('type', 'floating_market') + '>Floating Market</option></select></div><div class="form-group" id="' + mode + '-price-group" style="' + (s('type') === 'floating_market' ? 'display:none;' : '') + '"><label>Unit Price *</label><div style="display:flex;gap:4px;"><input id="' + mode + '-ad-price" type="number" step="0.01" value="' + s('unitPrice') + '" placeholder="e.g. 150' + (optimalPrice ? ' (optimal: ' + optimalPrice + ')' : '') + '" style="flex:1;"><button type="button" class="btn btn-sm btn-outline" data-on-click="adPriceAssist(\'' + mode + '\')" title="Fetch live market prices">💡 Market</button></div><div id="' + mode + '-price-assist" style="margin-top:6px;"></div></div></div>';
  h += '<div id="' + mode + '-floating-group" style="display:' + (s('type') === 'floating_market' ? 'flex' : 'none') + ';gap:8px;" class="form-row"><div class="form-group" style="flex:1;"><label>Price Margin</label><input id="' + mode + '-ad-margin" type="number" step="0.001" value="' + s('priceMargin') + '" placeholder="e.g. 0.01"></div><div class="form-group" style="flex:1;"><label>Price Floor</label><input id="' + mode + '-ad-floor" type="number" step="0.01" value="' + s('priceFloor') + '" placeholder="Lowest price before hidden"></div></div>';
  h += '<div class="form-row"><div class="form-group"><label>Crypto Amount *</label><div style="display:flex;gap:4px;"><input id="' + mode + '-ad-total" type="number" step="any" value="' + esc(s('cryptoAmount')) + '" placeholder="e.g. 10" oninput="syncCryptoInputs(\'' + mode + '\')" required style="flex:1;"><button type="button" class="btn btn-sm btn-primary" data-on-click="fillMaxAmount(\'' + mode + '\')">Max</button></div></div><div class="form-group"><label>Max Payment (min)</label><select id="' + mode + '-ad-pay-dur">' + ((s('side') || 'buy') === 'sell' ? durOptsSell : durOptsBuy) + '</select></div></div>';
  h += '<div class="form-row"><div class="form-group"><label>Min Order (fiat) *</label><input id="' + mode + '-ad-min" type="number" step="any" value="' + esc(s('minOrderLimit')) + '" placeholder="e.g. ' + (orderMin || '500') + '" required></div><div class="form-group"><label>Max Order (crypto) *</label><div style="display:flex;gap:4px;align-items:center;"><input id="' + mode + '-ad-max-crypto" type="number" step="any" value="' + esc(s('maxOrderLimitCrypto') || '') + '" placeholder="e.g. 100" oninput="calcFiatMax(\'' + mode + '\');syncCryptoInputs(\'' + mode + '\')" style="flex:1;"><button type="button" class="btn btn-sm btn-primary" data-on-click="fillMaxOrderCrypto(\'' + mode + '\')">Max</button><span id="' + mode + '-ad-max-fiat-display" style="font-size:11px;color:#90a4ae;white-space:nowrap;">→ ' + (s('maxOrderLimit') ? parseFloat(s('maxOrderLimit')).toLocaleString() + ' fiat' : '') + '</span></div></div></div>';
  h += '<div class="form-group"><label>Payment Methods</label>' + (mode === 'edit' ? '<div style="background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:6px;padding:8px;font-size:12px;color:var(--text-tertiary);line-height:1.5;">' + esc(Array.isArray(s('paymentMethods')) ? s('paymentMethods').join(', ') : s('paymentMethods') || '—') + '</div>' : '<input id="' + mode + '-ad-payments" value="' + esc(Array.isArray(s('paymentMethods')) ? s('paymentMethods').join(', ') : s('paymentMethods')) + '" placeholder="bank_transfer (comma-separated)">') + '</div>';
  h += '<div class="form-group"><label>Automated Message (sent to taker on order placed)</label><textarea id="' + mode + '-ad-auto-msg" rows="2" placeholder="Optional message...">' + esc(s('automatedMessage')) + '</textarea></div>';
  h += '<div class="form-group"><label>Remark (trading instructions for taker)</label><textarea id="' + mode + '-ad-remark" rows="2" placeholder="Optional instructions...">' + esc(s('remark')) + '</textarea></div>';
  h += '<div style="font-size:12px;font-weight:600;color:var(--text-tertiary);margin:12px 0 6px;">Taker Filters</div>';
  h += '<div class="form-row"><div class="form-group"><label>Min KYC Level</label><select id="' + mode + '-ad-kyc"><option value="" ' + sel('minKycLevel', '') + '>Any</option><option value="1" ' + sel('minKycLevel', '1') + '>Level 1</option><option value="2" ' + sel('minKycLevel', '2') + '>Level 2</option><option value="3" ' + sel('minKycLevel', '3') + '>Level 3</option></select></div><div class="form-group"><label>Min Account Age</label><select id="' + mode + '-ad-age"><option value="" ' + sel('minAccountAge', '') + '>Any</option><option value="30" ' + sel('minAccountAge', '30') + '>30 days</option><option value="60" ' + sel('minAccountAge', '60') + '>60 days</option><option value="180" ' + sel('minAccountAge', '180') + '>180 days</option><option value="365" ' + sel('minAccountAge', '365') + '>365 days</option></select></div></div>';
  h += '<div class="form-row"><div class="form-group"><label>Min Completed Orders</label><input id="' + mode + '-ad-min-orders" type="number" value="' + esc(s('minCompletedOrders')) + '" placeholder="0"></div><div class="form-group"><label>Min Sell Orders</label><input id="' + mode + '-ad-min-sell" type="number" value="' + esc(s('minSellOrders')) + '" placeholder="0"></div><div class="form-group"><label>Min Completion Rate</label><input id="' + mode + '-ad-comp-rate" type="number" step="0.01" min="0" max="1" value="' + esc(s('minCompletionRate')) + '" placeholder="e.g. 0.95"></div></div>';
  h += '<div style="font-size:12px;font-weight:600;color:var(--text-tertiary);margin:12px 0 6px;">Verification & Privacy</div>';
  h += '<div class="form-row"><div class="form-group"><label>Verification Type</label><select id="' + mode + '-ad-verif-type"><option value="" ' + sel('verificationType', '') + '>None</option><option value="0" ' + sel('verificationType', '0') + '>No verification</option><option value="1" ' + sel('verificationType', '1') + '>Verification required</option></select></div><div class="form-group"><label><input type="checkbox" id="' + mode + '-ad-proof" ' + chk('isProofRequired') + ' style="transform:scale(1.2);margin-right:4px;">Proof Required</label></div></div>';
  h += '<div class="form-group"><label>Whitelisted Countries (comma-separated, or ALL_COUNTRIES)</label><input id="' + mode + '-ad-countries" value="' + esc(Array.isArray(s('whitelistedCountries')) ? s('whitelistedCountries').join(', ') : s('whitelistedCountries')) + '" placeholder="ALL_COUNTRIES"></div>';
  return h;
}

window.updatePayDurOptions = function(mode) {
  var sideEl = document.getElementById(mode + '-ad-side');
  var durEl = document.getElementById(mode + '-ad-pay-dur');
  if (!sideEl || !durEl) return;
  var isSell = sideEl.value === 'sell';
  var curVal = durEl.value;
  durEl.innerHTML = isSell
    ? '<option value="30">30 min</option><option value="60">60 min</option><option value="120">120 min</option>'
    : '<option value="5">5 min</option><option value="10">10 min</option><option value="15">15 min</option><option value="30">30 min</option><option value="60">60 min</option><option value="120">120 min</option>';
  if (curVal && (!isSell || parseInt(curVal) >= 30)) durEl.value = curVal;
  syncCryptoAmounts(mode);
};

window.syncCryptoAmounts = function(mode) {
  var sideEl = document.getElementById(mode + '-ad-side');
  var totalEl = document.getElementById(mode + '-ad-total');
  var maxEl = document.getElementById(mode + '-ad-max-crypto');
  if (!sideEl || !totalEl || !maxEl) return;
  if (sideEl.value === 'buy') {
    if (totalEl.value && !maxEl.value) maxEl.value = totalEl.value;
    else if (maxEl.value && !totalEl.value) totalEl.value = maxEl.value;
  }
};

window.syncCryptoInputs = function(mode) {
  var sideEl = document.getElementById(mode + '-ad-side');
  var totalEl = document.getElementById(mode + '-ad-total');
  var maxEl = document.getElementById(mode + '-ad-max-crypto');
  if (!sideEl || !totalEl || !maxEl) return;
  if (sideEl.value === 'buy' && totalEl.value && maxEl.value) {
    var changed = document.activeElement;
    if (changed === totalEl) maxEl.value = totalEl.value;
    else if (changed === maxEl) totalEl.value = maxEl.value;
  }
};

window.togglePriceType = function(mode) {
  var sel = document.getElementById(mode + '-ad-type');
  var isFloat = sel && sel.value === 'floating_market';
  var priceGroup = document.getElementById(mode + '-price-group');
  var floatGroup = document.getElementById(mode + '-floating-group');
  if (priceGroup) priceGroup.style.display = isFloat ? 'none' : 'block';
  if (floatGroup) floatGroup.style.display = isFloat ? 'flex' : 'none';
};

window.adPriceAssist = async function(mode) {
  var box = document.getElementById(mode + '-price-assist');
  var sideEl = document.getElementById(mode + '-ad-side');
  var ccyEl = document.getElementById(mode + '-ad-ccy');
  var fiatEl = document.getElementById(mode + '-ad-fiat');
  if (!box || !ccyEl || !fiatEl) return;
  var ccy = (ccyEl.value || 'USDT').trim().toUpperCase();
  var fiat = (fiatEl.value || 'KES').trim().toUpperCase();
  var side = sideEl ? sideEl.value : 'sell';
  box.innerHTML = '<span style="color:var(--text-quaternary);font-size:11px;">⏳ Fetching live market prices…</span>';
  try {
    var res = await API.get('/api/okx/p2p/optimal-price?crypto=' + encodeURIComponent(ccy) + '&fiat=' + encodeURIComponent(fiat));
    var d = (Array.isArray(res.data) ? res.data[0] : res.data) || {};
    var hiBuy = d.currentHighestBuyAdPrice || '';
    var loSell = d.currentLowestSellAdPrice || '';
    if (!hiBuy && !loSell) {
      box.innerHTML = '<span style="color:var(--text-tertiary);font-size:11px;">No market data for ' + esc(ccy) + '/' + esc(fiat) + '</span>';
      return;
    }
    var hint = side === 'sell'
      ? 'You receive fiat — matching the lowest sell sells fastest; highest buy earns more but slower.'
      : 'You pay fiat — matching the highest buy fills fastest; lowest sell costs less but slower.';
    var mkBtn = function(label, val, color) {
      return '<button type="button" class="btn btn-sm btn-outline" style="font-size:10px;color:' + color + ';" data-on-click="adPriceApply(\'' + mode + '\',\'' + val + '\')">' + label + '</button>';
    };
    box.innerHTML = '<div style="padding:8px 10px;border-radius:6px;background:var(--bg-primary);border:1px solid var(--border-primary);font-size:11px;line-height:1.8;">' +
      '📊 Live ' + esc(ccy) + '/' + esc(fiat) + ': <strong style="color:#00c853;">Highest buy ' + esc(hiBuy || '-') + '</strong> · <strong style="color:#ff9100;">Lowest sell ' + esc(loSell || '-') + '</strong><br>' +
      '<span style="color:var(--text-tertiary);">' + esc(hint) + '</span><br>' +
      (hiBuy ? mkBtn('Use highest buy', hiBuy, '#00c853') : '') + ' ' +
      (loSell ? mkBtn('Use lowest sell', loSell, '#ff9100') : '') +
      '</div>';
  } catch (err) {
    box.innerHTML = '<span style="color:var(--accent-red);font-size:11px;">Failed to fetch market price: ' + esc(err.message) + '</span>';
  }
};

window.adPriceApply = function(mode, val) {
  var el = document.getElementById(mode + '-ad-price');
  if (!el) return;
  el.value = val;
  if (typeof calcFiatMax === 'function') calcFiatMax(mode);
  showToast('Price set to ' + val, 'success');
};

window.calcFiatMax = function(mode) {
  var priceEl = document.getElementById(mode + '-ad-price');
  var cryptoEl = document.getElementById(mode + '-ad-max-crypto');
  var displayEl = document.getElementById(mode + '-ad-max-fiat-display');
  if (!priceEl || !cryptoEl || !displayEl) return;
  var p = parseFloat(priceEl.value);
  var c = parseFloat(cryptoEl.value);
  if (!isNaN(p) && !isNaN(c) && p > 0 && c > 0) {
    displayEl.textContent = '→ ' + (p * c).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' fiat';
  } else {
    displayEl.textContent = '';
  }
};

async function createAd(e) {
  e.preventDefault();
  try {
    var mode = 'create';
    var payload = buildAdPayload(mode);
    await API.post('/api/okx/p2p/ads', payload);
    e.target.closest('.modal-overlay').remove();
    showToast('Ad created on OKX!', 'success');
    navigate('ads');
  } catch (err) { showToast(err.message, 'error'); }
}

function buildAdPayload(mode) {
  var g = function(id) { var el = document.getElementById(mode + '-' + id); return el ? el.value.trim() : ''; };
  var gArr = function(id) { var v = g(id); return v ? v.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : []; };
  var side = g('ad-side');
  var isEdit = mode === 'edit';
  var payload = {};
  if (isEdit) {
    payload.unitPrice = g('ad-price');
    payload.cryptoAmount = g('ad-total');
    payload.minOrderLimit = g('ad-min');
    var maxCrypto = parseFloat(g('ad-max-crypto'));
    var price = parseFloat(g('ad-price'));
    if (!isNaN(maxCrypto) && !isNaN(price) && price > 0) {
      payload.maxOrderLimit = String(Math.round(maxCrypto * price * 100) / 100);
    } else if (!isNaN(price) && price > 0) {
      var total = parseFloat(g('ad-total'));
      if (!isNaN(total) && total > 0) payload.maxOrderLimit = String(Math.round(total * price * 100) / 100);
    }
    if (g('ad-pay-dur')) payload.maxPaymentDurationInMinutes = g('ad-pay-dur');
    return payload;
  }
  payload.side = side;
  payload.cryptoCurrency = g('ad-ccy').toUpperCase() || 'USDT';
  payload.fiatCurrency = g('ad-fiat').toUpperCase() || 'KES';
  payload.unitPrice = g('ad-price');
  payload.cryptoAmount = g('ad-total');
  payload.minOrderLimit = g('ad-min');
  var maxCrypto = parseFloat(g('ad-max-crypto'));
  var price = parseFloat(g('ad-price'));
  if (!isNaN(maxCrypto) && !isNaN(price) && price > 0) {
    payload.maxOrderLimit = String(Math.round(maxCrypto * price * 100) / 100);
  } else if (!isNaN(price) && price > 0) {
    var total = parseFloat(g('ad-total'));
    if (!isNaN(total) && total > 0) payload.maxOrderLimit = String(Math.round(total * price * 100) / 100);
  }
  payload.type = g('ad-type') || 'limit';
  payload.targetGroup = g('ad-target') || 'all';
  if (g('ad-margin')) payload.priceMargin = g('ad-margin');
  if (g('ad-floor')) payload.priceFloor = g('ad-floor');
  if (g('ad-pay-dur')) payload.maxPaymentDurationInMinutes = g('ad-pay-dur');
  if (g('ad-auto-msg')) payload.automatedMessage = g('ad-auto-msg');
  if (g('ad-remark')) payload.remark = g('ad-remark');
  if (g('ad-kyc')) payload.minKycLevel = g('ad-kyc');
  if (g('ad-age')) payload.minAccountAge = g('ad-age');
  if (g('ad-min-orders')) payload.minCompletedOrders = g('ad-min-orders');
  if (g('ad-min-sell')) payload.minSellOrders = g('ad-min-sell');
  if (g('ad-comp-rate')) payload.minCompletionRate = g('ad-comp-rate');
  if (g('ad-verif-type')) payload.verificationType = g('ad-verif-type');
  var proofEl = document.getElementById(mode + '-ad-proof');
  payload.isProofRequired = proofEl ? proofEl.checked : false;
  var payments = gArr('ad-payments');
  if (payments.length > 0) {
    if (side === 'sell') {
      payload.paymentMethodIds = payments;
    } else {
      var allPms = window._allPaymentMethods || [];
      var types = payments.map(function(v) {
        var found = allPms.find(function(pm) { return (pm.paymentMethodId || pm.id) === v; });
        return found ? (found.type || v) : v;
      });
      payload.paymentMethods = types.join(',');
    }
  }
  var countries = gArr('ad-countries');
  if (countries.length > 0) payload.whitelistedCountries = countries;
  return payload;
}

// ========== Edit Ad (full spec) ==========

async function editAd(adId) {
  try {
    var results = await Promise.all([
      API.get('/api/okx/p2p/ads/' + adId),
      API.get('/api/okx/p2p/ad-config?side=SELL&cryptoCurrency=USDT&fiatCurrency=KES').catch(function() { return { data: {} }; }),
      API.get('/api/okx/p2p/payment-methods').catch(function() { return { data: [] }; })
    ]);
    var res = results[0];
    var config = results[1].data || {};
    var ad = Array.isArray(res.data) ? res.data[0] : res.data || {};
    var pmRes = results[2];
    var allPayments = Array.isArray(pmRes.data) ? pmRes.data : [];
    var overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    var cpmd = ad.configuredPaymentMethodDetails || [];
    var side = ad.side;
    var selectedIds = [];
    var selectedTypes = [];
    cpmd.forEach(function(d) {
      if (d.paymentMethod) selectedTypes.push(d.paymentMethod.toLowerCase());
      if (d.paymentMethodDetails) {
        d.paymentMethodDetails.forEach(function(pmd) {
          if (pmd.paymentMethodId) selectedIds.push(pmd.paymentMethodId);
        });
      }
    });
    var payments = (ad.paymentMethods || ad.paymentMethod || []);
    var payStr = Array.isArray(payments) ? payments.map(function(p) { return typeof p === 'object' ? (p.paymentMethodId || p.paymentMethod || p.paymentType || '') : p; }).filter(Boolean).join(', ') : (typeof payments === 'string' ? payments : '');
    // Payment methods are read-only during edit (must match OKX ad exactly)
    var pmHtml = '';
    window._allPaymentMethods = allPayments;
    var rawProof = ad.isProofRequired;
    var proofVal = rawProof === true || rawProof === 'true' || rawProof === 1 || rawProof === '1';
    var mapped = {
      side: ad.side,
      cryptoCurrency: ad.cryptoCurrency,
      fiatCurrency: ad.fiatCurrency,
      type: ad.type,
      unitPrice: ad.unitPrice,
      priceMargin: ad.priceMargin,
      priceFloor: ad.priceFloor,
      cryptoAmount: ad.cryptoAmount || ad.quantity || ad.availableQuantity || ad.cryptoAmount || ad.availableAmount,
      minOrderLimit: ad.minOrderSize || ad.minOrderLimit,
      maxOrderLimit: ad.maxOrderSize || ad.maxOrderLimit,
      maxOrderLimitCrypto: ad.availableAmount || ad.availableQuantity || ad.quantity || ad.maxOrderSizeCrypto || '',
      maxPaymentDurationInMinutes: ad.maxPaymentDurationInMinutes,
      targetGroup: ad.targetGroup,
      paymentMethods: payStr,
      automatedMessage: ad.automatedMessage,
      remark: ad.remark,
      minKycLevel: ad.minKycLevel,
      minAccountAge: ad.minAccountAge,
      minCompletedOrders: ad.minCompletedOrders,
      minSellOrders: ad.minSellOrders,
      minCompletionRate: ad.minCompletionRate,
      verificationType: ad.verificationType,
      isProofRequired: proofVal,
      whitelistedCountries: Array.isArray(ad.whitelistedCountries) ? ad.whitelistedCountries.join(', ') : (ad.whitelistedCountries || '')
    };
    overlay.innerHTML = '<div class="modal-content" style="max-width:560px;max-height:90vh;overflow-y:auto;"><h3>Edit P2P Ad</h3><p style="color:var(--text-tertiary);font-size:12px;margin-bottom:12px;">Ad ID: ' + esc(adId) + '</p><form data-on-submit="updateAd(event, \'' + esc(adId) + '\')">' + adFormFields('edit', mapped, config) + pmHtml + '<div class="form-actions"><button type="button" class="btn btn-secondary" data-on-click="this.closest(\'.modal-overlay\').remove()">Cancel</button><button type="submit" class="btn btn-primary">Save on OKX</button></div></form></div>';
    document.body.appendChild(overlay);
  } catch (err) {
    showToast('Failed to load ad: ' + err.message, 'error');
  }
}

window.cloneAd = async function(adId) {
  try {
    var res = await API.get('/api/okx/p2p/ads/' + adId);
    var ad = Array.isArray(res.data) ? res.data[0] : res.data || {};
    window._cloneAdData = {
      side: String(ad.side || 'BUY').toLowerCase(),
      cryptoCurrency: ad.cryptoCurrency || 'USDT',
      fiatCurrency: ad.fiatCurrency || 'KES',
      unitPrice: ad.unitPrice || '',
      type: ad.type === 'floating_market' || ad.type === 'floating' ? 'floating_market' : 'limit',
      priceMargin: ad.priceMargin || '',
      cryptoAmount: ad.cryptoAmount || '',
      minOrderLimit: ad.minOrderSize || '',
      maxOrderLimit: ad.maxOrderSize || '',
      maxPaymentDuration: ad.maxPaymentDurationInMinutes || '15',
      targetGroup: ad.targetGroup || 'all',
      minKycLevel: ad.minKycLevel || '0',
      minCompletedOrders: ad.minCompletedOrders || '0',
      minCompletionRate: ad.minCompletionRate || '',
      minAccountAge: ad.minAccountAge || '0',
      verificationType: ad.verificationType || '0',
      paymentMethod: (ad.configuredPaymentMethodDetails || []).map(function(m) { return m.paymentMethodId || m.paymentMethod; }).join(','),
      paymentMethodDetails: ad.configuredPaymentMethodDetails || []
    };
    showCreateAdModal();
  } catch (err) { showToast('Failed to clone ad: ' + err.message, 'error'); }
};

window.updatePmField = function(mode) {
  var checkboxes = document.querySelectorAll('#' + mode + '-ad-payments ~ div input[type=checkbox][data-pm-id]');
  var ids = [];
  // Actually fetch from parent container
  var container = document.querySelector('#' + mode + '-ad-payments') ? document.getElementById(mode + '-ad-payments').parentNode : null;
  var cbs = container ? container.querySelectorAll('input[type=checkbox][data-pm-id]') : [];
  cbs.forEach(function(cb) { if (cb.checked) ids.push(cb.getAttribute('data-pm-id')); });
  var input = document.getElementById(mode + '-ad-payments');
  if (input) input.value = ids.join(', ');
};

async function updateAd(e, adId) {
  e.preventDefault();
  try {
    var mode = 'edit';
    var payload = buildAdPayload(mode);
    payload.adId = adId;
    await API.post('/api/okx/p2p/ads/' + adId + '/update', payload);
    e.target.closest('.modal-overlay').remove();
    showToast('Ad updated on OKX!', 'success');
    navigate('ads');
  } catch (err) { showToast(err.message, 'error'); }
}

// ========== Legacy helpers ==========

async function toggleAdStatus(adId, status) {
  try {
    var action = status === 'active' ? 'show' : 'hidden';
    await API.post('/api/okx/p2p/ads/' + adId + '/toggle', { status: action });
    showToast('Ad ' + (status === 'active' ? 'activated' : 'paused'), 'success');
    navigate('ads');
  } catch (err) { showToast(err.message, 'error'); }
}

async function stopAllAds() {
  try {
    var r = await API.post('/api/okx/p2p/ads/stop-all', {});
    showToast('Stopped ' + r.data.stopped + ' of ' + r.data.total + ' ads', 'success');
    navigate('ads');
  } catch (err) { showToast(err.message, 'error'); }
}

async function startAllAds() {
  try {
    var r = await API.post('/api/okx/p2p/ads/start-all', {});
    showToast('Started ' + r.data.started + ' of ' + r.data.total + ' ads', 'success');
    navigate('ads');
  } catch (err) { showToast(err.message, 'error'); }
}

// ========== Settings Tab ==========

async function renderAdSettings(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  var html = '<div style="display:flex;flex-direction:column;gap:16px;">';

  // --- Payment Methods ---
  html += '<div class="card"><h4 style="margin-bottom:12px;">Payment Methods</h4><div id="ads-payment-methods-list"><p style="color:var(--text-tertiary);font-size:12px;">Loading...</p></div><div style="margin-top:10px;"><button class="btn btn-sm btn-primary" data-on-click="showAddPaymentMethodModal()">+ Add Payment Method</button></div></div>';

  // --- Merchant Profile ---
  html += '<div class="card"><h4 style="margin-bottom:12px;">Merchant Profile</h4><form data-on-submit="updateMerchantProfile(event)"><div class="form-group"><label>Avatar Image URL</label><input id="merchant-avatar" type="text" placeholder="https://example.com/avatar.jpg"></div><div class="form-group"><label>Description</label><textarea id="merchant-desc" rows="3" placeholder="Describe your trading terms..."></textarea></div><button type="submit" class="btn btn-primary btn-sm">Save Profile</button></form></div>';

  html += '</div>';
  content.innerHTML = html;

  loadPaymentMethods();
}

var _trailingTab = 'buy';

var _loadingTrailing = false;
async function loadTrailingConfig() {
  var section = document.getElementById('trailing-section');
  if (!section || _loadingTrailing) return;
  _loadingTrailing = true;
  section.innerHTML = '<div style="padding:20px;text-align:center;color:var(--text-quaternary);font-size:12px;">Loading trailing config...</div>';
  try {
    var [cfgRes, logRes, adsRes, persistentRes] = await Promise.all([
      API.get('/api/okx/p2p/trailing/config'),
      API.get('/api/okx/p2p/trailing/log'),
      API.get('/api/p2p/ads/mine'),
      API.get('/api/okx/p2p/trailing/persistent')
    ]);
    var cfg = cfgRes.data || {};
    if (!cfg.buy) cfg.buy = {};
    if (!cfg.sell) cfg.sell = {};
    if (!cfg.buy.coins) cfg.buy.coins = {};
    if (!cfg.sell.coins) cfg.sell.coins = {};
    if (!cfg.buy.activeCoin) cfg.buy.activeCoin = 'USDT';
    if (!cfg.sell.activeCoin) cfg.sell.activeCoin = 'USDT';
    if (!cfg.buy.coins[cfg.buy.activeCoin]) cfg.buy.coins[cfg.buy.activeCoin] = {};
    if (!cfg.sell.coins[cfg.sell.activeCoin]) cfg.sell.coins[cfg.sell.activeCoin] = {};
    var logs = Array.isArray(logRes.data) ? logRes.data : [];
    var userAds = Array.isArray(adsRes.data) ? adsRes.data : [];
    var persistent = persistentRes.data || {};
    var tab = _trailingTab;
    var html = '<div style="display:flex;gap:0;margin-bottom:12px;border-bottom:1px solid #1e1e2e;">';
    var pb = persistent.buy, ps = persistent.sell;
    var buyBadge = pb ? ' <span style="color:#4caf50;font-size:10px;">● ACTIVE' + (pb.durationHours > 0 ? ' ' + pb.durationHours + 'h' : '') + '</span>' : '';
    var sellBadge = ps ? ' <span style="color:#4caf50;font-size:10px;">● ACTIVE' + (ps.durationHours > 0 ? ' ' + ps.durationHours + 'h' : '') + '</span>' : '';
    html += '<button class="btn btn-sm ' + (tab === 'buy' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchTrailingTab(\'buy\')">📥 Buy Trailing' + buyBadge + '</button>';
    html += '<button class="btn btn-sm ' + (tab === 'sell' ? 'btn-primary' : 'btn-outline') + '" style="border-radius:6px 6px 0 0;border-bottom:none;" data-on-click="switchTrailingTab(\'sell\')">📤 Sell Trailing' + sellBadge + '</button>';
    html += '</div><div id="trailing-buy-panel" style="display:' + (tab === 'buy' ? 'block' : 'none') + '">';
    html += buildTrailingSideHTML('buy', cfg.buy, userAds);
    html += '</div><div id="trailing-sell-panel" style="display:' + (tab === 'sell' ? 'block' : 'none') + '">';
    html += buildTrailingSideHTML('sell', cfg.sell, userAds);
    html += '</div>';
    html += '<div style="display:flex;gap:6px;margin-top:12px;margin-bottom:10px;"><button class="btn btn-sm btn-primary" data-on-click="runTrailingNow()">▶ Run Now (both sides)</button><button class="btn btn-sm btn-danger" data-on-click="stopTrailing()">⏹ Stop Both</button></div>';
    html += '<div style="display:flex;gap:6px;margin-bottom:10px;"><button class="btn btn-sm btn-success" data-on-click="saveTrailingConfigToDb()" title="Save to server (persists across restarts)">💾 Save</button><button class="btn btn-sm btn-outline" data-on-click="loadTrailingConfigFromDb()" title="Load saved config from server">📂 Load</button><button class="btn btn-sm btn-warning" data-on-click="resetTrailingConfigToDefaults()" title="Reset to default config">🔄 Reset</button></div>';
    html += '<div style="display:flex;gap:6px;margin-bottom:6px;"><span style="font-size:12px;color:var(--text-tertiary);flex:1;">📜 Trailing log</span><button class="btn btn-sm btn-outline" data-on-click="clearTrailingLog()" title="Clear log entries">🗑 Clear</button></div>';
    html += '<div id="trailing-log" style="background:var(--bg-primary);border-radius:6px;padding:8px;max-height:200px;overflow-y:auto;font-size:11px;font-family:monospace;">';
    if (logs.length === 0) html += '<div style="color:var(--text-quaternary);">No trailing activity yet</div>';
    else logs.forEach(function(l) { html += '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; });
    html += '</div></div>';
    section.innerHTML = html;
    // Populate merchant dropdowns with per-side pairs and selected IDs
    var buyCoinCfg = cfg.buy.coins[cfg.buy.activeCoin] || {};
    var sellCoinCfg = cfg.sell.coins[cfg.sell.activeCoin] || {};
    var buyMids = Array.isArray(buyCoinCfg.trailMerchantIds) ? buyCoinCfg.trailMerchantIds : (buyCoinCfg.trailMerchantId ? [buyCoinCfg.trailMerchantId] : []);
    var sellMids = Array.isArray(sellCoinCfg.trailMerchantIds) ? sellCoinCfg.trailMerchantIds : (sellCoinCfg.trailMerchantId ? [sellCoinCfg.trailMerchantId] : []);
    loadTrailingMerchants(buyMids, sellMids, cfg.buy.activeCoin, buyCoinCfg.fiatCurrency || 'KES', cfg.sell.activeCoin, sellCoinCfg.fiatCurrency || 'KES');
    populateFollowMerchants();
    // Start trailing log auto-polling
    startTrailingLogPoll();
    // Auto-Message dashboard (independent of trailing)
    renderAutoMsgDashboard(cfg);
    startAutoMsgLogPoll();
  } catch (err) { section.innerHTML = '<p style="color:#f44336;font-size:12px;">Failed to load: ' + esc(err.message) + '</p>'; }
  finally { _loadingTrailing = false; }
}

function buildTrailingSideHTML(side, sideCfg, userAds) {
  sideCfg = sideCfg || {};
  if (!sideCfg.coins) sideCfg.coins = {};
  if (!sideCfg.activeCoin) sideCfg.activeCoin = 'USDT';
  if (!sideCfg.coins[sideCfg.activeCoin]) sideCfg.coins[sideCfg.activeCoin] = {};
  var coinCfg = sideCfg.coins[sideCfg.activeCoin];
  // Fill in missing defaults (ensures new fields show even in old stored configs)
  var _defaults = { rankMatch: false, verifiedOnly: false };
  for (var _dk in _defaults) { if (coinCfg[_dk] === undefined) coinCfg[_dk] = _defaults[_dk]; }
  var sideLabel = side === 'buy' ? 'Buy' : 'Sell';
  var trailMode = coinCfg.trailMode || 'price';
  var trailAdType = coinCfg.trailAdType || 'both';
  var selectedIds = Array.isArray(coinCfg.adIds) ? coinCfg.adIds : [];
  var cryptoCurrencies = ['USDT','BTC','ETH','SOL','XRP','USDC','TON','TRX'];
  var fiatCurrencies = ['KES','USD','NGN','GHS','ZAR','EUR','GBP','TZS','UGX','XAF','XOF'];
  var selCrypto = (sideCfg.activeCoin || 'USDT').toUpperCase();
  var selFiat = (coinCfg.fiatCurrency || 'KES').toUpperCase();
  var h = '<div class="card" style="padding:12px;margin-bottom:8px;border-color:rgba(68,138,255,0.15);">';
  h += '<div style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-bottom:10px;">';
  h += '<input type="hidden" class="trailing-active-coin-' + side + '" value="' + esc(selCrypto) + '">';
  h += '<span style="font-size:12px;color:var(--text-tertiary);">Coins:</span>';
  h += '<span class="trailing-coins-' + side + '" style="display:inline-flex;flex-wrap:wrap;gap:4px;align-items:center;">';
  var coinKeys = Object.keys(sideCfg.coins);
  if (coinKeys.length === 0) coinKeys = ['USDT'];
  coinKeys.forEach(function(ck) {
    var ccfg = sideCfg.coins[ck] || {};
    var isActive = selCrypto === ck;
    var isOn = ccfg.enabled === true;
    h += '<span data-on-click="switchTrailingCoin(\'' + side + '\',\'' + esc(ck) + '\')" title="' + (isActive ? 'Editing this coin — settings below apply to ' + esc(ck) : 'Click to edit ' + esc(ck) + ' settings') + '" style="cursor:pointer;display:inline-flex;align-items:center;gap:4px;border-radius:4px;padding:2px 6px;font-size:11px;background:' + (isActive ? 'rgba(68,138,255,0.4)' : (isOn ? 'rgba(68,138,255,0.15)' : 'rgba(120,120,138,0.12)')) + ';border:1px solid ' + (isActive ? '#448aff' : (isOn ? 'rgba(68,138,255,0.3)' : 'rgba(120,120,138,0.3)')) + ';">' + esc(ck) + ' <span style="color:' + (isOn ? '#4caf50' : '#78788a') + ';">' + (isOn ? '●' : '○') + '</span></span>';
  });
  h += '</span>';
  h += '<select class="trailing-coin-add-' + side + '" style="font-size:11px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);padding:2px;" data-on-change="addTrailingCoin(\'' + side + '\')"><option value="">+ coin</option>';
  cryptoCurrencies.forEach(function(cc) { if (!sideCfg.coins[cc]) h += '<option value="' + cc + '">' + cc + '</option>'; });
  h += '</select>';
  h += '<label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:4px;" title="Runs this coin on the schedule. Other coins with Enabled ticked also run."><input type="checkbox" class="trailing-enabled-' + side + '" ' + (coinCfg.enabled ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> Enabled</label>';
  h += '<label style="font-size:12px;color:var(--text-tertiary);">Fiat: <select class="trailing-fiat-' + side + '" data-on-change="saveTrailingConfig()">';
  fiatCurrencies.forEach(function(fc) { h += '<option value="' + fc + '" ' + (selFiat === fc ? 'selected' : '') + '>' + fc + '</option>'; });
  h += '</select></label>';
  h += '<label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:4px;"><input type="checkbox" class="trailing-persistent-' + side + '" ' + (coinCfg.persistent ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> <span title="Runs on server even when browser is closed. Stop button or duration expiry stops it.">Persistent</span></label>';
  h += '<label style="font-size:12px;color:var(--text-tertiary);">Duration: <select class="trailing-duration-' + side + '" data-on-change="saveTrailingConfig()">';
  for (var hh = 0; hh <= 24; hh++) { h += '<option value="' + hh + '" ' + (coinCfg.trailDurationHours == hh ? 'selected' : '') + '>' + (hh === 0 ? '∞' : hh + ' h') + '</option>'; }
  h += '</select></label>';
  h += '<label style="font-size:12px;color:var(--text-tertiary);">Interval: <select class="trailing-interval-' + side + '" data-on-change="saveTrailingConfig()">';
  [0.25,0.5,0.75,1,2,3,4,5,6,7,8,9,10].forEach(function(iv) {
    var label = iv < 1 ? Math.round(iv * 60) + ' sec' : iv + ' min';
    h += '<option value="' + iv + '" ' + (coinCfg.intervalMin == iv ? 'selected' : '') + '>' + label + '</option>';
  });
  h += '</select></label>';
 h += '<label style="font-size:12px;color:var(--text-tertiary);">Payment: <select class="trailing-pay-dur-' + side + '" data-on-change="saveTrailingConfig()">';
   var payOpts = side === 'sell' ? [30,60,120] : [5,10,15,30,60,120];
   payOpts.forEach(function(d) { h += '<option value="' + d + '" ' + (coinCfg.trailPaymentDuration == d ? 'selected' : '') + '>' + d + ' min</option>'; });
   h += '</select></label></div>';
  h += '<div style="margin-bottom:10px;"><label style="font-size:12px;color:var(--text-tertiary);">Trail mode: <select class="trailing-mode-' + side + '" data-on-change="trailModeChanged(\'' + side + '\')"><option value="price" ' + (trailMode === 'price' ? 'selected' : '') + '>Price target</option><option value="market" ' + (trailMode === 'market' ? 'selected' : '') + '>Market optimal</option><option value="merchant" ' + (trailMode === 'merchant' ? 'selected' : '') + '>Specific merchant</option></select></label>';
   h += '<span class="trailing-bp-section-' + side + '"><label style="font-size:12px;color:var(--text-tertiary);margin-left:8px;">Base rate: <input class="trailing-bp-' + side + '" type="number" step="0.01" value="' + (coinCfg.basePrice || '') + '" style="width:80px;" data-on-change="saveTrailingConfig()" placeholder="e.g. 128"></label>';
   h += '<span class="trailing-range-section-' + side + '" style="display:' + (trailMode === 'market' ? 'inline' : 'none') + ';"><label style="font-size:12px;color:var(--text-tertiary);margin-left:4px;">Range ±: <input class="trailing-range-margin-' + side + '" type="number" step="0.01" value="' + (coinCfg.rangeMargin || 0.2) + '" style="width:60px;" data-on-change="saveTrailingConfig()" placeholder="0.2"></label></span></span></div>';
    var marginType = coinCfg.marginType || 'fixed';
    var marginLabel = marginType === 'percent' ? 'Margin (%)' : 'Margin (KES)';
    var marginStep = marginType === 'percent' ? '0.1' : '0.01';
    h += '<div style="margin-bottom:10px;"><label style="font-size:12px;color:var(--text-tertiary);"><span class="trailing-margin-label-' + side + '">' + marginLabel + '</span>: <input class="trailing-margin-' + side + '" type="number" step="' + marginStep + '" value="' + (coinCfg.trailMargin || 0.01) + '" style="width:80px;" data-on-change="saveTrailingConfig()" placeholder="0.01"></label>';
    h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:6px;">Type: <select class="trailing-margin-type-' + side + '" data-on-change="onMarginTypeChange(\'' + side + '\')"><option value="fixed" ' + (marginType === 'fixed' ? 'selected' : '') + '>Fixed KES</option><option value="percent" ' + (marginType === 'percent' ? 'selected' : '') + '>Percent</option></select></label>';
    h += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:2px;">' + (side === 'buy' ? 'Buy: highest competitor price + margin' : 'Sell: lowest competitor price - margin') + '</div></div>';
   // Merchant section (multi-select, up to 5)
   var selectedMids = (coinCfg.trailMerchantIds && Array.isArray(coinCfg.trailMerchantIds)) ? coinCfg.trailMerchantIds : (coinCfg.trailMerchantId ? [coinCfg.trailMerchantId] : []);
  h += '<div class="trailing-merchant-section-' + side + '" style="display:' + (trailMode === 'merchant' ? 'block' : 'none') + ';margin-bottom:10px;">';
  h += '<div style="font-size:12px;color:var(--text-tertiary);margin-bottom:6px;">Merchants (up to 5): <span class="trailing-merchant-count-' + side + '" style="color:var(--text-quaternary);">' + selectedMids.length + '/5</span></div>';
  h += '<div class="trailing-merchant-list-' + side + '" style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:6px;">';
  if (selectedMids.length > 0) {
    selectedMids.forEach(function(mid, idx) {
      h += '<span class="trailing-merchant-tag-' + side + '" data-mid="' + esc(mid) + '" style="display:inline-flex;align-items:center;gap:4px;background:rgba(68,138,255,0.15);border:1px solid rgba(68,138,255,0.3);border-radius:4px;padding:2px 6px;font-size:11px;">';
      h += '<span>' + esc(mid.slice(-8)) + '</span>';
      h += '<span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" data-on-click="removeTrailingMerchant(\'' + side + '\',\'' + esc(mid) + '\')">×</span>';
      h += '</span>';
    });
  } else {
    h += '<span style="font-size:11px;color:var(--text-quaternary);">No merchants selected</span>';
  }
  h += '</div>';
  h += '<div style="display:flex;gap:4px;align-items:center;">';
  h += '<select class="trailing-merchant-add-' + side + '" style="flex:1;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:11px;" data-on-change="addTrailingMerchant(\'' + side + '\')"><option value="">— Add merchant —</option></select>';
  h += '<button class="btn btn-sm btn-outline" style="padding:2px 8px;font-size:11px;" data-on-click="refreshMerchants(\'' + side + '\')" title="Refresh list">↻</button>';
  h += '</div>';
  h += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:4px;">Tracks selected merchants\' best price + margin. The ad beats the best price among selected merchants.</div>';
  h += '</div>';
  // Price target section
  h += '<div class="trailing-price-section-' + side + '" style="display:' + (trailMode === 'price' ? 'block' : 'none') + ';margin-bottom:10px;">';
   h += '<label style="font-size:12px;color:var(--text-tertiary);">Starting Limit (KES): <input class="trailing-price-target-' + side + '" type="number" step="0.01" value="' + (coinCfg.trailPriceTarget != null ? coinCfg.trailPriceTarget : '') + '" style="width:120px;" data-on-change="saveTrailingConfig()" placeholder="e.g. 100"></label>';
    h += '<div style="margin:6px 0 4px 0;"><label style="font-size:12px;color:var(--text-tertiary);">Max Limit (KES): <input class="trailing-price-max-' + side + '" type="number" step="0.01" value="' + (coinCfg.trailPriceTargetMax || '') + '" style="width:120px;" data-on-change="saveTrailingConfig()" placeholder="e.g. 2000"></label></div>';
    h += '<div style="margin:6px 0 4px 0;"><label style="font-size:12px;color:var(--text-tertiary);">Price Cap (KES): <input class="trailing-price-cap-' + side + '" type="number" step="0.01" value="' + (coinCfg.priceCap || '') + '" style="width:120px;" data-on-change="saveTrailingConfig()" placeholder="0 = off"></label><span style="font-size:11px;color:var(--text-quaternary);margin-left:4px;">Ad won\'t go beyond this price</span></div>';
    h += '<label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:12px;color:var(--text-tertiary);"><input type="checkbox" class="trailing-price-use-max-' + side + '" ' + (coinCfg.priceTargetUseMaxLimit ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> <span>Use my ad\'s max order limit as upper bound</span></label>';
    var pfMargin = coinCfg.priceFilterMargin || 0;
    var pfType = coinCfg.priceFilterMarginType || 'fixed';
   h += '<div style="margin-top:6px;padding:6px;background:rgba(255,152,0,0.05);border-radius:4px;border:1px solid rgba(255,152,0,0.1);">';
   h += '<label style="font-size:12px;color:var(--text-tertiary);">Price outlier filter: <input class="trailing-price-filter-margin-' + side + '" type="number" step="0.01" value="' + pfMargin + '" style="width:70px;" data-on-change="saveTrailingConfig()" placeholder="0"></label>';
   h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:4px;"><select class="trailing-price-filter-type-' + side + '" data-on-change="saveTrailingConfig()"><option value="fixed" ' + (pfType === 'fixed' ? 'selected' : '') + '>KES</option><option value="percent" ' + (pfType === 'percent' ? 'selected' : '') + '>%</option></select></label>';
   h += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:2px;">Skips competitor prices that deviate from the median by more than this margin. 0 = disabled.</div></div>';
   h += '</div>';
  // Ad type
  h += '<div style="margin-bottom:10px;"><label style="font-size:12px;color:var(--text-tertiary);">Ad type: <select class="trailing-ad-type-' + side + '" data-on-change="trailingAdTypeChanged(\'' + side + '\')"><option value="both" ' + (trailAdType === 'both' ? 'selected' : '') + '>Both (floating + limit)</option><option value="floating" ' + (trailAdType === 'floating' ? 'selected' : '') + '>Floating only</option><option value="limit" ' + (trailAdType === 'limit' ? 'selected' : '') + '>Limit only</option></select></label>';
   h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:12px;"><input type="checkbox" class="trailing-exclude-offline-' + side + '" ' + (coinCfg.excludeOffline ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> Exclude offline</label>';
   h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:12px;"><input type="checkbox" class="trailing-unverified-match-' + side + '" ' + (coinCfg.unverifiedMatch ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> Match unverified (no margin)</label>';
    h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:12px;"><input type="checkbox" class="trailing-verified-match-' + side + '" ' + (coinCfg.verifiedMatch ? 'checked' : '') + ' data-on-change="onVerifiedMatchToggle(\'' + side + '\')"> Match verified (no margin)</label>';
    h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:12px;"><input type="checkbox" class="trailing-match-exact-' + side + '" ' + (coinCfg.matchExact ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> Zero margin always (match exact price)</label>';
     h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:12px;" title="Only price-compete with merchants at or above your rank. You outrank someone? Match their price. Outranked? Apply margin."><input type="checkbox" class="trailing-rank-match-' + side + '" ' + (coinCfg.rankMatch ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> Rank match</label>';
     h += '<label style="font-size:12px;color:var(--text-tertiary);margin-left:12px;" title="Compete only against verified merchants (Super and Diamond). Lite/unverified merchants are ignored when the best price is picked."><input type="checkbox" class="trailing-verified-only-' + side + '" ' + (coinCfg.verifiedOnly ? 'checked' : '') + ' data-on-change="saveTrailingConfig()"> Verified only (Super + Diamond)</label></div>';
     if (side === 'buy') {
      h += '<div style="margin-bottom:10px;display:none;"><label style="font-size:12px;color:var(--text-tertiary);">Available buy fiat (KES): <input class="trailing-buy-fiat-' + side + '" type="number" step="0.01" value="' + (coinCfg.buyFiatBudget || '0') + '" style="width:110px;"></label> <button class="btn btn-sm btn-primary" data-on-click="setBuyFiatBudget(\'' + side + '\')">Apply budget</button><input type="hidden" class="trailing-buy-fiat-at-' + side + '" value="' + (coinCfg.buyFiatBudgetSetAt || '') + '"></div>';
      h += '<div style="margin-bottom:10px;display:none;"><label style="font-size:12px;color:var(--text-tertiary);">Max buy amount (USDT): <input class="trailing-max-buy-' + side + '" type="number" step="0.01" value="' + (coinCfg.maxBuyAmountUSDT || '0') + '" style="width:100px;" data-on-change="saveTrailingConfig()"></label></div>';
      h += '<div style="margin-bottom:10px;"><label style="font-size:12px;color:var(--text-tertiary);" title="Freeze trailing when the ad\'s remaining listed amount drops below this (USDT). 0 = off.">Min buy amount on the ad to keep trailing: <input class="trailing-min-balance-' + side + '" type="number" step="0.01" value="' + (coinCfg.minBalanceUSDT || '') + '" style="width:100px;" data-on-change="saveTrailingConfig()" placeholder="0 = off"></label><span style="font-size:11px;color:var(--text-quaternary);margin-left:4px;">Price stays put if below this.</span></div>';
    }
    // Always-margin merchants (visible only when Match verified is ticked)
    var alwaysMids = (coinCfg.alwaysMarginMerchantIds && Array.isArray(coinCfg.alwaysMarginMerchantIds)) ? coinCfg.alwaysMarginMerchantIds : [];
    h += '<div class="trailing-always-margin-section-' + side + '" style="display:' + (coinCfg.verifiedMatch ? 'block' : 'none') + ';margin-bottom:10px;">';
    h += '<div style="font-size:12px;color:var(--text-tertiary);margin-bottom:6px;">Always apply margin to <span style="color:var(--text-quaternary);">(when match verified):</span> <span class="trailing-always-margin-count-' + side + '" style="color:var(--text-quaternary);">' + alwaysMids.length + '/5</span></div>';
    h += '<div class="trailing-always-margin-list-' + side + '" style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:6px;">';
    if (alwaysMids.length > 0) {
      alwaysMids.forEach(function(mid) {
        h += '<span class="trailing-always-margin-tag-' + side + '" data-mid="' + esc(mid) + '" style="display:inline-flex;align-items:center;gap:4px;background:rgba(156,39,176,0.15);border:1px solid rgba(156,39,176,0.3);border-radius:4px;padding:2px 6px;font-size:11px;">';
        h += '<span>' + esc(mid.slice(-8)) + '</span>';
        h += '<span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" data-on-click="removeAlwaysMarginMerchant(\'' + side + '\',\'' + esc(mid) + '\')">×</span>';
        h += '</span>';
      });
    } else {
      h += '<span style="font-size:11px;color:var(--text-quaternary);">No merchants selected</span>';
    }
    h += '</div>';
    h += '<div style="display:flex;gap:4px;align-items:center;">';
    h += '<select class="trailing-always-margin-add-' + side + '" style="flex:1;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:11px;" data-on-change="addAlwaysMarginMerchant(\'' + side + '\')"><option value="">— Add merchant —</option></select>';
    h += '<button class="btn btn-sm btn-outline" style="padding:2px 8px;font-size:11px;" data-on-click="refreshAlwaysMarginMerchants(\'' + side + '\')" title="Refresh list">↻</button>';
    h += '</div>';
    h += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:4px;">When one of these merchants is the top competitor, the ad places at his rate + your margin instead of exact-matching him. Other merchants behave normally.</div>';
    h += '</div>';
    // Excluded merchants
    var exclMids = coinCfg.excludedMerchantIds || [];
   h += '<div style="margin-bottom:10px;"><div style="font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">Exclude merchants from price calculation:</div>';
   h += '<div class="trailing-excl-merchant-list-' + side + '" style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:4px;">';
   if (exclMids.length > 0) {
     exclMids.forEach(function(mid) {
       h += '<span class="trailing-excl-mid-tag-' + side + '" data-mid="' + esc(mid) + '" style="display:inline-flex;align-items:center;gap:4px;background:rgba(244,67,54,0.15);border:1px solid rgba(244,67,54,0.3);border-radius:4px;padding:2px 6px;font-size:11px;"><span>' + esc(mid.slice(-8)) + '</span><span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" data-on-click="removeExcludedMerchant(\'' + side + '\',\'' + esc(mid) + '\')">×</span></span>';
     });
   } else {
     h += '<span style="font-size:11px;color:var(--text-quaternary);">No merchants excluded</span>';
   }
   h += '</div>';
    h += '<div style="display:flex;gap:4px;align-items:center;">';
    h += '<select class="trailing-excl-merchant-add-' + side + '" style="flex:1;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:11px;" data-on-change="addExcludedMerchant(\'' + side + '\')"><option value="">— Exclude merchant —</option></select>';
    h += '<button class="btn btn-sm btn-outline" style="padding:2px 8px;font-size:11px;" data-on-click="refreshMerchants(\'' + side + '\')" title="Refresh list">↻</button>';
    h += '</div>';
    h += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:2px;">Excluded merchants are ignored when computing best competitor price.</div></div>';
  // Ad selection
    var filteredAds = userAds.filter(function(a) { return (a.side || '').toLowerCase() === side; });
  var coinAds = filteredAds.filter(function(a) { return ((a.cryptoCurrency || 'USDT') || '').toUpperCase() === selCrypto; });
  h += '<div style="margin-bottom:10px;"><div style="font-size:12px;color:var(--text-tertiary);margin-bottom:6px;">Apply ' + sideLabel + ' trailing to <span style="color:var(--text-quaternary);font-weight:400;">(uncheck all = all ' + sideLabel + ' ' + selCrypto + ' ads)</span>:</div>';
  h += '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:4px;">Showing <strong style="color:#4caf50;">' + esc(selCrypto) + '</strong> ads only (active crypto).</div>';
  if (coinAds.length === 0) {
    h += '<div style="font-size:11px;color:var(--text-quaternary);">No ' + selCrypto + ' ' + sideLabel + ' ads available</div>';
  } else {
    coinAds.forEach(function(ad) {
      var adId = ad.adId || ad.ad_id || '';
      var shortId = adId.slice(-8);
      var ccy = (ad.cryptoCurrency || '').toUpperCase() || 'USDT';
      var label = ccy + ' ' + (ad.type === 'floating_market' ? (ad.priceMargin || '?') + '%' : (ad.unitPrice || '?')) + ' (…' + shortId + ')';
      var checked = selectedIds.indexOf(adId) !== -1 ? 'checked' : '';
      h += '<label style="display:flex;align-items:center;gap:6px;font-size:11px;padding:2px 0;cursor:pointer;"><input type="checkbox" class="trailing-ad-cb-' + side + '" value="' + esc(adId) + '" ' + checked + ' data-on-change="saveTrailingConfig()"> ' + esc(label) + '</label>';
    });
  }
  h += '</div>';
  h += '<div style="display:flex;gap:6px;"><button class="btn btn-sm btn-primary" data-on-click="runTrailingSide(\'' + side + '\')">▶ Run ' + sideLabel + '</button><button class="btn btn-sm btn-danger" data-on-click="stopTrailingSide(\'' + side + '\')">⏹ Stop ' + sideLabel + '</button></div>';
  h += '</div>';
  return h;
}

window.switchTrailingTab = function(side) {
  if (document.getElementById('trailing-buy-panel').style.display === (side === 'buy' ? 'block' : 'none') &&
      document.getElementById('trailing-sell-panel').style.display === (side === 'sell' ? 'block' : 'none')) return;
  _trailingTab = side;
  document.getElementById('trailing-buy-panel').style.display = side === 'buy' ? 'block' : 'none';
  document.getElementById('trailing-sell-panel').style.display = side === 'sell' ? 'block' : 'none';
  var btnBuy = document.querySelector('[data-on-click="switchTrailingTab(\'buy\')"]');
  var btnSell = document.querySelector('[data-on-click="switchTrailingTab(\'sell\')"]');
  if (btnBuy) btnBuy.className = 'btn btn-sm ' + (side === 'buy' ? 'btn-primary' : 'btn-outline');
  if (btnSell) btnSell.className = 'btn btn-sm ' + (side === 'sell' ? 'btn-primary' : 'btn-outline');
};

window.switchTrailingCoin = async function(side, coin) {
  try {
    var cfgRes = await API.get('/api/okx/p2p/trailing/config');
    var cfg = cfgRes.data || {};
    if (!cfg[side]) cfg[side] = { activeCoin: 'USDT', coins: {} };
    if (!cfg[side].coins) cfg[side].coins = {};
    // Persist the visible form values into the currently-active coin before switching
    var curCfg = readTrailingSideCfg(side);
    var curCoin = curCfg.cryptoCurrency || cfg[side].activeCoin || 'USDT';
    if (cfg[side].coins[curCoin]) {
      Object.keys(curCfg).forEach(function(k) {
        if (k !== 'cryptoCurrency') cfg[side].coins[curCoin][k] = curCfg[k];
      });
    }
    cfg[side].activeCoin = coin.toUpperCase();
    if (!cfg[side].coins[cfg[side].activeCoin]) cfg[side].coins[cfg[side].activeCoin] = {};
    await API.post('/api/okx/p2p/trailing/config', { buy: cfg.buy, sell: cfg.sell });
    // Persist: POST /config only updates memory. Without this the coin switch
    // or the added coin is gone after a restart - that is the "trailing config
    // wipe" the merchant saw.
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    loadTrailingConfig();
  } catch (err) { showToast(err.message, 'error'); }
};

window.addTrailingCoin = async function(side) {
  var sel = document.querySelector('.trailing-coin-add-' + side);
  if (!sel || !sel.value) return;
  var coin = sel.value.toUpperCase();
  sel.value = '';
  try {
    var cfgRes = await API.get('/api/okx/p2p/trailing/config');
    var cfg = cfgRes.data || {};
    if (!cfg[side]) cfg[side] = { activeCoin: 'USDT', coins: {} };
    if (!cfg[side].coins) cfg[side].coins = {};
    var curCfg = readTrailingSideCfg(side);
    var curCoin = curCfg.cryptoCurrency || cfg[side].activeCoin || 'USDT';
    if (cfg[side].coins[curCoin]) {
      Object.keys(curCfg).forEach(function(k) {
        if (k !== 'cryptoCurrency') cfg[side].coins[curCoin][k] = curCfg[k];
      });
    }
    if (!cfg[side].coins[coin]) cfg[side].coins[coin] = {};
    cfg[side].activeCoin = coin;
    await API.post('/api/okx/p2p/trailing/config', { buy: cfg.buy, sell: cfg.sell });
    // Persist: POST /config only updates memory. Without this the coin switch
    // or the added coin is gone after a restart - that is the "trailing config
    // wipe" the merchant saw.
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    loadTrailingConfig();
  } catch (err) { showToast(err.message, 'error'); }
};

var _trailingMerchantNames = {};

async function loadTrailingMerchants(buySelectedIds, sellSelectedIds, buyCrypto, buyFiat, sellCrypto, sellFiat) {
  try {
    buyCrypto = buyCrypto || 'USDT'; buyFiat = buyFiat || 'KES';
    sellCrypto = sellCrypto || 'USDT'; sellFiat = sellFiat || 'KES';
    var [buyRes, sellRes] = await Promise.all([
      API.get('/api/p2p/marketplace-list?side=buy&cryptoCurrency=' + buyCrypto + '&fiatCurrency=' + buyFiat + '&limit=50'),
      API.get('/api/p2p/marketplace-list?side=sell&cryptoCurrency=' + sellCrypto + '&fiatCurrency=' + sellFiat + '&limit=50')
    ]);
    var buyData = Array.isArray(buyRes.data) ? buyRes.data : [];
    var buyAds = buyData.length > 0 && Array.isArray(buyData[0].buyAds) ? buyData[0].buyAds : buyData;
    var sellData = Array.isArray(sellRes.data) ? sellRes.data : [];
    var sellAds = sellData.length > 0 && Array.isArray(sellData[0].sellAds) ? sellData[0].sellAds : sellData;
    var allAds = buyAds.concat(sellAds);
    var seen = {};
    var merchants = [];
    allAds.forEach(function(ad) {
      var cr = ad.creator || {};
      var mid = cr.userId || cr.user_id || '';
      if (mid && !seen[mid]) { seen[mid] = true; merchants.push({ id: mid, name: cr.nickName || cr.nick_name || mid.slice(-8) }); }
    });
    merchants.sort(function(a, b) { return a.name.localeCompare(b.name); });
    merchants.forEach(function(m) { _trailingMerchantNames[m.id] = m.name; });
    ['buy', 'sell'].forEach(function(s) {
      var el = document.querySelector('.trailing-merchant-add-' + s);
      if (el) {
        el.innerHTML = '<option value="">— Add merchant —</option>';
        merchants.forEach(function(m) { el.innerHTML += '<option value="' + esc(m.id) + '">' + esc(m.name) + '</option>'; });
      }
      var exclEl = document.querySelector('.trailing-excl-merchant-add-' + s);
      if (exclEl) {
        exclEl.innerHTML = '<option value="">— Exclude merchant —</option>';
        merchants.forEach(function(m) { exclEl.innerHTML += '<option value="' + esc(m.id) + '">' + esc(m.name) + '</option>'; });
      }
    });
    // Always-margin dropdowns: first 50 merchants from the side's marketplace list
    function sideMerchants(ads) {
      var seen = {};
      var out = [];
      (ads || []).forEach(function(ad) {
        var cr = ad.creator || {};
        var mid = cr.userId || cr.user_id || '';
        if (mid && !seen[mid]) { seen[mid] = true; out.push({ id: mid, name: cr.nickName || cr.nick_name || mid.slice(-8) }); }
      });
      return out.slice(0, 50);
    }
    var buyMers = sideMerchants(buyAds);
    var sellMers = sideMerchants(sellAds);
    ['buy', 'sell'].forEach(function(s) {
      var sel = document.querySelector('.trailing-always-margin-add-' + s);
      if (!sel) return;
      var list = s === 'buy' ? buyMers : sellMers;
      var current = Array.from(document.querySelectorAll('.trailing-always-margin-tag-' + s)).map(function(t) { return t.getAttribute('data-mid'); }).filter(function(id) { return id; });
      var all = list.slice();
      current.forEach(function(mid) {
        if (!all.some(function(m) { return m.id === mid; })) all.push({ id: mid, name: mid.slice(-8) });
      });
      sel.innerHTML = '<option value="">— Add merchant —</option>';
      all.forEach(function(m) { sel.innerHTML += '<option value="' + esc(m.id) + '">' + esc(m.name) + '</option>'; });
    });
  } catch (err) { /* ignore */ }
}

window.refreshMerchants = function(side) {
  var selBuy = document.querySelector('.trailing-merchant-add-buy');
  var selSell = document.querySelector('.trailing-merchant-add-sell');
  var buyCrypto = (document.querySelector('.trailing-active-coin-buy') || {}).value || 'USDT';
  var buyFiat = (document.querySelector('.trailing-fiat-buy') || {}).value || 'KES';
  var sellCrypto = (document.querySelector('.trailing-active-coin-sell') || {}).value || 'USDT';
  var sellFiat = (document.querySelector('.trailing-fiat-sell') || {}).value || 'KES';
  if (selBuy) selBuy.innerHTML = '<option value="">Refreshing...</option>';
  if (selSell) selSell.innerHTML = '<option value="">Refreshing...</option>';
  loadTrailingMerchants([], [], buyCrypto, buyFiat, sellCrypto, sellFiat);
  populateFollowMerchants();
};

// Feature: fill trailing merchant dropdowns from the merchants you follow
async function populateFollowMerchants() {
  try {
    var res = await API.get('/api/p2p/merchant/followings?pageLength=100');
    var rawResD = res.data;
    var list = Array.isArray(rawResD) ? rawResD : (Array.isArray(rawResD && rawResD.list) ? rawResD.list : []);
    if (list.length === 0) return;
    var row = function(f) {
      var id = f.userId || f.id || f.merchantId || '';
      var name = f.Nickname || f.nickName || f.nickname || (id ? id.slice(-8) : '?');
      return '<option value="' + esc(id) + '">⭐ ' + esc(name) + ' (follow)</option>';
    };
['buy', 'sell'].forEach(function(s) {
      var els = [document.querySelector('.trailing-merchant-add-' + s), document.querySelector('.trailing-excl-merchant-add-' + s)];
      els.forEach(function(el) {
        if (!el) return;
        list.forEach(function(f) { el.insertAdjacentHTML('beforeend', opt(f)); });
      });
      var sel = document.querySelector('.trailing-always-margin-add-' + s);
      if (sel) list.forEach(function(f) { sel.insertAdjacentHTML('beforeend', opt(f)); });
    });
  } catch (e) { /* ignore */ }
}

window.addTrailingMerchant = function(side) {
  var el = document.querySelector('.trailing-merchant-add-' + side);
  if (!el || !el.value) return;
  var mid = el.value;
  var name = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : mid.slice(-8);
  el.value = '';
  var tags = document.querySelectorAll('.trailing-merchant-tag-' + side);
  if (tags.length >= 5) { showToast('Max 5 merchants allowed', 'error'); return; }
  for (var i = 0; i < tags.length; i++) { if (tags[i].getAttribute('data-mid') === mid) { showToast('Already selected', 'error'); return; } }
  var list = document.querySelector('.trailing-merchant-list-' + side);
  if (!list) return;
  var placeholder = list.querySelector('span:only-child');
  if (placeholder && placeholder.textContent === 'No merchants selected') placeholder.remove();
  list.innerHTML += '<span class="trailing-merchant-tag-' + side + '" data-mid="' + esc(mid) + '" style="display:inline-flex;align-items:center;gap:4px;background:rgba(68,138,255,0.15);border:1px solid rgba(68,138,255,0.3);border-radius:4px;padding:2px 6px;font-size:11px;"><span>' + esc(name) + '</span><span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" data-on-click="removeTrailingMerchant(\'' + side + '\',\'' + esc(mid) + '\')">×</span></span>';
  var count = list.querySelectorAll('.trailing-merchant-tag-' + side).length;
  var countEl = document.querySelector('.trailing-merchant-count-' + side);
  if (countEl) countEl.textContent = count + '/5';
  saveTrailingConfig();
};

window.addExcludedMerchant = function(side) {
  var el = document.querySelector('.trailing-excl-merchant-add-' + side);
  if (!el || !el.value) return;
  var mid = el.value;
  var name = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : mid.slice(-8);
  el.value = '';
  var tags = document.querySelectorAll('.trailing-excl-mid-tag-' + side);
  for (var i = 0; i < tags.length; i++) { if (tags[i].getAttribute('data-mid') === mid) { showToast('Already excluded', 'error'); return; } }
  var list = document.querySelector('.trailing-excl-merchant-list-' + side);
  if (!list) return;
  var ph = list.querySelector('span:only-child');
  if (ph && ph.textContent === 'No merchants excluded') ph.remove();
  list.innerHTML += '<span class="trailing-excl-mid-tag-' + side + '" data-mid="' + esc(mid) + '" style="display:inline-flex;align-items:center;gap:4px;background:rgba(244,67,54,0.15);border:1px solid rgba(244,67,54,0.3);border-radius:4px;padding:2px 6px;font-size:11px;"><span>' + esc(name) + '</span><span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" data-on-click="removeExcludedMerchant(\'' + side + '\',\'' + esc(mid) + '\')">×</span></span>';
  saveTrailingConfig();
};

window.removeExcludedMerchant = function(side, mid) {
  var tag = document.querySelector('.trailing-excl-mid-tag-' + side + '[data-mid="' + mid + '"]');
  if (tag) tag.remove();
  var list = document.querySelector('.trailing-excl-merchant-list-' + side);
  if (list && list.children.length === 0) list.innerHTML = '<span style="font-size:11px;color:var(--text-quaternary);">No merchants excluded</span>';
  saveTrailingConfig();
};

window.removeTrailingMerchant = function(side, mid) {
  var tags = document.querySelectorAll('.trailing-merchant-tag-' + side + '[data-mid="' + mid + '"]');
  for (var i = 0; i < tags.length; i++) tags[i].remove();
  var list = document.querySelector('.trailing-merchant-list-' + side);
  var remaining = list ? list.querySelectorAll('.trailing-merchant-tag-' + side).length : 0;
  if (remaining === 0 && list) list.innerHTML = '<span style="font-size:11px;color:var(--text-quaternary);">No merchants selected</span>';
  var countEl = document.querySelector('.trailing-merchant-count-' + side);
  if (countEl) countEl.textContent = remaining + '/5';
  saveTrailingConfig();
};

window.onVerifiedMatchToggle = function(side) {
  var section = document.querySelector('.trailing-always-margin-section-' + side);
  var cb = document.querySelector('.trailing-verified-match-' + side);
  if (section && cb) section.style.display = cb.checked ? 'block' : 'none';
  saveTrailingConfig();
};

window.addAlwaysMarginMerchant = function(side) {
  var el = document.querySelector('.trailing-always-margin-add-' + side);
  if (!el || !el.value) return;
  var mid = el.value;
  var name = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : mid.slice(-8);
  el.value = '';
  var tags = document.querySelectorAll('.trailing-always-margin-tag-' + side);
  if (tags.length >= 5) { showToast('Max 5 merchants allowed', 'error'); return; }
  for (var i = 0; i < tags.length; i++) { if (tags[i].getAttribute('data-mid') === mid) { showToast('Already selected', 'error'); return; } }
  var list = document.querySelector('.trailing-always-margin-list-' + side);
  if (!list) return;
  var placeholder = list.querySelector('span:only-child');
  if (placeholder && placeholder.textContent === 'No merchants selected') placeholder.remove();
  list.innerHTML += '<span class="trailing-always-margin-tag-' + side + '" data-mid="' + esc(mid) + '" style="display:inline-flex;align-items:center;gap:4px;background:rgba(156,39,176,0.15);border:1px solid rgba(156,39,176,0.3);border-radius:4px;padding:2px 6px;font-size:11px;"><span>' + esc(name) + '</span><span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" data-on-click="removeAlwaysMarginMerchant(\'' + side + '\',\'' + esc(mid) + '\')">×</span></span>';
  var count = list.querySelectorAll('.trailing-always-margin-tag-' + side).length;
  var countEl = document.querySelector('.trailing-always-margin-count-' + side);
  if (countEl) countEl.textContent = count + '/5';
  saveTrailingConfig();
};

window.removeAlwaysMarginMerchant = function(side, mid) {
  var tags = document.querySelectorAll('.trailing-always-margin-tag-' + side + '[data-mid="' + mid + '"]');
  for (var i = 0; i < tags.length; i++) tags[i].remove();
  var list = document.querySelector('.trailing-always-margin-list-' + side);
  var remaining = list ? list.querySelectorAll('.trailing-always-margin-tag-' + side).length : 0;
  if (remaining === 0 && list) list.innerHTML = '<span style="font-size:11px;color:var(--text-quaternary);">No merchants selected</span>';
  var countEl = document.querySelector('.trailing-always-margin-count-' + side);
  if (countEl) countEl.textContent = remaining + '/5';
  saveTrailingConfig();
};

window.refreshAlwaysMarginMerchants = function(side) {
  var el = document.querySelector('.trailing-always-margin-add-' + side);
  if (el) el.innerHTML = '<option value="">Refreshing...</option>';
  var buyCrypto = (document.querySelector('.trailing-active-coin-buy') || {}).value || 'USDT';
  var buyFiat = (document.querySelector('.trailing-fiat-buy') || {}).value || 'KES';
  var sellCrypto = (document.querySelector('.trailing-active-coin-sell') || {}).value || 'USDT';
  var sellFiat = (document.querySelector('.trailing-fiat-sell') || {}).value || 'KES';
  loadTrailingMerchants([], [], buyCrypto, buyFiat, sellCrypto, sellFiat);
};

window.trailModeChanged = function(side) {
  var modeEl = document.querySelector('.trailing-mode-' + side);
  if (!modeEl) return;
  var mode = modeEl.value;
  var merchSection = document.querySelector('.trailing-merchant-section-' + side);
  var priceSection = document.querySelector('.trailing-price-section-' + side);
  var bpSection = document.querySelector('.trailing-bp-section-' + side);
  var rangeSection = document.querySelector('.trailing-range-section-' + side);
  if (merchSection) merchSection.style.display = mode === 'merchant' ? 'block' : 'none';
  if (priceSection) priceSection.style.display = mode === 'price' ? 'block' : 'none';
  if (bpSection) bpSection.style.display = 'inline';
  if (rangeSection) rangeSection.style.display = mode === 'market' ? 'inline' : 'none';
  saveTrailingConfig();
};

window.onMarginTypeChange = function(side) {
  var el = document.querySelector('.trailing-margin-type-' + side);
  if (!el) return;
  var type = el.value;
  var labelEl = document.querySelector('.trailing-margin-label-' + side);
  if (labelEl) labelEl.textContent = type === 'percent' ? 'Margin (%)' : 'Margin (KES)';
  var inputEl = document.querySelector('.trailing-margin-' + side);
  if (inputEl) inputEl.step = type === 'percent' ? '0.1' : '0.01';
  saveTrailingConfig();
};

window.trailingAdTypeChanged = function(side) {
  var el = document.querySelector('.trailing-ad-type-' + side);
  var val = el ? el.value : 'both';
  var limitSection = document.querySelector('.trailing-limit-section-' + side);
  if (limitSection) limitSection.style.display = val === 'floating' ? 'none' : 'block';
  saveTrailingConfig();
};

var _saveTrailingConfigTimer = null;
var _saveTrailingConfigPending = false;
window.saveTrailingConfig = function() {
  // Debounce: input changes fire saveTrailingConfig() rapidly (interval change,
  // margin change, ad type change, mode change, etc.) — collapse them into one
  // roundtrip to avoid 429 rate limits.
  clearTimeout(_saveTrailingConfigTimer);
  _saveTrailingConfigTimer = setTimeout(function() {
    _saveTrailingConfigNow();
  }, 800);
};

window._saveTrailingConfigNow = async function() {
  if (_saveTrailingConfigPending) {
    // A save is already in flight — queue one more run to flush the latest state
    clearTimeout(_saveTrailingConfigTimer);
    _saveTrailingConfigTimer = setTimeout(function() { _saveTrailingConfigNow(); }, 500);
    return;
  }
  _saveTrailingConfigPending = true;
  try {
    var cfgRes = await API.get('/api/okx/p2p/trailing/config');
    var cfg = cfgRes.data || {};
    if (!cfg.buy) cfg.buy = { activeCoin: 'USDT', coins: {} };
    if (!cfg.sell) cfg.sell = { activeCoin: 'USDT', coins: {} };
    ['buy', 'sell'].forEach(function(side) {
      if (!cfg[side].coins) cfg[side].coins = {};
      if (!cfg[side].activeCoin) cfg[side].activeCoin = 'USDT';
      var coinCfg = readTrailingSideCfg(side);
      var activeCoin = coinCfg.cryptoCurrency || cfg[side].activeCoin || 'USDT';
      cfg[side].activeCoin = activeCoin;
      if (!cfg[side].coins[activeCoin]) cfg[side].coins[activeCoin] = {};
      Object.keys(coinCfg).forEach(function(k) {
        if (k !== 'cryptoCurrency') cfg[side].coins[activeCoin][k] = coinCfg[k];
      });
    });
    await API.post('/api/okx/p2p/trailing/config', { buy: cfg.buy, sell: cfg.sell });
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    // Sync persistent job state for each side
    for (var si = 0; si < 2; si++) {
      var side = ['buy', 'sell'][si];
      var coinCfg = readTrailingSideCfg(side);
      if (coinCfg.persistent) {
        await API.post('/api/okx/p2p/trailing/start', { side: side, duration: coinCfg.trailDurationHours || 0 });
      } else {
        try { await API.post('/api/okx/p2p/trailing/stop', { side: side }); } catch (e) {}
      }
    }
    showToast('Trailing config saved', 'success');
  } catch (err) { showToast(err.message, 'error'); }
  finally {
    _saveTrailingConfigPending = false;
  }
};

window.setBuyFiatBudget = async function(side) {
  try {
    var input = document.querySelector('.trailing-buy-fiat-' + side);
    if (!input) return showToast('Buy fiat field not found', 'error');
    var v = parseFloat(input.value);
    if (!(v >= 0)) { showToast('Enter a valid KES amount', 'error'); return; }
    var hiddenAt = document.querySelector('.trailing-buy-fiat-at-' + side);
    if (hiddenAt) hiddenAt.value = Date.now();
    await _saveTrailingConfigNow();
    showToast('Buy fiat budget set to KES ' + v.toFixed(2) + (v === 0 ? ' — ad keeps its own amount' : ' — ad now follows this budget'), 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

function readTrailingSideCfg(side) {
  var cfg = {
    cryptoCurrency: (document.querySelector('.trailing-active-coin-' + side) ? document.querySelector('.trailing-active-coin-' + side).value : 'USDT').toUpperCase(),
    enabled: document.querySelector('.trailing-enabled-' + side) ? document.querySelector('.trailing-enabled-' + side).checked : false,
    fiatCurrency: (document.querySelector('.trailing-fiat-' + side) ? document.querySelector('.trailing-fiat-' + side).value : 'KES').toUpperCase(),
    persistent: document.querySelector('.trailing-persistent-' + side) ? document.querySelector('.trailing-persistent-' + side).checked : false,
    intervalMin: parseFloat(document.querySelector('.trailing-interval-' + side) ? document.querySelector('.trailing-interval-' + side).value : '1'),
    trailDurationHours: parseInt(document.querySelector('.trailing-duration-' + side) ? document.querySelector('.trailing-duration-' + side).value : '0'),
    trailMode: document.querySelector('.trailing-mode-' + side) ? document.querySelector('.trailing-mode-' + side).value : 'price',
    basePrice: document.querySelector('.trailing-bp-' + side) ? document.querySelector('.trailing-bp-' + side).value : '',
    rangeMargin: parseFloat(document.querySelector('.trailing-range-margin-' + side) ? document.querySelector('.trailing-range-margin-' + side).value : '0.2'),
    trailMargin: parseFloat(document.querySelector('.trailing-margin-' + side) ? document.querySelector('.trailing-margin-' + side).value : '0.01'),
    marginType: document.querySelector('.trailing-margin-type-' + side) ? document.querySelector('.trailing-margin-type-' + side).value : 'fixed',
    trailPaymentDuration: parseInt(document.querySelector('.trailing-pay-dur-' + side) ? document.querySelector('.trailing-pay-dur-' + side).value : '15'),
    trailMerchantIds: Array.from(document.querySelectorAll('.trailing-merchant-tag-' + side)).map(function(el) { return el.getAttribute('data-mid'); }).filter(function(id) { return id; }),
    trailPriceTarget: parseFloat(document.querySelector('.trailing-price-target-' + side) ? document.querySelector('.trailing-price-target-' + side).value : '0'),
    priceTargetUseMaxLimit: document.querySelector('.trailing-price-use-max-' + side) ? document.querySelector('.trailing-price-use-max-' + side).checked : false,
    trailPriceTargetMax: parseFloat(document.querySelector('.trailing-price-max-' + side) ? document.querySelector('.trailing-price-max-' + side).value : '0'),
    priceCap: parseFloat(document.querySelector('.trailing-price-cap-' + side) ? document.querySelector('.trailing-price-cap-' + side).value : '0'),
    priceFilterMargin: parseFloat(document.querySelector('.trailing-price-filter-margin-' + side) ? document.querySelector('.trailing-price-filter-margin-' + side).value : '0'),
    priceFilterMarginType: document.querySelector('.trailing-price-filter-type-' + side) ? document.querySelector('.trailing-price-filter-type-' + side).value : 'fixed',
    trailAdType: document.querySelector('.trailing-ad-type-' + side) ? document.querySelector('.trailing-ad-type-' + side).value : 'both',
    excludedMerchantIds: Array.from(document.querySelectorAll('.trailing-excl-mid-tag-' + side)).map(function(el) { return el.getAttribute('data-mid'); }).filter(function(id) { return id; }),
    excludeOffline: document.querySelector('.trailing-exclude-offline-' + side) ? document.querySelector('.trailing-exclude-offline-' + side).checked : false,
    unverifiedMatch: document.querySelector('.trailing-unverified-match-' + side) ? document.querySelector('.trailing-unverified-match-' + side).checked : false,
    verifiedMatch: document.querySelector('.trailing-verified-match-' + side) ? document.querySelector('.trailing-verified-match-' + side).checked : false,
    alwaysMarginMerchantIds: Array.from(document.querySelectorAll('.trailing-always-margin-tag-' + side)).map(function(el) { return el.getAttribute('data-mid'); }).filter(function(id) { return id; }),
    matchExact: document.querySelector('.trailing-match-exact-' + side) ? document.querySelector('.trailing-match-exact-' + side).checked : false,
    rankMatch: document.querySelector('.trailing-rank-match-' + side) ? document.querySelector('.trailing-rank-match-' + side).checked : false,
    verifiedOnly: document.querySelector('.trailing-verified-only-' + side) ? document.querySelector('.trailing-verified-only-' + side).checked : false,
    maxBuyAmountUSDT: parseFloat(document.querySelector('.trailing-max-buy-' + side) ? document.querySelector('.trailing-max-buy-' + side).value : '0') || 0,
    buyFiatBudget: parseFloat(document.querySelector('.trailing-buy-fiat-' + side) ? document.querySelector('.trailing-buy-fiat-' + side).value : '0') || 0,
    minBalanceUSDT: parseFloat(document.querySelector('.trailing-min-balance-' + side) ? document.querySelector('.trailing-min-balance-' + side).value : '0') || 0,
    adIds: Array.from(document.querySelectorAll('.trailing-ad-cb-' + side + ':checked')).map(function(cb) { return cb.value; })
  };
  // Always send the anchor, even when the hidden field is absent. The server
  // accepts a budget/anchor change only when the incoming anchor is strictly
  // newer than the stored one, so an explicit 0 here states plainly "this save
  // is not an Apply budget" instead of leaving the key undefined and relying on
  // how the merge happens to treat a missing field.
  var _buyAt = document.querySelector('.trailing-buy-fiat-at-' + side);
  cfg.buyFiatBudgetSetAt = (_buyAt && _buyAt.value) ? (parseInt(_buyAt.value, 10) || 0) : 0;
  return cfg;
}

window.updateTrailingStatus = async function() {
  try {
    var res = await API.get('/api/okx/p2p/trailing/persistent');
    var p = res.data || {};
    var btnBuy = document.querySelector('[data-on-click="switchTrailingTab(\'buy\')"]');
    var btnSell = document.querySelector('[data-on-click="switchTrailingTab(\'sell\')"]');
    function setBadge(btn, job) {
      if (!btn) return;
      var existing = btn.querySelector('span');
      var badge = job ? '<span style="color:#4caf50;font-size:10px;">● ACTIVE' + (job.durationHours > 0 ? ' ' + job.durationHours + 'h' : '') + '</span>' : '';
      if (existing) existing.outerHTML = badge;
      else btn.insertAdjacentHTML('beforeend', badge);
    }
    setBadge(btnBuy, p.buy);
    setBadge(btnSell, p.sell);
  } catch (e) {}
};

// Mobile networks silently kill idle keep-alive TCP connections (NAT timeouts).
// A POST fired right after a few seconds of editing then rides a dead connection
// and fails with 'Failed to fetch' — browsers never auto-retry POSTs. Retry once
// on a fresh connection; the trailing/run endpoint is idempotent (re-checks ads).
async function _runTrailingWithRetry() {
  var lastErr;
  for (var attempt = 0; attempt < 2; attempt++) {
    try {
      return await API.post('/api/okx/p2p/trailing/run', {}, 120000);
    } catch (err) {
      lastErr = err;
      var msg = String(err && err.message || err);
      if (msg.indexOf('Failed to fetch') === -1 && msg.indexOf('fetch failed') === -1 &&
          msg.indexOf('NetworkError') === -1 && msg.indexOf('timed out') === -1) throw err;
      await new Promise(function(r) { setTimeout(r, 1200); });
    }
  }
  throw lastErr;
}

window.runTrailingNow = async function() {
  try {
    var cfgRes = await API.get('/api/okx/p2p/trailing/config');
    var cfg = cfgRes.data || {};
    if (!cfg.buy) cfg.buy = { activeCoin: 'USDT', coins: {} };
    if (!cfg.sell) cfg.sell = { activeCoin: 'USDT', coins: {} };
    ['buy', 'sell'].forEach(function(side) {
      if (!cfg[side].coins) cfg[side].coins = {};
      if (!cfg[side].activeCoin) cfg[side].activeCoin = 'USDT';
      var coinCfg = readTrailingSideCfg(side);
      var activeCoin = coinCfg.cryptoCurrency || cfg[side].activeCoin || 'USDT';
      cfg[side].activeCoin = activeCoin;
      if (!cfg[side].coins[activeCoin]) cfg[side].coins[activeCoin] = {};
      cfg[side].coins[activeCoin].enabled = true;
      Object.keys(coinCfg).forEach(function(k) {
        if (k !== 'cryptoCurrency' && k !== 'enabled') cfg[side].coins[activeCoin][k] = coinCfg[k];
      });
    });
    await API.post('/api/okx/p2p/trailing/config', { buy: cfg.buy, sell: cfg.sell });
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    if (cfg.buy.coins[cfg.buy.activeCoin].persistent) {
      await API.post('/api/okx/p2p/trailing/start', { side: 'buy', duration: cfg.buy.coins[cfg.buy.activeCoin].trailDurationHours || 0 });
    }
    if (cfg.sell.coins[cfg.sell.activeCoin].persistent) {
      await API.post('/api/okx/p2p/trailing/start', { side: 'sell', duration: cfg.sell.coins[cfg.sell.activeCoin].trailDurationHours || 0 });
    }
    var res = await _runTrailingWithRetry();
    var data = res.data || {};
    var changes = data.changes || [];
    var adChanges = changes.filter(function(c) { return typeof c === 'string' && /^\d+$/.test(c); });
    if (adChanges.length === 0) showToast('Trailing run complete — no changes', 'info');
    else showToast(adChanges.length + ' ad(s) updated', 'success');
    var logEl = document.getElementById('trailing-log');
    if (logEl && data.logs) {
      logEl.innerHTML = data.logs.map(function(l) { return '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; }).join('');
    }
  } catch (err) { showToast(err.message, 'error'); }
};

window.clearTrailingLog = async function() {
  try {
    await API.post('/api/okx/p2p/trailing/log/clear', {});
    var logEl = document.getElementById('trailing-log');
    if (logEl) logEl.innerHTML = '<div style="color:var(--text-quaternary);">No trailing activity yet</div>';
    showToast('Trailing log cleared', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

window.runTrailingSide = async function(side) {
  try {
    var cfgRes = await API.get('/api/okx/p2p/trailing/config');
    var cfg = cfgRes.data || {};
    if (!cfg[side]) cfg[side] = { activeCoin: 'USDT', coins: {} };
    if (!cfg[side].coins) cfg[side].coins = {};
    if (!cfg[side].activeCoin) cfg[side].activeCoin = 'USDT';
    var coinCfg = readTrailingSideCfg(side);
    var activeCoin = coinCfg.cryptoCurrency || cfg[side].activeCoin || 'USDT';
    cfg[side].activeCoin = activeCoin;
    if (!cfg[side].coins[activeCoin]) cfg[side].coins[activeCoin] = {};
    cfg[side].coins[activeCoin].enabled = true;
    Object.keys(coinCfg).forEach(function(k) {
      if (k !== 'cryptoCurrency' && k !== 'enabled') cfg[side].coins[activeCoin][k] = coinCfg[k];
    });
    var other = side === 'buy' ? 'sell' : 'buy';
    if (!cfg[other]) cfg[other] = { activeCoin: 'USDT', coins: {} };
    var otherCoinCfg = readTrailingSideCfg(other);
    var otherActiveCoin = otherCoinCfg.cryptoCurrency || cfg[other].activeCoin || 'USDT';
    cfg[other].activeCoin = otherActiveCoin;
    if (!cfg[other].coins[otherActiveCoin]) cfg[other].coins[otherActiveCoin] = {};
    Object.keys(otherCoinCfg).forEach(function(k) {
      if (k !== 'cryptoCurrency' && k !== 'enabled') cfg[other].coins[otherActiveCoin][k] = otherCoinCfg[k];
    });
    await API.post('/api/okx/p2p/trailing/config', { buy: cfg.buy, sell: cfg.sell });
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    if (coinCfg.persistent) {
      var duration = coinCfg.trailDurationHours || 0;
      var res = await API.post('/api/okx/p2p/trailing/start', { side: side, duration: duration });
      // Do an initial run for immediate feedback
      var runRes = await _runTrailingWithRetry();
      var runData = runRes.data || {};
      var runChanges = runData.changes || [];
      var sideChanges = runChanges.filter(function(c) { return c.indexOf('[' + side + ']') !== -1; });
      var msg = 'Persistent ' + side + ' trailing started' + (duration > 0 ? ' for ' + duration + 'h' : '');
      if (sideChanges.length > 0) msg += ' — ' + sideChanges.length + ' ad(s) updated';
      showToast(msg, 'success');
      var logEl = document.getElementById('trailing-log');
      if (logEl && runData.logs) {
        logEl.innerHTML = runData.logs.map(function(l) { return '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; }).join('');
      }
      updateTrailingStatus();
    } else {
      // Stop any persistent job first, then run once
      try { await API.post('/api/okx/p2p/trailing/stop', { side: side }); } catch (e) {}
      var res = await _runTrailingWithRetry();
      var data = res.data || {};
      var changes = data.changes || [];
      var sideChanges = changes.filter(function(c) { return c.indexOf('[' + side + ']') !== -1; });
      if (sideChanges.length === 0) showToast(side + ' trailing run — no changes', 'info');
      else showToast(sideChanges.length + ' ' + side + ' ad(s) updated', 'success');
      var logEl = document.getElementById('trailing-log');
      if (logEl && data.logs) {
        logEl.innerHTML = data.logs.map(function(l) { return '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; }).join('');
      }
    }
  } catch (err) { showToast(err.message, 'error'); }
};

window.toggleTrailingLog = function() {
  var el = document.getElementById('trailing-log');
  if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none';
};

window.stopTrailing = async function() {
  try {
    try { await API.post('/api/okx/p2p/trailing/stop', { side: 'buy' }); } catch (e) {}
    try { await API.post('/api/okx/p2p/trailing/stop', { side: 'sell' }); } catch (e) {}
    await API.post('/api/okx/p2p/trailing/config', { buy: { enabled: false }, sell: { enabled: false } });
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    showToast('Both sides stopped', 'success');
    var logEl = document.getElementById('trailing-log');
    if (logEl) {
      logEl.innerHTML = '<div style="color:var(--text-quaternary);">Trailing stopped</div>';
    }
    updateTrailingStatus();
  } catch (err) { showToast(err.message, 'error'); }
};

window.stopTrailingSide = async function(side) {
  try {
    // Stop persistent job if any
    try { await API.post('/api/okx/p2p/trailing/stop', { side: side }); } catch (e) {}
    var otherCfg = readTrailingSideCfg(side === 'buy' ? 'sell' : 'buy');
    await API.post('/api/okx/p2p/trailing/config', { buy: side === 'buy' ? { enabled: false } : otherCfg, sell: side === 'sell' ? { enabled: false } : otherCfg });
    await API.post('/api/okx/p2p/trailing/config/save', {}).catch(function() {});
    showToast(side + ' trailing stopped', 'success');
    updateTrailingStatus();
  } catch (err) { showToast(err.message, 'error'); }
};

window.saveTrailingConfigToDb = async function() {
  try {
    await API.post('/api/okx/p2p/trailing/config/save', {});
    showToast('Trailing config saved to server', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

window.loadTrailingConfigFromDb = async function() {
  try {
    var res = await API.post('/api/okx/p2p/trailing/config/load', {});
    if (res.code === 0 && res.data) {
      showToast('Trailing config loaded from server', 'success');
      loadTrailingConfig();
    } else {
      showToast('No saved config found', 'info');
    }
  } catch (err) { showToast(err.message, 'error'); }
};

window.resetTrailingConfigToDefaults = function() {
  if (!confirm('Reset trailing config to defaults?')) return;
  API.post('/api/okx/p2p/trailing/config/reset', {}).then(function(res) {
    if (res.code === 0) { showToast('Config reset to defaults', 'success'); loadTrailingConfig(); }
    else showToast('Failed to reset', 'error');
  }).catch(function(err) { showToast(err.message, 'error'); });
};

async function loadAutoAdRules() {
  var section = document.getElementById('autoads-section');
  if (!section) return;
  try {
    var [rulesRes, logRes] = await Promise.all([
      API.get('/api/okx/p2p/auto-ads/config'),
      API.get('/api/okx/p2p/auto-ads/log')
    ]);
    var rules = Array.isArray(rulesRes.data) ? rulesRes.data : [];
    var logs = Array.isArray(logRes.data) ? logRes.data : [];
    var html = '';
    if (rules.length === 0) html += '<p style="color:var(--text-tertiary);font-size:12px;margin-bottom:10px;">No auto-ad rules configured.</p>';
    else {
      html += '<div style="display:flex;flex-direction:column;gap:6px;margin-bottom:10px;">';
      rules.forEach(function(r, i) {
        var modeLabel = '';
        if (r.mode === 'existing') modeLabel = ' · <span style="color:#448aff;">Use existing</span>';
        else if (r.mode === 'new') modeLabel = ' · <span style="color:#00c853;">Create new</span>';
        else modeLabel = ' · <span style="color:#90a4ae;">Auto</span>';
        html += '<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;background:var(--bg-primary);border-radius:6px;border:1px solid var(--border-primary);"><div><strong style="font-size:13px;color:var(--text-primary);">' + esc((r.side || '').toUpperCase()) + ' ' + esc(r.cryptoAmount || '') + ' ' + esc(r.cryptoCurrency || '') + '</strong>' + modeLabel + '<br><span style="font-size:11px;color:var(--text-quaternary);">' + (r.type === 'floating_market' ? esc(r.priceMargin) + '% margin' : 'fixed') + ' · ' + esc(r.minOrderLimit || '-') + ' - ' + esc(r.maxOrderLimit || '-') + ' ' + esc(r.fiatCurrency || '') + (r.enabled ? '' : ' · <span style="color:#f44336;">disabled</span>') + '</span></div><button class="btn btn-sm btn-danger" data-on-click="deleteAutoAdRule(' + i + ')">Delete</button></div>';
      });
      html += '</div>';
    }
    html += '<div style="display:flex;gap:6px;margin-bottom:10px;"><button class="btn btn-sm btn-primary" data-on-click="showAddAutoAdRuleModal()">+ Add Rule</button><button class="btn btn-sm btn-primary" data-on-click="runAutoAdsNow()">Run Now</button><button class="btn btn-sm btn-outline" data-on-click="toggleAutoAdLog()">Toggle Log</button></div>';
    html += '<div id="autoads-log" style="display:none;background:var(--bg-primary);border-radius:6px;padding:8px;max-height:200px;overflow-y:auto;font-size:11px;font-family:monospace;">';
    if (logs.length === 0) html += '<div style="color:var(--text-quaternary);">No auto-ad activity yet</div>';
    else logs.forEach(function(l) { html += '<div style="color:#90a4ae;padding:2px 0;border-bottom:1px solid #14141e;">' + fmtTimeAgo(l.ts) + ' — ' + esc(l.msg) + '</div>'; });
    html += '</div>';
    section.innerHTML = html;
  } catch (err) { section.innerHTML = '<p style="color:#f44336;font-size:12px;">Failed to load: ' + esc(err.message) + '</p>'; }
}

window.runAutoAdsNow = async function() {
  try {
    var res = await API.post('/api/okx/p2p/auto-ads/run', {});
    var changes = res.data.changes || [];
    if (changes.length === 0) showToast('Auto-ads run complete — no changes', 'info');
    else showToast(changes.length + ' ad(s) created/updated', 'success');
    loadAutoAdRules();
  } catch (err) { showToast(err.message, 'error'); }
};

window.toggleAutoAdLog = function() {
  var el = document.getElementById('autoads-log');
  if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none';
};

window.showAddAutoAdRuleModal = function() {
  var overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = '<div class="modal-content" style="max-width:520px;"><h3>Add Auto-Ad Rule</h3><form data-on-submit="addAutoAdRule(event)"><div class="form-group"><label>Mode *</label><select id="aa-mode" onchange="autoAdModeChanged()"><option value="auto">Auto (match existing or create)</option><option value="existing">Use existing ad</option><option value="new">Create new ad</option></select></div><div id="aa-existing-section" style="display:none;" class="form-group"><label>Select Ad *</label><select id="aa-ad-select"><option value="">Loading...</option></select></div><div class="form-row"><div class="form-group"><label>Side *</label><select id="aa-side"><option value="sell">Sell</option><option value="buy">Buy</option></select></div><div class="form-group"><label>Crypto *</label><input id="aa-ccy" value="USDT"></div><div class="form-group"><label>Fiat *</label><input id="aa-fiat" value="KES"></div></div><div class="form-row"><div class="form-group"><label>Type *</label><select id="aa-type"><option value="floating_market">Floating Market</option><option value="limit">Fixed</option></select></div><div class="form-group"><label>Crypto Amount *</label><input id="aa-amount" type="number" step="0.1" value="100"></div></div><div class="form-row"><div class="form-group"><label>Price Margin (%)</label><input id="aa-margin" type="number" step="0.1" value="2"></div><div class="form-group"><label>Price Floor</label><input id="aa-floor" type="number" step="0.01" placeholder="Optional"></div></div><div class="form-row"><div class="form-group"><label>Min Order *</label><input id="aa-min" type="number" step="0.01" value="500"></div><div class="form-group"><label>Max Order *</label><input id="aa-max" type="number" step="0.01" value="50000"></div></div><div class="form-group"><label>Target Group</label><select id="aa-target"><option value="all">All</option><option value="common">Common</option><option value="certified">Certified</option><option value="diamond">Diamond</option></select></div><div class="form-actions"><button type="button" class="btn btn-secondary" data-on-click="this.closest(\'.modal-overlay\').remove()">Cancel</button><button type="submit" class="btn btn-primary">Add Rule</button></div></form></div>';
  document.body.appendChild(overlay);
  // Load ads for the existing-ad selector
  API.get('/api/p2p/ads/mine').then(function(res) {
    var ads = Array.isArray(res.data) ? res.data : [];
    var sel = document.getElementById('aa-ad-select');
    if (!sel) return;
    if (ads.length === 0) { sel.innerHTML = '<option value="">No ads available</option>'; return; }
    sel.innerHTML = '<option value="">— Select ad —</option>';
    ads.forEach(function(ad) {
      var adId = ad.adId || ad.ad_id || '';
      var ccy = (ad.cryptoCurrency || '').toUpperCase() || 'USDT';
      var label = (ad.side || '').toUpperCase() + ' ' + ccy + ' ' + (ad.type === 'floating_market' ? (ad.priceMargin || '?') + '%' : (ad.unitPrice || '?')) + ' (…' + adId.slice(-8) + ')';
      sel.innerHTML += '<option value="' + esc(adId) + '">' + esc(label) + '</option>';
    });
  }).catch(function() { var sel = document.getElementById('aa-ad-select'); if (sel) sel.innerHTML = '<option value="">Failed to load ads</option>'; });
};

window.autoAdModeChanged = function() {
  var mode = document.getElementById('aa-mode').value;
  var section = document.getElementById('aa-existing-section');
  if (section) section.style.display = mode === 'existing' ? 'block' : 'none';
};

window.addAutoAdRule = async function(e) {
  e.preventDefault();
  try {
    var rulesRes = await API.get('/api/okx/p2p/auto-ads/config');
    var rules = Array.isArray(rulesRes.data) ? rulesRes.data : [];
    var mode = document.getElementById('aa-mode').value;
    var rule = {
      mode: mode,
      side: document.getElementById('aa-side').value,
      cryptoCurrency: document.getElementById('aa-ccy').value.trim().toUpperCase(),
      fiatCurrency: document.getElementById('aa-fiat').value.trim().toUpperCase(),
      type: document.getElementById('aa-type').value,
      cryptoAmount: document.getElementById('aa-amount').value,
      priceMargin: document.getElementById('aa-margin').value || '',
      priceFloor: document.getElementById('aa-floor').value || '',
      minOrderLimit: document.getElementById('aa-min').value,
      maxOrderLimit: document.getElementById('aa-max').value,
      targetGroup: document.getElementById('aa-target').value,
      enabled: true
    };
    if (mode === 'existing') {
      rule.adId = document.getElementById('aa-ad-select').value;
      if (!rule.adId) { showToast('Please select an ad', 'error'); return; }
    }
    rules.push(rule);
    await API.post('/api/okx/p2p/auto-ads/config', rules);
    e.target.closest('.modal-overlay').remove();
    showToast('Auto-ad rule added!', 'success');
    loadAutoAdRules();
  } catch (err) { showToast(err.message, 'error'); }
};

window.deleteAutoAdRule = async function(index) {
  if (!confirm('Delete this auto-ad rule?')) return;
  try {
    var rulesRes = await API.get('/api/okx/p2p/auto-ads/config');
    var rules = Array.isArray(rulesRes.data) ? rulesRes.data : [];
    rules.splice(index, 1);
    await API.post('/api/okx/p2p/auto-ads/config', rules);
    showToast('Rule deleted', 'success');
    loadAutoAdRules();
  } catch (err) { showToast(err.message, 'error'); }
};

function fmtTimeAgo(ts) {
  var d = new Date(ts);
  // East African Time (UTC+3) in 24h format
  var eat = new Date(d.getTime() + 3 * 3600000);
  return eat.getUTCHours().toString().padStart(2, '0') + ':' + eat.getUTCMinutes().toString().padStart(2, '0') + ':' + eat.getUTCSeconds().toString().padStart(2, '0');
}

async function renderAdAdvanced(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  let prefs = {};
  try {
    const res = await API.get('/api/auth/preferences');
    prefs = res.data || {};
  } catch {}
  if (!document.body.contains(content)) return;
  const autoShutdown = prefs.autoShutdownBuyAds === true;
  const autoReactivate = prefs.autoReactivateAds === true;
  const competitiveAlertEnabled = currentUser?.competitiveAlertEnabled || false;
  const competitiveAlertThreshold = currentUser?.competitiveAlertLimitThreshold || 100;
  const competitiveAlertPriceThreshold = currentUser?.competitiveAlertPriceThreshold || 0;
  content.innerHTML = `
    <div class="card" style="border-color:rgba(255,87,34,0.15);">
      <h3 style="display:flex;align-items:center;gap:8px;">⚡ Ads Advanced</h3>
      <p style="color:var(--text-tertiary);font-size:13px;margin:8px 0 16px;">High-risk automated ad features. Enable at your own discretion.</p>
      <div style="margin-top:12px;">
        <label class="toggle-row" style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div>
            <div style="font-size:14px;color:var(--text-primary);">Online Status</div>
            <div style="font-size:11px;color:var(--text-tertiary);margin-top:2px;">When offline, no orders can be placed against your ads</div>
          </div>
          <div style="display:flex;gap:6px;">
            <button class="btn btn-sm btn-primary" data-on-click="updateOnlineStatus('show')">Go Online</button>
            <button class="btn btn-sm btn-secondary" data-on-click="updateOnlineStatus('hidden')">Go Offline</button>
          </div>
        </label>
        <label class="toggle-row" style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div>
            <div style="font-size:14px;color:var(--text-primary);">Keep Me Online</div>
            <div style="font-size:11px;color:var(--text-tertiary);margin-top:2px;">Server keeps your OKX status online every few minutes. Turn OFF to stay offline until you go back online.</div>
          </div>
          <label class="switch" style="position:relative;display:inline-block;width:44px;height:24px;flex-shrink:0;">
            <input type="checkbox" ${prefs.keepOnlineEnabled !== false ? 'checked' : ''} onchange="toggleAdvancedSetting('keepOnlineEnabled', this.checked)" style="opacity:0;width:0;height:0;">
            <span class="slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#2a2a3e;border-radius:24px;transition:0.3s;"></span>
          </label>
        </label>
        <label class="toggle-row" style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div>
            <div style="font-size:14px;color:var(--text-primary);">Auto-Shutdown Buy Ads</div>
            <div style="font-size:11px;color:var(--text-tertiary);margin-top:2px;">Automatically stop all buy ads when a buy order fails or is cancelled</div>
          </div>
          <label class="switch" style="position:relative;display:inline-block;width:44px;height:24px;flex-shrink:0;">
            <input type="checkbox" ${autoShutdown ? 'checked' : ''} onchange="toggleAdvancedSetting('autoShutdownBuyAds', this.checked)" style="opacity:0;width:0;height:0;">
            <span class="slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#2a2a3e;border-radius:24px;transition:0.3s;"></span>
          </label>
        </label>
        <div style="margin:4px 0 12px;padding:10px;background:rgba(255,87,34,0.06);border-radius:8px;border:1px solid rgba(255,87,34,0.15);">
          <div style="font-size:12px;color:#ff5722;">⚠️ Warning</div>
          <div style="font-size:11px;color:var(--text-tertiary);margin-top:4px;">When enabled, cancelling or disputing a buy order will automatically hide all active buy ads. This prevents failed order accumulation. Use with caution.</div>
        </div>
        <label class="toggle-row" style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div>
            <div style="font-size:14px;color:var(--text-primary);">Auto-Reactivate Ads</div>
            <div style="font-size:11px;color:var(--text-tertiary);margin-top:2px;">Automatically reactivate offline/hidden P2P ads to keep them visible on the marketplace</div>
          </div>
          <label class="switch" style="position:relative;display:inline-block;width:44px;height:24px;flex-shrink:0;">
            <input type="checkbox" ${autoReactivate ? 'checked' : ''} onchange="toggleAutoReactivateAds(this.checked)" style="opacity:0;width:0;height:0;">
            <span class="slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#2a2a3e;border-radius:24px;transition:0.3s;"></span>
          </label>
        </label>
        <div style="margin:4px 0 12px;padding:10px;background:rgba(255,87,34,0.06);border-radius:8px;border:1px solid rgba(255,87,34,0.15);">
          <div style="font-size:12px;color:#ff5722;">⚠️ Warning</div>
          <div style="font-size:11px;color:var(--text-tertiary);margin-top:4px;">When enabled, the server will automatically reactivate any offline or hidden ads every 3 minutes. This can increase OKX API usage and may result in rate limiting.</div>
        </div>
        <label class="toggle-row" style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div>
            <div style="font-size:14px;color:var(--text-primary);">Competitive Price Alert 🔔</div>
            <div style="font-size:11px;color:var(--text-tertiary);margin-top:2px;">Get alerted with ringtone when sellers appear with minimum limit ≥ your threshold and price ≥ your price threshold</div>
          </div>
          <label class="switch" style="position:relative;display:inline-block;width:44px;height:24px;flex-shrink:0;">
            <input type="checkbox" ${competitiveAlertEnabled ? 'checked' : ''} onchange="toggleCompetitiveAlert(this.checked)" style="opacity:0;width:0;height:0;">
            <span class="slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#2a2a3e;border-radius:24px;transition:0.3s;"></span>
          </label>
        </label>
        ${competitiveAlertEnabled ? `<div style="padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <label style="display:block;font-size:13px;color:var(--text-primary);margin-bottom:8px;">Minimum Limit Threshold (KES)</label>
          <input type="number" id="alert-threshold" value="${competitiveAlertThreshold}" min="100" step="100" style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:rgba(6,6,12,0.6);color:var(--text-primary);font-size:13px;outline:none;" onchange="saveCompetitiveAlertThreshold(this.value)">
          <div style="font-size:11px;color:var(--text-tertiary);margin-top:6px;">Alert plays when a seller's minimum limit is ≥ ${competitiveAlertThreshold} KES</div>
          <label style="display:block;font-size:13px;color:var(--text-primary);margin:12px 0 8px;">Price Threshold (KES) — Optional</label>
          <input type="number" id="alert-price" value="${competitiveAlertPriceThreshold}" min="0" step="100" style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:rgba(6,6,12,0.6);color:var(--text-primary);font-size:13px;outline:none;" onchange="saveCompetitiveAlertPriceThreshold(this.value)">
          <div style="font-size:11px;color:var(--text-tertiary);margin-top:6px;">Set to 0 to alert on any price higher than your SELL ad, or enter a specific price (e.g. 45500) to only alert at or above that level</div>
        </div>` : ''}
        <label class="toggle-row" style="display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div>
            <div style="font-size:14px;color:var(--text-primary);">🖼 Require Payment Proof</div>
            <div style="font-size:11px;color:var(--text-tertiary);margin-top:2px;">When enabled, a payment proof image is required before marking an order as paid</div>
          </div>
          <label class="switch" style="position:relative;display:inline-block;width:44px;height:24px;flex-shrink:0;">
            <input type="checkbox" ${prefs.requirePaymentProof ? 'checked' : ''} onchange="toggleRequirePaymentProof(this.checked)" style="opacity:0;width:0;height:0;">
            <span class="slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#2a2a3e;border-radius:24px;transition:0.3s;"></span>
          </label>
        </label>
        ${prefs.requirePaymentProof ? `
        <div style="padding:12px 0;border-bottom:1px solid #1e1e2e;">
          <div style="font-size:13px;color:var(--text-primary);margin-bottom:6px;">🖼 Payment Proof Image</div>
          <div style="font-size:11px;color:var(--text-tertiary);margin-bottom:10px;">Upload a payment proof once, then it's attached automatically whenever you mark an order as paid. You can still override it per order.</div>
          ${prefs.paymentProofImage ? '<div style="margin-bottom:8px;"><img src="' + esc(prefs.paymentProofImage) + '" style="max-width:200px;max-height:140px;border-radius:8px;border:1px solid var(--border-primary);display:block;"></div>' : '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:8px;">No image saved yet.</div>'}
          <div style="display:flex;gap:8px;align-items:center;margin-bottom:8px;">
            <button class="btn btn-sm btn-primary" data-on-click="uploadSavedPaymentProof()">${prefs.paymentProofImage ? '↻ Replace Image' : '⬆ Upload Image'}</button>
            ${prefs.paymentProofImage ? '<button class="btn btn-sm btn-danger" data-on-click="removeSavedPaymentProof()">Remove</button>' : ''}
          </div>
          <label style="display:flex;align-items:center;gap:8px;font-size:12px;color:var(--text-tertiary);cursor:pointer;">
            <input type="checkbox" ${prefs.paymentProofUseForAll ? 'checked' : ''} onchange="setPaymentProofUseForAll(this.checked)">
            <span>Use this same image for all orders when marking paid</span>
          </label>
        </div>` : ''}
      </div>
    </div>`;
}

window.uploadSavedPaymentProof = function() {
  if (typeof showFileUploader === 'function') {
    showFileUploader(function(url) { setSavedPaymentProof(url); });
  } else {
    showToast('Upload not available', 'error');
  }
};
window.setSavedPaymentProof = async function(url) {
  if (!url) return;
  try {
    await API.put('/api/auth/preferences', { paymentProofImage: url, paymentProofUseForAll: true });
    showToast('Payment proof image saved', 'success');
    if (typeof renderAdAdvanced === 'function') renderAdAdvanced(document.getElementById('ads-tab-content'));
    if (typeof renderAdvancedTab === 'function') renderAdvancedTab(document.getElementById('settings-content'));
  } catch (err) { showToast(err.message, 'error'); }
};
window.removeSavedPaymentProof = async function() {
  try {
    await API.put('/api/auth/preferences', { paymentProofImage: '', paymentProofUseForAll: false });
    showToast('Payment proof image removed', 'success');
    if (typeof renderAdAdvanced === 'function') renderAdAdvanced(document.getElementById('ads-tab-content'));
    if (typeof renderAdvancedTab === 'function') renderAdvancedTab(document.getElementById('settings-content'));
  } catch (err) { showToast(err.message, 'error'); }
};
window.setPaymentProofUseForAll = async function(checked) {
  try {
    await API.put('/api/auth/preferences', { paymentProofUseForAll: !!checked });
    showToast('Will ' + (checked ? '' : 'not ') + 'reuse the saved image when marking paid', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

window.updateOnlineStatus = async function(status) {
  try {
    await API.post('/api/okx/p2p/online-status', { status: status });
    // Persist intent so the keep-online heartbeat does not override it.
    await API.put('/api/auth/preferences', { keepOnlineEnabled: status === 'show' });
    // If going offline, ALSO pause the headless presence tab (which keeps
    // merchant online via WebSocket). If coming online, resume it.
    if (status === 'hidden') {
      await API.post('/api/okx/tab/pause');
    } else {
      await API.post('/api/okx/tab/resume');
    }
    showToast('You are now ' + (status === 'show' ? 'online' : 'offline') + ' (presence ' + (status === 'show' ? 'resumed' : 'paused') + ')', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

async function loadPaymentMethods() {
  var listEl = document.getElementById('ads-payment-methods-list');
  if (!listEl) return;
  try {
    var res = await API.get('/api/p2p/payment-methods');
    var methods = Array.isArray(res.data) ? res.data : [];
    if (methods.length === 0) {
      listEl.innerHTML = '<p style="color:var(--text-tertiary);font-size:12px;">No payment methods added yet.</p>';
      return;
    }
    var html = '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(340px,1fr));gap:12px;">';
    methods.forEach(function(m) { html += _pmCard(m); });
    html += '</div>';
    listEl.innerHTML = html;
  } catch (err) {
    listEl.innerHTML = '<p style="color:#f44336;font-size:12px;">Failed to load: ' + esc(err.message) + '</p>';
  }
}

window.showAddPaymentMethodModal = function() {
  openPaymentMethodModal();
};

window.deletePaymentMethod = async function(id) {
  if (!confirm('Delete this payment method?')) return;
  try {
    await API.del('/api/p2p/payment-methods/' + id);
    showToast('Payment method deleted', 'success');
    loadPaymentMethods();
  } catch (err) { showToast(err.message, 'error'); }
};

window.updateMerchantProfile = async function(e) {
  e.preventDefault();
  try {
    var avatar = document.getElementById('merchant-avatar').value.trim();
    var desc = document.getElementById('merchant-desc').value.trim();
    if (!avatar && !desc) { showToast('Provide at least avatar URL or description', 'warning'); return; }
    await API.post('/api/okx/p2p/merchant/update-basic-info', { avatarImage: avatar, description: desc });
    showToast('Merchant profile updated!', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

// ── SMS Proofs (Ads → SMS Proofs) ─────────────────────────────────────────
// Reference cards for the three proof message formats, plus a live delivery
// log of every SMS-match attempt: what was sent (or skipped/failed), to which
// order, via which source (Manual paste / APK auto-forward / Server auto).
var _smsProofTimer = null;
var _smsProofFilter = 'all';
var _smsProofCache = null;

function _smsProofStatus(action) {
  var a = String(action || '');
  if (a === 'posted' || a === 'auto-released' || a === 'matched') return 'sent';
  if (a === 'error' || a === 'auto-release-failed') return 'failed';
  return 'skipped';
}

function _smsProofSourceLabel(r) {
  var s = String(r.source || '');
  if (s === 'manual') return 'Manual';
  if (s === 'apk') return 'APK';
  if (s === 'server') return 'Server';
  return r.side === 'sell' ? 'Server' : 'Auto';
}

function _smsProofMatchesFilter(r) {
  if (_smsProofFilter === 'all') return true;
  if (_smsProofFilter === 'manual') return String(r.source || '') === 'manual';
  if (_smsProofFilter === 'sent' || _smsProofFilter === 'failed' || _smsProofFilter === 'skipped') {
    return _smsProofStatus(r.action) === _smsProofFilter;
  }
  return true;
}

async function renderSmsProofs(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  if (typeof window.loadSmsProofFormats === 'function') { try { await window.loadSmsProofFormats(); } catch (e) {} }
  var fmts = window.smsProofFormatsEffective ? window.smsProofFormatsEffective() : {};
  var ph = window.smsProofFormatsPlaceholders ? window.smsProofFormatsPlaceholders() : [];
  content.innerHTML = '<div style="padding:4px 0;"><div style="color:var(--text-tertiary);font-size:13px;margin-bottom:12px;">SMS proof message templates sent to customers. Edit the template code — placeholders below are replaced with the real payment/order details at send time. Changes apply to both manual and auto-sent proofs.</div>'
    + '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:10px;margin-bottom:10px;">'
    + ['mpesa', 'airtel', 'bank'].map(function(kind) {
        var label = kind === 'mpesa' ? '📱 M-Pesa' : kind === 'airtel' ? '📱 Airtel Money' : '🏦 Bank Transfer';
        return '<div class="card" style="padding:12px;border-color:rgba(141,110,255,0.18);display:flex;flex-direction:column;gap:8px;">'
          + '<div style="display:flex;justify-content:space-between;align-items:center;"><b style="font-size:13px;">' + label + '</b>'
          + '<button class="btn btn-sm btn-outline" data-on-click="resetSmsProofFormat(\'' + kind + '\')">Reset</button></div>'
          + '<textarea data-sms-proof-format="' + kind + '" spellcheck="false" style="width:100%;min-height:150px;font-family:monospace;font-size:11px;line-height:1.6;color:var(--text-primary);background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:8px;padding:10px;resize:vertical;" placeholder="Type the template code here…">' + escHtml(fmts[kind] || '') + '</textarea>'
          + '</div>';
      }).join('')
    + '</div>'
    + '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:12px;">'
    + '<span style="font-size:11px;color:var(--text-tertiary);">Placeholders:</span>'
    + ph.map(function(p) { return '<code style="font-size:11px;background:rgba(141,110,255,0.1);color:#b39dff;padding:2px 8px;border-radius:6px;">' + escHtml(p) + '</code>'; }).join('')
    + '<span style="flex:1;"></span>'
    + '<button class="btn btn-sm btn-primary" data-on-click="saveSmsProofFormats()">💾 Save formats</button>'
    + '<span id="sms-proofs-save-status" style="font-size:11px;color:var(--text-tertiary);"></span>'
    + '</div>'
    + '<div id="sms-proofs-stats" style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px;"></div>'
    + '<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px;">'
    + ['all', 'sent', 'failed', 'skipped', 'manual'].map(function(f) {
        var lbl = { all: 'All', sent: '✅ Sent', failed: '❌ Failed', skipped: '⏭ Skipped', manual: '✋ Manual' }[f];
        return '<button class="btn btn-sm ' + (_smsProofFilter === f ? 'btn-primary' : 'btn-outline') + '" data-on-click="setSmsProofFilter(\'' + f + '\')">' + lbl + '</button>';
      }).join('')
    + '</div>'
    + '<div id="sms-proofs-log" style="min-height:120px;color:var(--text-quaternary);font-size:12px;">Loading…</div></div>';
  _loadSmsProofs();
  if (_smsProofTimer) clearInterval(_smsProofTimer);
  _smsProofTimer = setInterval(function() {
    if (document.hidden) return;
    if (!document.getElementById('sms-proofs-log')) { clearInterval(_smsProofTimer); _smsProofTimer = null; return; }
    _loadSmsProofs();
  }, 5000);
}

window.saveSmsProofFormats = async function() {
  var status = document.getElementById('sms-proofs-save-status');
  var fmts = {};
  ['mpesa', 'airtel', 'bank'].forEach(function(kind) {
    var el = document.querySelector('[data-sms-proof-format="' + kind + '"]');
    fmts[kind] = el ? el.value : '';
  });
  if (status) status.textContent = 'Saving…';
  try {
    await API.put('/api/auth/preferences', { smsProofFormats: fmts });
    await (window.loadSmsProofFormats ? window.loadSmsProofFormats() : Promise.resolve());
    if (status) status.textContent = '✅ Saved';
    setTimeout(function() { if (status) status.textContent = ''; }, 2500);
  } catch (err) {
    if (status) { status.textContent = '❌ ' + (err.message || err); status.style.color = '#ff5252'; }
  }
};

window.resetSmsProofFormat = function(kind) {
  var defs = window.smsProofFormatsDefaults ? window.smsProofFormatsDefaults() : {};
  var el = document.querySelector('[data-sms-proof-format="' + kind + '"]');
  if (el && defs[kind] != null) el.value = defs[kind];
};

async function _loadSmsProofs() {
  var content = document.getElementById('ads-tab-content');
  if (!content || !document.body.contains(content)) return;
  var logEl = document.getElementById('sms-proofs-log');
  var statsEl = document.getElementById('sms-proofs-stats');
  if (!logEl || !statsEl) return;
  try {
    var res = await API.getSmsMatchLog(150);
    var rows = (res && res.data) || [];
    _smsProofCache = rows;
    var counts = { sent: 0, failed: 0, skipped: 0, manual: 0 };
    rows.forEach(function(r) {
      var st = _smsProofStatus(r.action);
      if (st === 'sent') counts.sent++;
      else if (st === 'failed') counts.failed++;
      else counts.skipped++;
      if (String(r.source || '') === 'manual') counts.manual++;
    });
    statsEl.innerHTML = '<span class="badge" style="background:rgba(0,200,83,0.12);color:#00c853;">✅ ' + counts.sent + ' sent</span>'
      + '<span class="badge" style="background:rgba(244,67,54,0.12);color:#ff5252;">❌ ' + counts.failed + ' failed</span>'
      + '<span class="badge" style="background:rgba(255,179,0,0.12);color:#ffb300;">⏭ ' + counts.skipped + ' skipped</span>'
      + '<span class="badge" style="background:rgba(141,110,255,0.12);color:#b39dff;">✋ ' + counts.manual + ' manual</span>';
    var vis = rows.filter(_smsProofMatchesFilter);
    if (!vis.length) { logEl.innerHTML = '<div style="color:var(--text-quaternary);font-size:12px;padding:12px 0;">No ' + _smsProofFilter + ' SMS-proof events in the last ' + rows.length + ' logged.</div>'; return; }
    var rowsHtml = vis.map(function(r) {
      var st = _smsProofStatus(r.action);
      var stColor = st === 'sent' ? '#00c853' : st === 'failed' ? '#ff5252' : '#ffb300';
      var stLbl = st === 'sent' ? 'Sent' : st === 'failed' ? 'Failed' : 'Skipped';
      var src = _smsProofSourceLabel(r);
      var srcColor = src === 'Manual' ? '#b39dff' : src === 'APK' ? '#4fc3f7' : '#90a4ae';
      var t = (r.at || '').replace('T', ' ').slice(5, 16);
      var msg = (r.msgText || '').replace(/\n/g, ' ⏎ ').slice(0, 90);
      return '<tr>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;white-space:nowrap;font-size:11px;color:var(--text-secondary);">' + escHtml(t) + '</td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;"><span style="color:' + srcColor + ';font-weight:600;">' + escHtml(src) + '</span></td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;">' + (r.side === 'sell' ? 'In · sell' : 'Out · buy') + '</td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;font-family:monospace;">' + (r.orderId ? escHtml(String(r.orderId).slice(0, 8)) : '—') + '</td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;">' + (r.amount ? 'KES ' + Number(r.amount).toLocaleString() : '—') + '</td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;color:#00e676;font-family:monospace;">' + escHtml(r.smsRef || '—') + '</td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;color:' + stColor + ';font-weight:600;white-space:nowrap;">' + stLbl + '</td>'
        + '<td style="padding:6px 8px;border-bottom:1px solid #1e1e2e;font-size:11px;color:var(--text-tertiary);" title="' + escHtml(r.detail || '') + (msg ? ' — ' + escHtml(msg) : '') + '">' + (msg ? '<span style="font-family:monospace;font-size:10px;">' + escHtml(msg) + '</span>' : '<span style="font-family:monospace;font-size:10px;">' + escHtml((r.detail || '').slice(0, 70)) + '</span>') + '</td>'
        + '</tr>';
    }).join('');
    logEl.innerHTML = '<table style="width:100%;border-collapse:collapse;"><thead><tr style="text-align:left;color:#888;font-size:11px;"><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Time</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Source</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Side</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Order</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Amount</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Ref</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Status</th><th style="padding:6px 8px;border-bottom:1px solid #2a2a33;">Message</th></tr></thead><tbody>' + rowsHtml + '</tbody></table>';
  } catch (err) {
    logEl.innerHTML = '<div style="color:#ff5252;font-size:12px;">Failed to load proofs log: ' + escHtml(err.message || err) + '</div>';
  }
}

window.setSmsProofFilter = function(f) { _smsProofFilter = f || 'all'; _loadSmsProofs(); };
window.renderSmsProofs = renderSmsProofs;

// ===== OKX Merchant Presence tab =====
// Live control for the headless presence tab. OKX re-lists a merchant's ads
// whenever it detects live presence; the only way to stay "unavailable" is to
// drop presence entirely. This tab lets the user pause/resume with one tap.
async function renderOkxPresenceTab(container) {
  var content = document.getElementById('ads-tab-content');
  if (!content) return;
  let tabStatus = { state: 'starting', paused: false, lastSeen: null };
  try {
    const res = await API.get('/api/okx/tab/status');
    if (res && res.data) tabStatus = res.data;
  } catch (err) { console.warn('okx-tab status failed:', err); }
  const tabPaused = !!tabStatus.paused;
  const tabStateLabel = tabPaused ? 'Unavailable — ads off market' : 'Online — presence active';
  const tabStateColor = tabPaused ? 'var(--accent-orange, #ff9800)' : 'var(--accent-green, #00c853)';
  content.innerHTML = `
    <div class="card" style="border-color:rgba(0,150,255,0.25);">
      <h3 style="display:flex;align-items:center;gap:8px;">🛰️ OKX Merchant Presence</h3>
      <p style="color:var(--text-tertiary);font-size:13px;margin:8px 0 12px;">OKX re-lists your ads whenever it detects your merchant is active. To stay <strong>unavailable</strong> (ads offline), pause the presence tab.</p>
      <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;padding:12px;border-radius:10px;background:rgba(255,255,255,0.03);border:1px solid #1e1e2e;">
        <span style="display:inline-flex;align-items:center;gap:8px;font-size:14px;font-weight:600;color:${tabStateColor};">
          <span style="width:10px;height:10px;border-radius:50%;background:${tabStateColor};box-shadow:0 0 8px ${tabStateColor};"></span>
          ${tabStateLabel}
        </span>
        <span style="font-size:11px;color:var(--text-quaternary);">state: ${esc(tabStatus.state || 'unknown')}</span>
        <button class="btn ${tabPaused ? 'btn-primary' : 'btn-danger'} btn-sm" data-on-click="${tabPaused ? 'resumeOkxTab' : 'pauseOkxTab'}" style="margin-left:auto;">
          ${tabPaused ? '▶️ Come Back Online' : '⏸️ Go Unavailable (Pause)'}
        </button>
      </div>
      <div style="font-size:11px;color:var(--text-quaternary);margin-top:8px;">When paused your merchant shows offline and your ads leave the marketplace — this is the only way to stay offline, since OKX re-lists ads from any active presence.</div>
    </div>`;
}

window.renderOkxPresenceTab = renderOkxPresenceTab;

window.pauseOkxTab = async function() {
  if (!confirm('Go unavailable?\n\nYour merchant presence will be dropped — you will show OFFLINE in OKX and your ads will leave the marketplace. Click "Come Back Online" here later to resume.')) return;
  try {
    await API.post('/api/okx/tab/pause');
    await API.put('/api/auth/preferences', { keepOnlineEnabled: false });
    showToast('Paused — going unavailable (ads off market)', 'success');
    var content = document.getElementById('ads-tab-content');
    if (content) await renderOkxPresenceTab(content);
  } catch (err) { showToast(err.message || 'Pause failed', 'error'); }
};

window.resumeOkxTab = async function() {
  try {
    await API.post('/api/okx/tab/resume');
    await API.put('/api/auth/preferences', { keepOnlineEnabled: true });
    showToast('Resumed — coming back online in ~1 minute', 'success');
    var content = document.getElementById('ads-tab-content');
    if (content) setTimeout(function(){ if (content) renderOkxPresenceTab(content); }, 4000);
  } catch (err) { showToast(err.message || 'Resume failed', 'error'); }
};

/* ==== js/modules/okx/orders.js ==== */
// ═══════════════════════════════════════════════════════════════════
//  AFTER-TRADE THANK YOU NOTES — auto-sent on release / cancel
// ═══════════════════════════════════════════════════════════════════

// Global flag to disable on-screen order rendering (only FCM toasts)
window._disableOrderScreenRender = false; // Set to false to enable on-screen rendering

(function() {
  var DEFAULTS = {
    enabled: true,
    completed: '{greeting}, {name}! 👋\n\nThank you for trading with me! I hope you enjoyed our experience. Your order #{orderId} has been completed successfully.\n\nYou\'re always welcome back for more trades. Have a wonderful {time}! 😊',
    cancelledSell: '{greeting}, {name}! 👋\n\nThank you for considering me for this trade. Unfortunately, order #{orderId} has been cancelled.\n\nIf you encountered any challenges during payment, please don\'t hesitate to reach out on the chat — I\'m here to help. You\'re always welcome to try again. Have a great {time}! 🙏',
    cancelledBuy: '{greeting}, {name}! 👋\n\nThank you for your patience with this trade. Unfortunately, due to a technical difficulty on our end, payment could not be processed for order #{orderId}.\n\nWe sincerely apologize for the inconvenience. Please try again at a later time as we work to resolve this. Have a wonderful {time}! 🙏'
  };

  function loadCfg() {
    try { return JSON.parse(localStorage.getItem('thankYouNotes') || 'null') || DEFAULTS; } catch (e) { return DEFAULTS; }
  }

  function eatGreeting() {
    var h = (new Date().getUTCHours() + 3) % 24;
    if (h >= 5 && h < 12) return 'Good morning';
    if (h >= 12 && h < 17) return 'Good afternoon';
    if (h >= 17 && h < 21) return 'Good evening';
    return 'Good night';
  }
  function eatTod() {
    var h = (new Date().getUTCHours() + 3) % 24;
    if (h >= 5 && h < 12) return 'morning';
    if (h >= 12 && h < 17) return 'afternoon';
    if (h >= 17 && h < 21) return 'evening';
    return 'night';
  }

  function fillTemplate(tpl, name, orderId, side) {
    var g = eatGreeting(), t = eatTod(), id = (orderId || '').slice(0, 8);
    return tpl.replace(/\{name\}/g, name || 'Trader')
      .replace(/\{orderId\}/g, id)
      .replace(/\{side\}/g, side || 'sell')
      .replace(/\{greeting\}/g, g)
      .replace(/\{time\}/g, t)
      .replace(/,\s*!/g, '!')  // fix: {greeting}, {name}! -> {greeting}! when name empty
      .replace(/,\s*$/g, '');   // fix trailing comma
  }

  function _cpName(orderId) {
    var o = window._ordersMap && window._ordersMap[orderId];
    return o ? (getCounterpartyInfo(o).name || 'Trader') : 'Trader';
  }

  // `kind` declares WHICH lifecycle message this is. The server dedupes on this
  // and never on the wording, because the welcome and the completion thank-you
  // both contain "thank you for trading with me" — keying on text made them
  // collide and swallow each other.
  function _send(orderId, msg, kind) {
    return API.sendChatMessage(orderId, msg, kind || 'manual').then(function (res) {
      // The server refuses a completion notice while the trade is still open.
      // That is a CORRECT outcome, not a failure and not a success — it must not
      // be toasted as "notice sent", and must not be retried on a timer.
      if (res && res.withheld) {
        var e = new Error('Order is not complete yet');
        e.withheld = true;
        throw e;
      }
      return res;
    });
  }

  // SINGLE source of truth for "has this trade actually finished?".
  // CANCELLATION IS EVALUATED FIRST, and this ordering is load-bearing. A
  // cancelled OKX order still carries a completionTimestamp — verified live on
  // cancelled sell order 261005194127885: orderStatus='cancelled',
  // completionTimestamp=1791200607000. Every completion test below
  // (completionTimestamp>0, completionStatus/state) therefore matched a CANCELLED
  // order and returned 'completed', the SSE diff fired isNewCompleted instead of
  // isNewCancelled, and the buyer received "thank you for trading with me, your
  // order has been completed successfully" for a trade that was cancelled.
  // A cancelled order is never a completion, so it must be classified before any
  // completion signal is read.
  //   buy  -> complete only when the seller releases (completionTimestamp)
  //   sell -> our own release closes it, so orderStatus is enough
  window._tradeState = function (o) {
    if (!o) return '';
    var os = String(o.orderStatus || o.status || '').toLowerCase();
    if (os === 'cancelled' || os === 'canceled') return 'cancelled';
    var cs = String(o.completionStatus || o.state || '').toLowerCase();
    if (cs === 'cancelled' || cs === 'canceled') return 'cancelled';
    if (Number(o.completionTimestamp || 0) > 0) return 'completed';
    if (cs === 'completed' || cs === 'finished' || cs === 'released') return 'completed';
    var side = String(o.side || '').toLowerCase();
    if (side === 'sell' && (os === 'completed' || os === 'finished' || os === 'released')) return 'completed';
    return '';
  };

  // A buy order completes when the SELLER releases the crypto, which happens on
  // their side — there is no local 'release' action to hang the notice on, and a
  // missed SSE transition would lose it forever because _tyClaim is one-shot.
  // Polling the authoritative probe fixes both: it fires the moment
  // completionTimestamp appears, and provably cannot fire before it.
  var _tySweepAt = 0;
  window._sweepForCompletedOrders = function () {
    if (Date.now() - _tySweepAt < 20000) return;
    _tySweepAt = Date.now();
    var map = window._ordersMap || {};
    var ids = Object.keys(map);
    var checked = 0;
    for (var i = 0; i < ids.length && checked < 8; i++) {
      var oid = ids[i], o = map[oid];
      if (!o) continue;
      if (String(o.side || '') === 'sell') continue;          // handled by our release path
      if (window._tySentOrders && window._tySentOrders.has(oid)) continue;
      var ps = String(o.paymentStatus || '').toLowerCase();
      var isPaid = (typeof window.orderIsPaid === 'function') ? window.orderIsPaid(o)
                                                              : (ps === 'paid' || ps === 'confirmed');
      if (!isPaid) continue;                                   // cannot be complete if unpaid
      if (window._tradeState(o) === 'completed') continue;      // already handled
      checked++;
      (function (id) {
        API.get('/api/okx/p2p/orders/' + id + '/really-complete').then(function (res) {
          if (res && res.data && res.data.complete === true && window._tyClaim(id)) {
            window._autoSendThankYou(id);
          }
        }).catch(function () {});
      })(oid);
    }
  };

  // ── Auto-send after release ──────────────────────────────────
  window._autoSendThankYou = function(orderId) {
    var cfg = loadCfg();
    if (cfg.enabled === false) return;
    var o = window._ordersMap && window._ordersMap[orderId];
    var name = o ? (getCounterpartyInfo(o).name || '') : '';
    var side = o ? o.side : 'sell';

    // Ask the server whether the trade has ACTUALLY finished before saying it
    // has. On a buy order OKX reports orderStatus 'completed' as soon as the
    // buyer pays, while the seller still holds the crypto — so trusting the
    // local snapshot sent "your order has been completed successfully" to
    // sellers who then had no reason to release. The server re-checks this too;
    // this is just so we do not attempt it and mislead anyone in the meantime.
    if (typeof API !== 'undefined' && API.get) {
      API.get('/api/okx/p2p/orders/' + orderId + '/really-complete')
        .then(function (res) {
          if (res && res.data) {
            // Defence in depth: if the server says this trade was cancelled, send
            // the cancellation note instead of the completion thank-you. A buyer
            // who cancelled must never read "your order has been completed".
            if (res.data.cancelled === true) {
              console.log('[ThankYou] ' + String(orderId).slice(-8) + ' is CANCELLED — routing to cancellation note');
              if (typeof window._autoSendCancelledNote === 'function') {
                if (window._tyClaim) window._tyClaim(orderId);
                window._autoSendCancelledNote(orderId, side);
              }
              return;
            }
            if (res.data.complete === false) {
              console.log('[ThankYou] withheld for ' + String(orderId).slice(-8) + ' — trade not actually complete');
              return;
            }
          }
          doSend();
        })
        .catch(function () { doSend(); });
      return;
    }
    doSend();

    function doSend() {
      function sendWithName(cpName) {
      var msg = fillTemplate(cfg.completed || DEFAULTS.completed, cpName, orderId, side);
      return _send(orderId, msg, 'thankyou').then(function() {
        showToast('💌 Completed order notice sent to ' + cpName, 'success', 3000);
      }).catch(function(err) {
        if (err && err.withheld) {
          console.log('[ThankYou] withheld for ' + String(orderId).slice(-8) + ' — trade not complete yet');
          return;
        }
        console.error('Thank-you note send failed:', err);
        showToast('❌ Completed order notice failed: ' + (err.message || err), 'error', 5000);
        // Retry once after 2s
        setTimeout(function() {
          _send(orderId, msg, 'thankyou').then(function() {
            showToast('💌 Completed order notice sent to ' + cpName + ' (retry)', 'success', 3000);
          }).catch(function(e2) {
            console.error('Thank-you note retry failed:', e2);
            showToast('❌ Completed order notice retry failed: ' + (e2.message || e2), 'error', 5000);
          });
        }, 2000);
      });
    }

    // If name missing, fetch order detail (order completed via app/SMS)
    if (!name) {
      API.get('/api/okx/p2p/orders/' + orderId).then(function(res) {
        var detail = res.data || {};
        var cpName = getCounterpartyInfo(detail).name || 'Trader';
        sendWithName(cpName);
      }).catch(function(err) {
        console.error('Order detail fetch failed for thank-you:', err);
        // Fallback: send greeting only (no name)
        sendWithName('Trader');
      });
      return;
    }
    sendWithName(name);
    }
  };

  // ── Auto-send after cancel ───────────────────────────────────
  window._autoSendCancelledNote = function(orderId, side) {
    var cfg = loadCfg();
    if (cfg.enabled === false) return;
    var o = window._ordersMap && window._ordersMap[orderId];
    var name = o ? (getCounterpartyInfo(o).name || '') : '';
    var tpl = side === 'buy' ? (cfg.cancelledBuy || DEFAULTS.cancelledBuy) : (cfg.cancelledSell || DEFAULTS.cancelledSell);

    function sendWithName(cpName) {
      var msg = fillTemplate(tpl, cpName, orderId, side);
      return _send(orderId, msg, 'cancelled').then(function() {
        showToast('💌 ' + (side === 'buy' ? 'Apology' : 'Note') + ' sent to ' + cpName, 'success', 3000);
      }).catch(function(err) {
        console.error('Cancel note send failed:', err);
        showToast('❌ ' + (side === 'buy' ? 'Apology' : 'Note') + ' failed: ' + (err.message || err), 'error', 5000);
        setTimeout(function() {
          _send(orderId, msg, 'cancelled').then(function() {
            showToast('💌 ' + (side === 'buy' ? 'Apology' : 'Note') + ' sent to ' + cpName + ' (retry)', 'success', 3000);
          }).catch(function(e2) {
            console.error('Cancel note retry failed:', e2);
            showToast('❌ ' + (side === 'buy' ? 'Apology' : 'Note') + ' retry failed: ' + (e2.message || e2), 'error', 5000);
          });
        }, 2000);
      });
    }

    if (!name) {
      API.get('/api/okx/p2p/orders/' + orderId).then(function(res) {
        var detail = res.data || {};
        var cpName = getCounterpartyInfo(detail).name || 'Trader';
        sendWithName(cpName);
      }).catch(function(err) {
        console.error('Order detail fetch failed for cancel note:', err);
        sendWithName('Trader');
      });
      return;
    }
    sendWithName(name);
  };

  // ── Manual re-send (buttons on order rows) ───────────────────
  window._resendThankYou = function(orderId) {
    var cfg = loadCfg();
    var name = _cpName(orderId);
    var o = window._ordersMap && window._ordersMap[orderId];
    var side = o ? o.side : 'sell';
    var msg = fillTemplate(cfg.completed || DEFAULTS.completed, name, orderId, side);
    _send(orderId, msg).then(function() {
      showToast('Thank-you note sent!', 'success');
    }).catch(function(e) { showToast('Send failed: ' + e.message, 'error'); });
  };

  window._resendCancelledNote = function(orderId, side) {
    var cfg = loadCfg();
    var name = _cpName(orderId);
    var tpl = side === 'buy' ? (cfg.cancelledBuy || DEFAULTS.cancelledBuy) : (cfg.cancelledSell || DEFAULTS.cancelledSell);
    var msg = fillTemplate(tpl, name, orderId, side);
    _send(orderId, msg).then(function() {
      showToast((side === 'buy' ? 'Apology' : 'Note') + ' sent!', 'success');
    }).catch(function(e) { showToast('Send failed: ' + e.message, 'error'); });
  };
})();

// ===== Row identity / change detection =====
// Every rendered <tr> carries data-row-id + data-row-sig. The signature covers
// only things that change what a row LOOKS LIKE or WHICH section it belongs to.
// The countdown is deliberately excluded: it ticks every second and is updated
// in place by the timer registry, so including it would defeat the comparison.
function _rowSig(o) {
  if (!o) return '';
  var appealed = 0;
  try { appealed = window.isAppealedOrder && window.isAppealedOrder(o) ? 1 : 0; } catch (e) {}
  return [
    o.orderId || '',
    o.state || o.completionStatus || o.orderStatus || o.status || '',
    o.paymentStatus || '',
    appealed,
    o.fiatAmount || '',
    o.cryptoAmount || '',
    o.side || ''
  ].join('~');
}

// Shared failure handler. renderOrders is async and most of its ~15 call sites
// ignore the returned promise, so a throw used to become an unhandled rejection:
// no log, no DOM write, and the page kept showing whatever it had. That is why
// an order could sit invisible for a full minute after its SSE had arrived.
function _reportOrdersRenderFailure(container, err) {
  window.__ordersRenderError = { message: String((err && err.message) || err), at: Date.now() };
  try { console.error('[orders] render failed:', err); } catch (e) {}
  try {
    if (container) {
      // Force the next attempt to rewrite the body instead of treating what is
      // on screen as up-to-date. `_ordersRendered` deliberately stays true:
      // doRender() skips containers that never rendered, so clearing it here
      // would stop the SSE path from ever retrying.
      container._ordersBodyEmpty = true;
      container._ordersSig = null;
    }
  } catch (e2) {}
}

async function _renderOrdersImpl(container, sseData, silent) {
  syncOrdersOverlay(sseData && sseData.orders ? sseData.orders : null);
  if (currentPage !== 'orders') return;
  const _pg = currentPage;
  var _aiBubble = document.getElementById('ai-chat-bubble');
  if (_aiBubble) _aiBubble.style.display = 'none';
  if (currentUser && currentUser.role !== 'admin' && !currentUser.hasApiKeys) {
    if (currentPage !== _pg) return;
    container.innerHTML = `<div class="page-header"><div><h2>Orders</h2></div></div>` + noApiKeysDashboard();
    return;
  }
  if (currentUser && currentUser.approved === 0 && currentUser.hasApiKeys) {
    if (currentPage !== _pg) return;
    container.innerHTML = `<div class="page-header"><div><h2>Orders</h2></div></div><div class="card" style="border-color:rgba(255,145,0,0.3);margin-top:16px;text-align:center;padding:40px 20px;"><div style="font-size:48px;margin-bottom:16px;">🛂</div><h3 style="color:var(--accent-amber);">Account Pending Approval</h3><p style="color:var(--text-tertiary);font-size:14px;max-width:400px;margin:12px auto;">Your API keys have been submitted for admin review.</p><p style="color:var(--text-quaternary);font-size:12px;">Contact admin: +254723472206</p></div>`;
    return;
  }
  // Load order settings from localStorage
  window._ordersSettings = JSON.parse(localStorage.getItem('ordersSettings') || '{"requireRrn":false,"requireProofPaid":false,"requireProofRelease":false,"cryptoFilter":"","fiatFilter":"","dateStart":"","dateEnd":""}');
  // Do NOT clobber the active tab on a data refresh, or every SSE tick would
  // yank the user back to the Orders tab.
  if (window._ordersTab !== 'advanced') window._ordersTab = 'orders';
  window._unreleasedOrderIds = [];
  // Check unreleased orders in background
  _checkUnreleasedOrders();

  const _lu = new Date().toLocaleTimeString();
  var headerHtml = `<div class="page-header"><div><h2>P2P Orders</h2><div class="subtitle">Pending · Completed · Cancelled · <span id="page-last-updated" style="color:var(--text-quaternary);font-size:11px;">Updated ${_lu}</span> <span id="page-countdown" style="color:var(--text-tertiary);font-size:11px;"></span></div>
    <!-- Tab bar -->
    <div style="display:flex;gap:4px;margin:8px 0;">
      <button data-orders-tab="orders" class="orders-tab orders-tab-active" data-on-click="switchOrdersTab('orders')" style="padding:6px 16px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-secondary);color:var(--text-primary);font-size:12px;cursor:pointer;">📋 Orders</button>
      <button data-orders-tab="advanced" class="orders-tab" data-on-click="switchOrdersTab('advanced')" style="padding:6px 16px;border-radius:6px;border:1px solid var(--border-primary);background:transparent;color:var(--text-quaternary);font-size:12px;cursor:pointer;">⚙️ Advanced</button>
    </div>
    <!-- Unreleased orders banner -->
    <div id="unreleased-banner" style="display:none;padding:8px 12px;border-radius:8px;background:rgba(244,67,54,0.08);border:1px solid rgba(244,67,54,0.2);margin-bottom:8px;font-size:12px;color:var(--accent-red);"></div>
    <!-- Unmatched SMS banner (fresh this session) -->
    <div id="sms-unmatched-banner" style="display:none;margin-bottom:8px;"></div>
    <!-- Filter bar (visible only on Orders tab) -->
    <div id="orders-filter-bar" style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-top:8px;">
      <button onclick="freshRefreshOrders()" style="padding:4px 14px;border-radius:6px;border:1px solid #00e6c8;background:rgba(0,230,200,0.1);color:#00e6c8;font-size:12px;cursor:pointer;font-weight:700;" title="Stop poll, clear cache, fetch fresh orders">⟳ Fresh Fetch</button>
      <label style="font-size:12px;color:var(--text-quaternary);"><input type="checkbox" id="orders-auto-refresh" checked onchange="toggleOrdersPoll()"> Auto-refresh (SSE)</label>
      <button data-on-click="exportOrdersWithPicker('csv')" style="padding:3px 8px;border-radius:6px;border:1px solid #448aff;background:transparent;color:var(--accent-blue);font-size:11px;cursor:pointer;" title="Export as CSV">📥 CSV</button>
      <button data-on-click="exportOrdersWithPicker('json')" style="padding:3px 8px;border-radius:6px;border:1px solid #448aff;background:transparent;color:var(--accent-blue);font-size:11px;cursor:pointer;" title="Export as JSON">📥 JSON</button>
      <button data-on-click="showSmsPasteModal()" style="padding:3px 8px;border-radius:6px;border:1px solid #00e676;background:rgba(0,230,118,0.08);color:#00e676;font-size:11px;cursor:pointer;" title="Paste a payment SMS and post its ref to the right buy order chat">📲 Paste SMS</button>
      <button data-on-click="showSmsMatchLog()" style="padding:3px 8px;border-radius:6px;border:1px solid #8d6eff;background:rgba(141,110,255,0.08);color:#b39dff;font-size:11px;cursor:pointer;" title="View the SMS match audit log (what each captured/pasted SMS was matched to)">📋 Match Log</button>
      <button data-on-click="toggleAutoMarkPaidMode()" id="orders-auto-paid-toggle" style="padding:3px 8px;border-radius:6px;border:1px solid var(--border-primary);background:transparent;color:var(--text-quaternary);font-size:11px;cursor:pointer;" title="One-tap: pressing Mark Paid instantly marks the order paid (no confirm) and the captured SMS ref auto-posts to chat">⚡ Auto Mark Paid</button>
      <input id="order-search" placeholder="Search ID, name, amount..." oninput="filterOrders()" style="padding:6px 12px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;width:140px;">
      <select id="order-status-filter" onchange="filterOrders()" style="padding:6px 12px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;">
        <option value="all">All Status</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
        <option value="cancelled">Cancelled</option>
      </select>
      <select id="orders-crypto-filter" data-on-change="applyOrdersAdvancedFilter()" style="padding:6px 12px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;">
        <option value="">All Crypto</option>
        <option value="USDT">USDT</option>
        <option value="BTC">BTC</option>
        <option value="ETH">ETH</option>
      </select>
      <select id="orders-fiat-filter" data-on-change="applyOrdersAdvancedFilter()" style="padding:6px 12px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;">
        <option value="">All Fiat</option>
        <option value="KES">KES</option>
        <option value="USD">USD</option>
        <option value="CNY">CNY</option>
        <option value="NGN">NGN</option>
        <option value="GHS">GHS</option>
      </select>
      <input id="orders-date-start" type="date" data-on-change="applyOrdersAdvancedFilter()" style="padding:5px 8px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:11px;outline:none;max-width:140px;" title="Start date">
      <input id="orders-date-end" type="date" data-on-change="applyOrdersAdvancedFilter()" style="padding:5px 8px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:11px;outline:none;max-width:140px;" title="End date">
      <label style="font-size:11px;color:var(--text-quaternary);display:flex;align-items:center;gap:4px;"><input type="checkbox" id="orders-group-cp-toggle" ${window._ordersSettings.groupByCp ? 'checked' : ''} onchange="toggleOrderSetting('groupByCp',this.checked);triggerPageRefresh()"> Group CP</label>
    </div>
    <!-- Chart container (visible when setting enabled) -->
    <div id="orders-chart-container" style="${window._ordersSettings.showChart !== false ? '' : 'display:none;'}margin:8px 0;padding:12px;background:var(--bg-primary);border-radius:10px;border:1px solid var(--border-primary);height:100px;"></div>
    <div id="pinned-list" style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:6px;"></div>
  </div></div>`;
  var html = headerHtml;
  // headerHtml is re-declared further down for the first-load skeleton and the two
  // blocks are NOT the same length, so pin the body offset here at seed time.
  var _bodyOffset = headerHtml.length;
  try {
    var allOrders = [];
    var orderListError = null;

    if (sseData && sseData.orders) {
      allOrders = sseData.orders;
    } else {
      // Render instantly from whatever is already available (SSE cache), then refresh in background
      if (window._sseOrdersCache && window._sseOrdersCache.orders && window._sseOrdersCache.orders.length) {
        allOrders = window._sseOrdersCache.orders;
      }
      function _applyOrdersData(r) {
        if (currentPage !== 'orders') return;
        if (r && Array.isArray(r.data)) {
          // MERGE, do not replace. The fetch is paged, so assigning r.data over
          // the cache silently dropped every order outside the current page.
          if (r.data.length) window._mergeOrdersIntoCache(r.data);
          window._persistOrdersSnapshot();
          var el = document.getElementById('page-content');
          if (el && el.querySelector('#orders-filter-bar')) scheduleRender();
        }
      }
      // Single fresh OKX fetch (deduped with ui.js _refreshOrdersFromCache) — renders when it arrives.
      // Uses refresh=1 to bypass 5s cache on initial load so orders appear instantly.
      // Subsequent refreshes use cache (SSE push loop refreshes it every ~2-5s).
      // If a fetch is already in flight, queue a follow-up so the fresh data is never dropped
      if (!window.__ordersRefreshBusy) {
        window.__ordersRefreshBusy = true;
        API.get('/api/okx/p2p/order-list?pageSize=100&pageIndex=1&refresh=1')
          .then(_applyOrdersData)
          .catch(function() { orderListError = 'Request failed'; })
          .then(function() {
            window.__ordersRefreshBusy = false;
            if (window.__ordersRefreshQueued) {
              window.__ordersRefreshQueued = false;
              setTimeout(_refreshOrdersFromCache, 0);
            }
          });
      } else {
        window.__ordersRefreshQueued = true;
      }
      if (allOrders.length === 0 && orderListError) {
        // Render skeleton; the SSE push (every 5s) fills it in, or the user retries
      }
    }
    // Merge any pending orders loaded via "Load More" (dedupe by orderId)
    if (window._pendingExtra && window._pendingExtra.length) {
      var _extraIds = {};
      window._pendingExtra = window._pendingExtra.filter(function(o) {
        var s = orderState(o);
        if (s === 'completed' || s === 'canceled' || s === 'cancelled') return false;
        if (!o.orderId) return false;
        _extraIds[o.orderId] = 1;
        return true;
      });
      allOrders = allOrders.filter(function(o) { return !_extraIds[o.orderId]; }).concat(window._pendingExtra);
    }
    window._ordersMap = {};
    // No slice() cap: the map backs order detail, timers and auto-release, and a
    // hard cap here made older loaded orders unreachable ("lost orders").
    allOrders.forEach(function(o) { if (o.orderId) window._ordersMap[o.orderId] = o; });
    if (typeof window.__drainApkBuySmsQueue === 'function') window.__drainApkBuySmsQueue();

    // Use full dataset for stats if available
    var statsOrders = window._ordersAllPages && window._ordersAllPages.length > allOrders.length && window._ordersAllPages.length <= 200 ? window._ordersAllPages : allOrders;

    var _oldCutoff = Date.now() - 86400000 * 30;
    var filterOld = function(arr) { return arr.filter(function(o) { var ts = parseInt(o.completionTimestamp) || parseInt(o.createdTimestamp) || 0; return ts >= _oldCutoff; }); };
    var allCompletedOrders = filterOld(statsOrders.filter(function(o) { return isCompletedOrder(o); }));
    var allCancelledOrders = filterOld(statsOrders.filter(function(o) { var s = orderState(o); return s === 'canceled' || s === 'cancelled'; }));
    var pendingOrders = allOrders.filter(function(o) { var s = orderState(o); return s !== 'completed' && s !== 'canceled' && s !== 'cancelled'; }).slice(0, 30);
var completedOrders = allOrders.filter(function(o) { return isCompletedOrder(o); }).slice(0, 30);
var cancelledOrders = allOrders.filter(function(o) { var s = orderState(o); return s === 'canceled' || s === 'cancelled'; }).slice(0, 30);

    // Build counterparty trade history map
    window._counterpartyCount = {};
    allOrders.forEach(function(o) {
      var cp = o.counterpartyDetail || {};
      var key = cp.nickName || cp.realName || cp.userNo || o.nickName || o.realName || o.userNo || '';
      if (key) window._counterpartyCount[key] = (window._counterpartyCount[key] || 0) + 1;
    });

    // Stats computed from order data (card-info endpoint is too slow — skip it)
    var totalTrades = allCompletedOrders.length;
    var completed1d = allCompletedOrders.filter(function(o) { var ts = parseInt(o.completionTimestamp) || parseInt(o.createdTimestamp) || 0; return ts >= Date.now() - 86400000; }).length;
    var completed30d = allCompletedOrders.filter(function(o) { var ts = parseInt(o.completionTimestamp) || parseInt(o.createdTimestamp) || 0; return ts >= Date.now() - 86400000 * 30; }).length;
      var avgReleaseSec = (sseData && sseData.avgReleaseSec) || (window._sseOrdersCache && window._sseOrdersCache.avgReleaseSec);
      if (!avgReleaseSec && window._serverAvgRelease && Date.now() - window._serverAvgRelease.ts < 300000 && window._serverAvgRelease.v > 0) {
        avgReleaseSec = window._serverAvgRelease.v;
      }
      if (!avgReleaseSec) {
        avgReleaseSec = (function() {
          var sellOrders = allCompletedOrders.filter(function(o) { return o.side === 'sell'; });
          var durations = [];
          sellOrders.forEach(function(o) {
            // OKX's durationAfterCompletionInSeconds is a LIVE "elapsed since the
            // order completed" counter (0 at completion, grows forever), so using
            // it here made the average climb monotonically. Derive from the
            // immutable timestamps instead.
            var d = _orderReleaseSec(o);
            if (d > 0) durations.push(d);
          });
          return durations.length ? Math.round(durations.reduce(function(a, b) { return a + b; }, 0) / durations.length) : 0;
        })();
      }
      // Order lifetime = created -> completed. This block is only the instant
      // paint fallback (30-day window, both sides). The authoritative value is
      // sell-only and all-time, fetched from /api/p2p/order-lifetime below —
      // the client-side number grew every time a buy order completed, which is
      // what made the stat look like it was climbing for no reason.
      var avgLifetimeSec = (function() {
        var durations = [];
        allCompletedOrders.forEach(function(o) {
          var ct = parseInt(o.completionTimestamp);
          var crt = parseInt(o.createdTimestamp);
          if (ct > 0 && crt > 0) durations.push(Math.round((ct - crt) / 1000));
        });
        return durations.length ? Math.round(durations.reduce(function(a, b) { return a + b; }, 0) / durations.length) : 0;
      })();
      // Stable 30-day average from server stats (sell-only, 5-min cache) — fetched in the
      // background so the tab paints instantly; upgrades the stat in place when it arrives.
      if (!window._serverAvgRelease || Date.now() - window._serverAvgRelease.ts > 300000) {
        API.get('/api/p2p/avg-release').then(function(res) {
          var v = parseInt((res && res.data && res.data.avgReleaseTime) || '0');
          window._serverAvgRelease = { v: v > 0 ? v : 0, ts: Date.now() };
          if (v > 0 && currentPage === 'orders' && !document.hidden) {
            var el = document.getElementById('page-content');
            if (el) {
              var as = el.querySelector('[data-stat="avg-release"]');
              if (as) as.textContent = formatTime(Math.round(v));
            }
          }
        }).catch(function() { window._serverAvgRelease = { v: 0, ts: Date.now() }; });
      }
      // All-time sell-only order lifetime from the harvested server cache.
      if (!window._serverAvgLifetime || Date.now() - window._serverAvgLifetime.ts > 300000) {
        API.get('/api/p2p/order-lifetime').then(function(res) {
          var v = parseInt((res && res.data && res.data.avgOrderLifetimeSec) || '0');
          window._serverAvgLifetime = { v: v > 0 ? v : 0, ts: Date.now() };
          if (v > 0 && currentPage === 'orders' && !document.hidden) {
            var el2 = document.getElementById('page-content');
            if (el2) {
              var ls = el2.querySelector('[data-stat="avg-order-lifetime"]');
              if (ls) ls.textContent = formatTime(Math.round(v));
            }
          }
        }).catch(function() { window._serverAvgLifetime = { v: 0, ts: Date.now() }; });
      }
    const timeLeft = o => ordersTimeLeft(o);
    compareOrderChanges(allOrders);
    if (window.__syncAppealedFlags) window.__syncAppealedFlags(allOrders);
    const highlight = window._highlightOrderId;
    window._highlightOrderId = null;

    // ===== Pending Orders Subsection =====
    const buyOrders = pendingOrders.filter(o => o.side !== 'sell');
    const sellOrdersPad = pendingOrders.filter(o => o.side === 'sell');
    const buyUnpaid = buyOrders.filter(o => !orderIsPaid(o));
    const buyPaid = buyOrders.filter(o => orderIsPaid(o));
    const sellUnpaid = sellOrdersPad.filter(o => !orderIsPaid(o));
    const sellPaid = sellOrdersPad.filter(o => orderIsPaid(o));
    // NOTE: there is deliberately no "structure unchanged -> skip render" fast
    // path here. It used to return early whenever only order *contents* changed
    // (showing stale rows) but fall through to a full rebuild the moment a row
    // moved between sections, which is exactly the flash. Callers already gate
    // on a content hash, and the body is patched in place, so rebuilding the
    // body string here is both correct and cheap.
    // FIRST LOAD: build skeleton, then full render below
    if (!container._ordersRendered) {
      // Reuse the headerHtml already built above. It used to be redeclared here
      // with a slightly different length, which made the later
      // html.slice(headerHtml.length) chop 178 characters off the body on first
      // load (missing content at the top of the orders list).
      container.innerHTML = headerHtml + '<div id="orders-body"></div>';
      container._ordersRendered = true;
      // The body is still EMPTY here - rows are appended further down. Mark
      // that, because if the render throws between here and the body write the
      // page is left with a blank list that every later render treats as
      // up-to-date (it would take the "patch" branch and patch nothing).
      container._ordersBodyEmpty = true;
      // First load: proceed to full render below
    }
    if (orderListError && allOrders.length === 0) {
      var friendlyMsg = orderListError.includes('aborted') ? 'Request timed out. The server may be busy — retry.' : orderListError;
      html += `<div class="card" style="border-color:rgba(244,67,54,0.2);margin-bottom:16px;text-align:center;padding:16px;"><span style="color:var(--accent-red);font-size:13px;"> Failed to load orders: ${esc(friendlyMsg)}</span><br><button class="btn btn-sm btn-outline" data-on-click="triggerPageRefresh()" style="margin-top:8px;">Retry</button></div>`;
    }
    html += `<div data-order-status="pending"><div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px;"><h3 style="margin:16px 0 12px;font-size:15px;color:var(--accent-amber);">⏳ Pending Orders</h3><div style="display:flex;gap:6px;"><button onclick="freshRefreshOrders('buy')" style="padding:4px 12px;border-radius:6px;border:1px solid #448aff;background:rgba(68,138,255,0.1);color:#448aff;font-size:12px;cursor:pointer;font-weight:700;" title="Refresh pending buy orders">⟳ Buy</button><button onclick="loadMorePendingOrders()" style="padding:4px 12px;border-radius:6px;border:1px solid #7c5cff;background:rgba(124,92,255,0.1);color:#9d85ff;font-size:12px;cursor:pointer;font-weight:700;" title="Load older pending orders">⬇ Load More</button><button id="bulk-cancel-btn" class="btn btn-sm btn-outline" data-on-click="bulkCancelFilteredOrders()" style="font-size:10px;padding:4px 10px;color:var(--accent-red);border-color:#f4433644;" title="Cancel all visible pending orders matching current filters">🗑️ Bulk Cancel</button></div></div>`;

    const _groupByCp = window._ordersSettings.groupByCp;
    if (_groupByCp) {
      const allPending = [...buyUnpaid.map(o=>({o,t:'buyUnpaid'})), ...buyPaid.map(o=>({o,t:'buyPaid'})), ...sellUnpaid.map(o=>({o,t:'sellUnpaid'})), ...sellPaid.map(o=>({o,t:'sellPaid'}))];
      const groups = {};
      allPending.forEach(({o,t}) => {
        const n = (getCounterpartyInfo(o) || {}).name;
        if (!groups[n]) groups[n] = [];
        groups[n].push({o,t});
      });
      const cpNames = Object.keys(groups);
      if (cpNames.length === 0) {
        html += `<div class="card" style="border-color:rgba(68,138,255,0.2);margin-bottom:16px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px;">
            <h3 style="margin:0;font-size:15px;color:var(--accent-blue);">🤝 Orders by Counterparty</h3>
            <span style="font-size:12px;color:var(--text-quaternary);">${buyPaid.length + buyUnpaid.length + sellPaid.length + sellUnpaid.length} orders</span>
          </div>`;
        html += `<div style="text-align:center;padding:20px;background:var(--bg-primary);border-radius:10px;"><span style="color:var(--text-quaternary);font-size:13px;">No pending orders</span></div>`;
        html += `</div>`;
      } else {
        cpNames.forEach(name => {
          const items = groups[name];
          const buyU = items.filter(x=>x.t==='buyUnpaid').map(x=>x.o);
          const buyP = items.filter(x=>x.t==='buyPaid').map(x=>x.o);
          const sellU = items.filter(x=>x.t==='sellUnpaid').map(x=>x.o);
          const sellP = items.filter(x=>x.t==='sellPaid').map(x=>x.o);
          html += `<div class="card" style="border-color:rgba(68,138,255,0.2);margin-bottom:16px;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px;">
              <h3 style="margin:0;font-size:15px;color:var(--accent-blue);">🤝 ${esc(name)}</h3>
              <span style="font-size:12px;color:var(--text-quaternary);">${buyP.length + buyU.length} buy · ${sellP.length + sellU.length} sell</span>
            </div>`;
          if (buyU.length > 0) {
            html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-green);">🟢 Buy — Unpaid</h4>
            <div class="table-container"><table style="font-size:12px;"><thead><tr>
              <th>Order ID</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Rate</th><th>Countdown</th><th></th>
            </tr></thead><tbody>`;
            buyU.forEach(o => {
              const tl = ordersTimeLeft(o);
              const isH = o.orderId === highlight;
              html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
                <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
                <td><strong>${o.cryptoCurrency || '-'}</strong></td>
                <td>${o.cryptoAmount || '-'}</td>
                <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
                <td>${o.unitPrice || '-'}</td>
                <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
                <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
                <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
                  <button class="btn btn-sm btn-primary" data-on-click="ordersMarkBuyOrderPaid('${esc(o.orderId)}')" style="font-size:13px;padding:8px 16px;background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);font-weight:700;">💵 Pay</button>
                  <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
                </div></td>
              </tr>`;
            });
            html += `</tbody></table></div>`;
          }
          if (buyP.length > 0) {
            html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-blue);">🔵 Buy — Paid</h4>
            <div class="table-container"><table style="font-size:12px;"><thead><tr>
              <th>Order ID</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Rate</th><th>Countdown</th><th></th>
            </tr></thead><tbody>`;
            buyP.forEach(o => {
              const tl = ordersTimeLeft(o);
              const isH = o.orderId === highlight;
              html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
                <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
                <td><strong>${o.cryptoCurrency || '-'}</strong></td>
                <td>${o.cryptoAmount || '-'}</td>
                <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
                <td>${o.unitPrice || '-'}</td>
                <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
                <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
                <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
                  <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
                </div></td>
              </tr>`;
            });
            html += `</tbody></table></div>`;
          }
          if (sellU.length > 0) {
            html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-red);">🔴 Sell — Unpaid</h4>
            <div class="table-container"><table style="font-size:12px;"><thead><tr>
              <th>Order ID</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Rate</th><th>Countdown</th><th></th>
            </tr></thead><tbody>`;
            sellU.forEach(o => {
              const tl = ordersTimeLeft(o);
              const isH = o.orderId === highlight;
              html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
                <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
                <td><strong>${o.cryptoCurrency || '-'}</strong></td>
                <td>${o.cryptoAmount || '-'}</td>
                <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
                <td>${o.unitPrice || '-'}</td>
                <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
                <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
                <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
                  ${window._gotPaymentButtonHtml(o.orderId, window.getManualAutoReleaseState(o.orderId))}
                  <button class="btn btn-sm btn-outline" data-on-click="remindOrder('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Remind</button>
                  <button class="btn btn-sm btn-outline" data-on-click="cancelOrderWithReason('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Cancel</button>
                  <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
                </div></td>
              </tr>`;
            });
            html += `</tbody></table></div>`;
          }
          if (sellP.length > 0) {
            html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-red);">🔴 Sell — Paid</h4>
            <div class="table-container"><table style="font-size:12px;"><thead><tr>
              <th style="width:32px;"></th>
              <th>Order ID</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Rate</th><th>Countdown</th><th></th>
            </tr></thead><tbody>`;
            sellP.forEach(o => {
              const tl = ordersTimeLeft(o);
              const isH = o.orderId === highlight;
              const appealed = window.isAppealedOrder(o);
              html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
                <td>${appealed ? '<span style="font-size:12px;" title="Under appeal — release disabled">⚖️</span>' : '<input type="checkbox" class="sell-check" value="' + o.orderId + '" checked>'}</td>
                <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
                <td><strong>${o.cryptoCurrency || '-'}</strong></td>
                <td>${o.cryptoAmount || '-'}</td>
                <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
                <td>${o.unitPrice || '-'}</td>
                <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
                <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
                <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
      ${appealed ? '<span style="font-size:10px;padding:4px 8px;border-radius:4px;background:rgba(244,67,54,0.12);border:1px solid rgba(244,67,54,0.35);color:var(--accent-red);font-weight:700;white-space:nowrap;">⚖️ Under Appeal</span>' : '<button class="btn btn-sm btn-primary" data-on-click="releaseSingleOrder(\'' + esc(o.orderId) + '\')" style="font-size:10px;padding:5px 10px;">Release</button>'}
      ${appealed ? '' : window._gotPaymentButtonHtml(o.orderId, window.getManualAutoReleaseState(o.orderId))}
                  <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
                </div></td>
              </tr>`;
            });
            html += `</tbody></table></div>`;
          }
          html += `</div>`;
        });
      }
      html += `</div>`;
    } else {
    // Card 1: Buy Orders
    html += `<div class="card" style="border-color:rgba(68,138,255,0.2);margin-bottom:16px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px;">
        <h3 style="margin:0;font-size:15px;color:var(--accent-blue);">📥 Buy Orders</h3>
        <span data-counter="buy-count" style="font-size:12px;color:var(--text-quaternary);">${buyPaid.length} paid · ${buyUnpaid.length} unpaid</span>
      </div>`;
    if (buyOrders.length === 0) {
      html += `<div style="text-align:center;padding:20px;background:var(--bg-primary);border-radius:10px;"><span style="color:var(--text-quaternary);font-size:13px;">No buy orders</span></div>`;
    } else {
      if (buyUnpaid.length > 0) {
        html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-green);">🟢 Unpaid — Pay Now</h4>
        <div class="table-container"><table data-section="buy-unpaid" style="font-size:12px;"><thead><tr>
          <th>Order ID</th><th>Role</th><th>Client</th><th>Account</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Rate</th><th>Countdown</th><th></th>
        </tr></thead><tbody>`;
        buyUnpaid.forEach(o => {
          const cp = getCounterpartyInfo(o) || {};
          const tl = ordersTimeLeft(o);
          const isH = o.orderId === highlight;
          html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
            <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
            <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(91,124,250,0.15);color:var(--accent-blue);font-weight:600;">${orderRole(o)}</span></td>
            <td style="font-size:11px;"><div>${cp.name}${tradedBadge(o)}${smsReceivedBadge(o)}</div><div style="display:flex;align-items:center;gap:4px;"><span style="color:var(--text-quaternary);font-size:10px;">${cp.phone}</span><button data-on-click="copyText('${esc(cp.phone)}')" style="background:none;border:none;cursor:pointer;padding:1px 4px;font-size:9px;color:var(--text-tertiary);border:1px solid #33334a;border-radius:3px;" title="Copy">Copy</button></div></td>
            <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
            <td><strong>${o.cryptoCurrency || '-'}</strong></td>
            <td>${o.cryptoAmount || '-'}</td>
            <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
            <td>${o.unitPrice || '-'}</td>
            <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
            <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
            <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
              <button class="btn btn-sm btn-primary" data-on-click="ordersMarkBuyOrderPaid('${esc(o.orderId)}')" style="font-size:13px;padding:8px 16px;background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);font-weight:700;">💵 Mark Paid</button>
              <button class="btn btn-sm btn-outline" data-on-click="payNowOrder('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;border-color:var(--accent-blue);color:var(--accent-blue);">⚡ Pay now</button>
              <button class="btn btn-sm btn-outline" data-on-click="remindOrder('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Remind</button>
              <button class="btn btn-sm btn-outline" data-on-click="cancelOrderWithReason('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Cancel</button>
              <button class="btn btn-sm btn-outline" data-on-click="showDisputeModal('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-red);border-color:#f4433644;">Dispute</button>
              <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
            </div></td>
          </tr>`;
        });
        html += `</tbody></table></div>`;
      }
      if (buyPaid.length > 0) {
        html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-blue);">🔵 Pending Release</h4>
        <div class="table-container"><table data-section="buy-paid" style="font-size:12px;"><thead><tr>
          <th>Order ID</th><th>Role</th><th>Client</th><th>Account</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Countdown</th><th></th>
        </tr></thead><tbody>`;
        buyPaid.forEach(o => {
          const cp = getCounterpartyInfo(o) || {};
          const tl = ordersTimeLeft(o);
          const isH = o.orderId === highlight;
          html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
            <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
            <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(91,124,250,0.15);color:var(--accent-blue);font-weight:600;">${orderRole(o)}</span></td>
            <td style="font-size:11px;"><div>${cp.name}${tradedBadge(o)}${smsReceivedBadge(o)}</div><div style="display:flex;align-items:center;gap:4px;"><span style="color:var(--text-quaternary);font-size:10px;">${cp.phone}</span><button data-on-click="copyText('${esc(cp.phone)}')" style="background:none;border:none;cursor:pointer;padding:1px 4px;font-size:9px;color:var(--text-tertiary);border:1px solid #33334a;border-radius:3px;" title="Copy">Copy</button></div></td>
            <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
            <td><strong>${o.cryptoCurrency || '-'}</strong></td>
            <td>${o.cryptoAmount || '-'}</td>
            <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
            <td>${o.unitPrice || '-'}</td>
            <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
            <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
            <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
              <button class="btn btn-sm btn-outline" data-on-click="appealOrder('${esc(o.orderId)}')" style="font-size:11px;padding:6px 12px;color:var(--accent-amber);border-color:rgba(255,179,0,0.27);font-weight:600;">⚠️ Appeal</button>
              <button class="btn btn-sm btn-outline" data-on-click="remindOrder('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Remind</button>
              <button class="btn btn-sm btn-outline" data-on-click="showDisputeModal('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-red);border-color:#f4433644;">Dispute</button>
              <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
            </div></td>
          </tr>`;
        });
        html += `</tbody></table></div>`;
      }
    }
    html += `</div>`;
    html += `<div style="display:flex;justify-content:flex-end;margin:0 0 8px;"><button onclick="freshRefreshOrders('sell')" style="padding:4px 12px;border-radius:6px;border:1px solid var(--accent-amber);background:var(--accent-amber-glow);color:var(--accent-amber);font-size:12px;cursor:pointer;font-weight:700;" title="Refresh pending sell orders">⟳ Refresh Sell Orders</button></div>`;
    // Card 2: Sell Orders
    const sellCount = sellUnpaid.length + sellPaid.length;
    html += `${sellPaid.length > 0 ? `<div style="text-align:center;margin-bottom:12px;"><button class="btn btn-primary" data-on-click="releaseAllUnreleased()">Release All Selected</button></div>` : ''}`;
    html += `<div class="card" style="border-color:rgba(244,67,54,0.2);margin-bottom:16px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px;">
        <h3 style="margin:0;font-size:15px;color:var(--accent-red);">📤 Sell Orders</h3>
        <span data-counter="sell-count" style="font-size:12px;color:var(--text-quaternary);">${sellPaid.length} paid · ${sellUnpaid.length} unpaid</span>
      </div>`;
    if (sellCount === 0) {
      html += `<div style="text-align:center;padding:20px;background:var(--bg-primary);border-radius:10px;"><span style="color:var(--text-quaternary);font-size:13px;">No sell orders</span></div>`;
    } else {
      if (sellUnpaid.length > 0) {
        html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-green);">🟢 Unpaid — Waiting for Buyer Payment</h4>
        <div class="table-container"><table data-section="sell-unpaid" style="font-size:12px;"><thead><tr>
          <th>Order ID</th><th>Role</th><th>Client</th><th>Account</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Countdown</th><th></th>
        </tr></thead><tbody>`;
        sellUnpaid.forEach(o => {
          const cp = getCounterpartyInfo(o) || {};
          const tl = ordersTimeLeft(o);
          const isH = o.orderId === highlight;
          html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
            <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
            <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(245,69,92,0.15);color:var(--accent-red);font-weight:600;">${orderRole(o)}</span></td>
            <td style="font-size:11px;"><div>${cp.name}${tradedBadge(o)}${smsReceivedBadge(o)}</div><div style="display:flex;align-items:center;gap:4px;"><span style="color:var(--text-quaternary);font-size:10px;">${cp.phone}</span><button data-on-click="copyText('${esc(cp.phone)}')" style="background:none;border:none;cursor:pointer;padding:1px 4px;font-size:9px;color:var(--text-tertiary);border:1px solid #33334a;border-radius:3px;" title="Copy">Copy</button></div></td>
            <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
            <td><strong>${o.cryptoCurrency || '-'}</strong></td>
            <td>${o.cryptoAmount || '-'}</td>
            <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
            <td>${o.unitPrice || '-'}</td>
            <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
            <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
            <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
              ${window._gotPaymentButtonHtml(o.orderId, window.getManualAutoReleaseState(o.orderId))}
              <button class="btn btn-sm btn-outline" data-on-click="remindOrder('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Remind</button>
              <button class="btn btn-sm btn-outline" data-on-click="cancelOrderWithReason('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Cancel</button>
              <button class="btn btn-sm btn-outline" data-on-click="showDisputeModal('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-red);border-color:#f4433644;">Dispute</button>
              <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
            </div></td>
          </tr>`;
        });
        html += `</tbody></table></div>`;
      }
      if (sellPaid.length > 0) {
        html += `<h4 style="margin:12px 0 8px;font-size:13px;color:var(--accent-red);">🔴 Paid — Release Crypto</h4>
        <div class="table-container" style="margin-bottom:12px;"><table data-section="sell-paid" style="font-size:12px;"><thead><tr>
          <th style="width:32px;"><input type="checkbox" id="select-all-sell" onchange="toggleAllSell()"></th>
          <th>Order ID</th><th>Role</th><th>Client</th><th>Account</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Countdown</th><th></th>
        </tr></thead><tbody>`;
        sellPaid.forEach(o => {
          const cp = getCounterpartyInfo(o) || {};
          const tl = ordersTimeLeft(o);
          const isH = o.orderId === highlight;
          const appealed = window.isAppealedOrder(o);
          html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}"${isH ? ' style="background:var(--accent-amber-glow)!important;border:2px solid var(--accent-amber)!important;box-shadow:0 0 12px rgba(255,179,0,0.35);"' : ' style="border-bottom:1px solid #1e1e2e;"'}>
            <td>${appealed ? '<span style="font-size:12px;" title="Under appeal — release disabled">⚖️</span>' : '<input type="checkbox" class="sell-check" value="' + o.orderId + '" checked>'}</td>
            <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span><span data-on-click="event.stopPropagation();togglePinOrder('${(o.orderId || '')}')" style="cursor:pointer;font-size:10px;margin-left:2px;" title="Pin/unpin">📌</span></td>
            <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(245,69,92,0.15);color:var(--accent-red);font-weight:600;">${orderRole(o)}</span></td>
            <td style="font-size:11px;"><div>${cp.name}${tradedBadge(o)}${smsReceivedBadge(o)}</div><div style="display:flex;align-items:center;gap:4px;"><span style="color:var(--text-quaternary);font-size:10px;">${cp.phone}</span><button data-on-click="copyText('${esc(cp.phone)}')" style="background:none;border:none;cursor:pointer;padding:1px 4px;font-size:9px;color:var(--text-tertiary);border:1px solid #33334a;border-radius:3px;" title="Copy">Copy</button></div></td>
            <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
            <td><strong>${o.cryptoCurrency || '-'}</strong></td>
            <td>${o.cryptoAmount || '-'}</td>
            <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
            <td>${o.unitPrice || '-'}</td>
            <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
            <td><span data-timer-id="${o.orderId}" style="font-size:10px;color:var(--accent-amber);">${tl}</span></td>
            <td><div style="display:flex;gap:4px;flex-wrap:wrap;">
              ${appealed ? '<span style="font-size:10px;padding:4px 8px;border-radius:4px;background:rgba(244,67,54,0.12);border:1px solid rgba(244,67,54,0.35);color:var(--accent-red);font-weight:700;white-space:nowrap;">⚖️ Under Appeal</span>' : '<button class="btn btn-sm btn-primary" data-on-click="releaseSingleOrder(\'' + esc(o.orderId) + '\')" style="font-size:10px;padding:5px 10px;">Release</button>'}
              ${appealed ? '' : window._gotPaymentButtonHtml(o.orderId, window.getManualAutoReleaseState(o.orderId))}
              <button class="btn btn-sm btn-outline" data-on-click="markOrderUnpaid('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-amber);border-color:rgba(255,179,0,0.27);">Mark Unpaid</button>
              <button class="btn btn-sm btn-outline" data-on-click="remindOrder('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Remind</button>
              <button class="btn btn-sm btn-outline" data-on-click="cancelOrderWithReason('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;">Cancel</button>
              <button class="btn btn-sm btn-outline" data-on-click="showDisputeModal('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-red);border-color:#f4433644;">Dispute</button>
              <button class="btn btn-sm btn-outline" data-on-click="showOrderDetail('${esc(o.orderId)}')" style="font-size:10px;padding:5px 8px;color:var(--accent-blue);">Detail</button>
            </div></td>
          </tr>`;
        });
        html += `</tbody></table></div>`;
      }
    }
    html += `</div>`;
    html += `</div>`;
    }

    // ===== Stats Bar =====
    html += `<div data-section="stats-bar" style="display:flex;gap:12px;margin-bottom:12px;flex-wrap:wrap;">
      <div style="padding:8px 14px;background:rgba(0,210,104,0.08);border-radius:8px;font-size:12px;">
        <span style="color:var(--text-quaternary);">Avg Release Time:</span>
        <strong data-stat="avg-release" style="color:var(--accent-green);margin-left:4px;">${formatTime(Math.round(avgReleaseSec))}</strong>
      </div>
      <div style="padding:8px 14px;background:rgba(255,152,0,0.08);border-radius:8px;font-size:12px;">
        <span style="color:var(--text-quaternary);">Avg Order Lifetime:</span>
        <strong data-stat="avg-order-lifetime" style="color:var(--accent-amber);margin-left:4px;">${formatTime(Math.round(avgLifetimeSec))}</strong>
      </div>
      <div style="padding:8px 14px;background:rgba(91,124,250,0.08);border-radius:8px;font-size:12px;">
        <span style="color:var(--text-quaternary);">Total Trades:</span>
        <strong data-stat="total-trades" style="color:var(--accent-blue);margin-left:4px;">${totalTrades.toLocaleString()}</strong>
      </div>

    </div>`;

    // ===== Completed Section (searchable, paginated, max 50, 10 at a time) =====
    var _filterVal = (document.getElementById('order-status-filter')?.value || 'all');
    if (_filterVal === 'all' || _filterVal === 'completed') {
    const compSearch = (window._completedSearch || '').trim().toLowerCase();
    const compFiltered = compSearch ? completedOrders.filter(o => (o.orderId || '').toLowerCase().includes(compSearch)) : completedOrders;
    const compVisible = window._completedVisible || 10;
    window.__cachedCompleted = completedOrders; window.__cachedCancelled = cancelledOrders;
    html += `<div class="card" data-order-status="completed" style="border-color:rgba(0,200,83,0.1);margin-bottom:16px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
        <h3 style="margin:0;font-size:16px;color:var(--accent-green);">✓ Completed Orders</h3>
        <span data-counter="completed-count" style="font-size:12px;color:var(--text-quaternary);">Showing ${Math.min(compVisible, compFiltered.length)} of ${compFiltered.length}</span>
      </div>
      <div style="display:flex;gap:8px;margin-bottom:8px;">
        <input type="text" id="completed-search-input" placeholder="Search by Order ID..." value="${compSearch}" onkeydown="if(event.key==='Enter')searchCompletedOrders()" style="flex:1;padding:8px 10px;border-radius:8px;border:1px solid rgba(255,255,255,0.1);background:rgba(6,6,12,0.6);color:var(--text-primary);font-size:12px;outline:none;">
        <button class="btn btn-sm btn-outline" data-on-click="searchCompletedOrders()" style="padding:8px 16px;">Search</button>
        ${compSearch ? `<button class="btn btn-sm btn-outline" data-on-click="clearCompletedSearch()" style="padding:8px 16px;">Clear</button>` : ''}
      </div>`;
    html += `<div class="table-container"><table data-section="completed" style="font-size:12px;"><thead><tr>
      <th>Order ID</th><th>Role</th><th>Client</th><th>Account</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Price</th><th>Rate</th><th>Side</th><th>Completion</th><th>Release Time</th><th></th>
    </tr></thead><tbody>`;
    if (compFiltered.length === 0) {
      html += `<tr><td colspan="13" style="text-align:center;color:var(--text-quaternary);padding:16px;font-size:12px;">${compSearch ? 'No orders match "' + compSearch + '"' : 'No completed orders yet'}</td></tr>`;
    } else {
      const compSlice = compFiltered.slice(0, compVisible);
      compSlice.slice().reverse().forEach(o => {
        const cp = getCounterpartyInfo(o) || {};
        const releaseSec = _orderReleaseSec(o);
    const releaseTime = releaseSec > 0 ? formatTime(releaseSec) : '<span style="color:var(--text-quaternary);font-size:11px;">Instant</span>';
        html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}" style="cursor:pointer;" data-on-click="viewOrder('${esc(o.orderId || '')}')">
          <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="event.stopPropagation();copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span></td>
          <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(0,210,104,0.15);color:var(--accent-green);font-weight:600;">${orderRole(o)}</span></td>
          <td style="font-size:11px;">${cp.name}</td>
          <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
          <td><strong>${o.cryptoCurrency || '-'}</strong></td>
          <td>${o.cryptoAmount || '-'}</td>
          <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
          <td>${o.unitPrice || '-'}</td>
          <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
          <td><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></td>
          <td style="font-size:10px;color:var(--text-quaternary);">${o.completionType || '-'}</td>
          <td style="font-size:11px;">${releaseTime}</td>
          <td><div style="display:flex;gap:4px;">
            <button class="btn btn-sm btn-outline" data-on-click="event.stopPropagation();_resendThankYou('${esc(o.orderId || '')}')" style="font-size:10px;padding:4px 8px;color:var(--accent-green);border-color:rgba(0,200,83,0.3);" title="Send thank-you note">💌 Thank</button>
            <button class="btn btn-sm btn-outline" data-on-click="event.stopPropagation();showOrderDetail('${esc(o.orderId || '')}')" style="font-size:10px;padding:4px 8px;">Detail</button>
          </div></td>
        </tr>`;
      });
    }
    html += `</tbody></table></div>`;
    if (!compSearch && compFiltered.length > 0 && compVisible < completedOrders.length) {
      const next = Math.min(10, completedOrders.length - compVisible);
      html += `<div style="text-align:center;margin-top:12px;">
        <button class="btn btn-outline" data-on-click="showMoreCompleted()" style="padding:8px 24px;">
          Show ${next} More (${compVisible + 1}-${compVisible + next})
        </button>
      </div>`;
    }
    html += `</div>`;
    } // end if completed visible

    // ===== Cancelled Section (paginated, max 50, 10 at a time) =====
    if (_filterVal === 'all' || _filterVal === 'cancelled') {
    const cancVisible = window._cancelledVisible || 10;
    html += `<div class="card" data-order-status="cancelled" style="border-color:rgba(244,67,54,0.1);margin-bottom:16px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
        <h3 style="margin:0;font-size:16px;color:var(--accent-red);">✕ Cancelled Orders</h3>
        <span data-counter="cancelled-count" style="font-size:12px;color:var(--text-quaternary);">Showing ${Math.min(cancVisible, cancelledOrders.length)} of ${cancelledOrders.length}</span>
      </div>`;
    if (cancelledOrders.length === 0) {
      html += `<div style="text-align:center;padding:20px;background:var(--bg-primary);border-radius:10px;"><span style="color:var(--text-quaternary);font-size:13px;">No cancelled orders</span></div>`;
    } else {
      const cancSlice = cancelledOrders.slice(0, cancVisible);
      html += `<div class="table-container"><table data-section="cancelled" style="font-size:12px;"><thead><tr>
        <th>Order ID</th><th>Role</th><th>Client</th><th>Account</th><th>Asset</th><th>Amount</th><th>Fiat</th><th>Side</th><th></th>
      </tr></thead><tbody>`;
      cancSlice.slice().reverse().forEach(o => {
        const cp = getCounterpartyInfo(o) || {};
        html += `<tr data-row-id="${esc(o.orderId||'')}" data-row-sig="${esc(_rowSig(o))}" style="opacity:0.6;cursor:pointer;" data-on-click="viewOrder('${esc(o.orderId || '')}')">
          <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="event.stopPropagation();copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span></td>
          <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(0,210,104,0.15);color:var(--accent-green);font-weight:600;">${orderRole(o)}</span></td>
          <td style="font-size:11px;">${cp.name}</td>
          <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
          <td><strong>${o.cryptoCurrency || '-'}</strong></td>
          <td>${o.cryptoAmount || '-'}</td>
          <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
          <td><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></td>
          <td><div style="display:flex;gap:4px;">
            <button class="btn btn-sm btn-outline" data-on-click="event.stopPropagation();_resendCancelledNote('${esc(o.orderId || '')}','${o.side || 'sell'}')" style="font-size:10px;padding:4px 8px;color:${o.side === 'buy' ? 'var(--accent-amber)' : 'var(--accent-green)'};border-color:${o.side === 'buy' ? 'rgba(255,179,0,0.3)' : 'rgba(0,200,83,0.3)'};" title="${o.side === 'buy' ? 'Send apology note' : 'Send thank-you note'}">💌 ${o.side === 'buy' ? 'Apologize' : 'Note'}</button>
            <button class="btn btn-sm btn-outline" data-on-click="event.stopPropagation();showOrderDetail('${esc(o.orderId || '')}')" style="font-size:10px;padding:4px 8px;">Detail</button>
          </div></td>
        </tr>`;
      });
      html += `</tbody></table></div>`;
      if (cancVisible < cancelledOrders.length) {
        const next = Math.min(10, cancelledOrders.length - cancVisible);
        html += `<div style="text-align:center;margin-top:12px;">
          <button class="btn btn-outline" data-on-click="showMoreCancelled()" style="padding:8px 24px;">
            Show ${next} More (${cancVisible + 1}-${cancVisible + next})
          </button>
        </div>`;
      }
    }
    html += `</div>`;
    } // end if cancelled visible
    // Split: headerHtml stays visible, only orders content goes into tab-content wrapper
    var ordersContent = html.slice(_bodyOffset);
    html = headerHtml + `<div id="orders-tab-content">${ordersContent}</div>
<div id="orders-advanced-content" style="display:none;">
  <div class="card" style="margin-bottom:16px;">
    <h3 style="margin:0 0 12px 0;font-size:15px;">⚙️ Advanced Order Settings</h3>
    <p style="color:var(--text-quaternary);font-size:12px;margin-bottom:16px;">All settings are stored in your browser (localStorage). Changes apply immediately.</p>
    <div style="display:flex;flex-direction:column;gap:8px;">
      <h4 style="margin:8px 0 4px;font-size:13px;">📋 Order Processing</h4>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-rrn" ${window._ordersSettings.requireRrn ? 'checked' : ''} onchange="toggleOrderSetting('requireRrn',this.checked)" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">💰 M-Pesa RRN Code on Mark Paid</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Ask for M-Pesa transaction code when marking order as paid</span></div>
      </label>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-proof-paid" ${window._ordersSettings.requireProofPaid ? 'checked' : ''} onchange="toggleOrderSetting('requireProofPaid',this.checked)" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">🖼️ Payment Proof on Mark Paid</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Prompt for payment screenshot URL when marking paid</span></div>
      </label>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-proof-release" ${window._ordersSettings.requireProofRelease ? 'checked' : ''} onchange="toggleOrderSetting('requireProofRelease',this.checked)" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">🖼️ Payment Proof on Release Crypto</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Prompt for proof URL when releasing crypto</span></div>
      </label>
    </div>
    <div style="border-top:1px solid #1e1e2e;margin:12px 0;"></div>
    <div style="display:flex;flex-direction:column;gap:8px;">
      <h4 style="margin:0 0 4px;font-size:13px;">⚡ SMS Auto-Release (Sell orders)</h4>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-sms-autorelease" onchange="saveSmsAutoReleaseSettings()" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">🚀 Auto-release crypto when a payment SMS matches a sell order</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Only high-confidence matches (payer name + exact amount) are released automatically. Amount-only matches stay manual so nothing crypto leaves your account by accident. This setting is saved to your account (works on any device).</span></div>
      </label>
      <div style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);">
        <span style="font-size:12px;color:var(--text-tertiary);white-space:nowrap;">Max auto-release amount (KES):</span>
        <input id="orders-setting-sms-autorelease-cap" type="number" min="0" step="100" placeholder="0 = no limit" style="padding:5px 8px;border-radius:6px;border:1px solid var(--border-primary);background:#0d0d12;color:var(--text-primary);font-size:12px;width:130px;" onchange="saveSmsAutoReleaseSettings()">
        <span style="font-size:11px;color:var(--text-tertiary);">0 = no cap. Payments above the cap never auto-release.</span>
      </div>
      <div id="orders-setting-sms-autorelease-status" style="font-size:11px;color:var(--text-tertiary);"></div>
    </div>
    <div style="border-top:1px solid #1e1e2e;margin:12px 0;"></div>
    <div style="display:flex;flex-direction:column;gap:8px;">
      <h4 style="margin:0 0 4px;font-size:13px;">🔔 Notifications & Display</h4>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-audio-alert" ${window._ordersSettings.audioAlert ? 'checked' : ''} onchange="toggleOrderSetting('audioAlert',this.checked)" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">🔊 Audio Alert on New Orders</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Play a beep when a new pending order arrives</span></div>
      </label>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-group-cp" ${window._ordersSettings.groupByCp ? 'checked' : ''} onchange="toggleOrderSetting('groupByCp',this.checked);if(currentPage==='orders')triggerPageRefresh()" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">👥 Group Pending by Counterparty</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Group pending orders under each counterparty name</span></div>
      </label>
      <label style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);cursor:pointer;">
        <input type="checkbox" id="orders-setting-show-chart" ${window._ordersSettings.showChart !== false ? 'checked' : ''} onchange="toggleOrderSetting('showChart',this.checked);if(currentPage==='orders')triggerPageRefresh()" style="width:18px;height:18px;">
        <div><strong style="font-size:13px;">📊 Show 7-Day Order Chart</strong><br><span style="font-size:11px;color:var(--text-tertiary);">Display mini chart at top showing order volume</span></div>
      </label>
    </div>
    <div style="border-top:1px solid #1e1e2e;margin:12px 0;"></div>
    <div style="display:flex;flex-direction:column;gap:8px;">
      <h4 style="margin:0 0 4px;font-size:13px;">🧹 Auto-Dismiss Completed/Cancelled</h4>
      <div style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);">
        <span style="font-size:12px;color:var(--text-tertiary);white-space:nowrap;">Hide older than:</span>
        <select id="orders-setting-auto-dismiss" onchange="toggleOrderSetting('autoDismiss',this.value);if(currentPage==='orders')triggerPageRefresh()" style="flex:1;padding:6px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;">
          <option value="0" ${!window._ordersSettings.autoDismiss || window._ordersSettings.autoDismiss === '0' ? 'selected' : ''}>Never</option>
          <option value="1" ${window._ordersSettings.autoDismiss === '1' ? 'selected' : ''}>1 day</option>
          <option value="3" ${window._ordersSettings.autoDismiss === '3' ? 'selected' : ''}>3 days</option>
          <option value="7" ${window._ordersSettings.autoDismiss === '7' ? 'selected' : ''}>7 days</option>
          <option value="30" ${window._ordersSettings.autoDismiss === '30' ? 'selected' : ''}>30 days</option>
        </select>
      </div>
    </div>
    <div style="border-top:1px solid #1e1e2e;margin:12px 0;"></div>
    <div style="display:flex;flex-direction:column;gap:8px;">
      <h4 style="margin:0 0 4px;font-size:13px;">💾 Filter Presets</h4>
      <div style="display:flex;gap:8px;flex-wrap:wrap;">
        <select id="orders-preset-select" style="flex:1;padding:6px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;" data-on-change="loadFilterPreset()">
          <option value="">— Load Preset —</option>
        </select>
        <button class="btn btn-sm btn-outline" data-on-click="saveFilterPreset()" style="white-space:nowrap;">💾 Save</button>
        <button class="btn btn-sm btn-outline" data-on-click="deleteFilterPreset()" style="white-space:nowrap;color:var(--accent-red);border-color:#f4433644;">✕ Del</button>
      </div>
      <div id="orders-presets-list" style="font-size:11px;color:var(--text-quaternary);"></div>
    </div>
    <div style="border-top:1px solid #1e1e2e;margin:12px 0;"></div>
    <div style="display:flex;flex-direction:column;gap:8px;">
      <h4 style="margin:0 0 4px;font-size:13px;">📌 Pinned Orders</h4>
      <div id="orders-pinned-list" style="font-size:11px;color:var(--text-quaternary);"></div>
    </div>
  </div>
</div>`;
    if (currentPage !== _pg) return;
    // `html` was seeded with headerHtml, so everything after it is body markup.
    var bodyHtml = html.slice(_bodyOffset);
    var _bodyEl = document.getElementById('orders-body');

    // ---- No-op guard --------------------------------------------------------
    // If every rendered row is byte-identical to what is already on screen there
    // is nothing to draw, so DO NOT touch the DOM. Touching it (even with the
    // same markup) makes the browser tear down and rebuild every row, which is
    // what the user sees as a flash. Countdown ticks, stats polls, SSE pushes
    // that repeat the same snapshot and chart refreshes all land here.
    var _sigRows = (bodyHtml.match(/data-row-sig="[^"]*"/g) || []).join('|');
    // Every row (pending, completed and cancelled) is tagged, and _sigRows keeps
    // them in document order, so a row moving between sections changes the sig
    // even when its own fields are unchanged. Section counts are belt-and-braces.
    var _bodySig = _sigRows
      + '#' + buyUnpaid.length + ',' + buyPaid.length + ',' + sellUnpaid.length + ',' + sellPaid.length
      + ',' + (orderListError || '');
    if (_bodyEl && container._ordersRendered && _bodySig === container._ordersSig) {
      // Nothing row-visible changed. Refresh the volatile bits in place and bail.
      container._ordersSig = _bodySig;
      try {
        var _luEl = document.getElementById('page-last-updated');
        if (_luEl) _luEl.textContent = 'Updated ' + _lu;
      } catch (e) {}
      return;
    }
    container._ordersSig = _bodySig;

    if (_bodyEl && container._ordersRendered) {
      // Steady state: the shell (filter bar, tab bar, chart, pinned list) already
      // exists, so patch only the body. Filters, focus, scroll position and the
      // chart all survive -> no flash, and nothing appears to "disappear".
      var _checkedSell = {};
      _bodyEl.querySelectorAll('input.sell-check').forEach(function(cb) {
        if (cb.checked) _checkedSell[cb.value] = 1;
      });
      var _hScrolls = Array.from(_bodyEl.querySelectorAll('.table-container')).map(function(el) { return el.scrollLeft; });
      _bodyEl.innerHTML = bodyHtml;
      // A rebuild drops the selection the user made; put it back.
      _bodyEl.querySelectorAll('input.sell-check').forEach(function(cb) {
        if (_checkedSell[cb.value]) cb.checked = true;
      });
      restoreHorzScrolls(_bodyEl, _hScrolls);
    } else {
      // Cold render (first load, page navigation, Fresh Fetch). Save the user's
      // controls so a full rebuild does not silently reset them.
      var scrollPos = container.scrollTop;
      var horzScrolls = Array.from(container.querySelectorAll('.table-container')).map(function(el) { return el.scrollLeft; });
      var savedUi = _saveOrdersFilterUI();
      container.innerHTML = headerHtml + '<div id="orders-body">' + bodyHtml + '</div>';
      _restoreOrdersFilterUI(savedUi);
      container.scrollTop = scrollPos;
      restoreHorzScrolls(container, horzScrolls);
    }
    container._ordersRendered = true;
    container._ordersBodyEmpty = false;
    _applyOrdersTabVisibility();
    if (window._syncAutoMarkPaidToggle) window._syncAutoMarkPaidToggle();
    try { renderUnmatchedSmsBanner(); } catch (e) {}

    if (typeof bindClickHandlers === 'function') bindClickHandlers(container);
    filterOrders();
    // Post-render hooks
    window._initOrdersChart(allOrders);
    _refreshFilterPresetsUI();
    _refreshPinnedListUI();
    fetchOrderStats();
    rebuildTimerRegistry();
    // Audio alert for genuinely NEW pending orders (set-based — no false alerts from count fluctuation)
    if (window._ordersSettings.audioAlert && allOrders.length > 0) {
      var newPending = allOrders.filter(function(o) { var s = orderState(o); return s !== 'completed' && s !== 'canceled' && s !== 'cancelled'; });
      if (window._audioAlertIds === undefined) window._audioAlertIds = null;
      if (window._audioAlertIds !== null) {
        var _hasNew = false;
        for (var _ai = 0; _ai < newPending.length; _ai++) {
          var _oid = newPending[_ai].orderId;
          if (_oid && !window._audioAlertIds[_oid]) { _hasNew = true; break; }
        }
        if (_hasNew && !window._suppressOrderAlert) window._playOrderAlert();
      }
      if (!window._suppressOrderAlert) {
        var _next = {};
        for (var _bi = 0; _bi < newPending.length; _bi++) { var _bid = newPending[_bi].orderId; if (_bid) _next[_bid] = 1; }
        window._audioAlertIds = _next;
      }
    }
} catch (err) {
    // Every SSE/polled update renders with silent=true, so this used to be a
    // bare `if (silent) return;` - i.e. any exception was swallowed with no log
    // and no DOM write, leaving the empty first-load skeleton on screen.
    _reportOrdersRenderFailure(container, err);
    // Don't paint an error card on a silent update - that is exactly the flash
    // the body patch exists to avoid. The rebuild happens on the next event.
    if (silent) return;
    if (err.message && err.message.includes('API keys')) {
      if (currentPage !== _pg) return;
      var _errBody = document.getElementById('orders-body');
      if (_errBody && container._ordersRendered) {
        _errBody.innerHTML = html.slice(_bodyOffset) + configKeysPrompt();
      } else {
        container.innerHTML = headerHtml + '<div id="orders-body">' + html.slice(_bodyOffset) + configKeysPrompt() + '</div>';
        container._ordersRendered = true;
      }
      if (typeof bindClickHandlers === 'function') bindClickHandlers(container);
      return;
    }
    if (currentPage !== _pg) return;
    html += `<div class="card" style="text-align:center;padding:40px;background:rgba(255,122,0,0.03);border:1px solid rgba(255,152,0,0.1);"><p style="color:var(--accent-orange);font-size:13px;">⚠ ${err.message}</p><p style="color:var(--text-quaternary);font-size:11px;margin-top:8px;">Will retry automatically...</p></div>`;
    const scrollPos = container.scrollTop;
    const horzScrolls = Array.from(container.querySelectorAll('.table-container')).map(function(el) { return el.scrollLeft; });
    var _errBody2 = document.getElementById('orders-body');
    if (_errBody2 && container._ordersRendered) {
      _errBody2.innerHTML = html.slice(_bodyOffset);
    } else {
      container.innerHTML = headerHtml + '<div id="orders-body">' + html.slice(_bodyOffset) + '</div>';
      container.scrollTop = scrollPos;
      restoreHorzScrolls(container, horzScrolls);
    }
    container._ordersRendered = true;
    if (window._syncAutoMarkPaidToggle) window._syncAutoMarkPaidToggle();
    try { renderUnmatchedSmsBanner(); } catch (e) {}
    if (typeof bindClickHandlers === 'function') bindClickHandlers(container);
    filterOrders();
    rebuildTimerRegistry();
  }
}

// Public entry point. Swallows rejections so no caller can be taken down by a
// render bug, and routes them all through one place so failures are visible.
function renderOrders(container, sseData, silent) {
  if (window._disableOrderScreenRender) {
    // Render a simple empty state so tab isn't stuck on "Loading..."
    _renderEmptyState(container);
    return Promise.resolve();
  }
  return _renderOrdersImpl(container, sseData, silent).catch(function (err) {
    _reportOrdersRenderFailure(container, err);
  });
}

function _renderEmptyState(container) {
  if (!container) return;
  if (container._emptyRendered) return; // Only render once
  container._emptyRendered = true;
  container.innerHTML = '<div class="empty-state" style="padding:40px 20px;text-align:center;color:var(--text-tertiary);"><div style="font-size:48px;margin-bottom:12px;">📭</div><div style="font-size:16px;font-weight:600;margin-bottom:4px;">No active orders</div><div style="font-size:13px;color:var(--text-quaternary);">FCM notifications will appear when orders arrive</div></div>';
}

function orderRole(o) {
  var role = (o.role || '').toLowerCase();
  if (role === 'taker' || role === 'maker') return role === 'maker' ? 'Maker' : 'Taker';
  return 'Maker';
}

// Push active orders to the native floating widget ("draw over other apps").
// Called on every render; the native side rebuilds its card from the JSON.
window.syncOrdersOverlay = function(orders) {
  try {
    if (!window.AndroidOverlay) return;
    if (!window._overlayWidgetEnabled) {
      // Only cross the native bridge once per disabled state — hide() is a
      // no-op for the host once the widget is gone, and calling it on every
      // render was pure per-render bridge chatter.
      if (window.__overlayHiddenNotified) return;
      AndroidOverlay.hide();
      window.__overlayHiddenNotified = true;
      return;
    }
    window.__overlayHiddenNotified = false;
    var active = (Array.isArray(orders) ? orders : []).filter(function(o) {
      var s = String(o.orderStatus || o.state || o.completionStatus || o.status || '').toLowerCase();
      return s !== 'completed' && s !== 'canceled' && s !== 'cancelled';
    }).slice(0, 8).map(function(o) {
      return {
        orderId: o.orderId,
        side: o.side,
        cryptoAmount: o.cryptoAmount,
        cryptoCurrency: o.cryptoCurrency,
        fiatAmount: o.fiatAmount,
        fiatCurrency: o.fiatCurrency,
        paymentStatus: o.paymentStatus,
        orderStatus: o.orderStatus || o.state || ''
      };
    });
    AndroidOverlay.update(JSON.stringify(active));
  } catch (e) {}
};

// User closed the widget natively (✕) — remember until they re-enable it.
window.__overlayDismissed = function() {
  window._overlayWidgetEnabled = false;
  var sw = document.getElementById('overlay-widget-toggle');
  if (sw) sw.checked = false;
};
function ordersTimeLeft(o) {
  if (orderState(o) !== 'new' && orderState(o) !== 'pending') return '';
  if (orderIsPaid(o)) return '<span style="color:var(--accent-blue);font-size:10px;">Awaiting release</span>';
  const elapsed = (Date.now() - parseInt(o.createdTimestamp || '0')) / 1000;
  const total = parseInt(o.expiryTimeInSeconds || o.expiredInSeconds || '0');
  const remaining = total - elapsed;
  if (remaining <= 0) return '<span style="color:var(--accent-red);font-size:10px;">Expired</span>';
  const h = Math.floor(remaining / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = Math.floor(remaining % 60);
  return `${h > 0 ? h + 'h ' : ''}${m}m ${s}s`;
}
function formatTime(s) { var sec = parseInt(s); if (isNaN(sec)) return '-'; var m = Math.floor(sec / 60); var secs = sec % 60; return m > 0 ? m + 'm ' + secs + 's' : secs + 's'; }
// Release/lifetime durations must be derived from IMMUTABLE timestamps. OKX's
// durationAfterCompletionInSeconds field is a live elapsed-since-completion
// counter (0 at completion, grows forever); using it made every average and the
// per-order "Release Time" column climb without bound.
function _orderReleaseSec(o) {
  var ct = parseInt(o.completionTimestamp);
  var pt = parseInt(o.paymentTimestamp);
  var sec = 0;
  if (ct > 0 && pt > 0) sec = Math.round((ct - pt) / 1000);
  return sec > 0 ? sec : 0;
}
// ===== Row builder functions for targeted DOM updates =====
function _completedRowHtml(o) {
  const cp = getCounterpartyInfo(o) || {};
  const releaseSec = _orderReleaseSec(o);
  const releaseTime = releaseSec > 0 ? formatTime(releaseSec) : '<span style="color:var(--text-quaternary);font-size:11px;">Instant</span>';
  return `<tr style="cursor:pointer;" data-on-click="viewOrder('${esc(o.orderId || '')}')">
    <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="event.stopPropagation();copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span></td>
    <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(0,210,104,0.15);color:var(--accent-green);font-weight:600;">${orderRole(o)}</span></td>
    <td style="font-size:11px;">${cp.name}</td>
    <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
    <td><strong>${o.cryptoCurrency || '-'}</strong></td>
    <td>${o.cryptoAmount || '-'}</td>
    <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
    <td>${o.unitPrice || '-'}</td>
    <td style="font-size:10px;color:var(--text-quaternary);">${o.exchangeRate || '-'}</td>
    <td><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></td>
    <td style="font-size:10px;color:var(--text-quaternary);">${o.completionType || '-'}</td>
    <td style="font-size:11px;">${releaseTime}</td>
    <td><button class="btn btn-sm btn-outline" data-on-click="event.stopPropagation();showOrderDetail('${esc(o.orderId || '')}')">Detail</button></td>
  </tr>`;
}
function _cancelledRowHtml(o) {
  const cp = getCounterpartyInfo(o) || {};
  return `<tr style="opacity:0.6;cursor:pointer;" data-on-click="viewOrder('${esc(o.orderId || '')}')">
    <td><span style="font-family:monospace;font-size:11px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="event.stopPropagation();copyText('${(o.orderId || '').slice(0,12)}')">${(o.orderId || '').slice(0,12)}</span></td>
    <td><span style="font-size:10px;padding:2px 6px;border-radius:4px;background:rgba(0,210,104,0.15);color:var(--accent-green);font-weight:600;">${orderRole(o)}</span></td>
    <td style="font-size:11px;">${cp.name}</td>
    <td style="font-size:11px;">${renderPaymentInfo(o)}</td>
    <td><strong>${o.cryptoCurrency || '-'}</strong></td>
    <td>${o.cryptoAmount || '-'}</td>
    <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
    <td><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></td>
    <td><button class="btn btn-sm btn-outline" data-on-click="event.stopPropagation();showOrderDetail('${esc(o.orderId || '')}')">Detail</button></td>
  </tr>`;
}
function rebuildTimerRegistry() {
  // Cache timer cells so the tick never scans the whole document; write only when
  // text actually changes. Stop interval when no countdown cells exist.
  // Use 5s interval (not 1s) — countdown precision of minutes doesn't need 1s updates.
  if (window._ordersTimerTick) { clearInterval(window._ordersTimerTick); window._ordersTimerTick = null; }
  window._ordersTimerEls = [];
  window._ordersTimerTexts = {};
  try { window._ordersTimerEls = Array.from(document.querySelectorAll('[data-timer-id]')); } catch (e) { return; }
  if (!window._ordersTimerEls.length || !window._ordersMap) return;
  window._ordersTimerTick = setInterval(function() {
    if (document.hidden) return;
    var els = window._ordersTimerEls;
    var hasAny = false;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.isConnected) continue;
      hasAny = true;
      var oid = el.getAttribute('data-timer-id');
      if (!oid) continue;
      var order = window._ordersMap[oid];
      if (!order) continue;
      var txt = ordersTimeLeft(order);
      var plain = txt.indexOf('<') === -1 ? txt : 'awaiting';
      if (window._ordersTimerTexts[oid] === plain) continue;
      window._ordersTimerTexts[oid] = plain;
      if (txt.indexOf('<') !== -1) { el.innerHTML = txt; } else { el.textContent = txt; }
    }
    if (!hasAny) { clearInterval(window._ordersTimerTick); window._ordersTimerTick = null; }
  }, 5000);
}

// toggleOrdersPoll is referenced by the auto-refresh checkbox — orders arrive via SSE only
function toggleOrdersPoll() {
  // No-op: SSE pushes this user's orders every 5s while connected
}
// SSE is the sole update mechanism for orders
// See ui.js: prefetcher broadcasts 'orders' events; server broadcasts 'order-update' after actions

function restoreHorzScrolls(container, saved) {
  if (!saved || !saved.length) return;
  var els = container.querySelectorAll('.table-container');
  for (var i = 0; i < els.length && i < saved.length; i++) els[i].scrollLeft = saved[i];
}
function freshRefreshOrders(side) {
  var label = side ? (side === 'buy' ? 'buy' : 'sell') : 'pending';
  showToast('Fetching ' + label + ' orders...', 'info');
  var container = document.getElementById('page-content');
  if (!container) return;
  var ac = new AbortController();
  var tid = setTimeout(function() { ac.abort(); }, 30000);
  fetch('/api/okx/p2p/order-list?completionStatus=pending&pageSize=100&refresh=1', {
    method: 'GET',
    headers: API.getHeaders(),
    signal: ac.signal
  }).then(function(res) {
    clearTimeout(tid);
    var nt = res.headers.get('X-New-Token');
    if (nt) API.setToken(nt);
    return res.json();
  }).then(function(data) {
    if (data && Array.isArray(data.data)) {
      var orders = data.data;
      var fresh = side ? orders.filter(function(o) { return o.side === side; }) : orders;
      // Merge into the existing dataset instead of replacing — a side-only
      // refresh must not wipe the other sections (sell/completed/cancelled).
      if (window._sseOrdersCache && Array.isArray(window._sseOrdersCache.orders) && window._sseOrdersCache.orders.length) {
        var ids = {};
        fresh.forEach(function(o) { if (o.orderId) ids[o.orderId] = 1; });
        var kept = window._sseOrdersCache.orders.filter(function(o) { return o.orderId && !ids[o.orderId]; });
        fresh = kept.concat(fresh);
      }
      window._sseOrdersCache = { orders: fresh };
      window._persistOrdersSnapshot();
      showToast('Loaded ' + orders.length + ' ' + label + ' orders', 'success');
      renderOrders(container, { orders: fresh }, true);
    } else {
      showToast('Refresh failed: ' + (data.msg || 'Invalid response'), 'error');
      renderOrders(container);
    }
  }).catch(function(err) {
    clearTimeout(tid);
    showToast('Refresh failed: ' + (err.name === 'AbortError' ? 'timed out' : err.message), 'error');
    renderOrders(container);
  });
}
window.loadMorePendingOrders = function() {
  var next = (window._pendingPageIndex || 1) + 1;
  showToast('Loading more pending orders...', 'info');
  var container = document.getElementById('page-content');
  if (!container) return;
  // Use API.get (not raw fetch): it detects text/html responses and errors with a
  // friendly message instead of crashing on res.json() with "Unexpected token '<'"
  // when nginx/node serves an error page (OKX 504 storms, process restarts).
  API.get('/api/okx/p2p/order-list?completionStatus=pending&pageSize=100&pageIndex=' + next + '&refresh=1', 45000).then(function(data) {
    var orders = (data && Array.isArray(data.data)) ? data.data : [];
    var pending = orders.filter(function(o) { var s = orderState(o); return s !== 'completed' && s !== 'canceled' && s !== 'cancelled'; });
    if (!pending.length) { showToast('No more pending orders', 'info'); return; }
    if (!window._pendingExtra) window._pendingExtra = [];
    var known = {};
    window._pendingExtra.forEach(function(o) { if (o.orderId) known[o.orderId] = 1; });
    if (window._ordersMap) Object.keys(window._ordersMap).forEach(function(id) { known[id] = 1; });
    var added = 0;
    pending.forEach(function(o) {
      if (o.orderId && !known[o.orderId] && window._pendingExtra.length < 150) { window._pendingExtra.push(o); added++; }
    });
    window._pendingPageIndex = next;
    if (added === 0) { showToast('No more pending orders', 'info'); return; }
    showToast('Loaded ' + added + ' more pending orders', 'success');
    renderOrders(container, null, true);
  }).catch(function(err) {
    if (err && err.name === 'AbortError') { showToast('Failed to load more orders: timed out', 'error'); return; }
    showToast('Failed to load more orders: ' + ((err && err.message) || 'error'), 'error');
  });
}
// ---- SMS Match Log (audit) + unmatched-SMS banner ----

// Session list of unattributed payments (no-match / low-confidence). Populated
// by the drainer in sms-match.js and surfaced as a persistent banner.
function renderUnmatchedSmsBanner() {
  var b = document.getElementById('sms-unmatched-banner');
  if (!b) return;
  var items = window.__unmatchedSms || [];
  if (!items.length) { b.style.display = 'none'; b.innerHTML = ''; return; }
  var html = '<div style="padding:8px 12px;border-radius:8px;background:rgba(255,193,7,0.1);border:1px solid rgba(255,193,7,0.3);font-size:12px;color:#ffd54f;display:flex;flex-wrap:wrap;gap:8px;align-items:center;">';
  html += '<b>⚠️ ' + items.length + ' captured SMS matched no buy order</b>' + (items.length > 1 ? ' — tap entries to review' : ' — tap to review');
  html += '<a onclick="window.showSmsPasteModal()" style="cursor:pointer;color:#00e676;text-decoration:underline;margin-left:auto;font-weight:600;">Paste manually</a>';
  html += '<span onclick="window.dismissUnmatchedSms()" style="cursor:pointer;color:#ffd54f;font-weight:700;padding:0 4px;" title="Dismiss">✕</span>';
  html += '</div>';
  b.innerHTML = html;
  b.style.display = 'block';
}
window.renderUnmatchedSmsBanner = renderUnmatchedSmsBanner;
window.dismissUnmatchedSms = function() { window.__unmatchedSms = []; renderUnmatchedSmsBanner(); };

function showSmsMatchLog() {
  var m = document.getElementById('sms-match-log-modal');
  if (!m) {
    var d = document.createElement('div');
    d.id = 'sms-match-log-modal';
    d.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;padding:16px;';
    d.innerHTML = '<div class="modal-box" style="background:#141419;border:1px solid #2a2a33;border-radius:12px;max-width:720px;width:100%;max-height:78vh;display:flex;flex-direction:column;">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-bottom:1px solid #22222a;">' +
      '<b style="font-size:14px;color:var(--accent);">📋 SMS Match Log</b>' +
      '<span onclick="window.hideSmsMatchLog()" style="cursor:pointer;color:#999;font-size:18px;font-weight:700;">✕</span></div>' +
      '<div id="sms-match-log-body" style="overflow:auto;padding:12px 16px;font-size:12px;color:#ccc;"></div>' +
      '</div>';
    document.body.appendChild(d);
    d.onclick = function(e) { if (e.target === d) window.hideSmsMatchLog(); };
  }
  document.getElementById('sms-match-log-modal').style.display = 'flex';
  var body = document.getElementById('sms-match-log-body');
  body.innerHTML = '<div style="color:#999;text-align:center;padding:20px;">Loading…</div>';
  API.getSmsMatchLog(100).then(function(res) {
    var rows = (res && res.data) || [];
    if (!rows.length) { body.innerHTML = '<div style="color:#999;text-align:center;padding:20px;">No SMS matches logged yet.</div>'; return; }
    var h = '<table style="width:100%;border-collapse:collapse;">';
    h += '<tr style="text-align:left;color:#888;">';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Time</th>';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Side</th>';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Action</th>';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Order</th>';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Amount</th>';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Ref</th>';
    h += '<th style="padding:4px 6px;border-bottom:1px solid #2a2a33;">Detail</th>';
    h += '</tr>';
    rows.forEach(function(r) {
      var actionColor = r.action === 'posted' ? '#00e676' : r.action === 'auto-released' ? '#00e676' : r.action === 'auto-release-failed' ? '#ff5252' : r.action.indexOf('no-match') >= 0 || r.action === 'low-confidence' ? '#ffd54f' : r.action === 'error' ? '#ff5252' : '#b39dff';
      var act = { posted: 'Posted', duplicate: 'Duplicate', 'duplicate-server': 'Duplicate (server)', 'low-confidence': 'Low confidence', 'no-match': 'No match', 'skipped-completed': 'Skipped (completed)', 'no-ref': 'No ref', error: 'Error', matched: 'Matched', 'auto-released': 'Auto-released', 'auto-release-failed': 'Auto-release failed' }[r.action] || r.action;
      h += '<tr>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;white-space:nowrap;" title="' + escHtml(r.at || '') + '">' + escHtml(((r.at || '').replace('T', ' ').slice(5, 16))) + '</td>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;">' + (r.side === 'sell' ? 'In · sell' : 'Out · buy') + '</td>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;color:' + actionColor + ';font-weight:600;">' + escHtml(act) + '</td>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;">' + (r.orderId ? escHtml(r.orderId.slice(0, 10)) : '—') + '</td>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;">' + (r.amount ? 'KES ' + Number(r.amount).toLocaleString() : '—') + '</td>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;color:#00e676;">' + escHtml(r.smsRef || '—') + '</td>';
      h += '<td style="padding:4px 6px;border-bottom:1px solid #1c1c24;color:#aaa;">' + escHtml(r.detail || '') + '</td>';
      h += '</tr>';
    });
    h += '</table>';
    body.innerHTML = h;
  }).catch(function(err) {
    body.innerHTML = '<div style="color:#ff5252;text-align:center;padding:20px;">Failed to load: ' + escHtml(err.message || err) + '</div>';
  });
}
window.showSmsMatchLog = showSmsMatchLog;
window.hideSmsMatchLog = function() {
  var m = document.getElementById('sms-match-log-modal');
  if (m) m.style.display = 'none';
};
// escHtml: safe HTML escaping (shared with other helpers that define it).
function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

function renderOrdersFromCache(container) {
  if (!window._ordersAllPages || !window._ordersAllPages.length) { renderOrders(container); return; }
  var allOrders = window._ordersAllPages;
  var pending = allOrders.filter(function(o) { var s = orderState(o); return s !== 'completed' && s !== 'canceled' && s !== 'cancelled'; });
  var completed = allOrders.filter(function(o) { return isCompletedOrder(o); });
  var cancelled = allOrders.filter(function(o) { var s = orderState(o); return s === 'canceled' || s === 'cancelled'; });
  renderOrders(container, { orders: allOrders, pending: pending, completed: completed.slice(0, 50), cancelled: cancelled.slice(0, 50) }, true);
}
function showMoreCompleted() {
  const total = (window.__cachedCompleted || []).length;
  const current = window._completedVisible || 10;
  window._completedVisible = Math.min(current + 10, total);
  const el = document.getElementById('page-content');
  if (el) renderOrdersFromCache(el);
}
function showMoreCancelled() {
  const total = (window.__cachedCancelled || []).length;
  const current = window._cancelledVisible || 10;
  window._cancelledVisible = Math.min(current + 10, total);
  const el = document.getElementById('page-content');
  if (el) renderOrdersFromCache(el);
}
function searchCompletedOrders() {
  const input = document.getElementById('completed-search-input');
  if (input) window._completedSearch = input.value;
  window._completedVisible = 10;
  const el = document.getElementById('page-content');
  if (el) renderOrdersFromCache(el);
}
function clearCompletedSearch() {
  window._completedSearch = '';
  window._completedVisible = 10;
  const el = document.getElementById('page-content');
  if (el) renderOrders(el);
}
// ===== Trust badges (OKX trade-info for the counterparty) + inline dispute center =====
window.loadOrderTrustBadges = async function(orderId, orderObj) {
  var el = document.getElementById('order-trust-' + orderId);
  if (!el) return;
  var o = orderObj || (window._ordersMap && window._ordersMap[orderId]);
  var cp = (o && o.counterpartyDetail) || {};
  var uid = cp.userId || cp.userNo || o.userId || o.userNo || '';
  var realName = cp.realName || o.realName || '';
  var nickName = cp.nickName || o.nickName || '';
  var type = cp.type || o.type || '';
  var chips = [];
  if (realName || nickName) {
    chips.push('<span style="padding:3px 8px;background:rgba(68,138,255,0.12);border-radius:4px;color:#8ab4ff;">👤 ' + esc(nickName || realName) + '</span>');
  }
  if (type && type !== 'common') {
    chips.push('<span style="padding:3px 8px;background:rgba(255,215,64,0.12);border-radius:4px;color:#ffd75a;">' + (type === 'diamond' ? '💎 Diamond merchant' : '✅ Certified') + '</span>');
  }
  if (uid) {
    chips.push('<span style="padding:3px 8px;background:rgba(158,158,158,0.1);border-radius:4px;color:#9090a4;font-family:monospace;font-size:10px;">UID ' + esc(String(uid)) + '</span>');
  }
  if (!uid) {
    el.innerHTML = chips.length ? '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;font-size:11px;">' + chips.join('') + '</div>' : '';
    return;
  }
  el.innerHTML = '<div style="color:var(--text-quaternary);font-size:11px;">⏳ Loading trust info...</div>';
  try {
    var res = await API.get('/api/okx/p2p/trade-info/' + encodeURIComponent(uid));
    var rows = Array.isArray(res.data) ? res.data : [];
    var byside = {};
    rows.forEach(function(r) { if (r && r.side) byside[r.side] = r; });
    var b = byside.buy || {}, s2 = byside.sell || {};
    var tradesWithYou = (parseInt(b.tradeCount) || 0) + (parseInt(s2.tradeCount) || 0);
    var vol = [];
    if (b.tradeCount && parseInt(b.tradeCount) > 0) vol.push('buy ' + b.tradeCount + '× ' + (b.tradeAmount || ''));
    if (s2.tradeCount && parseInt(s2.tradeCount) > 0) vol.push('sell ' + s2.tradeCount + '× ' + (s2.tradeAmount || ''));
    if (tradesWithYou > 0) {
      chips.unshift('<span style="padding:3px 8px;background:' + (tradesWithYou >= 3 ? 'rgba(0,200,83,0.14);color:#00c853' : 'rgba(255,179,0,0.14);color:#ffb300') + ';border-radius:4px;">🤝 ' + tradesWithYou + ' trade' + (tradesWithYou === 1 ? '' : 's') + ' with you' + (vol.length ? ' (' + esc(vol.join(' · ')) + ')' : '') + '</span>');
    } else {
      chips.unshift('<span style="padding:3px 8px;background:rgba(158,158,158,0.08);border-radius:4px;color:var(--text-tertiary);">🆕 First trade with this user</span>');
    }
    el.innerHTML = '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;font-size:11px;"><span style="color:var(--text-quaternary);font-weight:600;">🛡️ Trust:</span>' + chips.join('') + '</div>';
  } catch (e) {
    el.innerHTML = chips.length ? '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;font-size:11px;"><span style="color:var(--text-quaternary);font-weight:600;">🛡️ Trust:</span>' + chips.join('') + '</div>' : '';
  }
};

window.renderOrderDisputeCenter = function(orderId) { _odRefreshDispute(orderId); };

window._odRefreshDispute = async function(orderId) {
  var el = document.getElementById('order-dispute-' + orderId);
  if (!el) return;
  el.innerHTML = '<div class="info-box" style="border-color:var(--accent-red);"><strong>⚖️ Dispute Center</strong><br><span style="color:var(--text-tertiary);font-size:12px;">Loading dispute details...</span></div>';
  try {
    var res = await API.get('/api/okx/p2p/dispute/' + orderId);
    var d = res.data?.[0] || res.data || {};
    var msgs = Array.isArray(d.messages) ? d.messages : [];
    var getSenderLabel = function(sender) {
      if (!sender) return 'You';
      var s = String(sender).toLowerCase();
      if (s === 'user' || s === 'self' || s === 'me') return 'You';
      if (s.indexOf('support') !== -1 || s.indexOf('admin') !== -1 || s.indexOf('cs') !== -1) return 'Customer Support';
      return 'Counterparty';
    };
    var msgHtml = msgs.length === 0
      ? '<p style="color:var(--text-quaternary);font-size:12px;margin:6px 0;">No dispute messages yet</p>'
      : msgs.map(function(m) {
          var label = getSenderLabel(m.sender);
          var labelColor = label === 'You' ? 'var(--accent-green)' : label === 'Customer Support' ? 'var(--accent-blue)' : '#f0a040';
          return '<div style="padding:6px 8px;margin-bottom:5px;background:#1e1e2e;border-radius:8px;"><div style="display:flex;justify-content:space-between;margin-bottom:2px;"><span style="color:' + labelColor + ';font-size:10px;font-weight:600;">' + esc(label) + '</span><span style="color:#8888a0;font-size:10px;">' + (function(t) { var n = parseInt(t); return n > 0 ? new Date(n).toLocaleString() : ''; })(m.timestamp || m.sendTime) + '</span></div><div style="color:var(--text-primary);font-size:12px;">' + esc(m.messageText || m.content || '-') + '</div></div>';
        }).join('');
    el.innerHTML = '<div class="info-box" style="border-color:var(--accent-red);">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px;margin-bottom:6px;">' +
      '<strong>⚖️ Dispute Center</strong>' +
      '<span><span class="badge badge-disputed" style="font-size:10px;">Active</span> ' +
      (d.disputeType ? '<span style="color:var(--text-tertiary);font-size:11px;">' + esc(d.disputeType) + (d.subDisputeType ? ' → ' + esc(d.subDisputeType) : '') + '</span>' : '') +
      (d.disputeResult ? '<span style="color:var(--text-tertiary);font-size:11px;"> · Result: ' + esc(d.disputeResult) + '</span>' : '') +
      '</span></div>' +
      '<div style="max-height:180px;overflow-y:auto;background:var(--bg-primary);border-radius:8px;padding:8px;margin-bottom:8px;">' + msgHtml + '</div>' +
      '<form data-on-submit="_odSendDisputeMsg(event, \'' + esc(orderId) + '\')" style="display:flex;gap:6px;">' +
      '<input id="order-dispute-msg-' + esc(orderId) + '" style="flex:1;padding:8px 12px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;" placeholder="Message support / counterparty..." required>' +
      '<button type="submit" class="btn btn-primary btn-sm">Send</button>' +
      '<button type="button" class="btn btn-outline btn-sm" data-on-click="_odRefreshDispute(\'' + esc(orderId) + '\')">⟳</button></form>' +
      '<div style="display:flex;gap:6px;margin-top:8px;flex-wrap:wrap;">' +
      '<button class="btn btn-danger btn-sm" data-on-click="_odCancelDispute(\'' + esc(orderId) + '\')">Cancel Dispute</button>' +
      '<button class="btn btn-outline btn-sm" data-on-click="this.closest(\'.modal-overlay\').remove();navigate(\'disputes\')">Open Disputes Page</button>' +
      '</div></div>';
  } catch (err) {
    el.innerHTML = '<div class="info-box" style="border-color:var(--accent-red);"><strong>⚖️ Dispute Center</strong><br><span style="color:var(--text-tertiary);font-size:12px;">Could not load details (' + esc(err.message) + ').</span> <button class="btn btn-sm btn-outline" data-on-click="this.closest(\'.modal-overlay\').remove();navigate(\'disputes\')">Open Disputes Page</button></div>';
  }
};

window._odSendDisputeMsg = async function(e, orderId) {
  e.preventDefault();
  var input = document.getElementById('order-dispute-msg-' + orderId);
  if (!input) return;
  var text = input.value;
  input.value = '';
  try {
    await API.post('/api/okx/p2p/dispute/' + orderId + '/message', { messageText: text });
    showToast('Dispute message sent', 'success');
    _odRefreshDispute(orderId);
  } catch (err) {
    input.value = text;
    showToast(err.message, 'error');
  }
};

window._odCancelDispute = async function(orderId) {
  if (!confirm('Cancel this dispute? The order will resume normally.')) return;
  try {
    await API.post('/api/okx/p2p/dispute/' + orderId + '/cancel');
    showToast('Dispute cancelled', 'info');
    document.getElementById('order-dispute-' + orderId)?.replaceChildren();
  } catch (err) { showToast(err.message, 'error'); }
};

async function viewOrder(orderId) {
  try {
    const res = await API.get('/api/okx/p2p/orders/' + orderId);
    const o = res.data?.[0] || res.data || {};
    const os = orderState(o);
    const isActive = os !== 'completed' && os !== 'canceled' && os !== 'cancelled';
    const canRelease = isActive && orderIsPaid(o) && o.side === 'sell' && !(window.isAppealedOrder && window.isAppealedOrder(o));
    const canDispute = isActive && (orderIsPaid(o) || o.paymentStatus === 'unpaid');
    const isDisputed = String(o.disputeStatus) === '1';
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
      <div class="modal-content" style="max-width:650px;">
        <h3>Order Details</h3>
        <div class="order-detail">
          <div class="order-detail-item"><div class="label">Asset</div><div class="value">${o.cryptoCurrency || '-'}</div></div>
          <div class="order-detail-item"><div class="label">Amount</div><div class="value">${o.cryptoAmount || '-'}</div></div>
          <div class="order-detail-item"><div class="label">Total</div><div class="value">${formatFiat(o.fiatAmount, o.fiatCurrency)}</div></div>
          <div class="order-detail-item"><div class="label">Price</div><div class="value">${o.unitPrice || '-'}</div></div>
          <div class="order-detail-item"><div class="label">Status</div><div class="value"><span class="badge badge-${os === 'completed' ? 'completed' : os === 'canceled' || os === 'cancelled' ? 'cancelled' : orderIsPaid(o) ? 'paid' : 'pending'}">${isActive ? (orderIsPaid(o) ? 'Awaiting release' : (o.paymentStatus || 'active')) : os}</span></div></div>
          <div class="order-detail-item"><div class="label">Side</div><div class="value"><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></div></div>
        </div>
        <div id="order-trust-${esc(o.orderId)}" style="margin:10px 0;"><div style="color:var(--text-quaternary);font-size:11px;">⏳ Loading trust info...</div></div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px;">
          ${canRelease ? `<button class="btn btn-primary" data-on-click="releaseOrder('${esc(o.orderId)}')">Release Crypto</button>` : ''}
          <div style="display:flex;gap:6px;margin-top:8px;"><button class="btn btn-sm btn-outline" data-on-click="showOrderTrust('${esc(o.orderId)}')">🛡 Trust</button><button class="btn btn-sm btn-outline" data-on-click="showOrderDispute('${esc(o.orderId)}')">⚖️ Dispute</button></div>
          ${canDispute && !isDisputed ? `<button class="btn btn-danger btn-sm" data-on-click="disputeOrder('${esc(o.orderId)}')">Dispute</button>` : ''}
          ${isActive && o.paymentStatus === 'unpaid' ? `<button class="btn btn-secondary btn-sm" data-on-click="cancelOrder('${esc(o.orderId)}')">Cancel Order</button>` : ''}
          <button class="btn btn-sm btn-outline" data-on-click="setOrderReminder('${esc(o.orderId)}')" style="font-size:10px;">⏰ Remind</button>
          <button class="btn btn-secondary btn-sm" data-on-click="this.closest('.modal-overlay').remove()">Close</button>
        </div>
        <div class="info-box"><strong>Order ID:</strong> <span style="font-family:monospace;color:var(--text-secondary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${esc(o.orderId || '')}')">${o.orderId || '-'}</span></div>
          ${isDisputed ? `<div id="order-dispute-${esc(o.orderId)}"></div>` : ''}
        ${o.createdTimestamp ? `<div class="info-box"><strong>Created:</strong> <span>${new Date(parseInt(o.createdTimestamp)).toLocaleString()}</span></div>` : ''}
        ${o.completionTimestamp ? `<div class="info-box"><strong>Completed:</strong> <span>${new Date(parseInt(o.completionTimestamp)).toLocaleString()}</span></div>` : ''}
        <!-- Order Timeline -->
        <div style="margin:12px 0;padding:12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);">
          <div style="font-size:12px;color:var(--text-quaternary);margin-bottom:8px;font-weight:600;">⏳ Order Timeline</div>
          <div style="display:flex;align-items:center;gap:4px;font-size:10px;flex-wrap:wrap;">
            ${o.createdTimestamp ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(0,210,104,0.1);border-radius:4px;"><span>📝 Created</span><span style="color:var(--text-tertiary);">${new Date(parseInt(o.createdTimestamp)).toLocaleString()}</span></div><span style="color:#33334a;">→</span>` : ''}
            ${orderIsPaid(o) || o.paymentTimestamp ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(68,138,255,0.1);border-radius:4px;"><span>💵 Paid</span><span style="color:var(--text-tertiary);">${o.paymentTimestamp ? new Date(parseInt(o.paymentTimestamp)).toLocaleString() : '✓'}</span></div><span style="color:#33334a;">→</span>` : ''}
            ${o.completionTimestamp ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(0,200,83,0.1);border-radius:4px;"><span>✅ Completed</span><span style="color:var(--text-tertiary);">${new Date(parseInt(o.completionTimestamp)).toLocaleString()}</span></div>` : os === 'canceled' || os === 'cancelled' ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(244,67,54,0.1);border-radius:4px;"><span>✕ Cancelled</span></div>` : `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:var(--accent-amber-glow);border-radius:4px;"><span>⏳ In Progress</span></div>`}
          </div>
        </div>
        <div style="margin-top:16px;border-top:1px solid #1e1e2e;padding-top:12px;">
          <h4 style="margin:0 0 8px 0;font-size:14px;">💬 Order Chat</h4>
          <div id="order-chat-${esc(o.orderId)}" style="max-height:200px;overflow-y:auto;background:var(--bg-primary);border-radius:8px;padding:8px;margin-bottom:8px;font-size:12px;">
            <div style="color:var(--text-quaternary);text-align:center;padding:12px;">Loading messages...</div>
          </div>
          <div style="display:flex;gap:6px;">
            <input type="text" id="chat-input-${esc(o.orderId)}" class="form-input" placeholder="Type a message..." style="flex:1;font-size:12px;padding:8px 12px;" onkeydown="if(event.key==='Enter')sendChatMessage('${esc(o.orderId)}')">
            <button class="btn btn-primary btn-sm" data-on-click="sendChatMessage('${esc(o.orderId)}')" style="white-space:nowrap;">Send</button>
          </div>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    loadOrderTrustBadges(o.orderId, o);
    if (isDisputed) renderOrderDisputeCenter(o.orderId);
    var chatPoll = setInterval(function() { if (!document.hidden) loadChatMessages(orderId); }, 15000);
    setTimeout(function() { loadChatMessages(orderId); }, 300);
    var closeModal = function() { clearInterval(chatPoll); };
    overlay.querySelectorAll('[data-on-click*="remove()"]').forEach(function(el) { el.addEventListener('click', closeModal); });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) { clearInterval(chatPoll); }
    });
    // Also clean up when modal is removed from DOM via MutationObserver
    var mo = new MutationObserver(function() {
      if (!document.body.contains(overlay)) { clearInterval(chatPoll); mo.disconnect(); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (err) { showToast(err.message, 'error'); }
}

async function releaseOrder(orderId) {
  if (window._ordersSettings.requireProofRelease) {
    showReleaseProofModal(orderId);
    return;
  }
  const order = window._ordersMap && window._ordersMap[orderId];
  const amount = order ? String(order.fiatAmount || '') : '';
  // Instant feedback — flip to releasing/completed immediately; OKX ack (5-20s) confirms behind the scenes.
  optimisticRelease(orderId);
  try {
    await API.post('/api/okx/p2p/orders/' + orderId + '/release', { amount });
    document.querySelector('.modal-overlay')?.remove();
    showToast('Crypto released to buyer on OKX!', 'success');
    API.post('/api/bank/auto-sync', { orders: [{ orderId, side: 'sell', fiatAmount: amount || '0', paymentStatus: 'paid', state: 'completed' }] }).catch(() => {});
    _autoSendThankYou(orderId);
  } catch (err) { revertOptimisticRelease(orderId); showToast(err.message, 'error'); }
}

async function cancelOrder(orderId) {
  if (!confirm('Cancel this order?')) return;
  try {
    const order = window._ordersMap && window._ordersMap[orderId];
    const amount = order ? String(order.fiatAmount || '') : '';
    await API.post('/api/okx/p2p/orders/' + orderId + '/cancel', { amount: amount });
    document.querySelector('.modal-overlay')?.remove();
    showToast('Order cancelled on OKX', 'info');
    _autoSendCancelledNote(orderId, order ? order.side : 'sell');
  } catch (err) { showToast(err.message, 'error'); }
}

async function disputeOrder(orderId) {
  var reasons = [];
  // Determine order side from cached data for correct dispute types
  var order = window._ordersMap && window._ordersMap[orderId];
  window._currentOrderSide = order ? order.side : 'buy';
  try {
    var res = await API.get('/api/okx/p2p/dispute/types?orderId=' + orderId + '&side=' + (window._currentOrderSide || 'buy'));
    var raw = res.data;
    if (raw && raw.length > 0) {
      var sideKey = (window._currentOrderSide === 'sell' && raw[0].sell) ? 'sell' : 'buy';
      reasons = (raw[0][sideKey] || []);
    }
  } catch (e) {}

  var html = '<div class="modal-overlay"><div class="modal-content"><h3>Raise Dispute</h3><p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">';
  if (reasons.length > 0) {
    html += 'Select a reason for this dispute</p><form data-on-submit="submitDispute(event,\'' + orderId + '\')">';
    html += '<div class="form-group"><label>Reason</label><select id="dispute-reason-select" required><option value="">-- Select --</option>';
    reasons.forEach(function(r) {
      html += '<option value="' + r.code + '">' + esc(r.subReason || 'Other') + '</option>';
      if (r.subType && r.subType.length > 0) {
        r.subType.forEach(function(st) {
          html += '<option value="' + r.code + '.' + st.code + '">-- ' + esc(st.subReason || '') + '</option>';
        });
      }
    });
    html += '</select></div>';
    html += '<div class="form-group"><label>Message (optional)</label><textarea id="dispute-message" rows="3" placeholder="Describe the issue..."></textarea></div>';
    html += '<div class="form-actions"><button type="button" class="btn btn-secondary" data-on-click="this.closest(\'.modal-overlay\').remove()">Cancel</button>';
    html += '<button type="submit" class="btn btn-danger">Submit Dispute to OKX</button></div></form>';
  } else {
    html += 'Dispute types not available for this order. You can raise an appeal instead.</p>';
    html += '<div class="form-actions"><button type="button" class="btn btn-secondary" data-on-click="this.closest(\'.modal-overlay\').remove()">Cancel</button>';
    html += '<button class="btn btn-primary" data-on-click="this.closest(\'.modal-overlay\').remove();appealOrder(\'' + orderId + '\')">⚠️ Appeal Instead</button></div>';
  }
  html += '</div></div>';

  var temp = document.createElement('div');
  temp.innerHTML = html;
  document.body.appendChild(temp.firstElementChild);
}

window.submitDispute = async function(e, orderId) {
  e.preventDefault();
  var val = document.getElementById('dispute-reason-select').value;
  if (!val) { showToast('Please select a reason', 'error'); return; }
  var parts = val.split('.');
  var reason = parts[0];
  var subReason = parts[1] || '';
  var msg = document.getElementById('dispute-message').value || 'Buyer opened a dispute';
  try {
    await API.post('/api/okx/p2p/dispute/create', { orderId, disputeType: reason, subDisputeType: subReason, messageText: msg });
    document.querySelector('.modal-overlay')?.remove();
    showToast('Dispute raised on OKX', 'info');
  } catch (err) {
    document.querySelector('.modal-overlay')?.remove();
    try { await API.post('/api/admin/appeal', { orderId, message: msg }); } catch (_) {}
    showToast('OKX dispute API unavailable — appeal sent to admin', 'warning');
  }
};

function showDisputeModal(orderId) { disputeOrder(orderId); }

window.appealOrder = function(orderId) {
  var overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.id = 'appeal-modal';
  overlay.innerHTML = '<div class="modal-content" style="max-width:450px;"><h3>⚠️ Appeal Order</h3><p style="color:var(--text-tertiary);font-size:13px;margin-bottom:12px;">Describe the issue — this will be submitted to <strong>OKX Customer Support</strong>:</p><textarea id="appeal-message" rows="4" style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;resize:vertical;margin-bottom:16px;box-sizing:border-box;" placeholder="e.g. Seller is not responding after payment. I paid 15,000 KES on 28 June but USDT not released."></textarea><div class="form-actions"><button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Cancel</button><button type="button" class="btn btn-primary" onclick="submitAppeal(\'' + orderId + '\')">Submit to OKX</button></div></div>';
  document.body.appendChild(overlay);
  setTimeout(function() { document.getElementById('appeal-message')?.focus(); }, 100);
};

window.submitAppeal = async function(orderId) {
  var msg = document.getElementById('appeal-message')?.value?.trim() || 'No details provided';
  var btn = document.querySelector('#appeal-modal .btn-primary');
  if (btn) { btn.disabled = true; btn.textContent = 'Submitting...'; }
  try {
    // Fetch dispute types to get a valid reason code
    var typesRes = await API.get('/api/okx/p2p/dispute/types?orderId=' + orderId + '&side=' + (window._currentOrderSide || 'buy'));
    var raw = typesRes.data;
    var types = [];
    if (raw && raw.length > 0) {
      var sideKey = (window._currentOrderSide === 'sell' && raw[0].sell) ? 'sell' : 'buy';
      types = (raw[0][sideKey] || []);
    }
    var reason = types.length > 0 ? types[0].code : '0';
    var subReason = '';
    if (types.length > 0 && types[0].subType && types[0].subType.length > 0) {
      subReason = types[0].subType[0].code;
    }
    await API.post('/api/okx/p2p/dispute/create', { orderId, disputeType: reason, subDisputeType: subReason, messageText: msg });
    if (window.__markOrderAppealed) window.__markOrderAppealed(orderId);
    document.querySelector('.modal-overlay')?.remove();
    showToast('✅ Dispute raised on OKX — they will review your case', 'success');
  } catch (err) {
    document.querySelector('.modal-overlay')?.remove();
    var errMsg = err.message || '';
    // Fallback to admin appeal on failure
    try {
      await API.post('/api/admin/appeal', { orderId, message: 'APPEAL: ' + msg + (errMsg ? ' (OKX: ' + errMsg + ')' : '') });
      showToast('⚠️ OKX dispute failed — appeal sent to admin instead', 'warning', 5000);
    } catch (_) {
      showToast('❌ Appeal failed: ' + errMsg, 'error', 6000);
    }
  }
};

function toggleAllPending() {
  const checked = document.getElementById('select-all-pending')?.checked;
  document.querySelectorAll('.pending-check').forEach(cb => cb.checked = checked);
}
function toggleAllSell() {
  const checked = document.getElementById('select-all-sell')?.checked;
  document.querySelectorAll('.sell-check').forEach(cb => cb.checked = checked);
}

async function releaseSingleOrder(orderId) {
  const order = window._ordersMap && window._ordersMap[orderId];
  if (order && window.isAppealedOrder && window.isAppealedOrder(order)) {
    showToast('⚠️ Order is under appeal — release blocked', 'error', 5000);
    return;
  }
  if (window._ordersSettings.requireProofRelease) {
    showReleaseProofModal(orderId);
    return;
  }
  try {
    const order = window._ordersMap && window._ordersMap[orderId];
    var payload = {};
    if (order && order.fiatAmount) payload.amount = String(order.fiatAmount);
    await API.post('/api/okx/p2p/orders/' + orderId + '/release', payload);
    showToast('Crypto released!', 'success');
    if (typeof _refreshOrdersFromCache === 'function') _refreshOrdersFromCache();
    const fiat = order ? String(order.fiatAmount || '0') : '0';
    API.post('/api/bank/auto-sync', { orders: [{ orderId, side: 'sell', fiatAmount: fiat, paymentStatus: 'paid', state: 'completed' }] }).catch(() => {});
    _autoSendThankYou(orderId);
  } catch (err) { console.error(err); showToast(err.message, 'error'); }
}

async function releaseAllUnreleased() {
  const selected = Array.from(document.querySelectorAll('.pending-check:checked, .sell-check:checked')).map(cb => cb.value);
  if (selected.length === 0) { showToast('Select orders to release', 'error'); return; }
  const skipped = [];
  let released = 0, failed = 0;
  for (const orderId of selected) {
    const order = window._ordersMap && window._ordersMap[orderId];
    if (order && window.isAppealedOrder && window.isAppealedOrder(order)) {
      skipped.push(orderId.slice(0, 12));
      continue;
    }
    try {
      await API.post('/api/okx/p2p/orders/' + orderId + '/release', {});
      released++;
      _autoSendThankYou(orderId);
    } catch (e) { console.error('Batch release failed for ' + orderId.slice(0,12), e); failed++; }
  }
  showToast('Released: ' + released + ', Failed: ' + failed + (skipped.length ? ', Skipped (appeal): ' + skipped.join(', ') : ''), failed > 0 ? 'error' : 'success', 6000);
}

async function remindOrder(orderId) {
  try {
    const res = await API.post('/api/okx/p2p/orders/' + orderId + '/remind');
    showToast('🔔 Reminder sent to counterparty for ' + orderId.slice(0,12), 'success');
  } catch (err) {
    if (err.message && err.message.includes('OKX')) {
      showToast('⚠️ Remind: ' + err.message, 'info');
    } else {
      showToast('🔔 Remind attempted — check OKX app for notification', 'info');
    }
  }
}

// ===== P2P Chat =====
window.sendChatMessage = async function(orderId) {
  const input = document.getElementById('chat-input-' + orderId);
  if (!input || !input.value.trim()) return;
  const msg = input.value.trim();
  input.value = '';
  try {
    await API.sendChatMessage(orderId, msg);
    // Reload messages after sending
    await loadChatMessages(orderId);
  } catch (err) {
    showToast('Failed to send: ' + err.message, 'error');
    input.value = msg;
  }
};

async function loadChatMessages(orderId) {
  const container = document.getElementById('order-chat-' + orderId);
  if (!container) return;
  try {
    const res = await API.getChatMessages(orderId);
    const msgs = res.data || [];
    if (msgs.length === 0) {
      container.innerHTML = '<div style="color:var(--text-quaternary);text-align:center;padding:12px;">No messages yet. Start the conversation.</div>';
      container._chatMsgCount = 0;
      return;
    }
    if (container._chatMsgCount && msgs.length === container._chatMsgCount) return;
    var prevCount = container._chatMsgCount || 0;
    container._chatMsgCount = msgs.length;
    if (prevCount > 0 && msgs.length > prevCount) {
      var newMsgs = msgs.slice(prevCount);
      var frag = document.createElement('div');
      frag.innerHTML = newMsgs.map(m => {
        const isMe = m.isSentBySelf === true || m.isSentBySelf === 'true';
        const sender = m.senderName || (isMe ? 'You' : m.nickName || 'Counterparty');
        const ts = m.sentTimestamp || m.createdAt || m.timestamp;
        const timeStr = ts ? new Date(parseInt(ts)).toLocaleTimeString() : '';
        const msgText = m.content || m.message || '';
        const isMedia = m.contentUrl && (m.contentType === '102' || m.contentType === '112');
        return `<div style="margin-bottom:6px;text-align:${isMe ? 'right' : 'left'};">
          <div style="display:inline-block;background:${isMe ? 'rgba(68,138,255,0.15)' : '#0a0a14'};border-radius:8px;padding:6px 10px;max-width:85%;border:1px solid ${isMe ? 'rgba(68,138,255,0.2)' : '#1e1e2e'};">
            <div style="font-size:10px;color:var(--text-quaternary);margin-bottom:2px;">${esc(sender)} · ${timeStr}</div>
            <div style="font-size:12px;color:var(--text-primary);word-break:break-word;">${isMedia ? '<a href="' + esc(m.contentUrl) + '" target="_blank" style="color:var(--accent-blue);">View media</a>' : esc(msgText)}</div>
          </div>
        </div>`;
      }).join('');
      while (frag.firstChild) container.appendChild(frag.firstChild);
    } else {
      container.innerHTML = msgs.map(m => {
      const isMe = m.isSentBySelf === true || m.isSentBySelf === 'true';
      const sender = m.senderName || (isMe ? 'You' : m.nickName || 'Counterparty');
      const ts = m.sentTimestamp || m.createdAt || m.timestamp;
      const timeStr = ts ? new Date(parseInt(ts)).toLocaleTimeString() : '';
      const msgText = m.content || m.message || '';
      const isMedia = m.contentUrl && (m.contentType === '102' || m.contentType === '112');
      return `<div style="margin-bottom:6px;text-align:${isMe ? 'right' : 'left'};">
        <div style="display:inline-block;background:${isMe ? 'rgba(68,138,255,0.15)' : '#0a0a14'};border-radius:8px;padding:6px 10px;max-width:85%;border:1px solid ${isMe ? 'rgba(68,138,255,0.2)' : '#1e1e2e'};">
          <div style="font-size:10px;color:var(--text-quaternary);margin-bottom:2px;">${esc(sender)} · ${timeStr}</div>
          <div style="font-size:12px;color:var(--text-primary);word-break:break-word;">${isMedia ? '<a href="' + esc(m.contentUrl) + '" target="_blank" style="color:var(--accent-blue);">View media</a>' : esc(msgText)}</div>
        </div>
      </div>`;
    }).join('');
    }
    container.scrollTop = container.scrollHeight;
  } catch (err) {
    container.innerHTML = '<div style="color:var(--accent-red);text-align:center;padding:12px;">Failed to load messages</div>';
  }
}

// SSE order cache — SSE is the primary real-time source for orders
window._sseOrdersCache = null;
window._lastSseTimestamp = 0;
window._persistOrdersSnapshot = function() {
  try {
    if (window._lastOrdersPersist && Date.now() - window._lastOrdersPersist < 4000) return;
    window._lastOrdersPersist = Date.now();
    var c = window._sseOrdersCache;
    if (c && Array.isArray(c.orders) && c.orders.length) {
      localStorage.setItem('ordersCacheV1', JSON.stringify({ t: Date.now(), orders: c.orders.slice(0, 100) }));
    }
  } catch (e) {}
};
// Restore last known orders so the Orders tab paints instantly on every load,
// even before SSE connects or the first live fetch completes.
try {
  var _ocRaw = localStorage.getItem('ordersCacheV1');
  if (_ocRaw) {
    var _ocRestored = JSON.parse(_ocRaw);
    if (_ocRestored && Array.isArray(_ocRestored.orders) && _ocRestored.orders.length && Date.now() - (_ocRestored.t || 0) < 24 * 60 * 60 * 1000) {
      window._sseOrdersCache = { orders: _ocRestored.orders };
    }
  }
} catch (e) {}
var _lastSseRender = 0;
var _lastOrdersHash = '';
var _lastRenderAt = 0;
var _renderQueued = false;

// Simple SSE handler: just update cache, trigger render if meaningful change
window.handleSSEOrderUpdate = function(data) {
  if (!data) return;
  window._lastSseTimestamp = Date.now();

  // Single-order action updates (release/mark-paid/cancel) - update cache inline
  if (!data.orders) {
    if (data.orderId && data.action && window._sseOrdersCache && window._sseOrdersCache.orders) {
      for (var i = 0; i < window._sseOrdersCache.orders.length; i++) {
        if (window._sseOrdersCache.orders[i].orderId === data.orderId) {
          if (data.action === 'release') {
            window._sseOrdersCache.orders[i].completionStatus = 'completed';
            window._sseOrdersCache.orders[i].paymentStatus = 'paid';
            var o = window._sseOrdersCache.orders[i];
            if (_tyClaim(o.orderId)) { setTimeout(function() { _autoSendThankYou(o.orderId); }, 200); }
          } else if (data.action === 'mark-paid') {
            window._sseOrdersCache.orders[i].paymentStatus = 'paid';
          } else if (data.action === 'cancel') {
            var o = window._sseOrdersCache.orders[i];
            var st = o.state || o.completionStatus || o.orderStatus || o.status || '';
            if ((st === 'cancelled' || st === 'canceled' || st === 'cancelled') && _tyClaim(o.orderId)) {
              setTimeout(function() { _autoSendCancelledNote(o.orderId, o.side || 'sell'); }, 200);
            }
          }
          break;
        }
      }
    }
    scheduleRender();
    return;
  }

  // Full orders snapshot
  if (Array.isArray(data.orders) && data.orders.length === 0 &&
      window._sseOrdersCache && Array.isArray(window._sseOrdersCache.orders) && window._sseOrdersCache.orders.length > 0) {
    return; // ignore transient empty payloads
  }

  window._sseOrdersCache = data;
  var orders = data.orders || [];
  window._persistOrdersSnapshot();
  if (typeof window.__drainApkBuySmsQueue === 'function') window.__drainApkBuySmsQueue();
  if (!window._tySentOrders) window._tySentOrders = new Set();

  // Compute stable hash for deduping
  var stable = orders.slice().sort(function(a, b) {
    return (a.orderId || '') < (b.orderId || '') ? -1 : (a.orderId || '') > (b.orderId || '') ? 1 : 0;
  });
  var str = '';
  for (var hi = 0; hi < stable.length; hi++) {
    // Use the same signature the renderer keys on. The old hash only covered
    // orderId|state|paymentStatus, so an appeal or an amount change mutated the
    // UI state without invalidating it -> the row stayed stale until some other
    // event happened to force a repaint.
    str += _rowSig(stable[hi]) + ',';
  }
  if (str === _lastOrdersHash) return; // no meaningful change

  _lastOrdersHash = str;
  scheduleRender();
};

// Single render scheduler.
// This used to debounce for up to 5s, which is exactly why a new order or a
// completion could take seconds to show up. It also cleared + re-armed the
// timer on every event, so steady SSE traffic could starve the render
// indefinitely. Now: paint on the next tick, coalescing only same-tick bursts.
// renderOrders is idempotent and its no-op guard skips the DOM write when
// nothing row-visible changed, so a frequent schedule costs almost nothing.
function scheduleRender() {
  if (_renderQueued) return; // a paint is already due; it reads the latest cache
  _renderQueued = true;
  setTimeout(function() {
    _renderQueued = false;
    doRender();
  }, 0);
}

function doRender() {
  if (currentPage !== 'orders') { window._tele && _tele('render_skip', {}); return; }
  var container = document.getElementById('page-content');
  if (!container) return;
  // Normally skip containers that have never rendered (page navigation owns the
  // first paint). But a render that threw leaves the body blank, and those DO
  // need the SSE path to pick them back up - otherwise a single failure means
  // the page never recovers until the user navigates away and back.
  if (!container._ordersRendered && !container._ordersBodyEmpty) return;
  if (window._ordersRenderInProgress) {
    // A render is mid-flight. Don't drop the update - remember it so it paints
    // the instant the current render settles.
    _renderQueued = true;
    return;
  }

  var data = { orders: window._sseOrdersCache && window._sseOrdersCache.orders };
  window._ordersRenderInProgress = true;
  _lastRenderAt = Date.now();

  renderOrders(container, data, true).then(function() {
    window._ordersRenderInProgress = false;
    window._tele && _tele('render_ok', { n: (data.orders || []).length });
    if (_renderQueued) { _renderQueued = false; scheduleRender(); }
  }).catch(function() {
    window._ordersRenderInProgress = false;
    if (_renderQueued) { _renderQueued = false; scheduleRender(); }
  });
}

// SSE chat message updates — re-fetch messages when SSE notifies
document.addEventListener('sse_chat_message', function(e) {
  const data = e.detail;
  if (data && data.orderId) {
    loadChatMessages(data.orderId);
  }
});

// Order filtering and search — supports local filter and optional backend searchKeyword
window._orderSearchFilterDebounce = null;
window.filterOrders = function() {
  const search = (document.getElementById('order-search')?.value || '').toLowerCase().trim();
  const status = document.getElementById('order-status-filter')?.value || 'all';
  // Check if the target section exists in DOM; if not, re-render
  if (status !== 'all' && !document.querySelector('[data-order-status="' + status + '"]')) {
    var c = document.getElementById('page-content');
    if (c) { renderOrders(c); return; }
  }
  // Show/hide sections by status
  document.querySelectorAll('[data-order-status]').forEach(el => {
    const section = el.getAttribute('data-order-status');
    el.style.display = (status === 'all' || status === section) ? '' : 'none';
  });
  // Filter rows by search text
  document.querySelectorAll('[data-order-status] table tbody tr').forEach(row => {
    if (!search) {
      row.style.display = '';
      return;
    }
    const text = (row.textContent || '').toLowerCase();
    row.style.display = text.includes(search) ? '' : 'none';
  });
  // Debounced backend searchKeyword pass
  if (window._orderSearchFilterDebounce) clearTimeout(window._orderSearchFilterDebounce);
  if (search.length >= 3) {
    window._orderSearchFilterDebounce = setTimeout(function() {
      var container = document.getElementById('page-content');
      if (container && currentPage === 'orders') {
        API.get('/api/okx/p2p/order-list?pageSize=100&pageIndex=1&searchKeyword=' + encodeURIComponent(search)).then(function(res) {
          if (res && Array.isArray(res.data)) {
            window._ordersAllPages = res.data.slice(0, 200);
            renderOrders(container, { orders: res.data.slice(0, 200) }, true);
          }
        }).catch(function() {});
      }
    }, 500);
  }
};

// ===== Order Detail Modal =====
window.showOrderDetail = async function(orderId) {
  let o = null;
  let fromCache = false;
  try {
    const res = await API.get('/api/okx/p2p/orders/' + orderId);
    o = res.data || {};
  } catch (err) {
    o = (window._ordersMap && window._ordersMap[orderId]) || null;
    if (o) fromCache = true;
  }
  if (!o || !o.orderId) { showToast('Could not load order detail', 'error'); return; }
  try {
    const cp = o.counterpartyDetail || {};
    // Fallback to root-level fields (preserved in SSE slim) for cached orders
    const nickName = cp.nickName || o.nickName || '';
    const realName = cp.realName || o.realName || '';
    const userNo = cp.userNo || o.userNo || '';
    const type = cp.type || o.type || '';
    const completedOrders = cp.completedOrders;
    const cancelledOrders = cp.cancelledOrders;
    const completionRate = cp.completionRate;
    const kycLevel = cp.kycLevel;
    const avgPaymentTime = cp.avgPaymentTime;
    const pm = o.paymentMethod || {};
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
      <div class="modal-content" style="max-width:700px;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">
          <h3 style="margin:0;font-size:16px;">Order Detail</h3>
          <button class="btn btn-sm btn-outline" onclick="this.closest('.modal-overlay').remove()" style="padding:4px 10px;">✕</button>
        </div>
        ${fromCache ? '<div style="padding:8px 12px;background:rgba(255,179,0,0.08);border-radius:6px;margin-bottom:12px;font-size:12px;color:var(--accent-amber);">Showing cached order data — live fetch failed. Pull to refresh.</div>' : ''}
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          <div class="info-box"><strong>Order ID</strong><br><span style="font-family:monospace;font-size:11px;color:var(--text-secondary);user-select:all;cursor:pointer;" onclick="event.stopPropagation();copyText('${esc(o.orderId || '')}')">${o.orderId || '-'}</span></div>
          <div class="info-box"><strong>Side</strong><br><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></div>
          <div class="info-box"><strong>Status</strong><br><span>${o.state || o.status || '-'}</span></div>
          <div class="info-box"><strong>Payment Status</strong><br><span>${o.paymentStatus || '-'}</span></div>
          <div class="info-box"><strong>Crypto Amount</strong><br><span>${o.cryptoAmount || '-'} ${o.cryptoCurrency || ''}</span></div>
          <div class="info-box"><strong>Fiat Amount</strong><br><span>${formatFiat(o.fiatAmount, o.fiatCurrency)}</span></div>
          <div class="info-box"><strong>Unit Price</strong><br><span>${o.unitPrice || '-'}</span></div>
          <div class="info-box"><strong>Exchange Rate</strong><br><span>${o.exchangeRate || '-'}</span></div>
        </div>
        <h4 style="margin:16px 0 8px;font-size:14px;">Counterparty</h4>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          <div class="info-box"><strong>Nickname</strong><br><span>${userNo ? `<a href="#" onclick="navigateToMerchant('${esc(userNo)}'); return false;" style="color:#448aff;text-decoration:none;">${esc(nickName || realName || '-')}</a>` : esc(nickName || '-')}</span></div>
          <div class="info-box"><strong>Real Name</strong><br><span>${esc(realName || '-')}</span></div>
          <div class="info-box"><strong>Type</strong><br><span style="color:${type === 'diamond' ? 'var(--accent-blue)' : type === 'certified' ? 'var(--accent-green)' : '#78788a'};">${type || '-'}</span></div>
          <div class="info-box"><strong>Completed Orders</strong><br><span>${completedOrders != null ? completedOrders : '-'}</span></div>
          <div class="info-box"><strong>Cancelled Orders</strong><br><span>${cancelledOrders != null ? cancelledOrders : '-'}</span></div>
          <div class="info-box"><strong>Completion Rate</strong><br><span>${completionRate != null ? completionRate + '%' : '-'}</span></div>
          <div class="info-box"><strong>KYC Level</strong><br><span>${kycLevel != null ? kycLevel : '-'}</span></div>
          <div class="info-box"><strong>Avg Payment Time</strong><br><span>${avgPaymentTime || '-'}</span></div>
        </div>
        <div id="order-trust-${esc(o.orderId)}" style="margin:10px 0;"><div style="color:var(--text-quaternary);font-size:11px;">⏳ Loading trust info...</div></div>
        <h4 style="margin:16px 0 8px;font-size:14px;">Payment Method</h4>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          <div class="info-box"><strong>Bank</strong><br><span>${esc(pm.bankName || '-')}</span></div>
          <div class="info-box"><strong>Account</strong><br><span>${esc(pm.accountNumber || pm.account || '-')}</span></div>
          <div class="info-box"><strong>Type</strong><br><span>${pm.paymentMethod || pm.type || '-'}</span></div>
          ${pm.qrCodeUrl ? `<div class="info-box"><strong>QR Code</strong><br><img src="${esc(pm.qrCodeUrl)}" style="max-width:120px;border-radius:4px;border:1px solid var(--border-primary);"></div>` : ''}
        </div>
        ${o.chatPayments && o.chatPayments.length ? `<div style="margin-top:8px;padding:8px 10px;background:rgba(68,138,255,0.06);border:1px solid rgba(68,138,255,0.2);border-radius:8px;"><strong style="font-size:12px;color:var(--accent-blue);">📩 Payment Method (from chat)</strong>
          <div style="margin-top:6px;">${o.chatPayments.map(function(cp){
            var cpNum = esc(String(cp.phoneNumber || cp.accountNumber || ''));
            var cpHint = esc(cp.bankHint || 'Chat');
            return cpNum ? `<div style="display:flex;align-items:center;gap:6px;font-size:12px;margin-top:2px;"><span style="font-family:monospace;user-select:all;">${cpNum}</span><span style="font-size:9px;color:var(--text-quaternary);">${cpHint}</span><button class="btn btn-sm btn-outline" onclick="event.stopPropagation();copyText('${cpNum}')" style="padding:1px 8px;font-size:10px;">Copy</button></div>` : '';
          }).join('')}</div></div>` : ''}
        <h4 style="margin:16px 0 8px;font-size:14px;">Dispute / Frozen</h4>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          <div class="info-box"><strong>Dispute Status</strong><br><span style="color:${o.disputeStatus === '1' ? 'var(--accent-red)' : 'var(--accent-green)'};">${o.disputeStatus === '1' ? 'Active' : 'None'}</span></div>
          <div class="info-box"><strong>Can Raise Dispute</strong><br><span>${o.canRaiseDispute ? 'Yes' : 'No'}</span></div>
          <div class="info-box"><strong>Frozen Type</strong><br><span>${o.frozenType || 'None'}</span></div>
        </div>
        ${String(o.disputeStatus) === '1' ? `<div id="order-dispute-${esc(o.orderId)}" style="margin-top:8px;"></div>` : ''}
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:8px;">
          ${o.createdTimestamp ? `<div class="info-box"><strong>Created</strong><br><span>${new Date(parseInt(o.createdTimestamp)).toLocaleString()}</span></div>` : ''}
          ${o.completionTimestamp ? `<div class="info-box"><strong>Completed</strong><br><span>${new Date(parseInt(o.completionTimestamp)).toLocaleString()}</span></div>` : ''}
        </div>
        <!-- Timeline -->
        <div style="margin:12px 0;padding:12px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);">
          <div style="font-size:12px;color:var(--text-quaternary);margin-bottom:8px;font-weight:600;">⏳ Order Timeline</div>
          <div style="display:flex;align-items:center;gap:4px;font-size:10px;flex-wrap:wrap;">
            ${o.createdTimestamp ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(0,210,104,0.1);border-radius:4px;"><span>📝 Created</span><span style="color:var(--text-tertiary);">${new Date(parseInt(o.createdTimestamp)).toLocaleString()}</span></div><span style="color:#33334a;">→</span>` : ''}
            ${orderIsPaid(o) || o.paymentTimestamp ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(68,138,255,0.1);border-radius:4px;"><span>💵 Paid</span><span style="color:var(--text-tertiary);">${o.paymentTimestamp ? new Date(parseInt(o.paymentTimestamp)).toLocaleString() : '✓'}</span></div><span style="color:#33334a;">→</span>` : ''}
            ${o.completionTimestamp ? `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:rgba(0,200,83,0.1);border-radius:4px;"><span>✅ Completed</span><span style="color:var(--text-tertiary);">${new Date(parseInt(o.completionTimestamp)).toLocaleString()}</span></div>` : `<div style="display:flex;align-items:center;gap:4px;padding:4px 8px;background:var(--accent-amber-glow);border-radius:4px;"><span>⏳ In Progress</span></div>`}
          </div>
        </div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:16px;padding-top:12px;border-top:1px solid #1e1e2e;">
          ${o.paymentStatus === 'unpaid' && o.side !== 'sell' ? `<button class="btn btn-primary" onclick="ordersMarkBuyOrderPaid('${esc(o.orderId)}');this.closest('.modal-overlay').remove()" style="background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);font-weight:700;">Mark as Paid</button>` : ''}
          ${orderIsPaid(o) && o.side === 'sell' && !(window.isAppealedOrder && window.isAppealedOrder(o)) ? `<button class="btn btn-primary" onclick="releaseSingleOrder('${esc(o.orderId)}');this.closest('.modal-overlay').remove()">Release</button>` : ''}
          ${o.canRaiseDispute ? `<button class="btn btn-danger btn-sm" onclick="this.closest('.modal-overlay').remove();setTimeout(function(){raiseDispute('${esc(o.orderId)}','${o.side || 'buy'}')},100)">Raise Dispute</button>` : ''}
          ${o.disputeStatus === '1' ? `<button class="btn btn-outline btn-sm" onclick="navigate('disputes')">View Dispute</button>` : ''}
          <button class="btn btn-sm btn-outline" onclick="setOrderReminder('${esc(o.orderId)}')" style="font-size:10px;">⏰ Remind</button>
          <button class="btn btn-secondary btn-sm" onclick="this.closest('.modal-overlay').remove()">Close</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    loadOrderTrustBadges(o.orderId, o);
    if (String(o.disputeStatus) === '1') renderOrderDisputeCenter(o.orderId);
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Cancel Order With Reason =====
window.cancelOrderWithReason = async function(orderId) {
  var reasons = [];
  try {
    var res = await API.get('/api/p2p/orders/' + orderId + '/cancel-reasons');
    reasons = res.data || [];
  } catch (e) {}
  var order = window._ordersMap && window._ordersMap[orderId];
  var orderAmt = order ? (order.fiatAmount || order.cryptoAmount || '') : '';
  var orderCur = order ? (order.fiatCurrency || order.cryptoCurrency || '') : '';
  var html = '<div class="modal-overlay"><div class="modal-content" style="max-width:420px;"><h3>Cancel Order</h3>';
  if (orderAmt) html += '<div style="padding:8px 12px;background:rgba(244,67,54,0.06);border-radius:6px;margin-bottom:12px;font-size:12px;color:var(--text-tertiary);">Order amount: <strong style="color:var(--text-primary);">' + esc(orderAmt) + ' ' + esc(orderCur) + '</strong></div>';
  if (reasons.length > 0) {
    html += '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:12px;">Select a reason for cancellation:</p>';
    html += '<form data-on-submit="submitCancelWithReason(event,\'' + orderId + '\')">';
    html += '<div class="form-group"><select id="cancel-reason-select" required style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;">';
    html += '<option value="">-- Select Reason --</option>';
    reasons.forEach(function(r) {
      html += '<option value="' + esc(r.code || r) + '">' + esc(r.reason || r.subReason || r) + '</option>';
    });
    html += '</select></div>';
    html += '<div class="form-actions" style="margin-top:16px;">';
    html += '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Back</button>';
    html += '<button type="submit" class="btn btn-danger">Confirm Cancel</button></div></form>';
  } else {
    html += '<p style="color:var(--text-tertiary);font-size:13px;">No cancel reasons available. Cancel directly?</p>';
    html += '<div class="form-actions" style="margin-top:16px;">';
    html += '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Back</button>';
    html += '<button class="btn btn-danger" onclick="submitDirectCancel(\'' + orderId + '\')">Cancel Order</button></div>';
  }
  html += '</div></div>';
  var temp = document.createElement('div');
  temp.innerHTML = html;
  document.body.appendChild(temp.firstElementChild);
};

window.submitCancelWithReason = async function(e, orderId) {
  e.preventDefault();
  var val = document.getElementById('cancel-reason-select')?.value;
  if (!val) { showToast('Please select a reason', 'error'); return; }
  try {
    const order = window._ordersMap && window._ordersMap[orderId];
    const amount = order ? String(order.fiatAmount || '') : '';
    await API.post('/api/okx/p2p/orders/' + orderId + '/cancel', { reason: val, amount: amount });
    document.querySelector('.modal-overlay')?.remove();
    showToast('Order cancelled', 'info');
  } catch (err) { showToast(err.message, 'error'); }
};

window.submitDirectCancel = async function(orderId) {
  try {
    const order = window._ordersMap && window._ordersMap[orderId];
    const amount = order ? String(order.fiatAmount || '') : '';
    await API.post('/api/okx/p2p/orders/' + orderId + '/cancel', { amount: amount });
    document.querySelector('.modal-overlay')?.remove();
    showToast('Order cancelled', 'info');
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Mark Unpaid =====
window.markOrderUnpaid = async function(orderId) {
  if (!confirm('Mark this order as unpaid? This will notify the counterparty.')) return;
  try {
    await API.post('/api/okx/p2p/orders/' + orderId + '/mark-unpaid');
    showToast('Order marked as unpaid', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Auto Mark Paid (one-tap) toggle =====
window._isAutoMarkPaidOn = function() {
  return localStorage.getItem('ordersAutoMarkPaid') === '1';
};
window._syncAutoMarkPaidToggle = function() {
  var btn = document.getElementById('orders-auto-paid-toggle');
  if (!btn) return;
  var on = window._isAutoMarkPaidOn();
  btn.innerHTML = on ? '⚡ Auto Mark Paid: ON' : '⚡ Auto Mark Paid';
  btn.style.borderColor = on ? '#00e676' : 'var(--border-primary)';
  btn.style.background = on ? 'rgba(0,230,118,0.15)' : 'transparent';
  btn.style.color = on ? '#00e676' : 'var(--text-quaternary)';
};
window.toggleAutoMarkPaidMode = function() {
  var on = !window._isAutoMarkPaidOn();
  localStorage.setItem('ordersAutoMarkPaid', on ? '1' : '0');
  window._syncAutoMarkPaidToggle();
  showToast(on ? 'Auto Mark Paid ON — tap Mark Paid to pay instantly' : 'Auto Mark Paid OFF', on ? 'success' : 'info');
};

// ===== Orders Mark Paid Wrapper (always routes BUY orders through the modal so
// the payment SMS can be matched + posted to chat; SELL-side untouched) =====
window.ordersMarkBuyOrderPaid = async function(orderId) {
  var o = window._ordersMap && window._ordersMap[orderId];
  var st = (o && String(o.paymentStatus || '').toLowerCase()) || '';
  if (st === 'paid' || st === 'confirmed' || (o && /(?:completed|released)/i.test(String(o.completionStatus || o.state || '')))) {
    showToast(st === 'paid' || st === 'confirmed' ? 'Order has already been paid — recheck the order status or try again later.' : 'Order is already complete — nothing left to mark paid.', 'info');
    return;
  }
  var isBuy = o && String(o.side || '').toLowerCase() === 'buy';
  if (isBuy) {
    // Buy orders always pay one-tap — never show the RRN/proof confirm modal.
    // The APK auto-captures the I&M outgoing SMS and the SMS matcher posts
    // the ref to this order's chat automatically.
    if (window._oneTapInFlight && window._oneTapInFlight[orderId]) return;
    await window._markBuyOrderPaidOneTap(orderId);
    return;
  }
  var settings = window._ordersSettings || {};
  if (settings.requireRrn || settings.requireProofPaid) {
    showMarkPaidModal(orderId);
    return;
  }
  // Fall through to bank's markBuyOrderPaid
  if (typeof markBuyOrderPaid === 'function') {
    await markBuyOrderPaid(orderId);
  }
};

// One-tap mark paid: attaches the saved proof image if configured, but never
// interrupts with uploaders or modals — the tapped order is paid instantly.
window._markBuyOrderPaidOneTap = async function(orderId) {
  // Two-second debounce per order so a double-tap can't double-POST.
  window._oneTapInFlight = window._oneTapInFlight || {};
  if (window._oneTapInFlight[orderId]) return;
  window._oneTapInFlight[orderId] = true;
  setTimeout(function() { window._oneTapInFlight[orderId] = false; }, 2000);
  var proofUrl = '';
  try {
    var _pf = (await API.get('/api/auth/preferences')).data || {};
    if (_pf.paymentProofImage && _pf.paymentProofUseForAll) proofUrl = _pf.paymentProofImage;
  } catch (e) {}
  var payload = {};
  if (proofUrl) payload.paymentProofFileUrls = proofUrl;
  optimisticMarkPaid(orderId);
  try {
    // Long timeout (90s): mark-paid runs on the OKX foreground queue, which can
    // be paused up to 60s by a throttle; a 30s default would abort the call and
    // the order would expire un-paid even though payment was made.
    await API.request('POST', '/api/okx/p2p/orders/' + orderId + '/mark-paid', payload, 90000);
  } catch (postErr) {
    if (typeof revertOptimisticPaid === 'function') revertOptimisticPaid(orderId);
    showToast(postErr.message, 'error');
    return;
  }
  showToast('Marked as paid ✅ — SMS ref auto-posting to chat', 'success');
  // Flush any buffered I&M SMS captured by the APK right away.
  if (window.__drainApkBuySmsQueue) { try { window.__drainApkBuySmsQueue(); } catch (e) {} }
  var _o = window._ordersMap?.[orderId];
  if (_o && _o.fiatAmount) {
    API.post('/api/bank/auto-sync', { orders: [{ orderId, side: 'buy', fiatAmount: _o.fiatAmount, paymentStatus: 'paid', state: 'pending' }] }).catch(function() {});
  }
};

// ===== Show Mark Paid Modal (with RRN + proof URL) =====
function showMarkPaidModal(orderId) {
  var order = window._ordersMap && window._ordersMap[orderId];
  var html = '<div class="modal-overlay"><div class="modal-content" style="max-width:460px;"><h3>💵 Mark Order as Paid</h3>';
  html += '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Optional: add transaction details to help seller verify payment faster.</p>';
  if (window._ordersSettings.requireRrn) {
    html += '<div class="form-group"><label for="mark-paid-rrn">M-Pesa Transaction Code (RRN)</label>';
    html += '<input id="mark-paid-rrn" class="form-input" placeholder="e.g. PBT23A1B2C" style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;" maxlength="30">';
    html += '<div style="font-size:10px;color:var(--text-quaternary);margin-top:4px;">Optional — enter the M-Pesa transaction code from your payment confirmation SMS</div></div>';
  }
  if (window._ordersSettings.requireProofPaid) {
    html += '<div class="form-group"><label for="mark-paid-proof-url">Payment Proof URL</label>';
    html += '<input id="mark-paid-proof-url" class="form-input" placeholder="https://imgur.com/..." style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;">';
    html += '<button type="button" class="btn btn-sm btn-outline" data-on-click="showProofUploaderForMarkPaid()" style="margin-top:6px;width:100%;padding:8px;">📎 Upload Payment Screenshot</button>';
    html += '<div style="font-size:10px;color:var(--text-quaternary);margin-top:4px;">Upload your payment screenshot directly (preferred), or paste an imgur.com link (optional)</div></div>';
  }
  if (order && order.fiatAmount) {
    html += '<div style="padding:8px 12px;background:rgba(0,210,104,0.06);border-radius:6px;margin-bottom:12px;font-size:12px;color:var(--text-tertiary);">Amount: <strong style="color:var(--accent-green);">' + esc(order.fiatAmount) + ' ' + esc(order.fiatCurrency || '') + '</strong></div>';
  }
  html += '<div style="font-size:10px;color:var(--text-quaternary);margin-bottom:4px;">Tip: your saved payment proof image (Ads → Advanced) is attached automatically when left blank.</div>';
  html += '<div class="form-actions" style="margin-top:16px;">';
  html += '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Cancel</button>';
  html += '<button type="button" id="mark-paid-confirm" class="btn btn-primary" onclick="submitMarkPaid(\'' + orderId + '\')" style="background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);font-weight:700;">Confirm Payment</button>';
  html += '</div></div></div>';
  var temp = document.createElement('div');
  temp.innerHTML = html;
  document.body.appendChild(temp.firstElementChild);
  setTimeout(function() { document.getElementById('mark-paid-rrn')?.focus(); }, 100);
}

window.showProofUploaderForMarkPaid = function() {
  showFileUploader(function(url) {
    var input = document.getElementById('mark-paid-proof-url');
    if (input && url) input.value = url;
    showToast('Proof image attached', 'success');
  });
};

window.submitMarkPaid = async function(orderId) {
  var rrn = document.getElementById('mark-paid-rrn')?.value?.trim() || '';
  var proofUrl = document.getElementById('mark-paid-proof-url')?.value?.trim() || '';
  if (!proofUrl) {
    try {
      var _pf = (await API.get('/api/auth/preferences')).data || {};
      if (_pf.paymentProofImage && _pf.paymentProofUseForAll) proofUrl = _pf.paymentProofImage;
    } catch (e) {}
  }
  try {
    var payload = {};
    if (rrn) payload.rrnCode = rrn;
    if (proofUrl) payload.paymentProofFileUrls = proofUrl;
    // Instant visual feedback — OKX ack can take 5-20s.
    optimisticMarkPaid(orderId);
    try {
      // Long timeout (90s): mark-paid runs on the OKX foreground queue, which can
      // be paused up to 60s by a throttle; a 30s default would abort the call and
      // the order would expire un-paid even though payment was made.
      await API.request('POST', '/api/okx/p2p/orders/' + orderId + '/mark-paid', payload, 90000);
    } catch (postErr) {
      revertOptimisticPaid(orderId);
      throw postErr;
    }
    document.querySelector('.modal-overlay')?.remove();
    showToast('Marked as paid — waiting for seller to release', 'success');
    var o = window._ordersMap?.[orderId];
    if (o && o.fiatAmount) {
      API.post('/api/bank/auto-sync', { orders: [{ orderId, side: 'buy', fiatAmount: o.fiatAmount, paymentStatus: 'paid', state: 'pending' }] }).catch(function() {});
    }
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Show Release Proof Modal =====
function showReleaseProofModal(orderId) {
  var order = window._ordersMap && window._ordersMap[orderId];
  var html = '<div class="modal-overlay"><div class="modal-content" style="max-width:440px;"><h3>📤 Release — Upload Proof</h3>';
  html += '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Upload payment proof before releasing crypto (optional).</p>';
  html += '<div class="form-group"><label for="release-proof-url">Payment Proof URL</label>';
  html += '<input id="release-proof-url" class="form-input" placeholder="https://imgur.com/..." style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;">';
  html += '<div style="font-size:10px;color:var(--text-quaternary);margin-top:4px;">Upload screenshot to imgur.com and paste link (optional)</div></div>';
  if (order && order.fiatAmount) {
    html += '<div style="padding:8px 12px;background:rgba(244,67,54,0.06);border-radius:6px;margin-bottom:12px;font-size:12px;color:var(--text-tertiary);">Amount: <strong>' + esc(order.fiatAmount) + ' ' + esc(order.fiatCurrency || '') + '</strong></div>';
  }
  html += '<div class="form-actions" style="margin-top:16px;">';
  html += '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Cancel</button>';
  html += '<button type="button" class="btn btn-primary" onclick="submitReleaseWithProof(\'' + orderId + '\')">Release Crypto</button>';
  html += '</div></div></div>';
  var temp = document.createElement('div');
  temp.innerHTML = html;
  document.body.appendChild(temp.firstElementChild);
}

window.submitReleaseWithProof = async function(orderId) {
  var proofUrl = document.getElementById('release-proof-url')?.value?.trim() || '';
  try {
    var o = window._ordersMap?.[orderId];
    var payload = {};
    if (proofUrl) payload.paymentProofFileUrls = proofUrl;
    if (o && o.fiatAmount) payload.amount = String(o.fiatAmount);
    await API.post('/api/okx/p2p/orders/' + orderId + '/release', payload);
    document.querySelector('.modal-overlay')?.remove();
    showToast('Crypto released!', 'success');
    if (typeof _refreshOrdersFromCache === 'function') _refreshOrdersFromCache();
    var o = window._ordersMap?.[orderId];
    var fiat = o ? String(o.fiatAmount || '0') : '0';
    API.post('/api/bank/auto-sync', { orders: [{ orderId, side: 'sell', fiatAmount: fiat, paymentStatus: 'paid', state: 'completed' }] }).catch(function() {});
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Tab Switching =====
window.switchOrdersTab = function(tab) {
  // Cleanup orders timers when leaving orders tab
  if (window._ordersTab === 'orders' && tab !== 'orders') {
    if (window._ordersTimerTick) { clearInterval(window._ordersTimerTick); window._ordersTimerTick = null; }
    window._ordersTimerEls = [];
    window._ordersTimerTexts = {};
  }
  window._ordersTab = tab;
  document.querySelectorAll('.orders-tab').forEach(function(el) {
    var t = el.getAttribute('data-orders-tab');
    if (t === tab) {
      el.style.background = '#14142a';
      el.style.color = '#e4e4ec';
      el.style.borderColor = '#1e1e2e';
    } else {
      el.style.background = 'transparent';
      el.style.color = '#55556a';
      el.style.borderColor = '#1e1e2e';
    }
  });
  var ordersContent = document.getElementById('orders-tab-content');
  var advancedContent = document.getElementById('orders-advanced-content');
  var filterBar = document.getElementById('orders-filter-bar');
  if (ordersContent) ordersContent.style.display = tab === 'orders' ? '' : 'none';
  if (advancedContent) advancedContent.style.display = tab === 'advanced' ? '' : 'none';
  if (filterBar) filterBar.style.display = tab === 'orders' ? '' : 'none';
  if (tab === 'advanced') { try { window.loadSmsAutoReleaseSettings(); } catch (e) {} }
};

// ===== Toggle Order Setting =====
window.toggleOrderSetting = function(key, value) {
  if (!window._ordersSettings) window._ordersSettings = {};
  window._ordersSettings[key] = value;
  localStorage.setItem('ordersSettings', JSON.stringify(window._ordersSettings));
  // Chart and counterparty grouping are presentation-only settings; refresh
  // the existing view locally instead of forcing a new API-backed page render.
};

// SMS auto-release settings (sell side) live server-side in user preferences,
// so they apply on any device. Load once, then save on change.
window.loadSmsAutoReleaseSettings = function() {
  API.getSmsAutoRelease().then(function(res) {
    var d = (res && res.data) || {};
    var cb = document.getElementById('orders-setting-sms-autorelease');
    var cap = document.getElementById('orders-setting-sms-autorelease-cap');
    var st = document.getElementById('orders-setting-sms-autorelease-status');
    if (!cb) return;
    cb.checked = !!d.enabled;
    if (cap && d.cap) cap.value = d.cap;
    if (st) st.textContent = d.enabled
      ? '🟢 On — high-confidence SMS-matched sell payments will auto-release' + (d.cap ? ' (cap KES ' + Number(d.cap).toLocaleString() + ')' : ' (no amount cap)')
      : 'Off — SMS matches only get a record + notification; release stays manual.';
    cb.disabled = false;
    if (cap) cap.disabled = false;
  }).catch(function() {
    var cb = document.getElementById('orders-setting-sms-autorelease');
    if (cb) cb.disabled = true;
  });
};
window.saveSmsAutoReleaseSettings = function() {
  var cb = document.getElementById('orders-setting-sms-autorelease');
  var capEl = document.getElementById('orders-setting-sms-autorelease-cap');
  var st = document.getElementById('orders-setting-sms-autorelease-status');
  if (!cb || cb.disabled) return;
  var enabled = cb.checked;
  var cap = Math.max(0, parseFloat(capEl ? capEl.value : 0) || 0);
  if (st) st.textContent = 'Saving…';
  API.setSmsAutoRelease({ enabled: enabled, cap: cap }).then(function() {
    if (st) st.textContent = (enabled ? '🟢 On — SMS-matched sell payments release automatically' + (cap ? ' (cap KES ' + Number(cap).toLocaleString() + ')' : ' (no cap)') : 'Off — release stays manual.') + ' ✓ Saved';
  }).catch(function(e) {
    if (st) st.textContent = 'Save failed: ' + (e.message || e);
    else showToast('Failed to save auto-release settings', 'error');
  });
};

// ===== Apply Advanced Filters (crypto, fiat, date) =====
window.applyOrdersAdvancedFilter = function() {
  if (!window._ordersSettings) window._ordersSettings = {};
  window._ordersSettings.cryptoFilter = document.getElementById('orders-crypto-filter')?.value || '';
  window._ordersSettings.fiatFilter = document.getElementById('orders-fiat-filter')?.value || '';
  window._ordersSettings.dateStart = document.getElementById('orders-date-start')?.value || '';
  window._ordersSettings.dateEnd = document.getElementById('orders-date-end')?.value || '';
  localStorage.setItem('ordersSettings', JSON.stringify(window._ordersSettings));
  // Re-fetch with filters
  var container = document.getElementById('page-content');
  if (container && currentPage === 'orders') {
    var crypto = window._ordersSettings.cryptoFilter;
    var fiat = window._ordersSettings.fiatFilter;
    var ds = window._ordersSettings.dateStart;
    var de = window._ordersSettings.dateEnd;
    var qs = 'pageSize=100&pageIndex=1' + (crypto ? '&cryptoCurrencies=' + crypto : '') + (fiat ? '&fiatCurrencies=' + fiat : '');
    if (ds) qs += '&start=' + new Date(ds + 'T00:00:00').getTime();
    if (de) {
      var endMs = new Date(de + 'T23:59:59').getTime();
      if (endMs < Date.now()) qs += '&end=' + endMs;
    }
    API.get('/api/okx/p2p/order-list?' + qs).then(function(res) {
      if (res && Array.isArray(res.data)) {
        window._ordersAllPages = res.data.slice(0, 200);
        renderOrders(container, { orders: res.data.slice(0, 200) }, true);
      }
    }).catch(function() {});
  }
};

// ===== Check Unreleased Orders (background) =====
var _unreleasedLastCheck = 0;
async function _checkUnreleasedOrders() {
  if (Date.now() - _unreleasedLastCheck < 30000) return;
  _unreleasedLastCheck = Date.now();
  try {
    var res = await API.get('/api/okx/p2p/unreleased');
    var orders = res.data || [];
    window._unreleasedOrderIds = orders.map(function(o) { return o.orderId; }).filter(Boolean);
    var banner = document.getElementById('unreleased-banner');
    if (banner) {
      if (orders.length > 0) {
        var waiting = '';
        if (orders[0] && orders[0].createdTimestamp) {
          var minSince = Math.floor((Date.now() - parseInt(orders[0].createdTimestamp)) / 60000);
          waiting = minSince > 1 ? ' (~' + minSince + ' min old)' : '';
        }
        banner.style.display = 'block';
        banner.innerHTML = '⚠️ <strong>' + orders.length + ' unreleased order' + (orders.length > 1 ? 's' : '') + '</strong> pending for too long' + waiting + '. <a href="#" onclick="document.getElementById(\'unreleased-banner\').style.display=\'none\';return false;" style="color:var(--accent-blue);text-decoration:none;">Dismiss</a>';
      } else {
        banner.style.display = 'none';
      }
    }
  } catch (e) {
    // Silently fail — unreleased check is non-critical
  }
}

// ===== 📌 Pinned List UI =====
window._refreshPinnedListUI = function() {
  var el = document.getElementById('pinned-list');
  if (!el) return;
  var pinned = window._getPinnedOrders();
  if (pinned.length === 0) { el.innerHTML = ''; return; }
  el.innerHTML = pinned.map(function(id) {
    return '<span style="display:inline-flex;align-items:center;gap:4px;padding:2px 8px;margin:2px;background:var(--bg-secondary);border-radius:4px;font-size:10px;"><span>📌</span><span style="max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + id.slice(0,12) + '</span><span data-on-click="togglePinOrder(\'' + id + '\')" style="cursor:pointer;color:#f44336;font-size:12px;">×</span></span>';
  }).join(' ');
};

// ===== 📌 Pin Orders (localStorage) =====
window._getPinnedOrders = function() {
  try { return JSON.parse(localStorage.getItem('_pinnedOrders') || '[]'); } catch(e) { return []; }
};
window._savePinnedOrders = function(ids) {
  localStorage.setItem('_pinnedOrders', JSON.stringify(ids));
};
window.togglePinOrder = function(orderId) {
  var pinned = window._getPinnedOrders();
  var idx = pinned.indexOf(orderId);
  if (idx >= 0) pinned.splice(idx, 1); else pinned.push(orderId);
  window._savePinnedOrders(pinned);
  var container = document.getElementById('page-content');
  if (container && currentPage === 'orders') renderOrders(container, null, true);
  showToast(idx >= 0 ? 'Order unpinned' : 'Order pinned', 'info');
};

// ===== ⏰ Order Reminder (Notification API) =====
window.setOrderReminder = function(orderId) {
  var html = '<div class="modal-overlay"><div class="modal-content" style="max-width:360px;"><h3>⏰ Set Reminder</h3>';
  html += '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:12px;">Get notified when it\'s time to check this order.</p>';
  html += '<div class="form-group"><label>Remind me in:</label>';
  html += '<select id="reminder-delay" style="width:100%;padding:10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;">';
  html += '<option value="15">15 minutes</option>';
  html += '<option value="30">30 minutes</option>';
  html += '<option value="60" selected>1 hour</option>';
  html += '<option value="120">2 hours</option>';
  html += '</select></div>';
  html += '<div class="form-actions" style="margin-top:16px;">';
  html += '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Cancel</button>';
  html += '<button type="button" class="btn btn-primary" onclick="confirmOrderReminder(\'' + orderId + '\')">Set Reminder</button></div></div></div>';
  var temp = document.createElement('div');
  temp.innerHTML = html;
  document.body.appendChild(temp.firstElementChild);
};
window.confirmOrderReminder = function(orderId) {
  var delayMin = parseInt(document.getElementById('reminder-delay')?.value || '60');
  var order = window._ordersMap && window._ordersMap[orderId];
  var label = (order ? order.cryptoAmount + ' ' + (order.cryptoCurrency || '') : orderId.slice(0, 12)) + ' — ' + (order ? order.side : '');
  setTimeout(function() {
    if (Notification.permission === 'granted') {
      new Notification('⏰ Order Reminder', { body: 'Time to check order: ' + label, tag: 'order-remind-' + orderId });
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(function(p) {
        if (p === 'granted') new Notification('⏰ Order Reminder', { body: 'Time to check order: ' + label, tag: 'order-remind-' + orderId });
        else showToast('Notification permission denied', 'error');
      });
    } else {
      showToast('Notification permission denied. Enable in browser settings.', 'error');
    }
    showToast('⏰ Reminder set for ' + delayMin + ' min: ' + label, 'info');
  }, delayMin * 60000);
  document.querySelector('.modal-overlay')?.remove();
  showToast('⏰ Reminder set for ' + delayMin + ' minutes', 'success');
};

// ===== 🔊 Audio Alert =====
window._playOrderAlert = function() {
  try {
    var ctx = new (window.AudioContext || window.webkitAudioContext)();
    var osc = ctx.createOscillator();
    var gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = 880;
    gain.gain.value = 0.15;
    osc.start();
    osc.stop(ctx.currentTime + 0.2);
    setTimeout(function() {
      var osc2 = ctx.createOscillator();
      var gain2 = ctx.createGain();
      osc2.connect(gain2);
      gain2.connect(ctx.destination);
      osc2.frequency.value = 1100;
      gain2.gain.value = 0.1;
      osc2.start();
      osc2.stop(ctx.currentTime + 0.15);
    }, 250);
  } catch(e) {}
};

// ===== 📊 7-Day Order Chart =====
window._ordersChart = null;
window._ordersChartHistory = null;
window._ordersChartHistoryBusy = false;
// Render the chart from a dataset. Buckets 7 days (completed vs cancelled),
// and skips the canvas recreate when the 14 data points are unchanged — this
// runs on every full render, so the key check alone avoids hundreds of redraws.
window._renderOrdersChart = function(orders) {
  var container = document.getElementById('orders-chart-container');
  if (!container) return;
  var showChart = window._ordersSettings && window._ordersSettings.showChart !== false;
  container.style.display = showChart ? '' : 'none';
  if (!showChart) return;
  if (!container.querySelector('canvas') || typeof window.Chart === 'undefined') {
    // No canvas yet (first draw) or Chart.js still lazy-loading — must compute
    // buckets so the chart draws once the library is ready.
  } else {
    // Cheap guard: skip the 14 filter passes below unless the snapshot actually
    // changed. Hash every order (id + completion ts + state) with a rolling
    // multiply-xor — no array.map/join, no Date, no string concat of headers.
    var _h1 = 5381, _h2 = 52711;
    for (var _k = 0; _k < orders.length; _k++) {
      var _o = orders[_k];
      if (!_o) continue;
      var _id = _o.orderId || '';
      var _mask = 0;
      for (var _c = 0; _c < _id.length; _c++) _mask = ((_mask << 5) + _mask) ^ _id.charCodeAt(_c);
      _h1 = ((_h1 << 5) + _h1) ^ (_mask + _id.length);
      _h2 = ((_h2 << 5) + _h2) ^ parseInt(_o.completionTimestamp || _o.createdTimestamp || '0', 10);
      if (isCompletedOrder(_o)) _h2 = ((_h2 << 5) + _h2) ^ 0x9e37;
      else if (orderState(_o) === 'canceled' || orderState(_o) === 'cancelled') _h2 = ((_h2 << 5) + _h2) ^ 0x5bd1;
    }
    var _sample = orders.length + ':' + _h1 + ':' + _h2;
    if (_sample === window._ordersChartSampleKey) return;
    window._ordersChartSampleKey = _sample;
  }
  var now = Date.now();
  var dayLabels = [];
  var completedData = [];
  var cancelledData = [];
  for (var i = 6; i >= 0; i--) {
    var d = new Date(now - i * 86400000);
    dayLabels.push(d.toLocaleDateString(undefined, { weekday: 'short' }));
    var dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    var dayEnd = dayStart + 86400000;
    var dayCompleted = orders.filter(function(o) {
      var ts = parseInt(o.completionTimestamp || o.createdTimestamp || '0');
      return ts >= dayStart && ts < dayEnd && isCompletedOrder(o);
    }).length;
    var dayCancelled = orders.filter(function(o) {
      var ts = parseInt(o.completionTimestamp || o.createdTimestamp || '0');
      return ts >= dayStart && ts < dayEnd && (orderState(o) === 'canceled' || orderState(o) === 'cancelled');
    }).length;
    completedData.push(dayCompleted);
    cancelledData.push(dayCancelled);
  }
  var _chartKey = completedData.join(',') + '|' + cancelledData.join(',');
  if (window._ordersChartKey === _chartKey && container.querySelector('canvas')) return;
  window._ordersChartKey = _chartKey;
  if (window._ordersChart) { window._ordersChart.destroy(); window._ordersChart = null; }
  var canvas = container.querySelector('canvas');
  if (!canvas) {
    canvas = document.createElement('canvas');
    container.appendChild(canvas);
  }
  if (typeof Chart !== 'undefined') {
    window._ordersChart = new Chart(canvas.getContext('2d'), {
      type: 'line',
      data: {
        labels: dayLabels,
        datasets: [{
          label: 'Completed',
          data: completedData,
          borderColor: '#00d268',
          backgroundColor: 'rgba(0,210,104,0.05)',
          tension: 0.3,
          pointRadius: 2,
          borderWidth: 1.5,
          fill: true
        }, {
          label: 'Cancelled',
          data: cancelledData,
          borderColor: '#f44336',
          backgroundColor: 'rgba(244,67,54,0.05)',
          tension: 0.3,
          pointRadius: 2,
          borderWidth: 1.5,
          fill: true
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: true, bodyFont: { size: 11 } } },
        scales: {
          x: { display: true, ticks: { color: '#55556a', font: { size: 9 } }, grid: { display: false } },
          y: { display: true, ticks: { color: '#55556a', font: { size: 9 }, stepSize: 1 }, grid: { color: '#1e1e2e' } }
        }
      }
});
  } else {
    // Chart.js not loaded yet (lazy-loaded) — this was a warm-up pass. Reset the
    // key so the post-load call from __loadChartJs actually draws instead of
    // tripping the _chartKey short-circuit above.
    window._ordersChartKey = null;
  }
};
// Fetch up to ~7 days of completed/cancelled history (bounded, 120s cache) so the
// chart shows the full week even though the tab only keeps a recent snapshot.
// Renders immediately with what we have, then upgrades to full history when the
// fetch lands. Cache-busted with _t so the server doesn't serve a stale warm cache.
window._ensureOrdersChartHistory = function(orders, cb) {
  cb(orders);
  var fresh = window._ordersChartHistory && (Date.now() - window._ordersChartHistory.ts < 120000);
  var hasOld = orders.some(function(o) {
    var ts = parseInt(o.completionTimestamp || o.createdTimestamp || '0');
    return ts > 0 && ts < Date.now() - 2 * 86400000;
  });
  if (fresh || hasOld || window._ordersChartHistoryBusy) return;
  window._ordersChartHistoryBusy = true;
  var begin = Date.now() - 7 * 86400000;
  var collected = [];
  var pg = 1;
  var fetchPage = function() {
    if (pg > 2 || collected.length >= 200) { finish(); return; }
    API.get('/api/okx/p2p/order-list?pageSize=100&pageIndex=' + pg + '&_t=' + Date.now() + '&begin=' + begin)
      .then(function(res) {
        var arr = (res && Array.isArray(res.data)) ? res.data : [];
        collected = collected.concat(arr);
        if (arr.length >= 100) { pg++; fetchPage(); } else { finish(); }
      }).catch(function() { finish(); });
  };
  var finish = function() {
    window._ordersChartHistoryBusy = false;
    window._ordersChartHistory = { data: collected, ts: Date.now() };
    cb(collected);
  };
  fetchPage();
};
// ===== 📊 7-Day Order Chart =====
window.__loadChartJs = function(cb) {
  if (window.Chart) { if (cb) cb(); return; }
  if (window.__chartJsLoading) {
    if (cb) window.__chartJsCallbacks = window.__chartJsCallbacks || [];
    if (cb) window.__chartJsCallbacks.push(cb);
    return;
  }
  window.__chartJsLoading = true;
  window.__chartJsCallbacks = [];
  var s = document.createElement('script');
  s.src = '/vendor/chart.umd.min.js?v=447';
  s.onload = function() {
    window.__chartJsLoading = false;
    var cbs = window.__chartJsCallbacks || [];
    window.__chartJsCallbacks = [];
    cbs.forEach(function(c) { try { c(); } catch (e) {} });
    if (cb) { try { cb(); } catch (e) {} }
  };
  s.onerror = function() { window.__chartJsLoading = false; window.__chartJsCallbacks = []; };
  document.head.appendChild(s);
};
window._initOrdersChart = function(orders) {
  var container = document.getElementById('orders-chart-container');
  if (!container) return;
  var showChart = window._ordersSettings && window._ordersSettings.showChart !== false;
  container.style.display = showChart ? '' : 'none';
  if (!showChart) return;
  window.__loadChartJs(function() {
    window._ensureOrdersChartHistory(orders, function(data) {
      window._renderOrdersChart(data);
    });
  });
};

// ===== 💾 Filter Presets =====
window._getFilterPresets = function() {
  try { return JSON.parse(localStorage.getItem('_filterPresets') || '{}'); } catch(e) { return {}; }
};
window._saveFilterPresets = function(presets) {
  localStorage.setItem('_filterPresets', JSON.stringify(presets));
};
window.saveFilterPreset = function() {
  var name = prompt('Enter a name for this filter preset:');
  if (!name || !name.trim()) return;
  name = name.trim();
  var presets = window._getFilterPresets();
  presets[name] = {
    cryptoFilter: window._ordersSettings.cryptoFilter || '',
    fiatFilter: window._ordersSettings.fiatFilter || '',
    dateStart: window._ordersSettings.dateStart || '',
    dateEnd: window._ordersSettings.dateEnd || '',
    status: document.getElementById('order-status-filter')?.value || 'all'
  };
  window._saveFilterPresets(presets);
  _refreshFilterPresetsUI();
  showToast('Filter preset saved: ' + name, 'success');
};
window.loadFilterPreset = function() {
  var name = document.getElementById('orders-preset-select')?.value;
  if (!name) return;
  var presets = window._getFilterPresets();
  var p = presets[name];
  if (!p) return;
  if (p.cryptoFilter && document.getElementById('orders-crypto-filter')) document.getElementById('orders-crypto-filter').value = p.cryptoFilter;
  if (p.fiatFilter && document.getElementById('orders-fiat-filter')) document.getElementById('orders-fiat-filter').value = p.fiatFilter;
  if (p.dateStart && document.getElementById('orders-date-start')) document.getElementById('orders-date-start').value = p.dateStart;
  if (p.dateEnd && document.getElementById('orders-date-end')) document.getElementById('orders-date-end').value = p.dateEnd;
  if (p.status && document.getElementById('order-status-filter')) document.getElementById('order-status-filter').value = p.status;
  window._ordersSettings.cryptoFilter = p.cryptoFilter || '';
  window._ordersSettings.fiatFilter = p.fiatFilter || '';
  window._ordersSettings.dateStart = p.dateStart || '';
  window._ordersSettings.dateEnd = p.dateEnd || '';
  localStorage.setItem('ordersSettings', JSON.stringify(window._ordersSettings));
  showToast('Loaded preset: ' + name, 'info');
  applyOrdersAdvancedFilter();
};
window.deleteFilterPreset = function() {
  var name = document.getElementById('orders-preset-select')?.value;
  if (!name) return;
  if (!confirm('Delete preset "' + name + '"?')) return;
  var presets = window._getFilterPresets();
  delete presets[name];
  window._saveFilterPresets(presets);
  _refreshFilterPresetsUI();
  showToast('Preset deleted: ' + name, 'info');
};
function _refreshFilterPresetsUI() {
  var sel = document.getElementById('orders-preset-select');
  var list = document.getElementById('orders-presets-list');
  if (!sel) return;
  var presets = window._getFilterPresets();
  var names = Object.keys(presets);
  sel.innerHTML = '<option value="">— Load Preset —</option>' + names.map(function(n) { return '<option value="' + esc(n) + '">' + esc(n) + '</option>'; }).join('');
  if (list) {
    if (names.length === 0) { list.innerHTML = '<span style="color:var(--text-quaternary);">No saved presets</span>'; }
    else { list.innerHTML = names.map(function(n) { return '<span style="display:inline-block;padding:2px 8px;margin:2px;background:var(--bg-secondary);border-radius:4px;font-size:11px;">' + esc(n) + '</span>'; }).join(' '); }
  }
}

// ===== 📥 Smart Export with Column Picker =====
window._exportColumns = ['Order ID', 'Side', 'Crypto', 'Amount', 'Fiat', 'Price', 'Rate', 'Status', 'Payment', 'Created', 'Counterparty', 'Completion Type', 'Release Time'];
window.exportOrdersWithPicker = function(format) {
  var allOrders = window._ordersAllPages || [];
  if (!allOrders.length) { showToast('No orders to export', 'error'); return; }
  var html = '<div class="modal-overlay"><div class="modal-content" style="max-width:500px;"><h3>📥 Export ' + format.toUpperCase() + '</h3>';
  html += '<p style="color:var(--text-tertiary);font-size:12px;margin-bottom:12px;">Select columns to include:</p>';
  html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;max-height:300px;overflow-y:auto;">';
  window._exportColumns.forEach(function(col) {
    var checked = col !== 'Rate' && col !== 'Completion Type' && col !== 'Release Time' ? 'checked' : '';
    html += '<label style="display:flex;align-items:center;gap:6px;padding:4px 8px;background:var(--bg-primary);border-radius:4px;font-size:12px;cursor:pointer;"><input type="checkbox" class="export-col-cb" value="' + esc(col) + '" ' + checked + '> ' + col + '</label>';
  });
  html += '</div>';
  html += '<div class="form-actions" style="margin-top:16px;">';
  html += '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Cancel</button>';
  html += '<button type="button" class="btn btn-primary" onclick="doExportWithColumns(\'' + format + '\')">Export ' + format.toUpperCase() + '</button></div></div></div>';
  var temp = document.createElement('div');
  temp.innerHTML = html;
  document.body.appendChild(temp.firstElementChild);
};
window.doExportWithColumns = function(format) {
  var selected = Array.from(document.querySelectorAll('.export-col-cb:checked')).map(function(cb) { return cb.value; });
  if (selected.length === 0) { showToast('Select at least one column', 'error'); return; }
  var allOrders = window._ordersAllPages || [];
  var rows = allOrders.map(function(o) {
    var cp = getCounterpartyInfo(o) || {};
    var map = {
      'Order ID': o.orderId || '',
      'Side': o.side || '',
      'Crypto': o.cryptoCurrency || '',
      'Amount': o.cryptoAmount || '',
      'Fiat': formatFiat(o.fiatAmount, o.fiatCurrency),
      'Price': o.unitPrice || '',
      'Rate': o.exchangeRate || '',
      'Status': o.paymentStatus || orderState(o) || '',
      'Payment': renderPaymentInfo(o).replace(/<[^>]*>/g, ''),
      'Created': o.createdTimestamp ? new Date(parseInt(o.createdTimestamp)).toLocaleString() : '',
      'Counterparty': cp.name || '',
      'Completion Type': o.completionType || '',
      'Release Time': formatTime(_orderReleaseSec(o))
    };
    return selected.map(function(col) { return '"' + String(map[col] || '').replace(/"/g, '""') + '"'; }).join(',');
  });
  if (format === 'csv') {
    var csv = selected.join(',') + '\n' + rows.join('\n');
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'orders_' + new Date().toISOString().slice(0,10) + '.csv';
    link.click();
    URL.revokeObjectURL(link.href);
  } else if (format === 'json') {
    var jsonData = allOrders.map(function(o) {
      var cp = getCounterpartyInfo(o) || {};
      var out = {};
      selected.forEach(function(col) {
        var map = {
          'Order ID': o.orderId || '',
          'Side': o.side || '',
          'Crypto': o.cryptoCurrency || '',
          'Amount': o.cryptoAmount || '',
          'Fiat': formatFiat(o.fiatAmount, o.fiatCurrency),
          'Price': o.unitPrice || '',
          'Rate': o.exchangeRate || '',
          'Status': o.paymentStatus || orderState(o) || '',
          'Payment': renderPaymentInfo(o).replace(/<[^>]*>/g, ''),
          'Created': o.createdTimestamp ? new Date(parseInt(o.createdTimestamp)).toISOString() : '',
          'Counterparty': cp.name || '',
          'Completion Type': o.completionType || '',
          'Release Time': formatTime(_orderReleaseSec(o))
        };
        out[col] = map[col] || '';
      });
      return out;
    });
    var blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'orders_' + new Date().toISOString().slice(0,10) + '.json';
    link.click();
    URL.revokeObjectURL(link.href);
  }
  document.querySelector('.modal-overlay')?.remove();
  showToast('Exported ' + rows.length + ' orders as ' + format.toUpperCase(), 'success');
};

// ===== 🔄 Bulk Cancel with Filter =====
window.bulkCancelFilteredOrders = function() {
  var container = document.getElementById('page-content');
  if (!container) return;
  var pendingRows = container.querySelectorAll('[data-section="buy-unpaid"] tbody tr, [data-section="buy-paid"] tbody tr, [data-section="sell-unpaid"] tbody tr, [data-section="sell-paid"] tbody tr');
  var visibleRows = Array.from(pendingRows).filter(function(r) { return r.style.display !== 'none'; });
  var orderIds = visibleRows.map(function(r) {
    var span = r.querySelector('td span[data-on-click^="copyText"]');
    if (span) {
      var match = span.getAttribute('data-on-click').match(/copyText\('([^']+)'/);
      return match ? match[1] : null;
    }
    return null;
  }).filter(Boolean);
  if (orderIds.length === 0) { showToast('No pending orders visible to cancel', 'error'); return; }
  if (!confirm('Cancel ' + orderIds.length + ' visible pending orders?')) return;
  var btn = document.getElementById('bulk-cancel-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Cancelling...'; }
  var cancelled = 0, failed = 0;
  orderIds.forEach(function(id) {
    API.post('/api/okx/p2p/orders/' + id + '/cancel').then(function() { cancelled++; }).catch(function() { failed++; }).finally(function() {
      if (cancelled + failed === orderIds.length) {
        if (btn) { btn.disabled = false; btn.textContent = '🗑️ Bulk Cancel'; }
        showToast('Cancelled: ' + cancelled + ', Failed: ' + failed, failed > 0 ? 'error' : 'success');
        triggerPageRefresh();
      }
    });
  });
};

// ===== 🧹 Auto-dismiss logic (call from renderOrders) =====
window._filterOldOrders = function(orders) {
  var days = parseInt(window._ordersSettings.autoDismiss || '0');
  if (days <= 0) return orders;
  var cutoff = Date.now() - days * 86400000;
  return orders.filter(function(o) {
    var ts = parseInt(o.completionTimestamp || o.createdTimestamp || '0');
    return ts === 0 || ts >= cutoff;
  });
};

// ===== 📊 Stats from API (no pagination needed) =====
window.fetchOrderStats = function() {
  var container = document.getElementById('page-content');
  if (!container || currentPage !== 'orders') return;
  // Stats change slowly — don't fire an HTTP call on every render (SSE pushes,
  // polls, focus events); refresh at most once per 60s.
  if (Date.now() - (window._lastFetchOrderStats || 0) < 60000) return;
  window._lastFetchOrderStats = Date.now();
  // Fast: total trades from user/statistics
  API.get('/api/okx/p2p/user/statistics').then(function(res) {
    if (res && res.data) {
      var s = Array.isArray(res.data) ? res.data[0] : res.data;
      if (s) {
        var stat = function(name) { return container.querySelector('[data-stat="' + name + '"]'); };
        var el = stat('total-trades');
        var v = parseInt(s.completedOrders) || 0;
        if (el && el.textContent !== v.toLocaleString()) el.textContent = v.toLocaleString();
        window._apiCompletedCount = v;
      }
    }
    window._apiTotalLoaded = true;
  }).catch(function() { window._apiTotalLoaded = true; });
  // Slow/split: 30-day count from stats/30day (independent)
  API.get('/api/okx/p2p/stats/30day').then(function(res) {
    if (res && res.data) {
      var v = parseInt(res.data.completedOrders30Day) || 0;
      var stat = function(name) { return container.querySelector('[data-stat="' + name + '"]'); };
      var el = stat('completed-30d');
      if (el && el.textContent !== v.toLocaleString()) el.textContent = v.toLocaleString();
    }
    window._api30dLoaded = true;
  }).catch(function() { window._api30dLoaded = true; });
};

// ===== Manual auto-release: seller "Got Payment" then poll until released =====
// Flow: seller receives the bank/M-Pesa payment -> taps "Got Payment" -> the order
// is armed for 24h -> a 30s sweep (plus SSE) releases the crypto the moment OKX
// reports the buyer marked it paid. Nothing here re-renders the orders list, so the
// arm/disarm state is painted into the existing DOM node only.

// ===== Order cache merge =====
// A paged fetch must never shrink the visible set. Known orders are refreshed in
// place (keeping their position so the list does not reshuffle) and unknown ones
// are appended. SSE snapshots stay authoritative and still replace wholesale.
var _MAR_CACHE_SOFT_CAP = 500;
window._mergeOrdersIntoCache = function(incoming) {
  var cur = (window._sseOrdersCache && Array.isArray(window._sseOrdersCache.orders)) ? window._sseOrdersCache.orders : [];
  var byId = {};
  var out = [];
  for (var i = 0; i < cur.length; i++) {
    var c = cur[i];
    if (c && c.orderId && !byId[c.orderId]) { byId[c.orderId] = c; out.push(c); }
  }
  var add = (incoming && Array.isArray(incoming)) ? incoming : [];
  for (var j = 0; j < add.length; j++) {
    var n = add[j];
    if (!n || !n.orderId) continue;
    var existing = byId[n.orderId];
    if (existing) {
      var idx = out.indexOf(existing);
      if (idx > -1) out[idx] = n; else out.push(n);
      // Re-point the index at the replacement, otherwise a repeated orderId in
      // the same payload no longer matches and gets appended as a duplicate row.
      byId[n.orderId] = n;
    } else {
      byId[n.orderId] = n;
      out.push(n);
    }
  }
  // Bound memory only. Keep the TAIL, not the head: known orders keep their
  // position and newly-seen orders are appended, so slice(0, N) would drop
  // every arriving order the moment the cache crossed the cap — the exact
  // "orders disappear" symptom this merge exists to prevent.
  if (out.length > _MAR_CACHE_SOFT_CAP) out = out.slice(-_MAR_CACHE_SOFT_CAP);
  window._sseOrdersCache = { orders: out };
  return out;
};

// ===== Filter/UI state across full rebuilds =====
// The shell is normally built once, but a page navigation or "Fresh Fetch" still
// rebuilds it. Without this the crypto/fiat/date filters silently reset, which
// looks to the user like orders going missing.
function _saveOrdersFilterUI() {
  var g = function(id) { var el = document.getElementById(id); return el ? el.value : null; };
  return {
    search: g('order-search'),
    status: g('order-status-filter'),
    crypto: g('orders-crypto-filter'),
    fiat: g('orders-fiat-filter'),
    dateStart: g('orders-date-start'),
    dateEnd: g('orders-date-end'),
    groupCp: (function() { var el = document.getElementById('orders-group-cp-toggle'); return el ? el.checked : null; })(),
    tab: window._ordersTab
  };
}
function _restoreOrdersFilterUI(s) {
  if (!s) return;
  var set = function(id, v) { if (v === null || v === undefined) return; var el = document.getElementById(id); if (el) el.value = v; };
  set('order-search', s.search);
  set('order-status-filter', s.status);
  set('orders-crypto-filter', s.crypto);
  set('orders-fiat-filter', s.fiat);
  set('orders-date-start', s.dateStart);
  set('orders-date-end', s.dateEnd);
  if (s.groupCp !== null && s.groupCp !== undefined) {
    var g = document.getElementById('orders-group-cp-toggle');
    if (g) g.checked = !!s.groupCp;
  }
  if (s.tab) window._ordersTab = s.tab;
}

// Re-apply the active tab after the body is replaced. switchOrdersTab() toggles
// display on nodes that live in the body, so without this an in-place body patch
// would snap the user back to the Orders tab mid-session.
function _applyOrdersTabVisibility() {
  var tab = window._ordersTab === 'advanced' ? 'advanced' : 'orders';
  var oc = document.getElementById('orders-tab-content');
  var ac = document.getElementById('orders-advanced-content');
  var fb = document.getElementById('orders-filter-bar');
  if (oc) oc.style.display = tab === 'orders' ? '' : 'none';
  if (ac) ac.style.display = tab === 'advanced' ? '' : 'none';
  if (fb) fb.style.display = tab === 'orders' ? '' : 'none';
}

var _MAR_KEY = 'okx_manual_autorelease_v1';
var _MAR_TTL_MS = 24 * 60 * 60 * 1000;
var _MAR_SWEEP_MS = 30000;
var _MAR_BUSY = {};

function _marRead() {
  try {
    var raw = localStorage.getItem(_MAR_KEY);
    var m = raw ? JSON.parse(raw) : null;
    return (m && typeof m === 'object') ? m : {};
  } catch (e) { return {}; }
}
var _MAR_SYNC_INFLIGHT = false;
var _MAR_SYNC_PENDING = false;
function _marServerSync() {
  if (_MAR_SYNC_INFLIGHT) { _MAR_SYNC_PENDING = true; return; }
  _MAR_SYNC_INFLIGHT = true;
  var m = _marRead();
  var now = Date.now();
  for (var k in m) { if (!m[k] || !m[k].t || (now - m[k].t) > _MAR_TTL_MS) delete m[k]; }
  var api = window.API || {};
  if (!api.post) { _MAR_SYNC_INFLIGHT = false; return; }
  api.post('/api/okx/p2p/manual-auto-release', { map: m })
    .catch(function () {})
    .then(function () { _MAR_SYNC_INFLIGHT = false; if (_MAR_SYNC_PENDING) { _MAR_SYNC_PENDING = false; _marServerSync(); } });
}
function _marWrite(m) {
  try { localStorage.setItem(_MAR_KEY, JSON.stringify(m)); } catch (e) {}
  try { _marServerSync(); } catch (e) {}
}
// Restore arms that were armed in a previous session or on another device.
function _marLoadFromServer() {
  var api = window.API || {};
  if (!api.get) return;
  api.get('/api/okx/p2p/manual-auto-release')
    .then(function (r) {
      var remote = (r && r.data) || {};
      var local = _marRead();
      var now = Date.now();
      var merged = {};
      var k, e;
      for (k in remote) { e = remote[k]; if (e && e.t && (now - e.t) <= _MAR_TTL_MS) merged[k] = { t: e.t }; }
      for (k in local) {
        e = local[k];
        if (!e || !e.t || (now - e.t) > _MAR_TTL_MS) continue;
        if (!merged[k] || Number(merged[k].t) < Number(e.t)) merged[k] = { t: e.t };
      }
      var before = JSON.stringify(_marRead());
      if (JSON.stringify(merged) !== before) _marWrite(merged);
    })
    .catch(function () {});
}
function _marDrop(oid) {
  var m = _marRead();
  if (m[oid]) { delete m[oid]; _marWrite(m); return true; }
  return false;
}
window.getManualAutoReleaseState = function(orderId) {
  var oid = String(orderId || '');
  if (!oid) return null;
  var e = _marRead()[oid];
  if (!e || !e.t) return null;
  var t = Number(e.t);
  if (!t || (Date.now() - t) > _MAR_TTL_MS) return null;
  return { armedAt: t, expiresAt: t + _MAR_TTL_MS };
};
function _marArmed(oid) { return !!window.getManualAutoReleaseState(oid); }

function _marBtnStyle(color, bg, border) {
  return 'font-size:10px;padding:5px 8px;font-weight:600;color:' + color + ';background:' + bg + ';border:1px solid ' + border + ';border-radius:4px;cursor:pointer;white-space:nowrap;';
}

// NOTE: kept deliberately on ONE line. Multi-line HTML strings inside JS string
// literals are what broke esbuild previously, so no literal newlines here.
function _marButtonInner(oid, armed) {
  var e = esc(oid);
  if (armed) {
    return '<span style="display:inline-flex;align-items:center;gap:4px;">'
      + '<span title="Armed - will auto-release when the buyer marks paid" style="' + _marBtnStyle('var(--accent-amber)', 'rgba(255,179,0,0.12)', 'rgba(255,179,0,0.35)') + '">&#9203; Armed</span>'
      + '<button class="btn btn-sm btn-outline" data-on-click="disarmManualAutoRelease(\'' + e + '\')" style="font-size:10px;padding:5px 8px;color:var(--accent-red);border-color:rgba(244,67,54,0.27);">Cancel</button>'
      + '</span>';
  }
  return '<button class="btn btn-sm btn-success" data-on-click="confirmPaymentReceived(\'' + e + '\')" style="' + _marBtnStyle('var(--accent-green)', 'rgba(0,210,104,0.14)', 'rgba(0,210,104,0.35)') + '" title="I have received the payment - auto-release as soon as the buyer marks it paid">&#9989; Got Payment</button>';
}

// Wrapper span carries the state so it can be repainted in place (no re-render).
window._gotPaymentButtonHtml = function(orderId, armed) {
  var oid = String(orderId || '');
  if (!oid) return '';
  return '<span data-mar-host="' + esc(oid) + '" data-mar-armed="' + (armed ? '1' : '0') + '" style="display:inline-flex;align-items:center;">' + _marButtonInner(oid, !!armed) + '</span>';
};

function _marPaintAll() {
  if (typeof document === 'undefined' || !document.querySelectorAll) return;
  var hosts = document.querySelectorAll('[data-mar-host]');
  for (var i = 0; i < hosts.length; i++) {
    var h = hosts[i];
    var oid = h.getAttribute('data-mar-host');
    if (!oid) continue;
    var want = _marArmed(oid);
    var cur = h.getAttribute('data-mar-armed') === '1';
    if (want !== cur) {
      h.innerHTML = _marButtonInner(oid, want);
      h.setAttribute('data-mar-armed', want ? '1' : '0');
    }
  }
}

function _marTerminal(o) {
  var s = String((o && (o.state || o.orderStatus || o.completionStatus)) || '').toLowerCase();
  return s === 'completed' || s === 'canceled' || s === 'cancelled' || s === 'completed.' ;
}

async function _marTryRelease(orderId) {
  var oid = String(orderId || '');
  if (!_marArmed(oid)) return false;
  if (_MAR_BUSY[oid]) return false;
  // Fetch FRESH order data from API (like server-side) instead of relying on SSE cache.
  // This avoids delays from stale SSE cache or slow pushes.
  var o = null;
  try {
    var rr = await API.get('/api/okx/p2p/orders/' + oid);
    o = rr && rr.data ? (Array.isArray(rr.data) ? rr.data[0] : rr.data) : null;
  } catch (e) {
    // Fallback to cached if API fails
    o = window._ordersMap && window._ordersMap[oid];
  }
  if (!o) return false;                                    // order not in view yet; next sweep retries
  if (String(o.side || '') !== 'sell') { _marDrop(oid); return false; }
  if (window.isAppealedOrder && window.isAppealedOrder(o)) {
    _marDrop(oid);
    showToast('Auto-release disarmed - order is under appeal', 'error', 5000);
    return false;
  }
  if (_marTerminal(o)) { _marDrop(oid); return false; }
  var isPaid = (typeof window.orderIsPaid === 'function') ? window.orderIsPaid(o)
                                                            : String(o.paymentStatus || '').toLowerCase() === 'paid';
  if (!isPaid) return false;                               // buyer has not marked paid yet
  _MAR_BUSY[oid] = true;
  try {
    var payload = {};
    if (o.fiatAmount) payload.amount = String(o.fiatAmount);
    await API.post('/api/okx/p2p/orders/' + oid + '/release', payload);
    _marDrop(oid);
    showToast('Auto-released ' + oid.slice(0, 12) + ' - crypto sent to buyer', 'success', 7000);
    try { if (typeof playNotification === 'function') playNotification(); } catch (e) {}
    if (typeof _refreshOrdersFromCache === 'function') _refreshOrdersFromCache();
    API.post('/api/bank/auto-sync', { orders: [{ orderId: oid, side: 'sell', fiatAmount: String(o.fiatAmount || '0'), paymentStatus: 'paid', state: 'completed' }] }).catch(function() {});
    if (typeof _autoSendThankYou === 'function') _autoSendThankYou(oid);
    return true;
  } catch (err) {
    // Stay armed: OKX often rejects a release for a few seconds after the buyer
    // marks paid, so the next 30s sweep retries instead of failing permanently.
    var msg = (err && err.message) ? err.message : 'release rejected';
    showToast('Auto-release pending - will retry: ' + msg, 'info', 5000);
    return false;
  } finally {
    _MAR_BUSY[oid] = false;
  }
}

function _marSweep() {
  var map = window._ordersMap;
  if (map) {
    var ids = Object.keys(map);
    for (var i = 0; i < ids.length; i++) {
      if (_marArmed(ids[i])) _marTryRelease(ids[i]);
    }
  }
  var raw = _marRead(), changed = false, now = Date.now();
  for (var k in raw) {
    if (!raw[k] || !raw[k].t || (now - Number(raw[k].t)) > _MAR_TTL_MS) { delete raw[k]; changed = true; }
  }
  if (changed) _marWrite(raw);
  _marPaintAll();
}

var _MAR_SWEEP_TIMER = null;
function _marSweepSoon(delay) {
  if (_MAR_SWEEP_TIMER) clearTimeout(_MAR_SWEEP_TIMER);
  _MAR_SWEEP_TIMER = setTimeout(function() { _MAR_SWEEP_TIMER = null; _marSweep(); }, delay || 1500);
}

window.confirmPaymentReceived = async function(orderId) {
  var oid = String(orderId || '');
  var o = window._ordersMap && window._ordersMap[oid];
  if (!o) { showToast('Order not in the current list - refresh Orders first', 'error'); return; }
  if (String(o.side || '') !== 'sell') { showToast('Auto-release arming only applies to sell orders', 'error'); return; }
  if (window.isAppealedOrder && window.isAppealedOrder(o)) { showToast('Order is under appeal - cannot arm', 'error', 5000); return; }
  if (_marTerminal(o)) { showToast('Order is already closed', 'error'); return; }
  var m = _marRead();
  m[oid] = { t: Date.now(), side: 'sell', amt: String(o.fiatAmount || '') };
  _marWrite(m);
  _marPaintAll();
  showToast('Payment received - auto-release armed for 24h', 'success');
  // Buyer may already have marked paid -> release right away.
  _marTryRelease(oid);
  _marSweepSoon(1200);
};

window.disarmManualAutoRelease = function(orderId) {
  var oid = String(orderId || '');
  if (_marDrop(oid)) showToast('Auto-release disarmed', 'info');
  _marPaintAll();
};

// Instant reaction to a buyer marking the order paid, without duplicating the
// existing renderer (a previous version re-wrapped renderOrders and recursed).
(function() {
  if (window.__marSseHooked) return;
  window.__marSseHooked = true;
  var prev = window.handleSSEOrderUpdate;
  if (typeof prev !== 'function') return;
  window.handleSSEOrderUpdate = function(data) {
    var out;
    try { out = prev.apply(this, arguments); }
    finally { try { _marSweepSoon(1500); } catch (e) {} }
    return out;
  };
})();

// Sweep every 30s so release happens even with no SSE traffic, and on tab focus.
if (!_MAR_SWEEP_TIMER) _MAR_SWEEP_TIMER = setInterval(_marSweep, _MAR_SWEEP_MS);
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) _marSweepSoon(400);
});
window.addEventListener('focus', function() { _marSweepSoon(400); });

// Pull arms saved in earlier sessions / other devices back into this browser.
try { _marLoadFromServer(); } catch (e) {}



/* ==== js/modules/okx/ordersStream.js ==== */
// Instant Orders Stream UI Handler
// Connects to /api/orders/stream, renders orders instantly with zero debounce.

const OrdersStream = (function() {
  let _es = null;
  let _cache = new Map(); // orderId -> order
  let _renderQueued = false;
  let _lastHash = '';
  let _reconnectTimer = null;
  let _connecting = false;
  let _ticket = null;
let _visible = false;
let _orderCount = 0;

// Disable on-screen rendering, only show FCM toasts
let _disableScreenRender = false; // Set to false to enable on-screen rendering

// Separate cache for completed orders
let _completedCache = new Map();

  const MAX_ORDERS = 500; // RAM cap for UI cache
  const POLL_INTERVAL_MS = 1500; // 1.5s client-side polling when tab is visible

  function _hashOrders(orders) {
    const arr = Array.from(orders.values()).sort((a,b) => a.orderId.localeCompare(b.orderId));
    let h = '';
    for (const o of arr) {
      h += o.orderId + ':' + (o.paymentStatus||'') + ':' + (o.completionStatus||'') + ':' + (o.orderStatus||'') + '|';
    }
    return h;
  }

  function _isCompleted(o) {
    const cs = String(o.completionStatus || o.state || '').toLowerCase();
    const os = String(o.orderStatus || o.status || '').toLowerCase();
    return cs === 'completed' || os === 'completed' || cs === 'released' || os === 'released';
  }

  function _mergeOrders(newOrders) {
    let changed = false;
    for (const o of newOrders) {
      if (!o || !o.orderId) continue;
      const isCompleted = _isCompleted(o);
      const existing = isCompleted ? _completedCache.get(o.orderId) : _cache.get(o.orderId);
      const targetCache = isCompleted ? _completedCache : _cache;
      const newSig = JSON.stringify(o);
      const oldSig = existing ? JSON.stringify(existing) : null;
      if (oldSig !== newSig) {
        targetCache.set(o.orderId, o);
        changed = true;
        // If order just became completed, remove from active cache
        if (isCompleted) {
          _cache.delete(o.orderId);
        }
      }
    }
    // Cap cache size (keep newest)
    if (_cache.size > 500) {
      const entries = Array.from(_cache.entries())
        .sort((a,b) => (parseInt(b[1].createdTimestamp)||0) - (parseInt(a[1].createdTimestamp)||0))
        .slice(0, 500);
      _cache = new Map(entries);
    }
    if (_completedCache.size > 200) {
      const entries = Array.from(_completedCache.entries())
        .sort((a,b) => (parseInt(b[1].createdTimestamp)||0) - (parseInt(a[1].createdTimestamp)||0))
        .slice(0, 200);
      _completedCache = new Map(entries);
    }
    return changed;
  }

  function _scheduleRender() {
    if (_renderQueued) return;
    _renderQueued = true;
    queueMicrotask(() => {
      _renderQueued = false;
      if (_visible) _render();
    });
  }

  // NOTE: On-screen rendering is owned by the main orders pipeline
  // (ui.js -> window.handleSSEOrderUpdate -> orders.js doRender/renderOrders),
  // which paints the rich order cards into #page-content. This stream shares the
  // same SSE broadcast as that pipeline, so rendering here duplicated the work.
  // Worse, the fallback below rewrote #orders-tab-content with a bare list, as
  // renderOrders is not exposed on window — wiping the real cards (no release
  // button, active-orders-only) on every tick. So this module now only keeps its
  // own cache in sync and lets the main pipeline render.
  function _render() {
    if (!_visible) return;
    const orders = Array.from(_cache.values())
      .sort((a,b) => (parseInt(b.createdTimestamp)||0) - (parseInt(a.createdTimestamp)||0));
    _orderCount = orders.length;
    const badge = document.getElementById('orders-count');
    if (badge) badge.textContent = orders.length;
  }

  function _getTicket() {
    return new Promise((resolve, reject) => {
      if (_ticket) return resolve(_ticket);
      fetch('/api/sse/ticket', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') }
      }).then(r => {
        // This call bypasses the API.request wrapper, so it must store the
        // sliding-expiration token itself. Without it a page whose only traffic
        // is this stream never renewed and hit the hard token expiry while open.
        const nt = r.headers.get('X-New-Token');
        if (nt) { if (typeof API !== 'undefined' && API.setToken) API.setToken(nt); else localStorage.setItem('token', nt); }
        return r.json();
      }).then(d => {
        if (d.code === 0 && d.data?.ticket) {
          _ticket = d.data.ticket;
          resolve(_ticket);
        } else {
          reject(new Error(d.msg || 'No ticket'));
        }
      }).catch(reject);
    });
  }

  function _connect() {
    if (_connecting) return;
    _connecting = true;
    
    _getTicket().then(ticket => {
      const url = `/api/orders/stream?ticket=${ticket}`;
      const es = new EventSource(url);
      _es = es;

      es.addEventListener('connected', () => {
        console.log('[OrdersStream] Connected');
      });

      es.addEventListener('orders-stream', (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.orders && _mergeOrders(data.orders)) {
            _scheduleRender();
          }
        } catch (e) {
          console.warn('[OrdersStream] Parse error:', e);
        }
      });

      es.addEventListener('orders', (e) => {
        // Handle legacy orders event from old system
        try {
          const data = JSON.parse(e.data);
          if (data.orders && _mergeOrders(data.orders)) {
            _scheduleRender();
          }
        } catch (e) {}
      });

      es.addEventListener('ping', () => {
        // Heartbeat - connection alive
      });

      es.onerror = (err) => {
        console.warn('[OrdersStream] Connection error, reconnecting...');
        _reconnect();
      };

      _connecting = false;
    }).catch(err => {
      console.error('[OrdersStream] Ticket failed:', err);
      _connecting = false;
      _reconnect();
    });
  }

  // Client-side polling fallback - runs when tab is visible
  let _pollTimer = null;
  let _lastPollHash = '';

  function _startPolling() {
    if (_pollTimer) return;
    console.log('[OrdersStream] Starting client-side polling');
    _poll();
  }

  function _stopPolling() {
    if (_pollTimer) {
      clearInterval(_pollTimer);
      _pollTimer = null;
    }
  }

  async function _poll() {
    if (!_visible) {
      _stopPolling();
      return;
    }
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      const res = await fetch('/api/okx/p2p/order-list?completionStatus=pending&pageSize=50', {
        headers: { 'Authorization': 'Bearer ' + token }
      });
      if (!res.ok) return;
      const data = await res.json();
      if (data.orders && data.orders.length > 0) {
        // Hash to detect changes
        const hash = _hashOrders(new Map(data.orders.map(o => [o.orderId, o])));
        if (hash !== _lastPollHash) {
          _lastPollHash = hash;
          if (_mergeOrders(data.orders)) {
            _scheduleRender();
            console.log('[OrdersStream] Poll detected changes, rendered');
          }
        }
      }
    } catch (e) {
      console.warn('[OrdersStream] Poll error:', e.message);
    }
    // Schedule next poll
    if (_visible) {
      _pollTimer = setTimeout(_poll, POLL_INTERVAL_MS);
    }
  }

  function _reconnect() {
    if (_reconnectTimer) clearTimeout(_reconnectTimer);
    _reconnectTimer = setTimeout(() => {
      if (_es) { _es.close(); _es = null; }
      _connect();
    }, 3000);
  }

  function _stop() {
    if (_reconnectTimer) clearTimeout(_reconnectTimer);
    if (_es) { _es.close(); _es = null; }
    _stopPolling();
    _connecting = false;
    _cache.clear();
  }

  function _setVisible(v) {
    _visible = v;
    if (v) {
      // Paint immediately from cache when tab becomes visible
      if (_cache.size > 0) _render();
      // Start client-side polling for instant updates
      _startPolling();
      // Also trigger immediate poll
      _poll();
    } else {
      _stopPolling();
    }
  }

  function _getOrderCount() {
    return _orderCount;
  }

  function _getCache() {
    return new Map(_cache);
  }

  // Public API
  return {
    start() {
      if (_visible) return; // Already running
      _connect();
    },
    stop() {
      _stop();
    },
    setVisible: _setVisible,
    getOrderCount: _getOrderCount,
    getCache: _getCache,
  };
})();

// Auto-start when orders tab is shown
document.addEventListener('DOMContentLoaded', () => {
  // Hook into orders tab switch
  const origSwitch = window.switchOrdersTab;
  window.switchOrdersTab = function(tab) {
    if (typeof origSwitch === 'function') origSwitch(tab);
    if (tab === 'orders') {
      OrdersStream.start();
      OrdersStream.setVisible(true);
    } else {
      OrdersStream.setVisible(false);
    }
  };

  // If already on orders tab
  if (document.querySelector('.orders-tab-active')?.dataset?.ordersTab === 'orders') {
    OrdersStream.start();
    OrdersStream.setVisible(true);
  }
});

// Expose for debugging
window.OrdersStream = OrdersStream;
/* ==== js/modules/okx/ranking.js ==== */
var _mpFilters = { side: 'all', maxPrice: '', paymentMethod: '', sortBy: 'price' };
var _mpData = null;

async function renderRanking(content) {
  if (!content) return;
  if (!currentUser) { renderLogin(content); return; }
  var lu = new Date().toLocaleTimeString();
  var html = '<div class="page-header"><div><h2>P2P Ranking</h2><div class="subtitle">USDT/KES marketplace · <span id="page-last-updated">Updated ' + lu + '</span> <span id="page-countdown"></span></div></div></div>';
  try {
    if (!_mpData) {
      var res = await API.get('/api/okx/p2p/marketplace-ranking');
      _mpData = res.data;
    }
    var d = _mpData;
    var allBuy = d.buyAds || [];
    var allSell = d.sellAds || [];

    var filteredBuy = applyFilters(allBuy, 'buy');
    var filteredSell = applyFilters(allSell, 'sell');

    var allPaymentMethods = [...new Set([...allBuy, ...allSell].flatMap(function(a) { return a.paymentMethods || []; }))];

    html += '<div class="card" style="margin-bottom:16px;padding:16px 20px;background:linear-gradient(135deg,#0c1220,#0e0e18);border-color:rgba(68,138,255,0.15);"><div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;"><span style="font-size:13px;color:#8888a0;font-weight:600;letter-spacing:0.5px;text-transform:uppercase;">Filters</span><div class="filter-group" style="display:flex;align-items:center;gap:4px;padding:3px;background:var(--bg-primary);border-radius:10px;border:1px solid var(--border-primary);">';
    html += '<button class="btn btn-sm ' + (!_mpFilters.side || _mpFilters.side === 'all' ? 'btn-primary' : 'btn-secondary') + '" style="border-radius:8px;padding:5px 14px;font-size:12px;' + (!_mpFilters.side || _mpFilters.side === 'all' ? '' : 'background:transparent;color:var(--text-quaternary);border:none;') + '" data-on-click="setRankingFilter(\'side\',\'all\')">All</button>';
    html += '<button class="btn btn-sm ' + (_mpFilters.side === 'buy' ? 'btn-primary' : 'btn-secondary') + '" style="border-radius:8px;padding:5px 14px;font-size:12px;' + (_mpFilters.side === 'buy' ? 'background:linear-gradient(135deg,var(--accent-green),var(--accent-green-bright));color:var(--text-on-accent);' : 'background:transparent;color:var(--text-quaternary);border:none;') + '" data-on-click="setRankingFilter(\'side\',\'buy\')">Buy</button>';
    html += '<button class="btn btn-sm ' + (_mpFilters.side === 'sell' ? 'btn-primary' : 'btn-secondary') + '" style="border-radius:8px;padding:5px 14px;font-size:12px;' + (_mpFilters.side === 'sell' ? 'background:linear-gradient(135deg,#f44336,#ef5350);color:#fff;' : 'background:transparent;color:var(--text-quaternary);border:none;') + '" data-on-click="setRankingFilter(\'side\',\'sell\')">Sell</button>';
    html += '</div><div style="display:flex;align-items:center;gap:6px;"><span style="font-size:12px;color:var(--text-quaternary);">USDT</span><span style="font-size:14px;color:#33334a;">→</span><span style="font-size:12px;color:var(--text-quaternary);">KES</span></div>';
    html += '<div class="filter-input" style="position:relative;"><input type="number" id="mp-max-price" placeholder="0.00" value="' + (_mpFilters.maxPrice || '') + '" style="width:90px;padding:7px 10px 7px 20px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;" onkeydown="if(event.key===\'Enter\')applyRankingFilter()"><span style="position:absolute;left:8px;top:50%;transform:translateY(-50%);font-size:11px;color:var(--text-quaternary);">≤</span></div>';
    html += '<select id="mp-payment" onchange="setRankingFilter(\'paymentMethod\',this.value)" style="padding:7px 10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;max-width:150px;"><option value="">All payments</option>';
    allPaymentMethods.forEach(function(m) { html += '<option value="' + esc(m) + '" ' + (_mpFilters.paymentMethod === m ? 'selected' : '') + '>' + esc(m) + '</option>'; });
    html += '</select><select id="mp-sort" onchange="setRankingFilter(\'sortBy\',this.value)" style="padding:7px 10px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;"><option value="price" ' + ((_mpFilters.sortBy || 'price') === 'price' ? 'selected' : '') + '>Sort: Price</option><option value="available" ' + (_mpFilters.sortBy === 'available' ? 'selected' : '') + '>Sort: Available</option><option value="limit" ' + (_mpFilters.sortBy === 'limit' ? 'selected' : '') + '>Sort: Max Limit</option></select>';
    html += '<div style="display:flex;gap:6px;"><button class="btn btn-sm btn-primary" data-on-click="applyRankingFilter()" style="padding:7px 16px;font-size:12px;">Apply</button>';
    if (_mpFilters.maxPrice || _mpFilters.paymentMethod || _mpFilters.sortBy !== 'price' || _mpFilters.side !== 'all') {
      html += '<button class="btn btn-sm btn-outline" data-on-click="clearRankingFilter()" style="padding:7px 12px;font-size:11px;">Reset</button>';
    }
    html += '</div></div></div>';

    html += '<div class="marketplace-grid">';
    html += renderRankingTable(filteredBuy, '📈 Buy USDT', '#00c853', 'buy');
    html += renderRankingTable(filteredSell, '📉 Sell USDT', '#f44336', 'sell');
    html += '</div>';


    var myRanking = d.myRanking || [];
    if (myRanking.length > 0) {
      html += '<div class="card"><h3>🏆 My Ads — Real OKX Marketplace Ranking</h3><div class="ranking-grid' + (myRanking.length > 1 ? '' : '-single') + '">';
      myRanking.forEach(function(r) {
        var myPrice = parseFloat(r.unitPrice || '0');
        var best = parseFloat(r.bestPrice || '0');
        var pct = best && myPrice ? ((myPrice - best) / best * 100).toFixed(2) : '0';
        var gap = best && myPrice ? Math.abs(myPrice - best) : 0;
        var behind = r.side === 'sell' ? (myPrice - best) : (best - myPrice);
        var rank = r.priceRank;
        var total = r.totalMarketAds;
        html += '<div style="padding:16px;background:rgba(10,10,20,0.6);border-radius:12px;border:1px solid rgba(26,26,40,0.8);"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;"><span class="badge badge-' + r.side + '">' + (r.side || '').toUpperCase() + ' USDT</span><span style="font-size:20px;font-weight:800;color:#fff;">' + myPrice.toFixed(2) + '</span></div><div style="display:flex;align-items:center;gap:12px;margin-bottom:10px;padding:10px;background:rgba(0,0,0,0.3);border-radius:10px;"><div style="flex:1;"><div style="font-size:11px;color:var(--text-quaternary);">Distance from #1</div><div style="font-size:22px;font-weight:800;color:' + (behind > 0 ? '#ff9800' : '#00c853') + ';">' + gap.toFixed(2) + ' <span style="font-size:12px;color:var(--text-quaternary);">KES</span></div></div><div style="text-align:right;"><div style="font-size:11px;color:var(--text-quaternary);">vs best</div><div style="font-size:18px;font-weight:700;color:' + (parseFloat(pct) > 0 ? '#ff9800' : '#00c853') + ';">' + (parseFloat(pct) > 0 ? '+' : '') + pct + '%</div></div><div style="text-align:right;"><div style="font-size:11px;color:var(--text-quaternary);">Rank</div><div style="font-size:18px;font-weight:700;color:var(--text-secondary);">#' + rank + ' / ' + total + '</div></div></div><div style="height:6px;background:rgba(26,26,40,0.8);border-radius:3px;overflow:hidden;margin-bottom:4px;"><div style="width:' + (total > 0 ? ((rank / total) * 100).toFixed(1) : 0) + '%;height:100%;background:linear-gradient(90deg,#00c853,#ff9800);border-radius:3px;"></div></div><div style="font-size:11px;color:var(--text-quaternary);">Price range: ' + r.worstPrice + ' – ' + r.bestPrice + '</div></div>';
      });
      html += '</div></div>';
    }

    var opt = d.optimalPrice || {};
    if (opt.buyPrice || opt.sellPrice) {
      html += '<div class="card" style="margin-top:16px;"><h4 style="margin-bottom:8px;">Optimal Prices</h4><div style="display:flex;gap:16px;"><div style="padding:8px 16px;background:var(--bg-primary);border-radius:8px;"><span style="color:var(--text-tertiary);font-size:11px;">Best Buy</span><div style="font-size:18px;font-weight:700;color:var(--accent-green);">KES ' + (opt.buyPrice || '—') + '</div></div><div style="padding:8px 16px;background:var(--bg-primary);border-radius:8px;"><span style="color:var(--text-tertiary);font-size:11px;">Best Sell</span><div style="font-size:18px;font-weight:700;color:var(--accent-red);">KES ' + (opt.sellPrice || '—') + '</div></div></div></div>';
    }

    content.innerHTML = html;
    startPageCountdown(30);
    startPagePoll(content, function() { _mpData = null; renderRanking(content); }, 30000);
  } catch (err) {
    content.innerHTML = '<div class="card"><div class="empty-state" style="text-align:center;padding:40px;"><div style="font-size:48px;margin-bottom:12px;">⚠️</div><p style="color:var(--text-tertiary);">Failed to load marketplace data.</p><p style="color:var(--text-quaternary);font-size:12px;">' + esc(err.message) + '</p></div></div>';
    startPageCountdown(30);
    startPagePoll(content, function() { renderRanking(content); }, 30000);
  }
}

function applyFilters(list, side) {
  var f = _mpFilters;
  if (f.side !== 'all' && f.side !== side) return [];
  var filtered = list.filter(function(a) {
    if (f.maxPrice) {
      var price = parseFloat(a.unitPrice || '0');
      if (price > parseFloat(f.maxPrice)) return false;
    }
    if (f.paymentMethod && (!a.paymentMethods || a.paymentMethods.indexOf(f.paymentMethod) === -1)) return false;
    return true;
  });
  if (f.sortBy === 'price') {
    filtered.sort(function(a, b) {
      var diff = parseFloat(a.unitPrice || '0') - parseFloat(b.unitPrice || '0');
      return side === 'sell' ? -diff : diff;
    });
  } else if (f.sortBy === 'available') {
    filtered.sort(function(a, b) { return parseFloat(b.availableAmount || '0') - parseFloat(a.availableAmount || '0'); });
  } else if (f.sortBy === 'limit') {
    filtered.sort(function(a, b) { return parseFloat(b.maxOrderSize || '0') - parseFloat(a.maxOrderSize || '0'); });
  }
  return filtered;
}

function renderRankingTable(list, label, priceColor, side) {
  var fmtN = function(v) { return v ? Number(v).toLocaleString() : ''; };
  var badgeColor = function(t) { return ({ certified: '#00c853', super: '#448aff', diamond: '#7c4dff' })[t] || '#8888a0'; };
  var badgeLabel = function(t) { return ({ certified: 'Certified', super: 'Super', diamond: 'Diamond' })[t] || t || 'Standard'; };
  var actionLabel = side === 'buy' ? 'Buy' : 'Sell';
  var actionColor = side === 'buy' ? '#00c853' : '#f44336';
  var head = '<thead><tr><th>#</th><th>Price</th><th>Available</th><th>Limits (KES)</th><th>Merchant</th><th>Type</th><th>Action</th></tr></thead><tbody>';
  var rows = list.length === 0 ? '<tr><td colspan="7"><div class="empty-state" style="padding:20px;"><p>No ads</p></div></td></tr>' :
    list.map(function(a, i) {
      var limit = (a.minOrderSize && a.maxOrderSize) ? 'KES ' + fmtN(a.minOrderSize) + ' - KES ' + fmtN(a.maxOrderSize) : (a.minOrderSize || a.maxOrderSize ? 'KES ' + fmtN(a.minOrderSize || a.maxOrderSize) : '-');
      var isOwner = a.isOwner === 'true';
      var t = a.creator ? a.creator.type : '';
      var bc = badgeColor(t);
      var bl = badgeLabel(t);
      var adId = a.adId || a.id || '';
      var price = a.unitPrice || '0';
      var minAmt = a.minOrderSize || '0';
      var maxAmt = a.maxOrderSize || '0';
      var btn = isOwner ? '<span style="font-size:10px;color:var(--text-quaternary);">—</span>' : '<button onclick="showOrderModal(\'' + adId + '\',\'' + side + '\',\'' + price + '\',\'' + minAmt + '\',\'' + maxAmt + '\')" style="padding:4px 12px;border:none;border-radius:6px;background:' + actionColor + ';color:#fff;font-size:11px;font-weight:600;cursor:pointer;">' + actionLabel + '</button>';
      var rowBg = isOwner ? 'rgba(' + (side === 'buy' ? '0,200,83' : '244,67,54') + ',0.08)' : '';
      var cellBg = isOwner ? rowBg : '';
      return '<tr' + (isOwner ? ' style="outline:2px solid ' + priceColor + ';outline-offset:-2px;background:' + rowBg + ';"' : '') + '><td style="color:var(--text-quaternary);font-size:12px;">' + (i + 1) + '</td><td style="font-weight:700;color:' + priceColor + ';">' + price + '</td><td>' + fmtN(a.availableAmount) + '</td><td style="font-size:11px;color:var(--text-secondary);">' + limit + '</td><td style="font-size:12px;">' + (a.creator ? esc(a.creator.nickName || '') : '—') + (isOwner ? ' <span style="color:' + priceColor + ';">(You)</span>' : '') + '</td><td><span style="font-size:10px;font-weight:600;padding:3px 8px;border-radius:4px;background:' + bc + '22;color:' + bc + ';border:1px solid ' + bc + '44;">' + bl + '</span></td><td>' + btn + '</td></tr>';
    }).join('');
  return '<div class="card"><h3>' + label + ' (' + list.length + ')</h3><div class="table-container"><table>' + head + rows + '</table></div></div>';
}

window.showOrderModal = function(adId, side, price, minAmt, maxAmt) {
  var existing = document.getElementById('order-modal-overlay');
  if (existing) existing.remove();
  var overlay = document.createElement('div');
  overlay.id = 'order-modal-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:200;display:flex;align-items:center;justify-content:center;';
  var action = side === 'buy' ? 'Buy' : 'Sell';
  var color = side === 'buy' ? '#00c853' : '#f44336';
  var minFiat = parseFloat(minAmt || '0') || 0;
  var maxFiat = parseFloat(maxAmt || '0') || 0;
  var defaultVal = minFiat > 0 ? minFiat : 1000;
  overlay.innerHTML = '<div style="background:var(--bg-secondary);border:1px solid var(--border-primary);border-radius:16px;padding:24px;width:360px;max-width:92vw;box-shadow:0 20px 60px rgba(0,0,0,0.5);"><h3 style="margin:0 0 4px 0;font-size:18px;">' + action + ' USDT</h3><div style="font-size:13px;color:var(--text-tertiary);margin-bottom:8px;">Price: KES <strong style="color:' + color + ';">' + price + '</strong></div>' + (minFiat && maxFiat ? '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:12px;">Min: KES ' + minFiat + ' · Max: KES ' + maxFiat + '</div>' : '') + '<label style="font-size:12px;color:#8888a0;display:block;margin-bottom:4px;">Amount (KES)</label><input id="order-amount-input" type="number" min="' + minFiat + '" max="' + (maxFiat || '') + '" step="1" value="' + defaultVal + '" style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:14px;outline:none;box-sizing:border-box;" autofocus><div id="order-crypto-hint" style="font-size:11px;color:var(--text-quaternary);margin-top:4px;">You will receive ≈ ' + (defaultVal / parseFloat(price)).toFixed(4) + ' USDT</div><div style="display:flex;gap:8px;margin-top:16px;justify-content:flex-end;"><button onclick="document.getElementById(\'order-modal-overlay\').remove()" style="padding:8px 20px;border-radius:10px;border:1px solid var(--border-primary);background:transparent;color:var(--text-tertiary);font-size:13px;cursor:pointer;">Cancel</button><button onclick="submitOrder(\'' + adId + '\',\'' + side + '\',\'' + price + '\')" style="padding:8px 20px;border-radius:10px;border:none;background:' + color + ';color:var(--text-on-accent);font-size:13px;font-weight:700;cursor:pointer;">' + action + ' USDT</button></div></div>';
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
  document.body.appendChild(overlay);
  var inp = document.getElementById('order-amount-input');
  if (inp) {
    inp.addEventListener('input', function() {
      var val = parseFloat(this.value || '0');
      var crypto = val > 0 ? (val / parseFloat(price)).toFixed(4) : '—';
      var hint = document.getElementById('order-crypto-hint');
      if (hint) hint.textContent = 'You will receive ≈ ' + crypto + ' USDT';
    });
    inp.focus();
  }
};

window.submitOrder = async function(adId, side, price) {
  var inp = document.getElementById('order-amount-input');
  if (!inp) return;
  var fiatAmount = parseFloat(inp.value);
  if (!fiatAmount || fiatAmount <= 0) { showToast('Enter a valid amount', 'error'); return; }
  var overlay = document.getElementById('order-modal-overlay');
  if (overlay) overlay.remove();
  try {
    showToast('Placing order...', 'info');
    var res = await API.placeOrder(adId, side, price, fiatAmount);
    if (res.code === 0 || res.code === '0') {
      showToast('Order placed successfully!', 'success');
      _mpData = null;
      renderRanking(document.getElementById('page-content'));
    } else {
      showToast(res.msg || 'Failed to place order', 'error');
    }
  } catch (err) {
    showToast(err.message || 'Failed to place order', 'error');
  }
};

window.setRankingFilter = function(key, val) {
  _mpFilters[key] = val;
  if (key === 'side' || key === 'paymentMethod' || key === 'sortBy') renderRanking(document.getElementById('page-content'));
};
window.applyRankingFilter = function() {
  _mpFilters.maxPrice = document.getElementById('mp-max-price') ? document.getElementById('mp-max-price').value : '';
  _mpFilters.paymentMethod = document.getElementById('mp-payment') ? document.getElementById('mp-payment').value : '';
  _mpFilters.sortBy = document.getElementById('mp-sort') ? document.getElementById('mp-sort').value : 'price';
  renderRanking(document.getElementById('page-content'));
};
window.clearRankingFilter = function() {
  _mpFilters = { side: 'all', maxPrice: '', paymentMethod: '', sortBy: 'price' };
  renderRanking(document.getElementById('page-content'));
};

/* ==== js/modules/okx/sms-match.js ==== */
// ===== I&M Bank SMS -> Buy Order Matcher =====
// Parses I&M Bank payment-confirmation SMS (bank transfer / Airtel Money /
// M-PESA) and matches it to the correct pending BUY order (we pay, seller
// sells us crypto) by amount + destination. Used by the Mark-as-Paid modal
// to prefill the TXID and auto-post it to the order chat on confirm.

function normBankSmsName(s) {
  return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}
function digitsOnly(s) {
  return String(s || '').replace(/\D/g, '');
}
function normPhoneLocal(p) {
  var d = digitsOnly(p);
  if (d.length < 9) return d;
  // Canonicalize to the 9-digit subscriber number: the bank may show
  // "+254712345678" while a client configured "+254-0712345678" (or
  // "0712345678"). Drop a leading 254 country code (with or without the extra
  // 0 the client typed after it), then any leading national 0, so all forms
  // compare equal.
  if (d.indexOf('254') === 0) d = d.slice(3);
  d = d.replace(/^0+/, '');
  return d;
}
function normNameSms(s) {
  return String(s || '').toLowerCase().replace(/[^a-z\s]/g, '').replace(/\s+/g, ' ').trim();
}

// A stored P2P account is "degenerate" when it's missing, all-zeros, or so short
// it says nothing about the real destination (typical for counterparties who send
// the actual pay number in the order chat instead of registering it). Degenerate
// accounts must never earn the +50 "destination match" — matching "00..." against
// random accounts sends receipts to the wrong order.
function accountIsDegenerate(acc) {
  var d = digitsOnly(acc || '');
  if (!d) return true;
  if (/^0+$/.test(d)) return true;
  if (/^(\d)\1+$/.test(d)) return true;
  if (d.length < 4) return true;
  return false;
}

// Parse an I&M payment SMS -> { kind, amount, currency, bankName, account,
// phone, recipientName, txRefId, walletRefId, dateStr } or null.
window.parseBankSms = function(text) {
  if (!text || typeof text !== 'string') return null;
  var t = String(text).replace(/\s+/g, ' ').trim();
  if (t.length < 20) return null;
  var out = { kind: 'bank', amount: null, currency: 'KES', bankName: '', account: '', phone: '', recipientName: '', txRefId: '', walletRefId: '', dateStr: '' };
  if (/airtel\s*money/i.test(t)) out.kind = 'airtel';
  else if (/m-?pesa/i.test(t)) out.kind = 'mpesa';

  var m = t.match(/KES\s*([\d,]+\.\d{2})/i);
  if (m) out.amount = parseFloat(m[1].replace(/,/g, ''));

  m = t.match(/Transaction Ref(?:erence)? ID\s*:\s*([\w-]+)/i);
  if (m) out.txRefId = m[1];

  m = t.match(/(?:Airtel Money|M-PESA|Mpesa)\s*Ref(?:erence)? ID\s*:\s*([\w-]+)/i);
  if (m) out.walletRefId = m[1];

  m = t.match(/on\s+(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2})/i);
  if (m) out.dateStr = m[1];

  if (out.kind === 'bank') {
    m = t.match(/to\s+(.+?)\s+A\/c\s*([\w-]+)/i);
    if (!m) m = t.match(/to\s+(.+?)\s+account\s+([\w-]+)/i);
    if (m) {
      out.bankName = m[1].trim();
      out.account = m[2].trim();
    }
  } else {
    m = t.match(/to\s+(\+?254[\s-]*0?\d{8,9}|0\d{9})\s*-\s*([A-Z][A-Z\s.']+?)(?=\s+successfully|\s+on\s+|\s+processed|\.|$)/i);
    if (m) {
      out.phone = m[1];
      out.recipientName = m[2].trim();
    } else {
      m = t.match(/to\s+(\+?254[\s-]*0?\d{8,9}|0\d{9})\b/i);
      if (m) out.phone = m[1];
    }
  }
  return out;
};

function smsOrderPaymentMethods(o) {
  var list = [];
  var cd = o && o.counterpartyDetail || {};
  var tpm = cd.takerPaymentMethod || o.takerPaymentMethod;
  if (tpm) list.push(tpm);
  if (cd.paymentMethod) list.push(cd.paymentMethod);
  if (o && o.paymentMethod) list.push(o.paymentMethod);
  if (o && o.makerPaymentMethod) list.push(o.makerPaymentMethod);
  // Secondary payment methods read from the order chat by the server (real
  // number pasted when the registered account is 00.../empty). Shape mirrors
  // the stored fields so the scorer handles them the same as primary methods.
  (o && Array.isArray(o.chatPayments) ? o.chatPayments : []).forEach(function(cp) {
    if (!cp) return;
    var pm = { bankName: cp.bankHint || 'Chat', accountNo: cp.accountNumber || '', phoneNumber: cp.phoneNumber || '' };
    if (pm.accountNo || pm.phoneNumber) list.push(pm);
  });
  return list;
}

// NOTE: the buy-side matcher used to live here too (window.smsOrderScore +
// window.findSmsOrderAll). It was a second implementation of smsAutoService's
// findBuyOrder, and the two disagreed - this copy could not see numbers the
// counterparty pasted into the order chat, and it ran bank ACCOUNT numbers
// through phone normalisation - so the same SMS could resolve to one order in
// the WebView and a different one via the native APK path. Matching now happens
// server-side only, via API.smsProof() -> smsAutoService.handleBuySms.
// Do not re-add a client-side matcher; that is what caused the mismatch.

// Local "already sent" tracking is intentionally gone. It duplicated
// userStore.markRefPosted (posted_sms_refs) and could disagree with it across
// devices; the server now answers "was this ref posted?".
// ===== Paste SMS modal (catch late arrivals) =====
// Placeholder-filled proof format templates. Edited live from Ads → SMS Proofs
// (stored in the user's preferences under smsProofFormats). Each template's
// placeholders are replaced from the parsed SMS payload at send time.
var _SMS_PROOF_FORMAT_PLACEHOLDERS = ['{amount}', '{phone}', '{recipientName}', '{bankName}', '{account}', '{txRefId}', '{walletRefId}', '{dateStr}'];
var _SMS_PROOF_FORMAT_DEFAULTS = {
  mpesa: '💳 Payment sent — KES {amount} to {phone} ({recipientName})\n📇 I&M Bank Reference code : {txRefId}\n💰 mpesa reference code: {walletRefId}\n🕒 {dateStr}',
  airtel: '💳 Payment sent — KES {amount} to {phone} ({recipientName})\n📇 I&M Bank Reference code : {txRefId}\n💰 Airtel money reference code: {walletRefId}\n🕒 {dateStr}',
  bank: '💳 Payment sent — KES {amount} to {bankName} A/c {account}\n📇 Bank Ref: {txRefId}\n💰 Wallet Ref: {walletRefId}\n🕒 {dateStr}'
};
var _smsProofFormats = null; // lazy cache of {mpesa, airtel, bank}
window._smsProofFormatsCache = function() { return _smsProofFormats; };

function _fillProofTemplate(tpl, p) {
  var amount = p.amount != null ? p.amount.toLocaleString('en', { minimumFractionDigits: 2 }) : '?';
  return String(tpl || '').replace(/\{amount\}/g, amount)
    .replace(/\{phone\}/g, p.phone || '')
    .replace(/\{recipientName\}/g, p.recipientName || '')
    .replace(/\{bankName\}/g, p.bankName || '')
    .replace(/\{account\}/g, p.account || '')
    .replace(/\{txRefId\}/g, p.txRefId || '')
    .replace(/\{walletRefId\}/g, p.walletRefId || '')
    .replace(/\{dateStr\}/g, p.dateStr || '')
    .split('\n').map(function(l) { return l.replace(/\s+$/g, ''); }).filter(function(l) { return l.replace(/[💳📇💰🕒\s]/g, '').length > 0; }).join('\n');
}
window._fillProofTemplate = _fillProofTemplate;

// Load (or reload) the user's saved proof-format templates. Called on bundle
// load and after every edit/save from the Ads → SMS Proofs tab.
window.loadSmsProofFormats = async function() {
  try {
    var res = await API.sendGet && API.get ? API.get('/api/auth/preferences') : null;
    var prefs = (res && res.data) || {};
    _smsProofFormats = prefs.smsProofFormats || null;
  } catch (e) { _smsProofFormats = null; }
  return _smsProofFormats;
};
window.smsProofFormatsDefaults = function() { return Object.assign({}, _SMS_PROOF_FORMAT_DEFAULTS); };
window.smsProofFormatsPlaceholders = function() { return _SMS_PROOF_FORMAT_PLACEHOLDERS.slice(); };
window.smsProofFormatsEffective = function() {
  var ef = Object.assign({}, _SMS_PROOF_FORMAT_DEFAULTS);
  if (_smsProofFormats) { Object.keys(_SMS_PROOF_FORMAT_DEFAULTS).forEach(function(k) { if (typeof _smsProofFormats[k] === 'string' && String(_smsProofFormats[k]).trim()) ef[k] = _smsProofFormats[k]; }); }
  return ef;
};

function smsMessageText(p) {
  var ef = window.smsProofFormatsEffective();
  var tpl = ef[p.kind] || ef.bank;
  return _fillProofTemplate(tpl, p);
}
window.smsMessageText = smsMessageText;

// Prime the cache on load (fire-and-forget; senders fall back to defaults).
if (typeof window.loadSmsProofFormats === 'function') window.loadSmsProofFormats();

// ===== APK auto-forward (no manual paste) =====
// The Android app forwards I&M outgoing transfer SMS (buy side) to
// window.__apkBuySms(text) — queued in __apkBuySmsQueue when api.js loads.
// Orders may not be in _ordersMap yet (page still loading / user not on the
// orders screen), so we retry until they arrive then auto-route each text
// through routeSmsToOrder. handleSSEOrderUpdate() (orders.js) kicks this on
// every orders refresh, so a queued SMS gets routed the moment data lands.
var _apkBuySmsBusy = false;
window.__drainApkBuySmsQueue = function() {
  var q = window.__apkBuySmsQueue || [];
  if (!q.length) { _apkBuySmsBusy = false; return; }
  if (_apkBuySmsBusy) return;
  // No longer gated on window._ordersMap: matching happens server-side, which
  // fetches pending buy orders itself. Previously a captured SMS sat in the
  // queue until the user happened to load the Orders screen.
  _apkBuySmsBusy = true;
  var text = q.shift();
  window.routeSmsToOrder(text, true, null, 'apk').then(function(res) {
    _apkBuySmsBusy = false;
    if (res && res.sent) {
      showToast('SMS matched — ref posted to order ' + String(res.orderId || (res.order && res.order.orderId) || '').slice(0, 8) + ' chat ✅', 'success', 5000);
    } else if (!res || (res && ['low-confidence', 'no-match', 'unparsed', 'none', 'no-amount'].indexOf(res.reason) !== -1)) {
      // Unattributed payment — surface it in the orders banner so it's not missed.
      // 'no-match'/'unparsed' are the server's action names; 'none'/'no-amount' are
      // kept for older cached responses.
      window.__unmatchedSms = window.__unmatchedSms || [];
      window.__unmatchedSms.push({ at: Date.now(), reason: (res && res.reason) || 'no-match', detail: res && res.reason === 'low-confidence' ? 'amount matched but destination unverified' : 'no pending buy order matches' });
      if (typeof window.renderUnmatchedSmsBanner === 'function') { try { window.renderUnmatchedSmsBanner(); } catch (e) {} }
    }
    setTimeout(window.__drainApkBuySmsQueue, 0);
  }).catch(function() {
    _apkBuySmsBusy = false;
    setTimeout(window.__drainApkBuySmsQueue, 0);
  });
};

// Kick the drainer on bundle load (retries itself via SSE kicks).
window.__drainApkBuySmsQueue();

// Route a pasted/captured SMS to the correct BUY order chat.
//
// MATCHING, dedupe, chat posting, receipts and logging all happen server-side
// (smsAutoService.handleBuySms). This function is only transport + UI: it
// forwards the raw text and renders the server's decision. Every previous bug
// here came from the browser and the server each holding their own idea of
// which order an SMS belongs to.
// args: text, silent?, customText?, source, orderId?
//   customText - user-edited proof text, posted verbatim by the server
//   orderId    - pins an order; server re-validates side/status/amount
window.routeSmsToOrder = async function(text, silent, customText, source, orderId) {
  source = source || (silent ? 'apk' : 'manual');
  if (!text || !String(text).trim()) {
    if (!silent) showToast('Could not read SMS - paste the full I&M Bank message', 'error');
    return null;
  }
  var res = null;
  try {
    var r = await API.smsProof({
      text: String(text).slice(0, 4000),
      customText: customText || '',
      orderId: orderId || '',
      source: source,
      preview: false
    });
    res = r && r.data;
  } catch (e) {
    var em = String((e && e.message) || e);
    if (!silent) showToast('Proof delivery failed: ' + em, 'error');
    return { order: null, sent: false, reason: 'error', error: em };
  }
  if (!res) {
    if (!silent) showToast('Proof delivery failed: empty response', 'error');
    return { order: null, sent: false, reason: 'error' };
  }

  var oid = res.orderId || '';
  // Callers still want a local order object; the server only returns the id.
  var local = (oid && window._ordersMap && window._ordersMap[oid]) ? window._ordersMap[oid] : null;
  var order = local || (oid ? { orderId: oid } : null);
  var id8 = oid ? oid.slice(0, 8) : '';

  if (res.action === 'posted') {
    if (!silent) showToast('Ref sent to order ' + id8 + ' chat', 'success');
    if (local && _chatActiveOrder === oid && typeof loadChatMessages === 'function') {
      try { await loadChatMessages(oid); } catch (e) {}
    }
    return { order: order, sent: true, orderId: oid, reason: 'posted', score: res.score, match: res };
  }

  var msg = null, kind = 'info';
  if (res.action === 'no-match') msg = 'No buy order matches amount KES ' + (res.amount || '?');
  else if (res.action === 'unparsed') { msg = 'Could not read this SMS'; kind = 'error'; }
  else if (res.action === 'low-confidence') msg = 'Match is ambiguous (only the amount matches) - confirm the right order first';
  else if (res.action === 'no-ref') msg = 'No transaction ref in SMS - nothing to send';
  else if (res.action === 'duplicate') msg = 'Ref already sent to order ' + id8 + ' chat';
  else if (res.action === 'skipped-completed') msg = 'Order ' + id8 + ' completed - skipped (SMS not sent)';
  else if (res.action === 'error') { msg = 'Send failed: ' + (res.detail || 'unknown error'); kind = 'error'; }
  if (msg && !silent) showToast(msg, kind);

  return {
    order: order, sent: false, orderId: oid,
    reason: res.action || res.reason || 'no-match',
    score: res.score, match: res
  };
};

// Audit a buy-side router decision on the server (shown in the Match Log panel
// alongside sell-side inbound entries). Fire-and-forget, never blocks routing.
function _logMatch(action, orderId, p, detail, source, msgText) {
  try {
    API.smsMatchLog({
      orderId: orderId || '',
      amount: p && p.amount ? p.amount : 0,
      smsRef: (p && (p.txRefId || p.walletRefId)) || '',
      action: action,
      detail: detail || '',
      source: source || '',
      msgText: msgText || ''
    }).catch(function() {});
  } catch (e) {}
}

window.showSmsPasteModal = function() {
  var overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = '<div class="modal-content" style="max-width:520px;"><h3>📲 Paste Payment SMS</h3>'
    + '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:12px;">Paste the I&amp;M Bank SMS now — even if it arrived late. It will be matched to the correct buy order and the transaction ref posted to that order\u2019s chat. Orders already completed are skipped.</p>'
    + '<textarea id="sms-paste-area" class="form-input" rows="5" placeholder="Paste the full SMS from I&M Bank here..." style="width:100%;resize:vertical;font-size:13px;"></textarea>'
    + '<div id="sms-paste-proof-wrap" style="display:none;margin-top:10px;">'
    + '<label for="sms-paste-proof" style="font-size:12px;color:var(--text-tertiary);display:block;margin-bottom:4px;">✏️ Proof message to send (editable)</label>'
    + '<textarea id="sms-paste-proof" class="form-input" rows="4" style="width:100%;resize:vertical;font-size:12px;font-family:monospace;"></textarea>'
    + '</div>'
    + '<div id="sms-paste-result" style="margin-top:8px;"></div>'
    + '<div class="form-actions" style="margin-top:12px;">'
    + '<button type="button" class="btn btn-secondary" onclick="this.closest(\'.modal-overlay\').remove()">Close</button>'
    + '<button type="button" class="btn btn-primary" onclick="window.routeSmsPaste()">Match &amp; Send to Chat</button>'
    + '</div></div>';
  document.body.appendChild(overlay);
  setTimeout(function() { var a = document.getElementById('sms-paste-area'); if (a) { a.focus(); a.addEventListener('input', function() { window._smsPasteDebounce = true; setTimeout(window.routeSmsPastePreview, 400); }); } }, 50);
  setTimeout(function() { var p = document.getElementById('sms-paste-proof'); if (p) { p.addEventListener('input', function() { if (p.dataset) p.dataset.touched = '1'; }); } }, 50);
  // Preview asks the SERVER which order it would pick - the same matcher that
  // performs the real send - so the panel can never promise a match the send
  // would disagree with. Stale-guarded by sequence + text.
  var _prevSeq = 0;
  window.routeSmsPastePreview = async function() {
    var area = document.getElementById('sms-paste-area');
    var out = document.getElementById('sms-paste-result');
    var wrap = document.getElementById('sms-paste-proof-wrap');
    var pf = document.getElementById('sms-paste-proof');
    if (!area || !out) return;
    var txt = area.value.trim();
    if (!txt) { out.innerHTML = ''; if (wrap && pf) wrap.style.display = 'none'; return; }
    var p = window.parseBankSms(txt);
    if (!p) {
      out.innerHTML = '<div style="padding:8px;border-radius:6px;background:rgba(244,67,54,0.07);border:1px solid rgba(244,67,54,0.25);font-size:12px;color:var(--accent-red);">Could not read this SMS</div>';
      if (wrap && pf) wrap.style.display = 'none';
      return;
    }
    window._smsPasteOrderId = '';
    var my = ++_prevSeq;
    var r = null;
    try { r = await API.smsProof({ text: txt, preview: true, source: 'manual' }); } catch (e) { r = null; }
    if (my !== _prevSeq) return;
    if (!area.isConnected || area.value.trim() !== txt) return;
    var res = r && r.data;
    if (!res || res.action === 'unparsed' || res.action === 'no-match') {
      out.innerHTML = '<div style="padding:8px;border-radius:6px;background:rgba(244,67,54,0.07);border:1px solid rgba(244,67,54,0.25);font-size:12px;color:var(--accent-red);">No buy order matches KES ' + (p.amount || '?') + '</div>';
      if (wrap && pf) wrap.style.display = 'none';
      return;
    }
    window._smsPasteOrderId = res.orderId || '';
    var o = (res.orderId && window._ordersMap && window._ordersMap[res.orderId]) || { orderId: res.orderId };
    var cp = getCounterpartyInfo(o);
    var disp = (o.fiatAmount != null ? formatFiat(o.fiatAmount, o.fiatCurrency) : '') + (cp && cp.name ? ' &middot; ' + esc(cp.name) : '');
    var ref = res.ref || p.txRefId || p.walletRefId || '';
    var stTxt;
    if (res.isCompleted) stTxt = '&#x26d4; Completed &mdash; will skip';
    else if (res.reason !== 'high') stTxt = '&#x26a0;&#xfe0f; Amount matches but destination is unverified &mdash; confirm below to send';
    else if (!ref) stTxt = '&#x26a0;&#xfe0f; No transaction ref in SMS &mdash; nothing to send';
    else stTxt = '&#x2705; Will send ref';
    var warn = res.isCompleted || res.reason !== 'high';
    out.innerHTML = '<div style="padding:8px 10px;border-radius:6px;font-size:12px;border:1px solid ' + (warn ? 'rgba(255,179,0,0.25)' : 'rgba(0,210,104,0.25)') + ';background:' + (warn ? 'rgba(255,179,0,0.07)' : 'rgba(0,210,104,0.07)') + ';color:' + (warn ? 'var(--accent-amber)' : 'var(--accent-green)') + ';">matches <strong>order ' + esc((res.orderId || '').slice(0, 12)) + '</strong>' + (disp ? ' (' + disp + ')' : '') + '<br>KES ' + (p.amount || '?') + (p.phone ? ' &rarr; ' + esc(p.phone) : '') + (p.account ? ' &rarr; A/c ' + esc(p.account) : '') + (ref ? '<br>&#128231; Ref: <strong style="font-family:monospace;">' + esc(ref) + '</strong>' : '') + '<br>' + stTxt + '</div>';
    if (wrap && pf) {
      // Offer the editable proof for high-confidence matches and for amount-only
      // matches, so an ambiguous SMS can still be sent as an explicit choice.
      if (!p.amount || res.isCompleted || !ref) {
        wrap.style.display = 'none';
        return;
      }
      var composed = window.smsMessageText(p);
      pf.setAttribute('data-composed', composed);
      if (!(pf.dataset && pf.dataset.touched === '1')) pf.value = composed;
      wrap.style.display = 'block';
    }
  };
  window.routeSmsPaste = async function() {
    var area = document.getElementById('sms-paste-area');
    if (!area || !area.value.trim()) { showToast('Paste the SMS first', 'error'); return; }
    var pf = document.getElementById('sms-paste-proof');
    var custom = null;
    if (pf && pf.style.display !== 'none' && pf.value.trim() && pf.value.trim() !== (pf.getAttribute('data-composed') || '')) custom = pf.value.trim();
    // Pin the order the preview matched. The server re-validates side, status
    // and amount, so this cannot be used to force a proof onto a wrong order -
    // it only converts an amount-only match into a deliberate one.
    var pinned = window._smsPasteOrderId || '';
    var result = await window.routeSmsToOrder(area.value.trim(), false, custom, 'manual', pinned);
    if (result && result.sent) {
      setTimeout(function() { var ov = document.querySelector('.modal-overlay'); if (ov) ov.remove(); }, 600);
    }
  };
};
/* ==== js/modules/okx/disputes.js ==== */
async function renderGeneralSupport(container) {
  if (!container) return;
  container.innerHTML = '<div style="text-align:center;padding:40px;color:var(--text-quaternary);">Loading General Support...</div>';
  try {
    // Fetch all data in parallel
    var [resPending, resCompleted, resCancelled, blRes, ticketRes] = await Promise.all([
      API.get('/api/okx/p2p/order-list?completionStatus=pending&pageSize=50').catch(function(){ return { data: [] }; }),
      API.get('/api/okx/p2p/order-list?completionStatus=completed&pageSize=50').catch(function(){ return { data: [] }; }),
      API.get('/api/okx/p2p/order-list?completionStatus=cancelled&pageSize=50').catch(function(){ return { data: [] }; }),
      API.get('/api/p2p/user/blacklist?currencySymbol=USDT').catch(function(){ return { data: [] }; }),
      API.getMyTickets().catch(function(){ return { data: [] }; })
    ]);
    var allOrders = [].concat(resPending.data || [], resCompleted.data || [], resCancelled.data || []);
    var disputed = allOrders.filter(function(o) {
      var ds = String(o.disputeStatus !== undefined ? o.disputeStatus : '').toLowerCase();
      var ft = String(o.frozenType !== undefined ? o.frozenType : '').toLowerCase();
      var st = String(o.state || o.completionStatus || o.orderStatus || '').toLowerCase();
      return ds === '1' || ds === '4' || ft.indexOf('appeal') !== -1 || st.indexOf('appealing') !== -1;
    });
    var blockedUsers = blRes.data || [];
    var tickets = ticketRes.data || [];
    var openTicket = tickets.filter(function(t) { return t.status === 'open'; })[0] || null;

    var html = '<div class="page-header"><h2>🛡️ General Support</h2><div class="subtitle">Merchant lookup, disputes, blocklist, customer support &amp; APK</div></div>';

    // === DISPUTES SECTION ===
    html += '<div class="card" style="margin-bottom:20px;"><h4 style="margin-bottom:10px;">⚖️ Disputes</h4>';
    if (disputed.length === 0) {
      html += '<div class="empty-state" style="padding:20px 0;"><div class="icon" style="font-size:32px;">🛡️</div><p style="color:var(--text-quaternary);">No disputes — all orders running smoothly</p></div>';
    } else {
      html += '<div class="table-container"><table><thead><tr><th>Order ID</th><th>Side</th><th>Amount</th><th>Fiat</th><th>Status</th><th></th></tr></thead><tbody>';
      disputed.forEach(function(o) {
        html += '<tr><td><span style="font-family:monospace;font-size:12px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText(\'' + esc((o.orderId || '').slice(0,12)) + '\')">' + (o.orderId || '').slice(0,12) + '</span></td>' +
          '<td><span class="badge badge-' + (o.side === 'sell' ? 'sell' : 'buy') + '">' + (o.side || '-') + '</span></td>' +
          '<td>' + (o.cryptoAmount || '-') + '</td>' +
          '<td>' + formatFiat(o.fiatAmount, o.fiatCurrency) + '</td>' +
          '<td><span class="badge badge-disputed">Active</span></td>' +
          '<td><button class="btn btn-sm btn-outline" data-on-click="viewDispute(\'' + esc(o.orderId) + '\')">View</button></td></tr>';
      });
      html += '</tbody></table></div>';
    }
    html += '</div>';

    // === BLACKLIST SECTION ===
    html += '<div class="card" style="margin-bottom:20px;"><h4 style="margin-bottom:10px;">🚫 Blocklist</h4>';
    if (blockedUsers.length === 0) {
      html += '<div class="empty-state" style="padding:20px 0;"><div class="icon" style="font-size:32px;opacity:0.3;">🚫</div><p style="color:var(--text-quaternary);">No blacklisted users</p></div>';
    } else {
      html += '<div class="table-container"><table class="table"><thead><tr><th>User</th><th>Type</th><th>Completion</th><th>Orders</th><th>Avg Paid</th><th>Avg Release</th><th>Added</th><th></th></tr></thead><tbody>';
      blockedUsers.forEach(function(u) {
        html += '<tr><td><strong>' + esc(u.userName || '-') + '</strong></td>' +
          '<td>' + esc(u.userType || '-') + '</td>' +
          '<td>' + (u.completionRate != null ? u.completionRate + '%' : '-') + '</td>' +
          '<td>' + (u.orders != null ? u.orders : '-') + '</td>' +
          '<td>' + (u.buyerAvgPaidTime ? Math.round(u.buyerAvgPaidTime / 60) + 'm' : '-') + '</td>' +
          '<td>' + (u.sellerAvgCompletedTime ? Math.round(u.sellerAvgCompletedTime / 60) + 'm' : '-') + '</td>' +
          '<td>' + (u.createdTimestamp ? new Date(Number(u.createdTimestamp)).toLocaleDateString() : '-') + '</td>' +
          '<td><button class="btn btn-sm btn-danger" data-on-click="confirmRemoveBlacklist(\'' + esc(u.userId || '') + '\')">Remove</button></td></tr>';
      });
      html += '</tbody></table></div>';
    }
    html += '</div>';

    // === MERCHANT SECTION ===
    html += '<div class="card" style="margin-bottom:20px;"><h4 style="margin-bottom:10px;">👤 Merchant Lookup</h4>';
    html += '<div id="gs-merchant-area" style="margin:0 auto;"></div></div>';

    // === SUPPORT SECTION ===
    html += '<div class="card" style="margin-bottom:20px;"><h4 style="margin-bottom:10px;">🎧 Customer Care</h4>';
    html += '<div style="max-width:800px;margin:0 auto;">';
    html += '<div class="chatbot-container" id="chatbot-container">';
    html += '<div class="chatbot-header"><div class="avatar">🤖</div><div><h3>AI Assistant</h3><div class="status">Powered by Llama 3.2 · Ask me anything</div></div></div>';
    html += '<div class="chatbot-messages" id="chatbot-messages">';
    html += '<div class="msg bot">Hi! I\'m your AI trading assistant. Ask me about P2P trading, API setup, strategies, or anything else about the platform.</div>';
    html += '</div><div class="chatbot-input" id="chatbot-input-area">';
    html += '<input id="chatbot-input" placeholder="Type your question..." onkeydown="if(event.key===\'Enter\')sendChatbotMsg()">';
    html += '<button id="chatbot-send-btn" onclick="sendChatbotMsg()">Send</button></div>';
    html += '<div id="chatbot-escalate-area">';
    if (openTicket) html += '<div class="chatbot-ticket-bar"><span class="dot"></span> Support ticket #' + openTicket.id.slice(0,8) + ' is open — admin will respond here</div>';
    html += '</div></div>'; // close chatbot-container
    html += '<div class="support-call-section" style="margin-top:12px;">';
    html += '<div class="support-call-bar"><div class="support-call-info"><span class="support-call-icon">🎧</span><div><div style="font-size:13px;font-weight:600;color:var(--text-primary);">Talk to an Admin</div><div class="support-call-status" id="support-call-status">Call support via audio</div></div></div>';
    html += '<button class="btn btn-primary" id="support-call-btn" onclick="clientStartCall()" style="white-space:nowrap;">🎧 Call Support</button></div>';
    html += '<div class="support-call-controls" id="support-call-controls" style="display:none;">';
    html += '<div class="support-call-timer-wrap"><span class="support-call-icon">🔊</span><span class="support-call-timer" id="support-call-timer">00:00</span></div>';
    html += '<div style="display:flex;gap:8px;"><button class="btn btn-sm btn-outline" id="support-call-mute-btn" onclick="clientToggleMute()">🔇 Mute</button>';
    html += '<button class="btn btn-sm btn-danger" onclick="clientEndCall()">🔴 End Call</button></div></div></div>';
    html += '</div></div>'; // close support section

    // === APK SECTION ===
    html += '<div class="card" style="margin-bottom:20px;"><h4 style="margin-bottom:10px;">📲 APK Downloads</h4>';
    html += '<div style="display:flex;flex-wrap:wrap;gap:16px;">';
    html += '<div class="version-card" style="flex:1;min-width:260px;background:var(--bg-input);border:1px solid var(--border-primary);border-radius:16px;padding:20px;">';
    html += '<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;"><span style="background:rgba(0,200,83,0.12);color:#00c853;padding:4px 14px;border-radius:20px;font-size:13px;font-weight:600;border:1px solid rgba(0,200,83,0.2);">v.4.000.3986 — Latest</span><span style="color:var(--text-quaternary);font-size:12px;" id="gs-apk-date">Jun 29, 2026</span></div>';
    html += '<ul style="list-style:none;padding:0;margin:8px 0 16px;font-size:13px;color:var(--text-secondary);">';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• In-app APK update (Check for Updates in Settings → About)</li>';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• Bank page now shows all pending order categories</li>';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• Per-user order cache for instant load</li>';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• Fresh Fetch button — one-click force refresh</li>';
    html += '</ul><a class="download-btn" href="/downloads/MONEYFESTLTD.apk" download style="display:inline-flex;align-items:center;gap:8px;padding:10px 24px;border-radius:10px;border:none;background:linear-gradient(135deg,#00c853,#00e676);color:var(--text-on-accent);font-size:14px;font-weight:700;cursor:pointer;text-decoration:none;">⬇ Debug APK (6.3 MB)</a>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:6px;">Android 8.0+ (API 26) · Debug build</div></div>';
    html += '<div class="version-card" style="flex:1;min-width:260px;background:var(--bg-input);border:1px solid var(--border-primary);border-radius:16px;padding:20px;">';
    html += '<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;"><span style="background:rgba(68,138,255,0.12);color:#448aff;padding:4px 14px;border-radius:20px;font-size:13px;font-weight:600;border:1px solid rgba(68,138,255,0.2);">v.2.000.3468 — Stable</span><span style="color:var(--text-quaternary);font-size:12px;">Jun 26, 2026</span></div>';
    html += '<ul style="list-style:none;padding:0;margin:8px 0 16px;font-size:13px;color:var(--text-secondary);">';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• Stable release build (signed)</li>';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• Passkey authentication with release key</li>';
    html += '<li style="padding:3px 0 3px 18px;position:relative;">• Debug-free signing for production stability</li>';
    html += '</ul><a class="download-btn" href="/downloads/MONEYFESTLTD-release.apk" download style="display:inline-flex;align-items:center;gap:8px;padding:10px 24px;border-radius:10px;border:none;background:linear-gradient(135deg,#448aff,#536dfe);color:#fff;font-size:14px;font-weight:700;cursor:pointer;text-decoration:none;">⬇ Release APK (2.3 MB)</a>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);margin-top:6px;">Android 8.0+ (API 26) · Signed release</div></div></div></div>';

    container.innerHTML = html;
    // Mount merchant profile embed
    var gsMerchantArea = document.getElementById('gs-merchant-area');
    if (gsMerchantArea && typeof renderMerchantProfile === 'function') renderMerchantProfile(gsMerchantArea, null);
    // Reset chatbot state
    _chatbotMessages = [];
    _activeTicketId = openTicket ? openTicket.id : null;
    _escalating = false;
    setTimeout(scrollChatbot, 100);
  } catch (e) {
    container.innerHTML = '<div class="card" style="text-align:center;padding:40px;"><p style="color:#f44336;">Failed to load: ' + esc(e.message) + '</p><button class="btn btn-sm btn-outline" style="margin-top:12px;" data-on-click="renderGeneralSupport(document.getElementById(\'page-content\'))">Retry</button></div>';
  }
}

async function renderReviews(container) {
  if (!container) return;
  container.innerHTML = `
    <div class="page-header"><h2>🎉 Funzone</h2><div class="subtitle">Suggestions &amp; fun stuff</div></div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;max-width:1000px;">
      <div class="card" style="border-color:rgba(68,138,255,0.3);">
        <h3 style="color:var(--accent-blue);margin-bottom:12px;">💡 Suggest a Feature</h3>
        <p style="font-size:13px;color:var(--text-tertiary);margin-bottom:16px;">Have an idea? Drop it here — we read every suggestion!</p>
        <form data-on-submit="submitSuggestion(event)" action="javascript:void(0)">
          <input id="suggestion-title" placeholder="Title (optional)" style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;margin-bottom:10px;box-sizing:border-box;">
          <textarea id="suggestion-message" placeholder="Describe your idea..." required style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;min-height:100px;resize:vertical;box-sizing:border-box;font-family:inherit;"></textarea>
          <button type="submit" class="btn btn-primary" style="margin-top:10px;">Send Suggestion</button>
        </form>
        <div id="suggestion-status" style="margin-top:8px;font-size:12px;color:var(--accent-green);"></div>
      </div>
      <div class="card" style="border-color:rgba(0,230,200,0.3);text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:200px;">
        <div style="font-size:64px;margin-bottom:16px;">🚀</div>
        <h3 style="color:#00e6c8;margin-bottom:8px;">More Coming Soon</h3>
        <p style="color:var(--text-tertiary);font-size:13px;max-width:300px;line-height:1.6;">We're building something exciting! Check back later for new features, tools, and fun stuff.</p>
        <div style="margin-top:16px;padding:12px 24px;background:rgba(91,124,250,0.08);border-radius:12px;border:1px solid rgba(68,138,255,0.2);">
          <span style="color:var(--accent-blue);font-size:13px;">✨ MONEYFESTLTD ✨</span>
        </div>
      </div>
    </div>`;
}

window.submitSuggestion = async function(e) {
  e.preventDefault();
  const title = document.getElementById('suggestion-title').value;
  const message = document.getElementById('suggestion-message').value;
  if (!message.trim()) return;
  const statusEl = document.getElementById('suggestion-status');
  statusEl.textContent = 'Submitting...';
  statusEl.style.color = '#8888a0';
  try {
    await API.submitSuggestion(title, message);
    document.getElementById('suggestion-title').value = '';
    document.getElementById('suggestion-message').value = '';
    statusEl.textContent = '✅ Suggestion submitted! Thank you.';
    statusEl.style.color = '#00c853';
    setTimeout(() => { statusEl.textContent = ''; }, 4000);
  } catch (err) {
    statusEl.textContent = '❌ ' + err.message;
    statusEl.style.color = '#f44336';
  }
};

async function renderDisputes(container) {
  const _lu = new Date().toLocaleTimeString();
  let html = `<div class="page-header"><div><h2>Disputes</h2><div class="subtitle">P2P order disputes on OKX · <span id="page-last-updated" style="color:var(--text-quaternary);font-size:11px;">Updated ${_lu}</span> <span id="page-countdown" style="color:var(--text-tertiary);font-size:11px;"></span></div></div></div>`;
  try {
    const [resPending, resCompleted, resCancelled] = await Promise.all([
      API.get('/api/okx/p2p/order-list?completionStatus=pending&pageSize=50').catch(() => ({ data: [] })),
      API.get('/api/okx/p2p/order-list?completionStatus=completed&pageSize=50').catch(() => ({ data: [] })),
      API.get('/api/okx/p2p/order-list?completionStatus=cancelled&pageSize=50').catch(() => ({ data: [] }))
    ]);
    const allOrders = (resPending.data || []).concat(resCompleted.data || [], resCancelled.data || []);
    const disputed = allOrders.filter(o => {
      const ds = String(o.disputeStatus !== undefined ? o.disputeStatus : '').toLowerCase();
      const ft = String(o.frozenType !== undefined ? o.frozenType : '').toLowerCase();
      const st = String(o.state || o.completionStatus || o.orderStatus || '').toLowerCase();
      return ds === '1' || ds === '4' || ft.indexOf('appeal') !== -1 || st.indexOf('appealing') !== -1;
    });

    if (disputed.length === 0) {
      html += '<div class="card"><div class="empty-state"><div class="icon">🛡️</div><h4>No disputes</h4><p style="color:var(--text-quaternary);">All orders are running smoothly</p></div></div>';
      container.innerHTML = html;
      startPageCountdown(15);
      startPagePoll(container, () => renderDisputes(container), 30000);
      return;
    }
    html += `<div class="card"><div class="table-container"><table><thead><tr><th>Order ID</th><th>Side</th><th>Amount</th><th>Fiat</th><th>Dispute Status</th><th></th></tr></thead><tbody>`;
    disputed.forEach(o => {
      html += `<tr>
        <td><span style="font-family:monospace;font-size:12px;color:var(--text-quaternary);user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${esc((o.orderId || '').slice(0,12))}')">${(o.orderId || '').slice(0,12)}</span></td>
        <td><span class="badge badge-${o.side === 'sell' ? 'sell' : 'buy'}">${o.side || '-'}</span></td>
        <td>${o.cryptoAmount || '-'}</td>
        <td>${formatFiat(o.fiatAmount, o.fiatCurrency)}</td>
        <td><span class="badge badge-disputed">Active</span></td>
        <td><button class="btn btn-sm btn-outline" data-on-click="viewDispute('${esc(o.orderId)}')">View</button></td>
      </tr>`;
    });
    html += '</tbody></table></div></div>';
    const horzScrolls = Array.from(container.querySelectorAll('.table-container')).map(function(el) { return el.scrollLeft; });
    container.innerHTML = html;
    restoreHorzScrolls(container, horzScrolls);
    startPageCountdown(15);
    startPagePoll(container, () => renderDisputes(container), 30000);
  } catch (err) {
    retryError(container, () => renderDisputes(container), err);
  }
}

async function viewDispute(orderId) {
  try {
    const res = await API.get('/api/okx/p2p/dispute/' + orderId);
    const d = res.data?.[0] || res.data || {};
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    const disputeStatus = d.disputeStatus || '1';

    const getSenderLabel = (sender) => {
      if (!sender) return 'You';
      const s = String(sender).toLowerCase();
      if (s === 'user' || s === 'self' || s === 'me') return 'You';
      if (s.includes('support') || s.includes('admin') || s.includes('cs')) return 'Customer Support';
      if (s.includes('counterparty') || s.includes('other') || s.includes('seller') || s.includes('buyer')) return 'Counterparty';
      return sender;
    };

    overlay.innerHTML = `
      <div class="modal-content" style="max-width:600px;">
        <h3>Dispute Details</h3>
        <div class="order-detail">
          <div class="order-detail-item"><div class="label">Order ID</div><div class="value" style="font-family:monospace;font-size:12px;user-select:all;cursor:pointer;" title="Click to copy" data-on-click="copyText('${esc(orderId || '')}')">${orderId}</div></div>
          <div class="order-detail-item"><div class="label">Status</div><div class="value"><span class="badge badge-disputed">${disputeStatus === '1' ? 'Active' : disputeStatus === '4' ? 'Resolved' : disputeStatus}</span></div></div>
          <div class="order-detail-item"><div class="label">Side</div><div class="value"><span class="badge badge-${d.side === 'sell' ? 'sell' : 'buy'}">${esc(d.side || '-')}</span></div></div>
          <div class="order-detail-item"><div class="label">Reason</div><div class="value">${esc(d.disputeType || '-')}${d.subDisputeType ? ' <span style="color:#8888a0;">→</span> ' + esc(d.subDisputeType) : ''}</div></div>
          <div class="order-detail-item"><div class="label">Result</div><div class="value">${esc(d.disputeResult || 'Pending')}</div></div>
        </div>
        <div style="margin-top:16px;">
          <h4 style="margin-bottom:8px;">Messages</h4>
          <div style="max-height:240px;overflow-y:auto;background:var(--bg-primary);border-radius:10px;padding:12px;margin-bottom:12px;">
            ${(d.messages || []).length === 0 ? '<p style="color:var(--text-quaternary);font-size:13px;">No messages yet</p>' : d.messages.map(m => {
              const label = getSenderLabel(m.sender);
              const labelColor = label === 'You' ? 'var(--accent-green)' : label === 'Customer Support' ? 'var(--accent-blue)' : '#f0a040';
              return `
              <div style="padding:8px;margin-bottom:6px;background:#1e1e2e;border-radius:8px;">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:2px;">
                  <span style="color:${labelColor};font-size:11px;font-weight:600;">${esc(label)}</span>
                  <span style="color:#8888a0;font-size:11px;">${new Date(parseInt(m.timestamp || m.sendTime) || Date.now()).toLocaleString()}</span>
                </div>
                <div style="color:var(--text-primary);font-size:13px;margin-top:2px;">${esc(m.messageText || m.content || '-')}</div>
              </div>`;
            }).join('')}
          </div>
          ${(d.imageUrls && d.imageUrls.length > 0) || (d.videoUrls && d.videoUrls.length > 0) ? `
          <div style="margin-bottom:12px;background:var(--bg-primary);border-radius:10px;padding:12px;">
            ${d.imageUrls && d.imageUrls.length > 0 ? `
              <div style="margin-bottom:${d.videoUrls && d.videoUrls.length > 0 ? '8px' : '0'};">
                <span style="color:#8888a0;font-size:11px;display:block;margin-bottom:4px;">📷 Images</span>
                <div style="display:flex;flex-direction:column;gap:4px;">
                  ${d.imageUrls.map(url => `<a href="${esc(url)}" target="_blank" rel="noopener" style="color:var(--accent-blue);font-size:12px;word-break:break-all;">${esc(url)}</a>`).join('')}
                </div>
              </div>
            ` : ''}
            ${d.videoUrls && d.videoUrls.length > 0 ? `
              <div>
                <span style="color:#8888a0;font-size:11px;display:block;margin-bottom:4px;">🎥 Videos</span>
                <div style="display:flex;flex-direction:column;gap:4px;">
                  ${d.videoUrls.map(url => `<a href="${esc(url)}" target="_blank" rel="noopener" style="color:var(--accent-blue);font-size:12px;word-break:break-all;">${esc(url)}</a>`).join('')}
                </div>
              </div>
            ` : ''}
          </div>
          ` : ''}
          <form data-on-submit="sendDisputeMessage(event, '${esc(orderId)}')" style="display:flex;gap:8px;">
            <input id="dispute-msg-input" style="flex:1;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;" placeholder="Type a message..." required>
            <button type="submit" class="btn btn-primary btn-sm">Send</button>
          </form>
        </div>
        <div style="display:flex;gap:8px;margin-top:16px;">
          <button class="btn btn-danger btn-sm" data-on-click="cancelDispute('${esc(orderId)}')">Cancel Dispute</button>
          <button class="btn btn-secondary btn-sm" data-on-click="this.closest('.modal-overlay').remove()">Close</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
  } catch (err) { showToast(err.message, 'error'); }
}

async function sendDisputeMessage(e, orderId) {
  e.preventDefault();
  const input = document.getElementById('dispute-msg-input');
  const text = input.value;
  input.value = '';
  try {
    await API.post('/api/okx/p2p/dispute/' + orderId + '/message', { messageText: text });
    document.querySelectorAll('.modal-overlay').forEach(el => el.remove());
    viewDispute(orderId);
    showToast('Message sent', 'success');
  } catch (err) { showToast(err.message, 'error'); input.value = text; }
}

async function cancelDispute(orderId) {
  if (!confirm('Cancel this dispute?')) return;
  try {
    await API.post('/api/okx/p2p/dispute/' + orderId + '/cancel');
    document.querySelector('.modal-overlay')?.remove();
    navigate('disputes');
    showToast('Dispute cancelled', 'info');
  } catch (err) { showToast(err.message, 'error'); }
}

window._rdState = null;

window.raiseDispute = async function(orderId, side) {
  window._rdState = { types: [], selectedType: null, selectedSubType: null, orderId: orderId, side: side || 'buy' };

  const existingOverlay = document.querySelector('.modal-overlay[data-rd="1"]');
  if (existingOverlay) existingOverlay.remove();

  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.setAttribute('data-rd', '1');
  overlay.innerHTML = `
    <div class="modal-content" style="max-width:520px;">
      <h3>Raise Dispute</h3>
      <div id="rd-loading" style="text-align:center;padding:40px 0;">
        <div style="color:#8888a0;font-size:13px;">Loading dispute types...</div>
      </div>
      <div class="rd-body" style="min-height:80px;"></div>
    </div>`;
  document.body.appendChild(overlay);

  try {
    const res = await API.get('/api/okx/p2p/dispute/types?orderId=' + orderId + '&side=' + (side || 'buy'));
    const raw = res.data;
    let types = [];
    if (raw && typeof raw === 'object') {
      if (Array.isArray(raw)) {
        const sideData = side === 'sell' ? raw[0]?.sell : raw[0]?.buy;
        types = sideData || raw[0]?.buy || [];
      } else {
        const sideData = side === 'sell' ? raw.sell : raw.buy;
        types = sideData || raw.buy || [];
      }
    }
    if (!Array.isArray(types) || types.length === 0) {
      throw new Error('No dispute types available for this order');
    }
    window._rdState.types = types;
    document.getElementById('rd-loading')?.remove();
    _rdRenderStep1();
  } catch (err) {
    const loading = document.getElementById('rd-loading');
    if (loading) {
      loading.innerHTML = `<div style="color:#f44336;font-size:13px;padding:20px 0;">❌ ${esc(err.message)}</div>
        <div style="margin-top:12px;"><button class="btn btn-secondary btn-sm" data-on-click="this.closest('.modal-overlay').remove()">Close</button></div>`;
    }
  }
};

window._rdSelect = function(what, index) {
  const state = window._rdState;
  if (!state) return;

  if (what === 'type') {
    if (state.types[index]) {
      state.selectedType = state.types[index];
      state.selectedSubType = null;
    }
    const labels = document.querySelectorAll('[data-rd-body] .rd-type-label');
    labels.forEach((l, i) => {
      l.style.background = i === index ? 'rgba(68,138,255,0.1)' : '#1a1a2e';
      l.style.borderColor = i === index ? 'rgba(68,138,255,0.4)' : '#1e1e2e';
    });
    const nextBtn = document.getElementById('rd-next-btn');
    if (nextBtn) nextBtn.disabled = false;
  } else if (what === 'subtype') {
    if (state.selectedType && state.selectedType.subType && state.selectedType.subType[index]) {
      state.selectedSubType = state.selectedType.subType[index];
    }
    const labels = document.querySelectorAll('[data-rd-body] .rd-subtype-label');
    labels.forEach((l, i) => {
      l.style.background = i === index ? 'rgba(68,138,255,0.1)' : '#1a1a2e';
      l.style.borderColor = i === index ? 'rgba(68,138,255,0.4)' : '#1e1e2e';
    });
    const nextBtn = document.getElementById('rd-next-btn');
    if (nextBtn) nextBtn.disabled = false;
  }
};

window._rdNext = function() {
  const state = window._rdState;
  if (!state) return;
  const body = document.querySelector('[data-rd-body]');
  if (!body) return;

  if (body.querySelector('.rd-type-label')) {
    if (!state.selectedType) { showToast('Please select a reason', 'error'); return; }
    _rdRenderStep2();
  } else if (body.querySelector('.rd-subtype-label')) {
    if (state.selectedType && state.selectedType.subType && state.selectedType.subType.length > 0 && !state.selectedSubType) {
      showToast('Please select a sub-reason', 'error'); return;
    }
    _rdRenderStep3();
  }
};

window._rdBack = function() {
  const body = document.querySelector('[data-rd-body]');
  if (!body) return;
  if (body.querySelector('.rd-subtype-label') || body.querySelector('.rd-review-area')) {
    if (body.querySelector('.rd-subtype-label')) {
      _rdRenderStep1();
    } else {
      _rdRenderStep2();
    }
  } else {
    _rdRenderStep1();
  }
};

window._rdSubmit = async function() {
  const state = window._rdState;
  if (!state || !state.selectedType) { showToast('Please select a dispute reason', 'error'); return; }

  const imageUrls = document.getElementById('rd-image-urls')?.value?.split('\n').map(s => s.trim()).filter(Boolean) || [];
  const videoUrls = document.getElementById('rd-video-urls')?.value?.split('\n').map(s => s.trim()).filter(Boolean) || [];
  const remarkText = document.getElementById('rd-remark')?.value?.trim() || '';

  const submitBtn = document.getElementById('rd-submit-btn');
  const errorEl = document.getElementById('rd-error');
  if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting...'; }
  if (errorEl) errorEl.style.display = 'none';

  try {
    await API.post('/api/okx/p2p/dispute/create', {
      orderId: state.orderId,
      disputeType: state.selectedType.code,
      subDisputeType: state.selectedSubType ? state.selectedSubType.code : '',
      messageText: remarkText,
      imageUrls: imageUrls,
      videoUrls: videoUrls
    });
    document.querySelector('.modal-overlay[data-rd="1"]')?.remove();
    window._rdState = null;
    showToast('Dispute raised successfully', 'success');
    const hash = window.location.hash?.slice(1) || '';
    if (hash === 'disputes' || hash === '/disputes') {
      const cont = document.querySelector('.content');
      if (cont) renderDisputes(cont);
    }
  } catch (err) {
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit Dispute'; }
    if (errorEl) { errorEl.style.display = 'block'; errorEl.textContent = '❌ ' + err.message; }
    showToast(err.message, 'error');
  }
};

function _rdRenderStep1() {
  const state = window._rdState;
  const overlay = document.querySelector('.modal-overlay[data-rd="1"]');
  if (!overlay || !state) return;
  const container = overlay.querySelector('.modal-content');
  if (!container) return;

  const header = container.querySelector('h3');
  let html = '';
  if (header) html += header.outerHTML;
  html += `<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Select a reason for this dispute:</p>`;
  html += `<div data-rd-body style="min-height:80px;">`;
  html += `<div style="display:flex;flex-direction:column;gap:8px;margin-bottom:16px;">`;
  state.types.forEach((t, i) => {
    const checked = state.selectedType && state.selectedType.code === t.code;
    html += `
      <label class="rd-type-label" data-on-click="_rdSelect('type',${i})" style="display:flex;align-items:flex-start;gap:10px;padding:10px 12px;background:${checked ? 'rgba(68,138,255,0.1)' : '#1a1a2e'};border:1px solid ${checked ? 'rgba(68,138,255,0.4)' : '#1e1e2e'};border-radius:10px;cursor:pointer;transition:all 0.15s;">
        <input type="radio" name="rd-type" value="${i}" ${checked ? 'checked' : ''} style="margin-top:2px;accent-color:var(--accent-blue);" data-on-click="_rdSelect('type',${i})">
        <div style="flex:1;">
          <div style="color:var(--text-primary);font-size:13px;font-weight:500;">${esc(t.subReason || 'Reason ' + (i + 1))}</div>
          ${t.suggestions && t.suggestions.length > 0 ? `<div style="color:var(--text-quaternary);font-size:11px;margin-top:2px;">${esc(t.suggestions[0].suggestText || '')}</div>` : ''}
        </div>
      </label>`;
  });
  html += `</div>`;
  html += `<div style="display:flex;gap:8px;justify-content:flex-end;border-top:1px solid #1e1e2e;padding-top:16px;margin-top:8px;">
    <button class="btn btn-secondary btn-sm" data-on-click="this.closest('.modal-overlay').remove()">Cancel</button>
    <button class="btn btn-danger btn-sm" id="rd-next-btn" ${state.selectedType ? '' : 'disabled'} data-on-click="_rdNext()">Next</button>
  </div></div>`;

  container.innerHTML = html;
}

function _rdRenderStep2() {
  const state = window._rdState;
  const overlay = document.querySelector('.modal-overlay[data-rd="1"]');
  if (!overlay || !state || !state.selectedType) return _rdRenderStep1();
  const container = overlay.querySelector('.modal-content');
  if (!container) return;

  const st = state.selectedType.subType || [];
  const header = container.querySelector('h3');
  let html = '';
  if (header) html += header.outerHTML;

  if (!st || st.length === 0) {
    _rdRenderStep3();
    return;
  }

  html += `<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Select sub-reason for <strong style="color:var(--text-primary);">${esc(state.selectedType.subReason)}</strong>:</p>`;
  html += `<div data-rd-body style="min-height:80px;">`;
  html += `<div style="display:flex;flex-direction:column;gap:8px;margin-bottom:16px;">`;
  st.forEach((sub, i) => {
    const checked = state.selectedSubType && state.selectedSubType.code === sub.code;
    html += `
      <label class="rd-subtype-label" data-on-click="_rdSelect('subtype',${i})" style="display:flex;align-items:flex-start;gap:10px;padding:10px 12px;background:${checked ? 'rgba(68,138,255,0.1)' : '#1a1a2e'};border:1px solid ${checked ? 'rgba(68,138,255,0.4)' : '#1e1e2e'};border-radius:10px;cursor:pointer;transition:all 0.15s;">
        <input type="radio" name="rd-subtype" value="${i}" ${checked ? 'checked' : ''} style="margin-top:2px;accent-color:var(--accent-blue);" data-on-click="_rdSelect('subtype',${i})">
        <div style="flex:1;color:var(--text-primary);font-size:13px;">${esc(sub.subReason || 'Option ' + (i + 1))}</div>
      </label>`;
  });
  html += `</div>`;
  html += `<div style="display:flex;gap:8px;justify-content:flex-end;border-top:1px solid #1e1e2e;padding-top:16px;margin-top:8px;">
    <button class="btn btn-secondary btn-sm" data-on-click="_rdBack()">Back</button>
    <button class="btn btn-danger btn-sm" id="rd-next-btn" ${state.selectedSubType ? '' : 'disabled'} data-on-click="_rdNext()">Next</button>
  </div></div>`;

  container.innerHTML = html;
}

function _rdRenderStep3() {
  const state = window._rdState;
  const overlay = document.querySelector('.modal-overlay[data-rd="1"]');
  if (!overlay || !state || !state.selectedType) return _rdRenderStep1();
  const container = overlay.querySelector('.modal-content');
  if (!container) return;

  const suggestions = state.selectedType.suggestions || [];
  const needsImage = state.selectedType.isImageSubmissionNeeded;
  const needsVideo = state.selectedType.isVideoSubmissionNeeded;
  const needsRemark = state.selectedType.isRemarkSubmissionNeeded;

  const header = container.querySelector('h3');
  let html = '';
  if (header) html += header.outerHTML;
  html += `<div data-rd-body style="min-height:80px;">`;
  html += `<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:12px;">Review and submit your dispute for <strong style="color:var(--text-primary);">${esc(state.selectedType.subReason)}</strong>${state.selectedSubType ? ' <span style="color:#8888a0;">→</span> <strong style="color:var(--text-primary);">' + esc(state.selectedSubType.subReason) + '</strong>' : ''}</p>`;

  if (suggestions.length > 0) {
    html += `<div class="rd-review-area" style="background:#0d1b2a;border:1px solid rgba(68,138,255,0.2);border-radius:10px;padding:12px;margin-bottom:16px;">`;
    suggestions.forEach(s => {
      if (s.suggestText) {
        html += `<p style="color:#8899bb;font-size:12px;line-height:1.5;margin-bottom:${suggestions.length > 1 ? '8px' : '0'};">💡 ${esc(s.suggestText)}</p>`;
      }
    });
    html += `</div>`;
  }

  if (needsImage) {
    html += `
      <div style="margin-bottom:12px;">
        <label style="color:#8888a0;font-size:12px;display:block;margin-bottom:4px;">Image URLs (one per line)</label>
        <textarea id="rd-image-urls" rows="2" placeholder="https://example.com/image1.jpg" style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;resize:vertical;box-sizing:border-box;font-family:inherit;"></textarea>
      </div>`;
  }
  if (needsVideo) {
    html += `
      <div style="margin-bottom:12px;">
        <label style="color:#8888a0;font-size:12px;display:block;margin-bottom:4px;">Video URLs (one per line)</label>
        <textarea id="rd-video-urls" rows="2" placeholder="https://example.com/video.mp4" style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;resize:vertical;box-sizing:border-box;font-family:inherit;"></textarea>
      </div>`;
  }
  if (needsRemark) {
    html += `
      <div style="margin-bottom:12px;">
        <label style="color:#8888a0;font-size:12px;display:block;margin-bottom:4px;">Description</label>
        <textarea id="rd-remark" rows="3" placeholder="Describe the issue in detail..." style="width:100%;padding:10px 14px;border-radius:10px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:13px;outline:none;resize:vertical;box-sizing:border-box;font-family:inherit;"></textarea>
      </div>`;
  }

  html += `<div id="rd-error" style="color:#f44336;font-size:12px;margin-bottom:8px;display:none;"></div>`;
  html += `<div style="display:flex;gap:8px;justify-content:flex-end;border-top:1px solid #1e1e2e;padding-top:16px;margin-top:8px;">
    <button class="btn btn-secondary btn-sm" data-on-click="_rdBack()">Back</button>
    <button class="btn btn-danger btn-sm" id="rd-submit-btn" data-on-click="_rdSubmit()">Submit Dispute</button>
  </div></div>`;

  container.innerHTML = html;
}

/* ==== js/modules/okx/chat.js ==== */
var _chatOrders = [];
var _chatActiveOrder = null;
var _chatPollTimer = null;
var _chatTypingTimer = null;
var _chatRefreshCount = 0;

function getCPName(o) {
  var cp = o.counterpartyDetail || {};
  return cp.nickName || cp.realName || cp.userName || cp.takerName || cp.sellerName || o.counterpartNickName || o.makerNickName || o.takerNickName || '';
}

function getAlias(o) {
  var name = getCPName(o);
  if (name) return name;
  var sellerName = '';
  try { var cp = o.counterpartyDetail || {}; sellerName = cp.sellerName || cp.userName || ''; } catch(e) {}
  if (sellerName) return sellerName;
  return 'Order ' + (o.orderId || '').slice(0, 8);
}

async function renderChat(container) {
  if (!container) return;
  if (window._chatCurrentContainer) { if (_chatPollTimer) clearInterval(_chatPollTimer); _chatOrders = []; _chatActiveOrder = null; }
  window._chatCurrentContainer = container;

  container.innerHTML = '<div class="page-header"><h2>💬 Messages</h2><div class="subtitle">Your order conversations</div></div><div id="chat-layout" style="display:flex;gap:8px;margin:8px auto 0;max-width:720px;min-height:calc(100vh - 200px);"><div id="chat-conversations" style="width:200px;flex-shrink:0;overflow-y:auto;font-size:12px;"><div style="font-size:11px;color:var(--text-quaternary);margin-bottom:6px;padding:0 4px;">Loading conversations...</div></div><div id="chat-main" style="flex:1;display:flex;align-items:center;justify-content:center;min-height:400px;"><div style="text-align:center;color:var(--text-quaternary);font-size:13px;">Select a conversation to view messages</div></div></div>';
  if (typeof bindClickHandlers === 'function') bindClickHandlers(container);

  try {
    var res = await API.get('/api/okx/p2p/order-list?pageSize=50&pageIndex=1&completionStatus=all');
    _chatOrders = res.data || [];
    renderConversations();
  } catch (e) {
    var needsKeys = e && e.message && (e.message.includes('keys') || e.message.includes('configured'));
    document.getElementById('chat-conversations').innerHTML = needsKeys
      ? '<div style="font-size:12px;color:#ff9800;padding:12px;">Configure your OKX API keys in <a href="/settings/api-config" data-on-click="navigate(\'settings-api\');return false;" style="color:#448aff;">Settings → API Config</a> to view your order conversations.</div>'
      : '<div style="font-size:12px;color:#f44336;padding:12px;">Failed to load orders. ' + (e.message || '') + '</div>';
  }

  if (_chatPollTimer) clearInterval(_chatPollTimer);
  _chatPollTimer = setInterval(function() { if (!document.hidden) pollChat(); }, 30000);
  window._chatPollTimer = _chatPollTimer;
}

function renderConversations() {
  var el = document.getElementById('chat-conversations');
  if (!el) return;
  var sorted = _chatOrders.slice().sort(function(a, b) {
    var ta = Number(a.completionTimestamp || a.latestMessageTimestamp || a.orderCreateTime || 0);
    var tb = Number(b.completionTimestamp || b.latestMessageTimestamp || b.orderCreateTime || 0);
    return tb - ta;
  });
  var html = '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:6px;padding:0 4px;">' + _chatOrders.length + ' orders</div>';
  sorted.forEach(function(o) {
    var id = o.orderId || o.order_id || '';
    var isActive = _chatActiveOrder === id;
    var alias = getAlias(o);
    var crypto = o.cryptoCurrency || 'USDT';
    var fiat = o.fiatAmount ? (o.fiatCurrency || 'KES') + ' ' + o.fiatAmount : '';
    var sideLabel = o.side === 'sell' ? 'Sell' : 'Buy';
    var unread = '';
    try {
      var read = JSON.parse(localStorage.getItem('chat_read') || '{}');
      if (read[id]) { var d = read[id]; if (d && d.c) unread = d.c; }
    } catch {}
    html += '<div id="chat-conv-' + id + '" style="padding:8px 10px;border-radius:6px;cursor:pointer;margin-bottom:2px;background:' + (isActive ? 'rgba(68,138,255,0.15)' : 'transparent') + ';border:1px solid ' + (isActive ? 'rgba(68,138,255,0.3)' : 'transparent') + ';" data-on-click="selectChatConversation(\'' + esc(id) + '\')"><div style="font-size:12px;font-weight:600;color:var(--text-primary);display:flex;align-items:center;gap:6px;">' + esc(alias) + '<span id="chat-badge-' + id + '" style="display:none;background:#f44336;color:#fff;border-radius:10px;padding:1px 6px;font-size:9px;font-weight:700;"></span></div><div style="font-size:10px;color:var(--text-quaternary);margin-top:2px;">' + crypto + ' · ' + fiat + ' · ' + sideLabel + '</div></div>';
  });
  el.innerHTML = html;
  if (typeof bindClickHandlers === 'function') bindClickHandlers(el);
  _chatUpdateBadges(sorted);
}

var _chatBadgeCache = {};
var _chatBadgeQueue = Promise.resolve();

function _chatSetBadge(id, unread) {
  var badge = document.getElementById('chat-badge-' + id);
  if (!badge) return;
  if (unread > 0) { badge.style.display = 'inline'; badge.textContent = unread; }
  else badge.style.display = 'none';
}

function _chatUpdateBadges(orders) {
  if (document.hidden) return;
  orders.forEach(function(o) {
    var id = o.orderId || o.order_id || '';
    if (!id || id === _chatActiveOrder) return;
    var cached = _chatBadgeCache[id];
    if (cached && Date.now() - cached.ts < 60000) {
      _chatSetBadge(id, cached.unread);
      return;
    }
    _chatBadgeQueue = _chatBadgeQueue.then(function() {
      if (document.hidden) return;
      return API.getOkxChatHistory(id).then(function(r) {
        var unread = _chatGetUnread(id, r.data || []);
        _chatBadgeCache[id] = { unread: unread, ts: Date.now() };
        _chatSetBadge(id, unread);
      }).catch(function() {});
    });
  });
}

window.selectChatConversation = async function(orderId) {
  _chatActiveOrder = orderId;
  _chatMarkRead(orderId);
  renderConversations();
  var main = document.getElementById('chat-main');
  if (!main) return;
  main.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;min-height:200px;"><div style="color:var(--text-quaternary);font-size:12px;">Loading messages...</div></div>';
  if (typeof bindClickHandlers === 'function') bindClickHandlers(main);
  try {
    var [chatRes, orderRes] = await Promise.all([
      API.getOkxChatHistory(orderId),
      API.getOrder(orderId).catch(function() { return { data: null }; })
    ]);
    var msgs = chatRes.data || [];
    // Check order details for payment proof URLs
    if (orderRes && orderRes.data) {
      var order = orderRes.data;
      // Look for payment proof in order data
      var proofUrls = order.paymentProofFileUrls || order.paymentProofUrls || order.proofUrls || [];
      if (typeof proofUrls === 'string') proofUrls = [proofUrls];
      if (proofUrls && proofUrls.length) {
        proofUrls.forEach(function(url) {
          // Add as a counterparty message if not already in chat
          if (url && !msgs.some(function(m) { return m.contentUrl === url; })) {
            msgs.push({ content: '', contentUrl: url, sentBySelf: false, sentTimestamp: String(Date.now()) });
          }
        });
      }
    }
    renderChatMessages(orderId, msgs);
  } catch (e) {
    renderChatMessages(orderId, []);
  }
};

function _chatTimeStr(time) {
  if (!time) return '';
  var t = String(time).trim();
  if (!t) return '';
  var d = null;
  if (/^\d+$/.test(t)) {
    d = new Date(Number(t));
  } else if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(t)) {
    d = new Date(t.replace(' ', 'T'));
  } else {
    d = new Date(t);
  }
  if (!d || isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function _chatSafeMedia(url) {
  var u = String(url || '').trim();
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  if (/^data:image\//i.test(u)) return u;
  if (/^data:video\//i.test(u)) return u;
  return '';
}

function _chatMsgHtml(m) {
  var text = m.message || m.content || m.msg || '';
  var time = m.createdAt || m.createTime || m.sentTimestamp || '';
  var isMe = m.sentBySelf === true || m.sentBySelf === 1 || m.sent_by_self === 1 || m.sent_by_self === true;
  var imgHtml = '';
  var media = _chatSafeMedia(m.contentUrl);
  if (media) {
    imgHtml = '<div style="margin-bottom:4px;"><a href="' + esc(media) + '" target="_blank" rel="noopener"><img src="' + esc(media) + '" style="max-width:180px;max-height:180px;border-radius:6px;display:block;cursor:pointer;" onerror="this.style.display=\'none\'"></a></div>';
  }
  var shortTime = _chatTimeStr(time);
  return '<div style="margin-bottom:6px;text-align:' + (isMe ? 'right' : 'left') + ';"><div style="display:inline-block;max-width:70%;padding:6px 10px;border-radius:8px;background:' + (isMe ? 'linear-gradient(135deg,#00e676,#00c853)' : '#448aff') + ';color:' + (isMe ? 'var(--text-on-accent)' : '#fff') + ';font-size:12px;text-align:left;word-break:break-word;box-shadow:0 1px 3px rgba(0,0,0,0.3);">' + imgHtml + (text ? '<div>' + esc(text) + '</div>' : '') + '<div style="font-size:8px;color:' + (isMe ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.5)') + ';margin-top:2px;text-align:right;">' + shortTime + '</div></div></div>';
}

function renderChatMessages(orderId, messages) {
  var main = document.getElementById('chat-main');
  if (!main) return;
  var order = _chatOrders.find(function(o) { return (o.orderId || o.order_id) === orderId; });
  var alias = order ? getAlias(order) : 'Conversation';
  var crypto = order ? (order.cryptoCurrency || 'USDT') : 'USDT';
  var fiat = order ? (order.fiatAmount || '') : '';
  var cur = order ? (order.fiatCurrency || 'KES') : 'KES';
  var sideLabel = order ? (order.side === 'sell' ? 'Sold' : 'Bought') : '';
  main.style.alignItems = 'stretch';
  main.style.justifyContent = 'stretch';
  main.innerHTML = '<div style="display:flex;flex-direction:column;flex:1;min-height:400px;border:1px solid var(--border-primary);border-radius:8px;overflow:hidden;"><div style="padding:8px 12px;border-bottom:1px solid #1e1e2e;background:var(--bg-primary);"><div style="font-size:12px;font-weight:600;color:var(--text-primary);">' + esc(alias) + '</div><div style="font-size:10px;color:var(--text-tertiary);">' + sideLabel + ' ' + crypto + ' · ' + cur + ' ' + fiat + '</div></div><div id="chat-msgs-' + orderId + '" style="flex:1;overflow-y:auto;padding:6px 8px;background:var(--bg-secondary);"></div><div id="chat-typing-' + orderId + '" style="display:none;padding:1px 12px 4px;font-size:10px;color:var(--text-tertiary);font-style:italic;background:var(--bg-secondary);">typing...</div><div style="display:flex;gap:4px;padding:6px 8px;border-top:1px solid #1e1e2e;background:var(--bg-primary);"><input type="text" id="chat-input-' + orderId + '" placeholder="Message..." style="flex:1;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-input);color:var(--text-primary);font-size:12px;outline:none;" onkeydown="if(event.key===\'Enter\')sendChatMessage(\'' + orderId + '\')" oninput="showTypingIndicator(\'' + orderId + '\')"><button class="btn btn-sm" style="padding:4px 8px;background:#1e1e2e;border:none;border-radius:5px;color:var(--text-primary);cursor:pointer;font-size:14px;line-height:1;" data-on-click="showChatAttachmentOptions(\'' + orderId + '\')" title="Attach">+</button><button class="btn btn-primary btn-sm" data-on-click="sendChatMessage(\'' + orderId + '\')" style="padding:6px 12px;font-size:11px;">Send</button></div></div>';
  if (typeof bindClickHandlers === 'function') bindClickHandlers(main);
  var msgsEl = document.getElementById('chat-msgs-' + orderId);
  if (!msgsEl) return;
  if (!messages || messages.length === 0) {
    msgsEl.innerHTML = '<div style="text-align:center;color:var(--text-quaternary);font-size:12px;padding:40px 0;">No messages yet. Start the conversation!</div>';
    return;
  }
  msgsEl.innerHTML = messages.map(_chatMsgHtml).join('');
  msgsEl.scrollTop = msgsEl.scrollHeight;
}

window.sendChatMessage = async function(orderId, contentType, contentUrl) {
  var msg = '';
  var isMedia = contentType && contentType !== '101';
  if (isMedia) {
    if (!contentUrl) return;
  } else {
    var input = document.getElementById('chat-input-' + orderId);
    if (!input) return;
    msg = input.value.trim();
    if (!msg) return;
    input.value = '';
  }
  try {
    var payload = { contentType: contentType || '101' };
    if (isMedia) {
      payload.contentUrl = contentUrl;
    } else {
      payload.content = msg;
    }
    await API.post('/api/okx/p2p/chat/' + orderId, payload);
    pollChat();
  } catch (e) {
    try {
      if (isMedia) return;
      await API.sendChatMessage(orderId, msg);
      pollChat();
    } catch (e2) {}
  }
};

window.showChatAttachmentOptions = function(orderId) {
  var existing = document.getElementById('chat-attach-dropdown');
  if (existing) { existing.remove(); return; }
  var dropdown = document.createElement('div');
  dropdown.id = 'chat-attach-dropdown';
  dropdown.style.cssText = 'position:fixed;background:var(--bg-input);border:1px solid var(--border-primary);border-radius:8px;padding:4px;z-index:1000;min-width:140px;box-shadow:0 4px 16px rgba(0,0,0,0.4);';
  dropdown.innerHTML = '<div data-on-click="sendChatImage(\'' + orderId + '\')" style="padding:8px 14px;cursor:pointer;border-radius:6px;font-size:12px;color:var(--text-primary);display:flex;align-items:center;gap:8px;">🖼 Send Image</div><div data-on-click="sendChatVideo(\'' + orderId + '\')" style="padding:8px 14px;cursor:pointer;border-radius:6px;font-size:12px;color:var(--text-primary);display:flex;align-items:center;gap:8px;">🎬 Send Video</div>';
  var btn = document.querySelector('#chat-main button[data-on-click*="showChatAttachmentOptions"]');
  if (btn) {
    var rect = btn.getBoundingClientRect();
    dropdown.style.left = Math.max(4, rect.left) + 'px';
    dropdown.style.bottom = (window.innerHeight - rect.top + 4) + 'px';
  } else {
    dropdown.style.left = '100px';
    dropdown.style.top = '200px';
  }
  dropdown.addEventListener('mouseleave', function() { this.remove(); });
  document.body.appendChild(dropdown);
  if (typeof bindClickHandlers === 'function') bindClickHandlers(dropdown);
};

window._chatPickFile = function(orderId, accept, contentType, maxSize) {
  var existing = document.getElementById('chat-attach-dropdown');
  if (existing) existing.remove();
  var input = document.createElement('input');
  input.type = 'file';
  input.accept = accept;
  input.onchange = function(e) {
    var file = e.target.files[0];
    if (!file) return;
    if (file.size > maxSize) { showToast('File too large (max ' + Math.round(maxSize / 1024 / 1024) + 'MB)', 'error'); return; }
    var reader = new FileReader();
    reader.onload = async function(ev) {
      await sendChatMessage(orderId, contentType, ev.target.result);
    };
    reader.readAsDataURL(file);
  };
  input.click();
};

window.sendChatImage = function(orderId) {
  window._chatPickFile(orderId, 'image/*', '102', 10 * 1024 * 1024);
};

window.sendChatVideo = function(orderId) {
  window._chatPickFile(orderId, 'video/*', '112', 50 * 1024 * 1024);
};

// Close attachment dropdown on outside click
document.addEventListener('click', function(e) {
  var dd = document.getElementById('chat-attach-dropdown');
  if (dd && !dd.contains(e.target) && !e.target.matches('[data-on-click*="showChatAttachmentOptions"]')) {
    dd.remove();
  }
});



document.addEventListener('sse_chat_message', function(e) {
  if (_chatActiveOrder && e.detail && e.detail.orderId === _chatActiveOrder) {
    var typingEl = document.getElementById('chat-typing-' + _chatActiveOrder);
    if (typingEl) typingEl.style.display = 'block';
    setTimeout(function() {
      if (typingEl) typingEl.style.display = 'none';
      pollChat();
    }, 600);
  }
});

window.showTypingIndicator = function(orderId) {
  var typingEl = document.getElementById('chat-typing-' + orderId);
  if (!typingEl) return;
  typingEl.style.display = 'none';
  var input = document.getElementById('chat-input-' + orderId);
  if (input && input.value.trim()) {
    typingEl.style.display = 'block';
    if (_chatTypingTimer) clearTimeout(_chatTypingTimer);
    _chatTypingTimer = setTimeout(function() {
      var te = document.getElementById('chat-typing-' + orderId);
      if (te) te.style.display = 'none';
    }, 2000);
  }
};

function _chatMarkRead(orderId) {
  try {
    var read = JSON.parse(localStorage.getItem('chat_read') || '{}');
    read[orderId] = Date.now();
    localStorage.setItem('chat_read', JSON.stringify(read));
  } catch {}
}

function _chatGetUnread(orderId, messages) {
  try {
    var read = JSON.parse(localStorage.getItem('chat_read') || '{}');
    var lastRead = read[orderId] || 0;
    return messages.filter(function(m) { return !m.sentBySelf && (Number(m.sentTimestamp) || 0) > lastRead; }).length;
  } catch { return 0; }
}

window.renderChat = renderChat;

async function pollChat() {
  _chatRefreshCount++;
  // Refresh conversation list every 5 polls (~30s)
  if (_chatRefreshCount % 5 === 0) {
    API.get('/api/okx/p2p/order-list?pageSize=50&pageIndex=1&completionStatus=all').then(function(res) {
      _chatOrders = res.data || [];
      renderConversations();
    }).catch(function(){});
  }
  if (!_chatActiveOrder) return;
  try {
    var res = await API.getOkxChatHistory(_chatActiveOrder);
    var msgsEl = document.getElementById('chat-msgs-' + _chatActiveOrder);
    if (!msgsEl) return;
    var msgs = res.data || [];
    if (!msgs || msgs.length === 0) {
      msgsEl.innerHTML = '<div style="text-align:center;color:var(--text-quaternary);font-size:12px;padding:40px 0;">No messages yet</div>';
      return;
    }
    msgsEl.innerHTML = msgs.map(_chatMsgHtml).join('');
    msgsEl.scrollTop = msgsEl.scrollHeight;
  } catch (e) {}
}

/* ==== js/modules/okx/paymentMethods.js ==== */
function _pmTypeColor(type) {
  var map = {
    BANK: { bg: 'rgba(68,138,255,0.15)', color: '#448aff' },
    MPESA: { bg: 'rgba(0,200,83,0.15)', color: '#00c853' },
    ALIPAY: { bg: 'rgba(233,30,99,0.15)', color: '#e91e63' },
    PAYPAL: { bg: 'rgba(0,150,255,0.15)', color: '#0096ff' },
    WISE: { bg: 'rgba(0,200,200,0.15)', color: '#00c8c8' },
    PESALINK: { bg: 'rgba(156,39,176,0.15)', color: '#9c27b0' },
    RTGS: { bg: 'rgba(255,152,0,0.15)', color: '#ff9800' },
    SKRILL: { bg: 'rgba(0,150,136,0.15)', color: '#009688' },
    NETELLER: { bg: 'rgba(233,30,99,0.15)', color: '#e91e63' },
    PERFECT_MONEY: { bg: 'rgba(0,150,255,0.15)', color: '#0096ff' },
  };
  return map[type] || { bg: 'rgba(91,124,250,0.1)', color: '#5b7cfa' };
}

// Returns details rows array for any payment method from OKX API fields
function _pmDetailRows(m) {
  var rows = [];
  var type = (m.type || '').toUpperCase();
  var num = m.paymentMethodNumber || '';
  var name = m.paymentMethodName || '';
  var desc = m.paymentDescription || '';
  var bankName = m.bankName || '';
  var bankCode = m.bankCode || '';
  var branch = m.bankBranchName || '';
  var qr = m.paymentMethodQrCodeUrl || '';
  var linked = m.adsLinkedCount || '0';
  var instant = m.isInstantSettlePayment;

  if (type === 'MPESA') {
    rows.push({ label: 'Paybill Number', value: num, mono: true, highlight: true });
    // The accountNo was sent as accountNo in details, OKX returns it as paymentMethodNumber
    // Extra account ref can be stored in description
  } else if (type === 'BANK' || type === 'WISE' || type === 'RTGS') {
    if (bankName) rows.push({ label: 'Bank Name', value: bankName });
    if (bankCode) rows.push({ label: 'Bank Code', value: bankCode, mono: true });
    if (branch) rows.push({ label: 'Branch', value: branch });
    if (num) rows.push({ label: 'Account Number', value: num, mono: true });
  } else {
    if (num) rows.push({ label: 'Account / ID', value: num, mono: true });
    if (bankName) rows.push({ label: 'Bank', value: bankName });
  }
  if (name) rows.push({ label: 'Account Name', value: name });
  if (desc) rows.push({ label: 'Description', value: desc, span: 2 });
  if (qr) rows.push({ label: 'QR Code', value: qr, isUrl: true });
  rows.push({ label: 'Ads Linked', value: linked });
  if (instant !== undefined) rows.push({ label: 'Instant Settle', value: instant === true || instant === 'true' ? 'Yes' : 'No' });
  return rows;
}

function _pmCard(m) {
  var id = m.paymentMethodId || m._id || m.id || '';
  var type = (m.type || 'BANK').toUpperCase();
  var currency = m.currency || 'KES';
  var isEnabled = m.isDisabled !== true && m.isDisabled !== 'true';
  var tc = _pmTypeColor(type);
  var rows = _pmDetailRows(m);

  var detailHtml = rows.map(function(r) {
    if (r.span === 2) return '<div style="grid-column:span 2;"><span style="color:var(--text-quaternary);">' + esc(r.label) + ':</span> <span style="color:var(--text-primary);' + (r.mono ? 'font-family:monospace;' : '') + '">' + esc(r.value) + '</span></div>';
    if (r.highlight) return '<div style="grid-column:span 2;background:rgba(0,200,83,0.08);border-radius:6px;padding:6px 8px;border:1px solid rgba(0,200,83,0.2);"><span style="color:#00c853;font-weight:600;">' + esc(r.label) + ':</span> <span style="color:var(--text-primary);font-family:monospace;font-size:14px;font-weight:700;">' + esc(r.value) + '</span></div>';
    if (r.isUrl) return '<div style="grid-column:span 2;"><span style="color:var(--text-quaternary);">' + esc(r.label) + ':</span> <a href="' + esc(r.value) + '" target="_blank" style="color:#448aff;font-size:11px;word-break:break-all;">' + esc(r.value) + '</a></div>';
    return '<div><span style="color:var(--text-quaternary);">' + esc(r.label) + ':</span> <span style="color:var(--text-primary);' + (r.mono ? 'font-family:monospace;' : '') + '">' + esc(r.value) + '</span></div>';
  }).join('');

  return '<div class="card" style="border-color:' + tc.bg + ';position:relative;">' +
    '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px;">' +
    '<div><span style="display:inline-block;padding:3px 10px;border-radius:6px;background:' + tc.bg + ';color:' + tc.color + ';font-size:11px;font-weight:700;">' + type + '</span>' +
    '<span style="margin-left:6px;font-size:11px;color:var(--text-quaternary);background:#1e1e2e;padding:2px 8px;border-radius:4px;">' + currency + '</span></div>' +
    '<label class="switch" style="position:relative;display:inline-block;width:40px;height:20px;flex-shrink:0;">' +
    '<input type="checkbox" ' + (isEnabled ? 'checked' : '') + ' onchange="togglePaymentMethodStatus(\'' + esc(id) + '\', this.checked)" style="opacity:0;width:0;height:0;">' +
    '<span class="slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:' + (isEnabled ? '#448aff' : '#2a2a3e') + ';border-radius:20px;transition:0.3s;"></span></label>' +
    '</div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;font-size:12px;margin-bottom:10px;">' + detailHtml + '</div>' +
    '<div style="display:flex;gap:6px;border-top:1px solid #1e1e2e;padding-top:10px;">' +
    '<button class="btn btn-sm btn-outline" data-on-click="editPaymentMethod(\'' + esc(id) + '\')" style="font-size:10px;flex:1;">✏️ Edit</button>' +
    '<button class="btn btn-sm btn-outline" data-on-click="deletePaymentMethod(\'' + esc(id) + '\')" style="font-size:10px;flex:1;color:var(--accent-red);border-color:rgba(244,67,54,0.3);">🗑 Delete</button></div></div>';
}

window.renderPaymentMethods = async function (container) {
  if (!container) return;
  const _lu = new Date().toLocaleTimeString();
  let html = '<div class="page-header"><div><h2>Payment Methods</h2><div class="subtitle">Manage your P2P payment accounts · <span id="page-last-updated" style="color:var(--text-quaternary);font-size:11px;">Updated ' + _lu + '</span></div></div><button class="btn btn-primary btn-sm" data-on-click="openPaymentMethodModal()" style="font-size:12px;">+ Add Payment Method</button></div>';
  try {
    var [methodsRes, supportedRes] = await Promise.all([
      API.get('/api/p2p/payment-methods').catch(function() { return { data: [] }; }),
      API.get('/api/p2p/payment-methods/supported?currencies=KES,USD').catch(function() { return { data: [] }; })
    ]);
    var methods = methodsRes.data || [];
    var supported = supportedRes.data || [];

    html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:16px;">';
    supported.forEach(function(s) {
      var raw = s.paymentMethods || s.types || s.supportedPaymentMethods || s.methods || [];
      var types = '';
      if (Array.isArray(raw)) {
        types = raw.map(function(m) {
          if (typeof m === 'string') return m;
          return m.paymentMethod || m.name || m.type || '';
        }).filter(Boolean).join(', ');
      } else {
        types = raw || s.method || s.type || s.name || '';
      }
      if (!types) types = '—';
      html += '<div style="background:rgba(91,124,250,0.06);border:1px solid rgba(68,138,255,0.12);border-radius:10px;padding:12px 16px;"><div style="font-size:11px;color:var(--text-quaternary);">' + esc(s.currency || s.ccy || '?') + ' — Supported</div><div style="font-size:13px;color:var(--text-primary);margin-top:4px;">' + esc(types) + '</div></div>';
    });
    html += '</div>';

    if (methods.length === 0) {
      html += '<div class="card"><div class="empty-state"><div class="icon">💳</div><h4>No payment methods</h4><p style="color:var(--text-quaternary);">Add a payment method to start trading</p></div></div>';
      container.innerHTML = html;
      return;
    }

    html += '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(380px,1fr));gap:14px;">';
    methods.forEach(function(m) { html += _pmCard(m); });
    html += '</div>';
    container.innerHTML = html;
  } catch (err) {
    container.innerHTML = '<div class="card" style="text-align:center;padding:40px;"><p style="color:var(--accent-red);">' + esc(err.message) + '</p><button class="btn btn-sm btn-outline" style="margin-top:12px;" data-on-click="renderPaymentMethods(document.getElementById(\'page-content\'))">Retry</button></div>';
  }
};

window.openPaymentMethodModal = function (existing) {
  var overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  var isEdit = !!existing;
  var d = existing || {};
  var num = d.paymentMethodNumber || '';
  var name = d.paymentMethodName || '';
  var desc = d.paymentDescription || '';
  var bankName = d.bankName || '';
  var bankCode = d.bankCode || '';
  var branch = d.bankBranchName || '';
  var qr = d.paymentMethodQrCodeUrl || '';
  var currencies = ['KES', 'USD', 'EUR', 'GBP', 'NGN', 'TZS', 'UGX', 'ZAR', 'GHS', 'XOF'];
  var typesList = ['BANK', 'MPESA', 'ALIPAY', 'PAYPAL', 'WISE', 'PESALINK', 'RTGS', 'SKRILL', 'NETELLER', 'PERFECT_MONEY'];
  var appTypes = [
    { value: '1', label: 'Deposit (receive payment)' },
    { value: '2', label: 'Withdrawal (make payment)' },
    { value: '0', label: 'Both' }
  ];
  var curOpts = currencies.map(function(c) { return '<option value="' + c + '" ' + ((d.currency || 'KES') === c ? 'selected' : '') + '>' + c + '</option>'; }).join('');
  var typeOpts = typesList.map(function(t) { return '<option value="' + t + '" ' + ((d.type || 'BANK') === t ? 'selected' : '') + '>' + t + '</option>'; }).join('');
  var appOpts = appTypes.map(function(a) { return '<option value="' + a.value + '" ' + ((d.applicationType || '1') == a.value ? 'selected' : '') + '>' + a.label + '</option>'; }).join('');

  overlay.innerHTML = '<div class="modal-content" style="max-width:560px;"><h3>' + (isEdit ? 'Edit' : 'Add') + ' Payment Method</h3><p style="color:var(--text-tertiary);font-size:12px;margin-bottom:12px;">All fields per P2P API (Section 3)</p><form data-on-submit="savePaymentMethod(event' + (isEdit ? ",'" + esc(d.paymentMethodId || d._id || d.id) + "'" : '') + ')"><div class="form-row"><div class="form-group"><label>Currency *</label><select id="pm-currency">' + curOpts + '</select></div><div class="form-group"><label>Type *</label><select id="pm-type" onchange="pmTypeChanged()">' + typeOpts + '</select></div></div><div id="pm-type-specific"><div class="form-group"><label id="pm-account-label">Account / Paybill Number *</label><input id="pm-account-no" value="' + esc(num) + '" placeholder="e.g. 542542"></div></div><div class="form-row"><div class="form-group"><label>Account Name</label><input id="pm-name" value="' + esc(name) + '" placeholder="e.g. M-Pesa Paybill"></div><div class="form-group"><label>Bank Name</label><input id="pm-bank-name" value="' + esc(bankName) + '" placeholder="e.g. Equity Bank"></div></div><div class="form-row"><div class="form-group"><label>Bank Code</label><input id="pm-bank-code" value="' + esc(bankCode) + '" placeholder="e.g. 100"></div><div class="form-group"><label>Branch Name</label><input id="pm-branch" value="' + esc(branch) + '" placeholder="e.g. Nairobi"></div></div><div class="form-group"><label>Description</label><input id="pm-desc" value="' + esc(desc) + '" placeholder="e.g. Paybill 542542, Account 29160"></div><div class="form-row"><div class="form-group"><label>Application Type</label><select id="pm-app-type">' + appOpts + '</select></div><div class="form-group"><label>QR Code URL</label><input id="pm-qr" value="' + esc(qr) + '" placeholder="https://example.com/qr.png"></div></div><div class="form-actions" style="margin-top:16px;"><button type="button" class="btn btn-secondary" data-on-click="this.closest(\'.modal-overlay\').remove()">Cancel</button><button type="submit" class="btn btn-primary">' + (isEdit ? 'Update' : 'Add') + ' Payment Method</button></div></form></div>';
  document.body.appendChild(overlay);
};

// Adjust labels when type changes
window.pmTypeChanged = function() {
  var type = document.getElementById('pm-type');
  var label = document.getElementById('pm-account-label');
  if (!type || !label) return;
  if (type.value === 'MPESA') label.textContent = 'Paybill / Till Number *';
  else label.textContent = 'Account Number *';
};

window.editPaymentMethod = async function (id) {
  try {
    var res = await API.get('/api/p2p/payment-methods/' + id);
    var method = res.data;
    if (!method) { showToast('Payment method not found', 'error'); return; }
    openPaymentMethodModal(method);
  } catch (err) { showToast(err.message, 'error'); }
};

window.savePaymentMethod = async function (e, id) {
  e.preventDefault();
  var currency = document.getElementById('pm-currency').value;
  var type = document.getElementById('pm-type').value;
  var account = document.getElementById('pm-account-no').value.trim();
  var name = document.getElementById('pm-name').value.trim();
  var bank = document.getElementById('pm-bank-name').value.trim();
  var bankCode = document.getElementById('pm-bank-code').value.trim();
  var branch = document.getElementById('pm-branch').value.trim();
  var desc = document.getElementById('pm-desc').value.trim();
  var qr = document.getElementById('pm-qr').value.trim();
  var appType = parseInt(document.getElementById('pm-app-type').value);
  if (!account) { showToast('Account/Paybill number is required', 'error'); return; }
  var details = { accountNo: account };
  if (name) details.paymentMethodName = name;
  if (bank) details.bankName = bank;
  if (bankCode) details.bankCode = bankCode;
  if (branch) details.bankBranchName = branch;
  if (desc) details.paymentDescription = desc;
  if (qr) details.paymentMethodQrCodeUrl = qr;
  try {
    if (id) {
      await API.put('/api/p2p/payment-methods/' + id, { currency: currency, type: type, isEnabled: true, applicationType: appType, details: details });
      showToast('Payment method updated', 'success');
    } else {
      await API.post('/api/p2p/payment-methods', { currency: currency, type: type, isEnabled: true, applicationType: appType, details: details });
      showToast('Payment method added', 'success');
    }
    e.target.closest('.modal-overlay').remove();
    var content = document.getElementById('page-content');
    if (content) renderPaymentMethods(content);
  } catch (err) { showToast(err.message, 'error'); }
};

window.deletePaymentMethod = async function (id) {
  if (!confirm('Delete this payment method?')) return;
  try {
    await API.del('/api/p2p/payment-methods/' + id);
    showToast('Payment method deleted', 'info');
    const content = document.getElementById('page-content');
    if (content) renderPaymentMethods(content);
  } catch (err) { showToast(err.message, 'error'); }
};

window.togglePaymentMethodStatus = async function (id, enabled) {
  try {
    await API.post('/api/p2p/payment-methods/' + id + '/status', { disable: !enabled });
    showToast(enabled ? 'Payment method enabled' : 'Payment method disabled', 'info');
  } catch (err) {
    showToast(err.message, 'error');
    const content = document.getElementById('page-content');
    if (content) renderPaymentMethods(content);
  }
};

/* ==== js/modules/okx/merchant.js ==== */
var _merchantData = null;

function _merchantTarget() {
  return document.getElementById('gs-merchant-area') || document.getElementById('page-content');
}

window.renderMerchantProfile = async function(container, params) {
  const _pg = currentPage;
  var userId = window._merchantUserId;
  if (!userId) {
    container.innerHTML = '<div style="max-width:500px;margin:60px auto;padding:24px;">' +
      '<h2 style="color:var(--text-primary);margin:0 0 16px;font-size:20px;">Merchant Profile</h2>' +
      '<p style="color:var(--text-tertiary);font-size:13px;margin:0 0 16px;">Enter a merchant User ID to view their profile.</p>' +
      '<div style="display:flex;gap:8px;">' +
      '<input type="text" id="merchant-search-input" placeholder="Enter User ID..." style="flex:1;padding:10px 14px;border-radius:8px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:14px;outline:none;">' +
      '<button id="merchant-search-btn" class="btn btn-primary" onclick="var v=document.getElementById(\'merchant-search-input\').value.trim();if(v){window._merchantUserId=v;renderMerchantProfile(_merchantTarget())}" style="padding:10px 20px;">Search</button>' +
      '</div></div>';
    return;
  }

  container.innerHTML = '<div class="page-loading"><div class="spinner"></div><span>Loading merchant profile...</span></div>';

  try {
    var profileP = API.get('/api/p2p/merchant/profile?userId=' + userId).then(function(r) { return r.data || {}; }).catch(function() { return {}; });
    var adsP = API.get('/api/p2p/merchant/ads/' + userId).then(function(r) { return r.data || {}; }).catch(function() { return {}; });
    var tradeP = API.get('/api/p2p/trade-summary/' + userId).then(function(r) { return r.data || {}; }).catch(function() { return {}; });

    var results = await Promise.all([profileP, adsP, tradeP]);
    if (currentPage !== _pg) return;
    _merchantData = { profile: results[0], ads: results[1], trade: results[2] };
    buildMerchantHTML(container, _merchantData);
    startPagePoll(container, function() { pollMerchant(container); }, 15000);
    startPageCountdown(15);
  } catch (err) {
    if (currentPage !== _pg) return;
    container.innerHTML = '<div style="text-align:center;padding:60px 20px;">' +
      '<div style="font-size:48px;margin-bottom:16px;">⚠️</div>' +
      '<h3 style="color:var(--text-primary);margin:0 0 8px;">Failed to Load Profile</h3>' +
      '<p style="color:var(--text-tertiary);font-size:13px;">' + esc(err.message) + '</p>' +
      '<button class="btn btn-outline" onclick="window._merchantUserId=\'' + esc(userId) + '\';renderMerchantProfile(_merchantTarget())" style="margin-top:16px;">Retry</button>' +
      '</div>';
  }
};

async function pollMerchant(container) {
  if (!_merchantData || !window._merchantUserId) return;
  try {
    var userId = window._merchantUserId;
    var results = await Promise.all([
      API.get('/api/p2p/merchant/profile?userId=' + userId).then(function(r) { return r.data || {}; }).catch(function() { return {}; }),
      API.get('/api/p2p/merchant/ads/' + userId).then(function(r) { return r.data || {}; }).catch(function() { return {}; }),
      API.get('/api/p2p/trade-summary/' + userId).then(function(r) { return r.data || {}; }).catch(function() { return {}; })
    ]);
    _merchantData = { profile: results[0], ads: results[1], trade: results[2] };
    updateMerchantStats(_merchantData);
  } catch (e) {}
}

function updateMerchantStats(d) {
  var p = d.profile;
  var a = d.ads;
  var ts = d.trade;
  var info30 = p.merchantInfo30DayOrderInfo || {};

  function setText(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }

  setText('merch-last-updated', 'Updated ' + new Date().toLocaleTimeString());
  setText('merch-completed-30d', fmtNum(info30.completedOrders30Day));
  setText('merch-total-completed', fmtNum(p.completedBuyOrders));
  setText('merch-trade-count', fmtNum(ts.tradeCount));
  setText('merch-completion-rate', info30.completionRate30Day != null ? info30.completionRate30Day + '%' : '-');
  setText('merch-positive-reviews', p.positiveReviewPercentage != null ? p.positiveReviewPercentage + '%' : '-');
  setText('merch-followers', fmtNum(p.followerCount));
  setText('merch-traded-users', fmtNum(p.tradedUsers));

  if (info30.completedOrders30Day > 0) {
    setText('merch-buy-30d', fmtNum(info30.completedBuyOrders30Day));
    setText('merch-sell-30d', fmtNum(info30.completedSellOrders30Day));
    setText('merch-buy-completion', info30.completionRateBuyOrders30Day != null ? info30.completionRateBuyOrders30Day + '%' : '-');
    setText('merch-sell-completion', info30.completionRateSellOrders30Day != null ? info30.completionRateSellOrders30Day + '%' : '-');
    if (info30.totalFiatAmount30Day) {
      setText('merch-total-fiat', formatFiat(info30.totalFiatAmount30Day, info30.fiatCurrency || 'KES'));
    }
  }

  setText('merch-positive-count', fmtNum(p.positiveReviews));
  setText('merch-negative-count', fmtNum(p.negativeReviews));
  setText('merch-total-reviews', fmtNum(p.totalReviews));
  if (p.positiveReviewPercentage != null) setText('merch-positive-pct', p.positiveReviewPercentage + '%');

  // Update follow button if state changed
  var btn = document.getElementById('follow-btn');
  if (btn && !p.isSelf && window._merchantUserId) {
    if (p.isFollowingUser) {
      btn.className = 'btn btn-outline';
      btn.textContent = 'Unfollow';
      btn.onclick = function() { toggleMerchantFollow(window._merchantUserId, false); };
    } else {
      btn.className = 'btn btn-primary';
      btn.textContent = '+ Follow';
      btn.onclick = function() { toggleMerchantFollow(window._merchantUserId, true); };
    }
  }

  updateMerchantAds(d);
}

function updateMerchantAds(d) {
  var adsTab = window._merchantAdsTab || 'buy';
  var el = document.getElementById('merch-ads-table');
  if (!el) return;
  var buyAdsList = (d.ads.buyAds || []);
  var sellAdsList = (d.ads.sellAds || []);
  var showBuy = adsTab !== 'sell';
  var currentAds = showBuy ? buyAdsList : sellAdsList;

  var tabBtnBuy = document.getElementById('merch-ads-tab-buy');
  var tabBtnSell = document.getElementById('merch-ads-tab-sell');
  if (tabBtnBuy) tabBtnBuy.className = 'btn btn-sm ' + (adsTab === 'buy' ? 'btn-primary' : 'btn-outline');
  if (tabBtnSell) tabBtnSell.className = 'btn btn-sm ' + (adsTab === 'sell' ? 'btn-primary' : 'btn-outline');
  if (tabBtnBuy) tabBtnBuy.innerHTML = 'Buy (' + buyAdsList.length + ')';
  if (tabBtnSell) tabBtnSell.innerHTML = 'Sell (' + sellAdsList.length + ')';

  if (currentAds.length === 0) {
    el.innerHTML = '<div style="text-align:center;padding:20px;color:var(--text-quaternary);font-size:13px;">No ' + (showBuy ? 'buy' : 'sell') + ' ads available</div>';
  } else {
    var html = '<div class="table-container"><table style="font-size:12px;"><thead><tr>' +
      '<th>#</th><th>Asset</th><th>Amount</th><th>Price</th><th>Fiat</th><th>Limit</th><th>Status</th>' +
      '</tr></thead><tbody>';
    currentAds.forEach(function(ad, i) {
      html += '<tr style="border-bottom:1px solid #1e1e2e;">' +
        '<td>' + (i + 1) + '</td>' +
        '<td>' + esc(ad.cryptoCurrency || '-') + '</td>' +
        '<td>' + (ad.quantity || '-') + '</td>' +
        '<td>' + (ad.price || '-') + '</td>' +
        '<td>' + esc(ad.fiatCurrency || '-') + '</td>' +
        '<td>' + (ad.minAmount || '0') + ' - ' + (ad.maxAmount || '-') + '</td>' +
        '<td><span style="color:' + (ad.status === 'enabled' ? '#00e676' : '#f44336') + ';">' + esc(ad.status || '-') + '</span></td>' +
        '</tr>';
    });
    html += '</tbody></table></div>';
    el.innerHTML = html;
  }
}

window.switchMerchantAdsTab = function(tab) {
  window._merchantAdsTab = tab;
  if (_merchantData) updateMerchantAds(_merchantData);
};

function buildMerchantHTML(container, d) {
  var p = d.profile;
  var a = d.ads;
  var ts = d.trade;

  var avatarUrl = p.avatarImage || '';
  var initials = (p.merchantName || p.merchantId || 'U').charAt(0).toUpperCase();
  var merchantName = p.merchantName || p.merchantId || 'Unknown';
  var userId = window._merchantUserId;

  var typeColor = '#78788a';
  var typeLabel = 'Common';
  if (p.type === 'diamond') { typeColor = '#448aff'; typeLabel = 'Diamond'; }
  else if (p.type === 'certified') { typeColor = '#00e676'; typeLabel = 'Certified'; }

  var info30 = p.merchantInfo30DayOrderInfo || {};

  var html = '<div style="padding:16px;max-width:900px;margin:0 auto;">';

  html += '<div style="margin-bottom:16px;display:flex;justify-content:space-between;align-items:center;">' + (document.getElementById('gs-merchant-area') ? '' : '<button class="btn btn-outline btn-sm" onclick="history.back()">← Back</button>') + '<span id="merch-last-updated" style="color:var(--text-quaternary);font-size:11px;">Updated ' + new Date().toLocaleTimeString() + '</span></div>';

  html += '<div class="card" style="padding:24px;margin-bottom:16px;">' +
    '<div style="display:flex;align-items:center;gap:16px;">' +
    '<div style="width:64px;height:64px;border-radius:50%;background:linear-gradient(135deg,#448aff,#7c4dff);display:flex;align-items:center;justify-content:center;font-size:28px;font-weight:700;color:#fff;flex-shrink:0;overflow:hidden;">' +
    (avatarUrl ? '<img src="' + esc(avatarUrl) + '" style="width:100%;height:100%;object-fit:cover;">' : esc(initials)) +
    '</div>' +
    '<div style="flex:1;">' +
    '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">' +
    '<h2 style="margin:0;font-size:20px;color:var(--text-primary);">' + esc(merchantName) + '</h2>' +
    '<span style="font-size:11px;padding:2px 8px;border-radius:4px;background:' + typeColor + '22;color:' + typeColor + ';font-weight:600;">' + typeLabel + '</span>' +
    (p.isKycVerified ? '<span style="font-size:11px;padding:2px 8px;border-radius:4px;background:rgba(0,230,118,0.15);color:#00e676;font-weight:600;">✓ KYC</span>' : '<span style="font-size:11px;padding:2px 8px;border-radius:4px;background:rgba(244,67,54,0.15);color:#f44336;font-weight:600;">✕ Unverified</span>') +
    (p.isDisabled ? '<span style="font-size:11px;padding:2px 8px;border-radius:4px;background:rgba(244,67,54,0.2);color:#f44336;font-weight:600;">Disabled</span>' : '') +
    '</div>' +
    (p.countryName ? '<div style="color:var(--text-tertiary);font-size:13px;margin-top:4px;">📍 ' + esc(p.countryName) + '</div>' : '') +
    (p.merchantRegisteredTimestamp ? '<div style="color:var(--text-quaternary);font-size:11px;margin-top:4px;">Merchant since ' + new Date(parseInt(p.merchantRegisteredTimestamp)).toLocaleDateString() + '</div>' : '') +
    '</div></div></div>';

  html += '<div class="card" style="padding:20px;margin-bottom:16px;">' +
    '<h3 style="margin:0 0 12px;font-size:15px;color:var(--text-primary);">📊 Statistics</h3>' +
    '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px;">' +
    statBox('Completed (30d)', '<span id="merch-completed-30d">' + fmtNum(info30.completedOrders30Day) + '</span>', '#448aff') +
    statBox('Total Completed', '<span id="merch-total-completed">' + fmtNum(p.completedBuyOrders) + '</span>', '#448aff') +
    statBox('Trade Count', '<span id="merch-trade-count">' + fmtNum(ts.tradeCount) + '</span>', '#00e676') +
    statBox('Completion Rate', '<span id="merch-completion-rate">' + (info30.completionRate30Day != null ? info30.completionRate30Day + '%' : '-') + '</span>', '#00e676') +
    statBox('Positive Reviews', '<span id="merch-positive-reviews">' + (p.positiveReviewPercentage != null ? p.positiveReviewPercentage + '%' : '-') + '</span>', '#00e676') +
    statBox('Followers', '<span id="merch-followers">' + fmtNum(p.followerCount) + '</span>', '#7c4dff') +
    statBox('Traded Users', '<span id="merch-traded-users">' + fmtNum(p.tradedUsers) + '</span>', '#ff9100') +
    '</div></div>';

  if (info30.completedOrders30Day > 0) {
    html += '<div class="card" style="padding:20px;margin-bottom:16px;">' +
      '<h3 style="margin:0 0 12px;font-size:15px;color:var(--text-primary);">📅 30-Day Order Breakdown</h3>' +
      '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:10px;">' +
      statBox('Buy Orders', '<span id="merch-buy-30d">' + fmtNum(info30.completedBuyOrders30Day) + '</span>', '#448aff') +
      statBox('Sell Orders', '<span id="merch-sell-30d">' + fmtNum(info30.completedSellOrders30Day) + '</span>', '#ff9100') +
      statBox('Buy Completion', '<span id="merch-buy-completion">' + (info30.completionRateBuyOrders30Day != null ? info30.completionRateBuyOrders30Day + '%' : '-') + '</span>', '#448aff') +
      statBox('Sell Completion', '<span id="merch-sell-completion">' + (info30.completionRateSellOrders30Day != null ? info30.completionRateSellOrders30Day + '%' : '-') + '</span>', '#ff9100') +
      (info30.totalFiatAmount30Day ? statBox('Total Fiat', '<span id="merch-total-fiat">' + formatFiat(info30.totalFiatAmount30Day, info30.fiatCurrency || 'KES') + '</span>', '#00e676') : '') +
      '</div></div>';
  }

  html += '<div class="card" style="padding:20px;margin-bottom:16px;">' +
    '<h3 style="margin:0 0 12px;font-size:15px;color:var(--text-primary);">⭐ Reviews</h3>' +
    '<div style="display:flex;gap:16px;flex-wrap:wrap;">' +
    '<div style="padding:12px 20px;background:rgba(0,230,118,0.08);border-radius:8px;border:1px solid rgba(0,230,118,0.2);text-align:center;">' +
    '<div style="font-size:24px;font-weight:700;color:#00e676;" id="merch-positive-count">' + fmtNum(p.positiveReviews) + '</div>' +
    '<div style="font-size:12px;color:var(--text-tertiary);margin-top:4px;">Positive</div></div>' +
    '<div style="padding:12px 20px;background:rgba(244,67,54,0.08);border-radius:8px;border:1px solid rgba(244,67,54,0.2);text-align:center;">' +
    '<div style="font-size:24px;font-weight:700;color:#f44336;" id="merch-negative-count">' + fmtNum(p.negativeReviews) + '</div>' +
    '<div style="font-size:12px;color:var(--text-tertiary);margin-top:4px;">Negative</div></div>' +
    '<div style="padding:12px 20px;background:rgba(91,124,250,0.08);border-radius:8px;border:1px solid rgba(91,124,250,0.2);text-align:center;">' +
    '<div style="font-size:24px;font-weight:700;color:#5b7cfa;" id="merch-total-reviews">' + fmtNum(p.totalReviews) + '</div>' +
    '<div style="font-size:12px;color:var(--text-tertiary);margin-top:4px;">Total Reviews</div></div>' +
    (p.positiveReviewPercentage != null ? '<div style="padding:12px 20px;background:rgba(156,39,176,0.08);border-radius:8px;border:1px solid rgba(156,39,176,0.2);text-align:center;">' +
    '<div style="font-size:24px;font-weight:700;color:#9c27b0;" id="merch-positive-pct">' + p.positiveReviewPercentage + '%</div>' +
    '<div style="font-size:12px;color:var(--text-tertiary);margin-top:4px;">Positive %</div></div>' : '') +
    '</div></div>';

  var buyAdsList = a.buyAds || [];
  var sellAdsList = a.sellAds || [];
  var adsTab = window._merchantAdsTab || 'buy';
  html += '<div class="card" style="padding:20px;margin-bottom:16px;">' +
    '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;"><h3 style="margin:0;font-size:15px;color:var(--text-primary);">📋 Merchant Ads</h3><span id="page-countdown" style="color:var(--text-tertiary);font-size:11px;"></span></div>' +
    '<div style="display:flex;gap:8px;margin-bottom:12px;">' +
    '<button class="btn btn-sm ' + (adsTab === 'buy' ? 'btn-primary' : 'btn-outline') + '" id="merch-ads-tab-buy" onclick="window.switchMerchantAdsTab(\'buy\')">Buy (' + buyAdsList.length + ')</button>' +
    '<button class="btn btn-sm ' + (adsTab === 'sell' ? 'btn-primary' : 'btn-outline') + '" id="merch-ads-tab-sell" onclick="window.switchMerchantAdsTab(\'sell\')">Sell (' + sellAdsList.length + ')</button>' +
    '</div><div id="merch-ads-table">';

  var showBuy = adsTab !== 'sell';
  var currentAds = showBuy ? buyAdsList : sellAdsList;

  if (currentAds.length === 0) {
    html += '<div style="text-align:center;padding:20px;color:var(--text-quaternary);font-size:13px;">No ' + (showBuy ? 'buy' : 'sell') + ' ads available</div>';
  } else {
    html += '<div class="table-container"><table style="font-size:12px;"><thead><tr>' +
      '<th>#</th><th>Asset</th><th>Amount</th><th>Price</th><th>Fiat</th><th>Limit</th><th>Status</th>' +
      '</tr></thead><tbody>';
    currentAds.forEach(function(ad, i) {
      html += '<tr style="border-bottom:1px solid #1e1e2e;">' +
        '<td>' + (i + 1) + '</td>' +
        '<td>' + esc(ad.cryptoCurrency || '-') + '</td>' +
        '<td>' + (ad.quantity || '-') + '</td>' +
        '<td>' + (ad.price || '-') + '</td>' +
        '<td>' + esc(ad.fiatCurrency || '-') + '</td>' +
        '<td>' + (ad.minAmount || '0') + ' - ' + (ad.maxAmount || '-') + '</td>' +
        '<td><span style="color:' + (ad.status === 'enabled' ? '#00e676' : '#f44336') + ';">' + esc(ad.status || '-') + '</span></td>' +
        '</tr>';
    });
    html += '</tbody></table></div>';
  }
  html += '</div></div>';

  html += '<div class="card" style="padding:20px;margin-bottom:16px;">' +
    '<h3 style="margin:0 0 12px;font-size:15px;color:var(--text-primary);">⚡ Actions</h3>' +
    '<div style="display:flex;gap:8px;flex-wrap:wrap;">';

  if (!p.isSelf) {
    if (p.isFollowingUser) {
      html += '<button class="btn btn-outline" onclick="toggleMerchantFollow(\'' + esc(userId) + '\',false)" id="follow-btn">Unfollow</button>';
    } else {
      html += '<button class="btn btn-primary" onclick="toggleMerchantFollow(\'' + esc(userId) + '\',true)" id="follow-btn">+ Follow</button>';
    }
  }
  html += '<button class="btn btn-outline" style="border-color:#f4433644;color:#f44336;" onclick="blacklistMerchantUser(\'' + esc(userId) + '\')">🚫 Blacklist</button>';
  html += '<button class="btn btn-outline" onclick="history.back()">← Back</button>';
  html += '</div></div></div>';

  container.innerHTML = html;
}

function statBox(label, value, color) {
  return '<div style="padding:12px;background:rgba(10,10,20,0.6);border-radius:8px;border:1px solid var(--border-primary);text-align:center;">' +
    '<div style="font-size:22px;font-weight:700;color:' + color + ';">' + value + '</div>' +
    '<div style="font-size:11px;color:var(--text-tertiary);margin-top:4px;">' + label + '</div></div>';
}

function fmtNum(n) {
  if (n === null || n === undefined) return '0';
  return Number(n).toLocaleString();
}

window.toggleMerchantFollow = async function(userId, shouldFollow) {
  try {
    await API.post('/api/p2p/merchant/follow', { userId: userId, shouldFollow: shouldFollow });
    showToast(shouldFollow ? 'Followed successfully' : 'Unfollowed', 'success');
    window._merchantUserId = userId;
    if (_merchantData) {
      _merchantData.profile.isFollowingUser = shouldFollow;
      var btn = document.getElementById('follow-btn');
      if (btn) {
        if (shouldFollow) {
          btn.className = 'btn btn-outline';
          btn.textContent = 'Unfollow';
          btn.onclick = function() { toggleMerchantFollow(userId, false); };
        } else {
          btn.className = 'btn btn-primary';
          btn.textContent = '+ Follow';
          btn.onclick = function() { toggleMerchantFollow(userId, true); };
        }
      }
    }
  } catch (err) {
    showToast(err.message, 'error');
  }
};

// Listen for SSE order-update to refresh merchant page
document.addEventListener('order-update', function() {
  if (currentPage === 'merchant-profile') {
    var c = document.getElementById('page-content');
    if (c) pollMerchant(c);
  }
});

window.blacklistMerchantUser = async function(userId) {
  if (!confirm('Add this user to your blacklist?')) return;
  try {
    await API.post('/api/p2p/user/blacklist', { userId: userId });
    showToast('User blacklisted', 'success');
  } catch (err) {
    showToast(err.message, 'error');
  }
};

/* ==== js/modules/okx/extra.js ==== */
// ===== Extra Module: File Upload, Blacklist, Online Status =====

// ===== Feature 1: File Upload =====

window.openFileUploader = function(options) {
  var opts = options || {};
  showModal([
    '<h3>' + esc(opts.title || 'Upload Payment Proof') + '</h3>',
    '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Paste a URL to your payment proof image, or upload a file.</p>',
    '<div class="form-group">',
    '<label>Image URL</label>',
    '<input type="url" id="fu-url-input" class="form-input" placeholder="https://example.com/proof.jpg" value="' + esc(opts.url || '') + '">',
    '</div>',
    '<div style="text-align:center;color:var(--text-quaternary);font-size:11px;margin:8px 0;">— or —</div>',
    '<div class="form-group">',
    '<label>Upload from device</label>',
    '<input type="file" id="fu-file-input" accept="image/*" style="width:100%;padding:8px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-input);color:var(--text-primary);font-size:12px;">',
    '</div>',
    '<div id="fu-preview" style="margin-bottom:12px;display:none;text-align:center;"></div>',
    '<button class="btn btn-primary" style="width:100%;" data-on-click="confirmOpenFileUpload()">' + esc(opts.buttonText || 'Submit') + '</button>',
    '<div style="display:flex;gap:6px;margin-top:6px;">',
    '<button class="btn btn-secondary" style="flex:1;" data-on-click="closeModal()">Cancel</button>',
    (opts.showCopyUrl ? '<button class="btn btn-outline" style="flex:1;" data-on-click="fuCopyUrl()">Copy URL</button>' : ''),
    '</div>'
  ].join(''));
  window._fuOptions = opts;
};

window.fuCopyUrl = function() {
  var input = document.getElementById('fu-url-input');
  if (input && input.value) {
    copyText(input.value);
  } else {
    showToast('No URL to copy', 'error');
  }
};

window.confirmOpenFileUpload = function() {
  var urlInput = document.getElementById('fu-url-input');
  var fileInput = document.getElementById('fu-file-input');
  var opts = window._fuOptions || {};
  var file = fileInput && fileInput.files && fileInput.files[0];

  if (file) {
    if (file.size > 10 * 1024 * 1024) { showToast('File too large (max 10MB)', 'error'); return; }
    var reader = new FileReader();
    reader.onload = function(e) {
      closeModal();
      if (typeof opts.onSubmit === 'function') opts.onSubmit(e.target.result, 'data-url');
    };
    reader.readAsDataURL(file);
  } else if (urlInput && urlInput.value.trim()) {
    closeModal();
    if (typeof opts.onSubmit === 'function') opts.onSubmit(urlInput.value.trim(), 'url');
  } else {
    showToast('Provide a URL or select a file', 'error');
  }
};

window.showFileUploader = function(callback) {
  showModal([
    '<h3>Upload Payment Proof</h3>',
    '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Select an image to attach as payment evidence</p>',
    '<div class="form-group">',
    '<label>Image (JPEG, PNG)</label>',
    '<input type="file" id="fu-simple-input" accept="image/*" style="width:100%;padding:8px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-input);color:var(--text-primary);font-size:12px;">',
    '</div>',
    '<button class="btn btn-primary" style="width:100%;" data-on-click="confirmSimpleFileUpload()">Upload</button>',
    '<button class="btn btn-secondary" style="width:100%;margin-top:6px;" data-on-click="closeModal()">Close</button>'
  ].join(''));
  window._simpleUploadCallback = callback;
};

window.confirmSimpleFileUpload = function() {
  var input = document.getElementById('fu-simple-input');
  if (!input || !input.files || !input.files[0]) {
    showToast('Select a file first', 'error');
    return;
  }
  var file = input.files[0];
  if (file.size > 10 * 1024 * 1024) { showToast('File too large (max 10MB)', 'error'); return; }
  var reader = new FileReader();
  reader.onload = async function(e) {
    var cb = window._simpleUploadCallback;
    var b64 = e.target.result;
    closeModal();
    // Upload to OKX to get a hosted URL. NEVER fall back to a data:-URL here —
    // OKX rejects data: URLs in mark-as-paid (52900), and if one gets saved as
    // the payment proof it fails every subsequent order.
    try {
      var upRes = await API.post('/api/okx/p2p/file/upload', { file: b64, fileName: file.name });
      var okxItem = upRes?.data?.[0] || {};
      var okxUrl = okxItem.path || okxItem.fileUrl || okxItem.link || okxItem.url || upRes?.data?.fileUrl || '';
      if (okxUrl) {
        if (typeof cb === 'function') cb(okxUrl, 'url');
        return;
      }
      showToast('Upload rejected by OKX: ' + (upRes?.msg || 'no file URL returned'), 'error');
    } catch (upErr) {
      showToast('OKX rejected the image: ' + upErr.message, 'error');
    }
  };
  reader.readAsDataURL(file);
};

// ===== Feature 2: User Blacklist Management =====

window.renderBlacklist = async function(container) {
  container.innerHTML = '<div style="text-align:center;padding:40px;color:var(--text-quaternary);">Loading blacklist...</div>';
  try {
    var res = await API.get('/api/p2p/user/blacklist?currencySymbol=USDT');
    var users = res.data || [];
    var html = [
      '<div class="page-header">',
      '<div><h2>Blacklist</h2><div class="subtitle">Manage blocked users</div></div>',
      '<div><span style="color:var(--text-quaternary);font-size:12px;">' + users.length + ' blocked</span></div>',
      '</div>'
    ].join('');

    if (users.length === 0) {
      html += '<div class="card" style="text-align:center;padding:60px 20px;"><div style="font-size:48px;margin-bottom:12px;opacity:0.3;">🚫</div><p style="color:var(--text-quaternary);font-size:14px;">No blacklisted users</p></div>';
      container.innerHTML = html;
      return;
    }

    html += '<div class="table-container"><table class="table"><thead><tr>' +
      '<th>User Name</th><th>Type</th><th>Completion</th><th>Orders</th><th>Avg Paid</th><th>Avg Release</th><th>Added</th><th>Actions</th>' +
      '</tr></thead><tbody>';

    users.forEach(function(u) {
      var name = esc(u.userName || '-');
      var type = esc(u.userType || '-');
      var rate = u.completionRate != null ? u.completionRate + '%' : '-';
      var orders = u.orders != null ? u.orders : '-';
      var paidTime = u.buyerAvgPaidTime ? Math.round(u.buyerAvgPaidTime / 60) + 'm' : '-';
      var releaseTime = u.sellerAvgCompletedTime ? Math.round(u.sellerAvgCompletedTime / 60) + 'm' : '-';
      var added = u.createdTimestamp ? new Date(Number(u.createdTimestamp)).toLocaleDateString() : '-';
      var uid = esc(u.userId || '');
      html += '<tr><td><strong>' + name + '</strong></td>' +
        '<td>' + type + '</td>' +
        '<td>' + rate + '</td>' +
        '<td>' + orders + '</td>' +
        '<td>' + paidTime + '</td>' +
        '<td>' + releaseTime + '</td>' +
        '<td>' + added + '</td>' +
        '<td><button class="btn btn-sm btn-danger" data-on-click="confirmRemoveBlacklist(\'' + uid + '\')">Remove</button></td></tr>';
    });

    html += '</tbody></table></div><div style="margin-top:12px;font-size:11px;color:var(--text-quaternary);text-align:center;">Showing ' + users.length + ' blacklisted user(s)</div>';
    container.innerHTML = html;
    if (typeof bindClickHandlers === 'function') bindClickHandlers(container);
  } catch (e) {
    container.innerHTML = '<div class="card" style="text-align:center;padding:40px;"><p style="color:#f44336;">Failed to load blacklist: ' + esc(e.message) + '</p><button class="btn btn-sm btn-outline" style="margin-top:12px;" data-on-click="renderBlacklist(document.getElementById(\'page-content\'))">Retry</button></div>';
    if (typeof bindClickHandlers === 'function') bindClickHandlers(container);
  }
};

window.confirmRemoveBlacklist = function(userId) {
  if (!userId) return;
  window._blRemoveUserId = userId;
  showConfirm('Remove this user from blacklist?', async function() {
    var uid = window._blRemoveUserId;
    if (!uid) return;
    try {
      await API.delete('/api/p2p/user/blacklist', { userId: uid });
      showToast('User removed from blacklist', 'success');
      var c = document.getElementById('page-content');
      if (c) renderGeneralSupport(c);
    } catch (err) { showToast(err.message, 'error'); }
  }, 'Remove', 'Cancel');
};

window.showBlacklistUser = function(userId, userName) {
  var reasons = ['Scam / Fraud', 'Fake Payment', 'Harassment', 'No show / Late payment', 'Chargeback risk', 'Other'];
  showModal([
    '<h3>Block ' + esc(userName || 'User') + '?</h3>',
    '<p style="color:var(--text-tertiary);font-size:13px;margin-bottom:16px;">Add this user to your blacklist. They will not be able to trade with you.</p>',
    '<div class="form-group">',
    '<label>Reason (optional)</label>',
    '<select id="bl-reason-select" class="form-input" style="width:100%;">',
    '<option value="">Select a reason...</option>',
    reasons.map(function(r) { return '<option value="' + esc(r) + '">' + esc(r) + '</option>'; }).join(''),
    '</select>',
    '</div>',
    '<button class="btn btn-danger" style="width:100%;" data-on-click="confirmBlacklistUser(\'' + esc(userId) + '\')">Block User</button>',
    '<button class="btn btn-secondary" style="width:100%;margin-top:6px;" data-on-click="closeModal()">Cancel</button>'
  ].join(''));
  window._blUserName = userName;
};

window.confirmBlacklistUser = async function(userId) {
  var reasonEl = document.getElementById('bl-reason-select');
  var reason = reasonEl ? reasonEl.value : '';
  try {
    await API.post('/api/p2p/user/blacklist', { userId: userId, reasons: reason || 'Manual block' });
    closeModal();
    showToast('User blocked', 'success');
  } catch (err) { showToast(err.message, 'error'); }
};

// ===== Feature 3: Online Status Toggle =====

window.showOnlineStatusToggle = function(container) {
  var isOnline = localStorage.getItem('p2p_online_status') !== 'hidden';
  container.innerHTML = [
    '<div class="card" style="border-color:rgba(0,200,83,0.15);">',
    '<h3 style="display:flex;align-items:center;gap:8px;">🌐 Online Status</h3>',
    '<p style="color:var(--text-tertiary);font-size:13px;margin:4px 0 16px;">Control whether you appear online or hidden on the P2P marketplace</p>',
    '<div style="display:flex;align-items:center;justify-content:space-between;padding:12px 16px;background:var(--bg-primary);border-radius:8px;border:1px solid var(--border-primary);">',
    '<div>',
    '<div style="font-size:14px;color:var(--text-primary);font-weight:500;" id="online-status-label">' + (isOnline ? '🟢 Online' : '🔴 Hidden') + '</div>',
    '<div style="font-size:11px;color:var(--text-quaternary);margin-top:2px;">' + (isOnline ? 'Visible to other traders' : 'Hidden from other traders') + '</div>',
    '</div>',
    '<button class="btn ' + (isOnline ? 'btn-outline' : 'btn-primary') + '" id="online-toggle-btn" data-on-click="toggleOnlineStatus()">' + (isOnline ? 'Go Offline' : 'Go Online') + '</button>',
    '</div>',
    '<div style="margin-top:12px;font-size:11px;color:var(--text-quaternary);text-align:center;">Status persisted until you change it</div>',
    '</div>'
  ].join('');
  if (typeof bindClickHandlers === 'function') bindClickHandlers(container);
};

window.toggleOnlineStatus = async function() {
  var isOnline = localStorage.getItem('p2p_online_status') !== 'hidden';
  var newStatus = isOnline ? 'hidden' : 'show';
  var btn = document.getElementById('online-toggle-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Updating...'; }
  try {
    await API.post('/api/p2p/user/online-status', { status: newStatus });
    // Persist intent so the keep-online heartbeat does not override it.
    await API.put('/api/auth/preferences', { keepOnlineEnabled: newStatus === 'show' });
    localStorage.setItem('p2p_online_status', newStatus);
    showToast('Status set to ' + (newStatus === 'show' ? 'Online' : 'Hidden'), 'success');
    var c = document.getElementById('page-content');
    if (c && typeof showOnlineStatusToggle === 'function') showOnlineStatusToggle(c);
    if (btn) btn.disabled = false;
  } catch (err) {
    showToast(err.message, 'error');
    if (btn) btn.disabled = false;
  }
};

// Extend API with chat media method
API.sendChatMedia = function(orderId, contentUrl, contentType) {
  return API.post('/api/okx/p2p/chat/' + orderId, { contentUrl: contentUrl, contentType: contentType });
};

// Corrupt-load guard: if automation.js failed to parse (truncated download),
// reload the page once so the user never sits on a dead UI.
window.addEventListener('DOMContentLoaded', function() {
  var tried = sessionStorage.getItem('afReloadGuard');
  setTimeout(function() {
    if (window.__autoModLoaded) return;
    if (tried) return;
    sessionStorage.setItem('afReloadGuard', '1');
    location.reload();
  }, 1500);
});

/* ==== js/modules/okx/automation.js ==== */
// ===== Configuration passthrough =====
var _autoTab = 'engine';
var _autoTimers = {};
var _autoCfgs = {};

async function renderAutomation(container) {
  container.innerHTML = '';
  var header = document.createElement('div');
  header.className = 'page-header';
  header.innerHTML = '<div><h2>🤖 Automation</h2><p style="color:var(--text-tertiary);font-size:13px;margin:2px 0 0;">Auto-engine, trailing, order filtering, and more</p></div>';
  container.appendChild(header);

  var tabs = document.createElement('div');
  tabs.style.cssText = 'display:flex;gap:4px;flex-wrap:wrap;margin-bottom:16px;';
  var tabList = [
    ['engine', '⚙️ Engine'],
    ['orderAccept', '📋 Accept'],
    ['schedule', '⏰ Schedules'],
    ['balanceGuard', '🛡️ Guard'],
    ['volumePricing', '📈 Volume'],
    ['copyStrategy', '📋 Copy'],
    ['blacklist', '🚫 Blacklist'],
    ['notif', '🔔 Notifs'],
    ['report', '📊 Reports'],
    ['autoFund', '💰 Auto-Fund']
  ];
  tabList.forEach(function(t) {
    var btn = document.createElement('button');
    btn.className = 'btn' + (t[0] === _autoTab ? ' btn-primary' : ' btn-ghost');
    btn.textContent = t[1];
    btn.style.cssText = 'font-size:12px;padding:6px 12px;border-radius:6px;';
    btn.onclick = function() { _autoTab = t[0]; renderAutomation(container); };
    tabs.appendChild(btn);
  });
  container.appendChild(tabs);

  var content = document.createElement('div');
  content.id = 'auto-page-content';
  container.appendChild(content);

  // Clear any previous timers
  for (var k in _autoTimers) { clearInterval(_autoTimers[k]); delete _autoTimers[k]; }

  switch (_autoTab) {
    case 'engine': _renderEngine(content); break;
    default: _renderFeature(content, _autoTab); break;
  }
}

// ===== Tab 1: Auto-Order Engine =====
var ENGINE_FEATURES = [
  {id:'autoPay',icon:'💳',title:'Auto-Pay Buy Orders',desc:'Automatically send payment to the counterparty via the I&M payment agent (mobile or bank rail). Marks the order as paid on OKX.',btn:'Pay',color:'#4caf50'},
  {id:'autoRelease',icon:'🚀',title:'Auto-Release Crypto',desc:'When a sell order shows payment is confirmed (paid), automatically release the crypto to the buyer.',btn:'Release',color:'#ff9100'},
  {id:'autoAppeal',icon:'⚖️',title:'Auto-Appeal Stuck Orders',desc:'If an order is stuck for more than 30 minutes — paid but not released, or unpaid with no action — automatically create a dispute/appeal.',btn:'Appeal',color:'#f44336'},
  {id:'autoMessage',icon:'💬',title:'Auto-Message Counterparties',desc:'Automatically send a chat message to counterparties when a new order is placed. Configure buy/sell messages below.',btn:'Message',color:'#8888aa'}
];

function _clearJsErrBox() {
  var box = document.getElementById('js-err-box');
  if (box) {
    box.style.display = 'none';
    box.textContent = '';
  }
  if (window.__jsErrors) window.__jsErrors.length = 0;
}

function _renderEngine(container) {
  _clearJsErrBox();
  container.innerHTML = '';
  var card = document.createElement('div');
  card.className = 'card';
  card.style.cssText = 'max-width:800px;margin:0 auto 20px;';

  // Header
  card.innerHTML = '\
    <div style="display:flex;align-items:center;gap:12px;margin-bottom:20px;">\
      <span style="font-size:32px;">🤖</span>\
      <div>\
        <h2 style="margin:0;">Auto-Order Engine</h2>\
        <p style="margin:4px 0 0;color:var(--text-tertiary);font-size:13px;">\
          Automatically processes P2P orders — sends payment, releases crypto, and handles disputes\
        </p>\
      </div>\
    </div>\
    <div id="automation-status-card" style="border-radius:10px;padding:16px;margin-bottom:16px;border:1px solid var(--glass-border);">\
      <div style="display:flex;justify-content:space-between;align-items:center;">\
        <div>\
          <div style="font-size:13px;color:var(--text-tertiary);">Status</div>\
          <div id="automation-status" style="font-size:18px;font-weight:700;margin-top:4px;">⏸ Stopped</div>\
        </div>\
        <div style="display:flex;gap:8px;">\
          <button id="automation-toggle-btn" class="btn btn-primary" style="padding:10px 24px;">Start Engine</button>\
        </div>\
      </div>\
    </div>';

  // Feature cards with toggle buttons
  var featSection = document.createElement('div');
  featSection.style.cssText = 'margin-bottom:16px;';
  featSection.innerHTML = '<h3 style="margin:0 0 12px;font-size:14px;">⚡ What this engine does</h3>';
  var featGrid = document.createElement('div');
  featGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:10px;';
  ENGINE_FEATURES.forEach(function(f) {
    var extra = '';
    if (f.id === 'autoMessage') {
      extra = '\
        <div id="auto-msg-fields" style="display:none;margin-top:8px;padding-top:8px;border-top:1px solid #1e1e2e;">\
          <div style="font-size:11px;color:var(--text-tertiary);margin-bottom:6px;">📤 Buy order message</div>\
          <label style="display:flex;align-items:center;gap:4px;font-size:10px;color:var(--text-tertiary);margin-bottom:4px;cursor:pointer;">\
            <input type="checkbox" id="auto-msg-buy-enable" onchange="_saveAutoMsgCfg()"> Enable\
          </label>\
          <textarea id="auto-msg-buy-text" rows="2" style="width:100%;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:11px;padding:6px;margin-bottom:8px;" placeholder="Hello, welcome to my ad. Kindly complete payment within the time limit." onchange="_saveAutoMsgCfg()"></textarea>\
          <div style="font-size:11px;color:var(--text-tertiary);margin-bottom:6px;">📥 Sell order message</div>\
          <label style="display:flex;align-items:center;gap:4px;font-size:10px;color:var(--text-tertiary);margin-bottom:4px;cursor:pointer;">\
            <input type="checkbox" id="auto-msg-sell-enable" onchange="_saveAutoMsgCfg()"> Enable\
          </label>\
          <textarea id="auto-msg-sell-text" rows="2" style="width:100%;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:11px;padding:6px;" placeholder="Thank you for your order. I will release crypto once payment is confirmed." onchange="_saveAutoMsgCfg()"></textarea>\
        </div>';
    }
    featGrid.innerHTML += '\
      <div id="eng-card-' + f.id + '" style="border-radius:8px;padding:14px;border:1px solid ' + f.color + '44;background:rgba(0,0,0,0.1);">\
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">\
          <span style="font-size:20px;">' + f.icon + '</span>\
          <strong style="font-size:13px;color:' + f.color + ';">' + f.title + '</strong>\
        </div>\
        <p style="font-size:11px;color:var(--text-quaternary);margin:0 0 10px;line-height:1.5;">' + f.desc + '</p>\
        <div style="display:flex;align-items:center;gap:8px;justify-content:space-between;">\
          <span id="eng-badge-' + f.id + '" style="display:inline-block;padding:2px 10px;border-radius:4px;font-size:10px;font-weight:600;background:' + f.color + '22;color:' + f.color + ';">Auto-' + f.btn + '</span>\
          <label style="display:flex;align-items:center;gap:4px;font-size:11px;cursor:pointer;color:var(--text-tertiary);">\
            <input type="checkbox" id="eng-toggle-' + f.id + '" checked onchange="_toggleEngineFeature(\'' + f.id + '\',this.checked)"> Enable\
          </label>\
        </div>' + extra + '\
      </div>';
  });
  featSection.appendChild(featGrid);
  card.appendChild(featSection);

  // Stats
  card.innerHTML += '\
    <div style="border-radius:10px;padding:16px;margin-bottom:16px;border:1px solid var(--glass-border);">\
      <h3 style="margin:0 0 10px;font-size:14px;">📊 Performance Stats</h3>\
      <div style="display:flex;gap:20px;flex-wrap:wrap;">\
        <div><span style="color:var(--text-tertiary);font-size:12px;">Orders Processed</span><br><span id="auto-orders-count" style="font-size:18px;font-weight:700;">0</span></div>\
        <div><span style="color:var(--text-tertiary);font-size:12px;">Payments Sent</span><br><span id="auto-payments-count" style="font-size:18px;font-weight:700;color:#4caf50;">0</span></div>\
        <div><span style="color:var(--text-tertiary);font-size:12px;">Crypto Released</span><br><span id="auto-releases-count" style="font-size:18px;font-weight:700;color:#ff9100;">0</span></div>\
        <div><span style="color:var(--text-tertiary);font-size:12px;">Appeals Created</span><br><span id="auto-appeals-count" style="font-size:18px;font-weight:700;color:#f44336;">0</span></div>\
        <div><span style="color:var(--text-tertiary);font-size:12px;">Errors</span><br><span id="auto-errors-count" style="font-size:18px;font-weight:700;color:#8888a0;">0</span></div>\
      </div>\
    </div>';

  // Prereqs
  card.innerHTML += '\
    <div id="automation-prereqs" style="border-radius:10px;padding:16px;margin-bottom:16px;border:1px solid var(--glass-border);">\
      <h3 style="margin:0 0 12px;font-size:14px;">🛠 Prerequisites</h3>\
      <div id="prereq-okx" style="display:flex;align-items:center;gap:8px;padding:8px 0;font-size:13px;border-top:1px solid #1e1e2e;">\
        <span class="prereq-icon">⏳</span>\
        <span>OKX API Keys — required for all order management operations</span>\
        <span class="prereq-status" style="margin-left:auto;font-size:12px;">Checking...</span>\
      </div>\
      <div id="automation-error" class="hidden" style="margin-top:12px;padding:10px;border-radius:8px;background:rgba(244,67,54,0.1);color:#f44336;font-size:13px;"></div>\
    </div>';

  // Activity log
  card.innerHTML += '\
    <div style="border-radius:10px;padding:16px;border:1px solid var(--glass-border);">\
      <h3 style="margin:0 0 8px;font-size:14px;">Activity Log</h3>\
      <div id="automation-log" style="max-height:300px;overflow-y:auto;font-size:12px;font-family:monospace;line-height:1.8;">\
        <div style="color:var(--text-quaternary);padding:20px 0;text-align:center;">No activity yet</div>\
      </div>\
    </div>';

  container.appendChild(card);

  _autoLog('Automation page loaded. Checking prerequisites...', 'info');
  _checkPrereqs();
  _fetchStatus();
  _fetchV2Logs(); // Also show v2 engine activity immediately
  _loadEngineFeatureToggles();

  document.getElementById('automation-toggle-btn').onclick = function() {
    var btn = this;
    if (btn.textContent === 'Start Engine') { _startAutomation(btn); } else { _stopAutomation(btn); }
  };

  _autoTimers.engine = setInterval(function() { if (!document.hidden) _fetchStatus(); }, 30000);
}

async function _loadEngineFeatureToggles() {
  var cfg = await _loadCfg('engine');
  ENGINE_FEATURES.forEach(function(f) {
    var enabled = cfg[f.id] !== false;
    var el = document.getElementById('eng-toggle-' + f.id);
    if (el) {
      el.checked = enabled;
      _updateEngineCardStyle(f.id, enabled);
    }
  });
  // Load auto-message fields
  var msgBuyEnable = document.getElementById('auto-msg-buy-enable');
  var msgBuyText = document.getElementById('auto-msg-buy-text');
  var msgSellEnable = document.getElementById('auto-msg-sell-enable');
  var msgSellText = document.getElementById('auto-msg-sell-text');
  if (msgBuyEnable) msgBuyEnable.checked = cfg.autoMsgBuyEnabled === true;
  if (msgBuyText) msgBuyText.value = cfg.autoMsgBuyText || '';
  if (msgSellEnable) msgSellEnable.checked = cfg.autoMsgSellEnabled === true;
  if (msgSellText) msgSellText.value = cfg.autoMsgSellText || '';
}

function _toggleEngineFeature(id, checked) {
  _loadCfg('engine').then(function(cfg) {
    cfg[id] = checked;
    _saveCfg('engine', cfg);
    _updateEngineCardStyle(id, checked);
    // For auto-message, show/hide the message fields when toggled
    if (id === 'autoMessage') {
      var fields = document.getElementById('auto-msg-fields');
      if (fields) fields.style.display = checked ? 'block' : 'none';
    }
  });
}

function _updateEngineCardStyle(id, enabled) {
  var card = document.getElementById('eng-card-' + id);
  if (!card) return;
  card.style.borderColor = enabled ? 'var(--glass-border)' : 'rgba(60,60,80,0.3)';
  card.style.opacity = enabled ? '1' : '0.45';
  var badge = document.getElementById('eng-badge-' + id);
  if (badge) badge.textContent = enabled ? 'Auto-' + (ENGINE_FEATURES.find(function(f){return f.id===id})||{}).btn : '⏸ Off';
}

function _saveAutoMsgCfg() {
  _loadCfg('engine').then(function(cfg) {
    cfg.autoMsgBuyEnabled = document.getElementById('auto-msg-buy-enable').checked;
    cfg.autoMsgBuyText = document.getElementById('auto-msg-buy-text').value;
    cfg.autoMsgSellEnabled = document.getElementById('auto-msg-sell-enable').checked;
    cfg.autoMsgSellText = document.getElementById('auto-msg-sell-text').value;
    _saveCfg('engine', cfg);
  });
}

function _autoLog(msg, type) {
  var log = document.getElementById('automation-log');
  if (!log) return;
  var first = log.querySelector('div:first-child');
  if (first && first.textContent === 'No activity yet') first.remove();
  var time = new Date().toLocaleTimeString();
  var color = type === 'error' ? '#f44336' : type === 'success' ? '#4caf50' : type === 'warning' ? '#ff9800' : '#8888aa';
  log.insertAdjacentHTML('afterbegin', '<div style="color:' + color + ';"><span style="color:var(--text-quaternary);">[' + time + ']</span> ' + esc(msg) + '</div>');
  if (log.children.length > 200) log.lastElementChild.remove();
}

async function _checkPrereqs() {
  try {
    var res = await API.get('/api/automation/prereqs');
    if (res.code !== 0) throw new Error(res.msg || 'Failed');
    var d = res.data || {};
    var el = document.getElementById('prereq-okx');
    if (el) {
      el.querySelector('.prereq-icon').textContent = d.okx ? '✅' : '❌';
      el.querySelector('.prereq-status').textContent = d.okx ? 'Configured' : 'Not configured';
      el.querySelector('.prereq-status').style.color = d.okx ? '#4caf50' : '#f44336';
    }
    if (!d.okx) _autoLog('OKX API keys not configured', 'error');
  } catch (err) { _autoLog('Failed to check prerequisites: ' + err.message, 'error'); }
}

async function _fetchV2Logs() {
  try {
    var res = await API.get('/api/automation/v2/logs');
    if (res.code !== 0 || !res.data) return;
    // Merge v2 logs into the main #automation-log (top-level activity log)
    res.data.forEach(function(l) {
      // Skip logs that are clearly non-engine or internal server messages
      if (!l.msg || !l.ts) return;
      // Skip feature-specific messages that are already shown in their own panels
      var lower = l.msg.toLowerCase();
      if (lower.includes('[notif]') || lower.includes('[order') || lower.includes('[trade')) {
        // Only show key engine activities like "engine started/stopped", "process", "payment", "release", "error" etc.
        return;
      }
      // Filter out messages that are better shown in their respective feature cards
      // Keep general engine status messages, errors, successes, and important activities
      // Only skip clearly feature-card messages; most v2 logs go to the top log
      if (lower.includes('[notif]')) return;
      // Use the same format as _autoLog
      var time = new Date(l.ts).toLocaleTimeString();
      var color = l.type === 'error' ? '#f44336' : l.type === 'success' ? '#4caf50' : l.type === 'warning' ? '#ff9800' : '#8888aa';
      var log = document.getElementById('automation-log');
      if (!log) return;
      var first = log.querySelector('div:first-child');
      if (first && first.textContent === 'No activity yet') first.remove();
      log.insertAdjacentHTML('afterbegin', '<div style="color:' + color + ';"><span style="color:var(--text-quaternary);">[' + time + ']</span> ' + esc(l.msg) + '</div>');
      if (log.children.length > 200) log.lastElementChild.remove();
    });
  } catch (e) {}
}

async function _fetchStatus() {
  try {
    var res = await API.get('/api/automation/status');
    if (res.code !== 0) return;
    var d = res.data;
    var statusEl = document.getElementById('automation-status');
    var btn = document.getElementById('automation-toggle-btn');
    if (!statusEl || !btn) return;
    if (d.running) {
      statusEl.textContent = '▶ Running'; statusEl.style.color = '#4caf50';
      btn.textContent = 'Stop Engine'; btn.className = 'btn btn-danger';
    } else {
      statusEl.textContent = '⏸ Stopped'; statusEl.style.color = '#8888aa';
      btn.textContent = 'Start Engine'; btn.className = 'btn btn-primary';
    }
    if (d.stats) {
      document.getElementById('auto-orders-count').textContent = d.stats.ordersProcessed || 0;
      document.getElementById('auto-payments-count').textContent = d.stats.paymentsSent || 0;
      document.getElementById('auto-releases-count').textContent = d.stats.cryptoReleased || 0;
      document.getElementById('auto-appeals-count').textContent = d.stats.appealsCreated || 0;
    }
  } catch (e) {}
}

async function _pollV2Logs() {
  _fetchV2Logs();
}

// Add periodic V2 log polling (every 30s, same as status updates)
if (typeof _autoTimers === 'undefined') var _autoTimers = {};
_autoTimers.v2Logs = setInterval(_pollV2Logs, 30000);

async function _startAutomation(btn) {
  btn.disabled = true; btn.textContent = 'Starting...';
  try {
    var res = await API.post('/api/automation/start');
    if (res.code !== 0) {
      var errEl = document.getElementById('automation-error');
      if (errEl) { errEl.textContent = res.msg || 'Failed'; errEl.classList.remove('hidden'); }
      _autoLog('Failed to start: ' + (res.msg || 'unknown error'), 'error');
      btn.textContent = 'Start Engine'; btn.className = 'btn btn-primary';
      return;
    }
    _autoLog('Automation engine started', 'success');
    await _fetchStatus();
  } catch (err) {
    _autoLog('Failed to start: ' + err.message, 'error');
    btn.textContent = 'Start Engine'; btn.className = 'btn btn-primary';
  } finally { btn.disabled = false; }
}

async function _stopAutomation(btn) {
  btn.disabled = true; btn.textContent = 'Stopping...';
  try {
    var res = await API.post('/api/automation/stop');
    if (res.code !== 0) {
      _autoLog('Failed to stop: ' + (res.msg || 'unknown error'), 'error');
      btn.textContent = 'Stop Engine'; btn.className = 'btn btn-danger';
      return;
    }
    _autoLog('Automation engine stopped', 'info');
    await _fetchStatus();
  } catch (err) {
    _autoLog('Failed to stop: ' + err.message, 'error');
    btn.textContent = 'Stop Engine'; btn.className = 'btn btn-danger';
  } finally { btn.disabled = false; }
}

// ===== Generic feature tab renderer =====
var FEATURE_META = {
  orderAccept: { icon:'📋', title:'Smart Order Filtering', desc:'Reviews incoming P2P orders and auto-accepts or rejects them based on counterparty trust rules (KYC level, completion rate, amount ranges, disputes). Helps you avoid bad traders without watching the screen.', fields:[
    {k:'minAmount',l:'Min Amount (KES)',t:'number',p:'0 = no minimum'},
    {k:'maxAmount',l:'Max Amount (KES)',t:'number',p:'0 = no maximum'},
    {k:'minRating',l:'Min Counterparty Rating (0-5)',t:'number',p:'0 = any'},
    {k:'maxDisputes',l:'Max Disputes (-1=any)',t:'number',p:'-1 allows any'},
    {k:'cancelBadOrders',l:'Auto-cancel orders from bad counterparties',t:'checkbox'},
    {k:'cancelWithinSec',l:'Cancel within (seconds)',t:'number',p:'120'},
    {k:'autoReleaseSell',l:'Auto-release crypto on paid sell orders',t:'checkbox'}
  ]},
  schedule: { icon:'⏰', title:'Scheduled Profiles', desc:'Time-based trailing config switching — automatically apply different trailing settings at different times of day. E.g., tighter margins during peak hours, wider off-peak.', fields:['custom-schedule'] },
  balanceGuard: { icon:'🛡️', title:'Balance Guard', desc:'Automatically pauses your Buy ads when KES balance runs low, or pauses Sell ads when USDT is low. Resumes them when balance recovers. Prevents accepting orders you cannot fulfill.', fields:[
    {k:'pauseBuyWhenFiatBelow',l:'Pause Buy Ads when fiat below (KES)',t:'number',p:'0 = off'},
    {k:'pauseSellWhenCryptoBelow',l:'Pause Sell Ads when USDT below',t:'number',p:'0 = off'},
    {k:'autoResume',l:'Auto-resume ads when balance recovers',t:'checkbox'}
  ]},
  volumePricing: { icon:'📈', title:'Smart Volume Pricing', desc:'Auto-adjusts your margins based on 30-day trading volume. High volume = tighten margins to stay competitive. Low volume = widen margins for more profit per trade.', fields:[
    {k:'volumeThreshold',l:'Volume threshold (USDT)',t:'number',p:'30d volume above this tightens margins'},
    {k:'tightMargin',l:'Tight margin (%)',t:'number',p:'0.5'},
    {k:'wideMargin',l:'Wide margin (%)',t:'number',p:'2.0'},
    {k:'side',l:'Apply to side',t:'select',o:['both','buy','sell']}
  ]},
  copyStrategy: { icon:'📋', title:'Copy Strategy', desc:'Mirror pricing from selected competitor merchants. Pick merchants from the marketplace list, set a margin offset, and automatically match their prices on your ads.', fields:[
    {k:'marginOffset',l:'Margin offset (%)',t:'number',p:'0.1'},
    {k:'copyMode',l:'Copy mode',t:'select',o:[['price','Base price'],['margin','Margin rate']]}
  ]},
  blacklist: { icon:'🚫', title:'Auto Blacklist', desc:'Automatically blacklists counterparties with excessive cancellations or disputes. Can also auto-add them to your OKX block list so they cannot trade with you again.', fields:[
    {k:'cancelThreshold',l:'Cancel threshold (ratio, -1=off)',t:'number',p:'0.5 = 50% cancellation rate'},
    {k:'disputeThreshold',l:'Dispute threshold (count)',t:'number',p:'1 = blacklist after 1 dispute'},
    {k:'autoAdd',l:'Auto-add to OKX blacklist',t:'checkbox'}
  ]},
  notif: { icon:'🔔', title:'Performance Notifications', desc:'Sends push or desktop alerts for important events: new orders completed, engine errors, balance thresholds hit, or counterparty disputes. Stay informed without refreshing.', fields:[
    {k:'events',l:'Events',t:'sub'},
    {k:'channels',l:'Channels',t:'sub'}
  ]},
  report: { icon:'📊', title:'Automated Reports', desc:'Generates daily or weekly summaries of your P2P performance: total volume, profit, completed orders, and trends. Delivered automatically to your notifications.', fields:[
    {k:'frequency',l:'Frequency',t:'select',o:[['daily','Daily'],['weekly','Weekly']]},
    {k:'channels',l:'Channels',t:'sub'}
  ]},
  autoFund: { icon:'💰', title:'Auto Fund', desc:'Buy and Sell each run as their own strategy: target balance, check interval, funding reserve, payment duration and ad selection — configured per tab below.', fields:[]}
};

async function _renderFeature(container, feature) {
  var meta = FEATURE_META[feature];
  container.innerHTML = '<div class="card" style="max-width:780px;margin:0 auto 20px;"><div id="auto-feature-inner">Loading...</div></div>';
  var inner = container.querySelector('#auto-feature-inner');

  var cfg = await _loadCfg(feature);
  // One-time migration: legacy single paymentDuration → per-side fields
  if (feature === 'autoFund' && cfg.paymentDuration && cfg.buyPaymentDuration === undefined && cfg.sellPaymentDuration === undefined) {
    cfg.buyPaymentDuration = cfg.paymentDuration;
    cfg.sellPaymentDuration = cfg.paymentDuration;
    delete cfg.paymentDuration;
    _saveCfgDebounced('autoFund', { buyPaymentDuration: cfg.buyPaymentDuration, sellPaymentDuration: cfg.sellPaymentDuration });
  }
  var statusData = await _loadStatus();
  var featEnabled = statusData && statusData.features && statusData.features[feature];

  var h = '';
  h += '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;flex-wrap:wrap;gap:8px;">';
  h += '<div style="display:flex;align-items:center;gap:10px;"><span style="font-size:28px;">' + meta.icon + '</span><div><h2 style="margin:0;font-size:18px;">' + meta.title + '</h2><p style="margin:2px 0 0;color:var(--text-tertiary);font-size:12px;">' + meta.desc + '</p></div></div>';
  h += '<label style="display:flex;align-items:center;gap:6px;font-size:13px;cursor:pointer;padding:6px 12px;border-radius:6px;background:' + (featEnabled ? 'rgba(76,175,80,0.1)' : 'rgba(100,100,120,0.08)') + ';border:1px solid ' + (featEnabled ? 'rgba(76,175,80,0.3)' : 'transparent') + ';"><input type="checkbox" id="feat-toggle-' + feature + '" ' + (featEnabled ? 'checked' : '') + ' onchange="_toggleFeature(\'' + feature + '\',this.checked)"> <span style="font-weight:600;">' + (featEnabled ? '🟢 Enabled' : '⏸ Disabled') + '</span></label>';
  h += '</div>';

  // Engine status bar
  h += '<div style="display:flex;align-items:center;gap:12px;padding:10px 14px;border-radius:8px;background:rgba(0,0,0,0.15);margin-bottom:16px;font-size:13px;">';
  h += '<span>⚙️ Engine: <strong id="v2-status-text">' + (statusData && statusData.running ? '▶ Running' : '⏸ Stopped') + '</strong></span>';
  h += '<button class="btn btn-sm ' + (statusData && statusData.running ? 'btn-danger' : 'btn-primary') + '" style="font-size:11px;padding:4px 12px;" onclick="_toggleV2Engine()">' + (statusData && statusData.running ? 'Stop' : 'Start') + ' Engine</button>';
  h += '<span style="margin-left:auto;font-size:10px;color:#8888aa;" title="AutoFund UI build">UI 20260804o</span>';
  h += '<button class="btn btn-sm btn-ghost" style="font-size:10px;padding:3px 10px;" onclick="_afSaveTest()">Save test</button>';
  h += '<span id="af-save-test-out" style="font-size:10px;color:#8888aa;"></span>';
  h += '</div>';

  // Config fields
  h += '<div style="margin-bottom:12px;">';
  if (feature === 'schedule') {
    h += _renderScheduleProfiles(cfg);
  } else if (feature === 'copyStrategy') {
    h += '<div id="cs-merchant-area">Loading merchants...</div>';
    h += '<div style="margin-top:10px;padding:6px 0;">';
    h += '<label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">Margin offset (%)</label>';
    h += '<input type="number" data-feat="copyStrategy" data-key="marginOffset" value="' + esc(String(cfg.marginOffset ?? '')) + '" placeholder="0.1" onchange="_cfgChange(this)" style="width:100%;max-width:260px;padding:7px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;"></div>';
    h += '<div style="padding:6px 0;"><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">Copy mode</label><select data-feat="copyStrategy" data-key="copyMode" onchange="_cfgChange(this)" style="padding:7px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;width:100%;max-width:260px;">';
    h += '<option value="price"' + (cfg.copyMode === 'price' ? ' selected' : '') + '>Base price</option>';
    h += '<option value="margin"' + (cfg.copyMode === 'margin' ? ' selected' : '') + '>Margin rate</option>';
    h += '</select></div>';
  } else {
    meta.fields.forEach(function(f) {
      if (f === 'custom-schedule') return;
      if (feature === 'autoFund' && (f.k === 'buyPaymentDuration' || f.k === 'sellPaymentDuration')) return;
      var val = cfg[f.k];
      if (val === undefined) val = '';
      if (f.t === 'checkbox') {
        h += '<label style="display:flex;align-items:center;gap:8px;padding:8px 0;font-size:13px;cursor:pointer;"><input type="checkbox" data-feat="' + feature + '" data-key="' + f.k + '" ' + (val ? 'checked' : '') + ' onchange="_cfgChange(this)"> ' + f.l + '</label>';
      } else if (f.t === 'select') {
        h += '<div style="padding:6px 0;"><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">' + f.l + '</label><select data-feat="' + feature + '" data-key="' + f.k + '" onchange="_cfgChange(this)" style="padding:7px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;width:100%;max-width:260px;">';
        f.o.forEach(function(o) {
          var ov = Array.isArray(o) ? o[0] : o;
          var ol = Array.isArray(o) ? o[1] : o;
          h += '<option value="' + ov + '"' + (String(val) === String(ov) ? ' selected' : '') + '>' + ol + '</option>';
        });
        h += '</select></div>';
      } else if (f.t === 'sub') {
        h += '<div style="padding:8px 0;border-top:1px solid #1e1e2e;margin-top:8px;"><div style="font-size:12px;font-weight:600;color:var(--text-tertiary);margin-bottom:6px;">' + f.l + '</div>';
        if (cfg[f.k] && typeof cfg[f.k] === 'object') {
          for (var sk in cfg[f.k]) {
            var sv = cfg[f.k][sk];
            if (typeof sv === 'boolean') {
              h += '<label style="display:inline-flex;align-items:center;gap:6px;margin:4px 8px 4px 0;font-size:12px;cursor:pointer;"><input type="checkbox" data-feat="' + feature + '" data-key="' + f.k + '.' + sk + '" ' + (sv ? 'checked' : '') + ' onchange="_cfgChange(this)"> ' + sk + '</label>';
            }
          }
        }
        h += '</div>';
      } else {
        h += '<div style="padding:6px 0;"><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">' + f.l + '</label><input type="' + f.t + '" data-feat="' + feature + '" data-key="' + f.k + '" value="' + esc(String(val)) + '" placeholder="' + (f.p || '') + '" onchange="_cfgChange(this)" style="width:100%;max-width:260px;padding:7px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;"></div>';
      }
    });
  }
  h += '</div>';

  // Auto-fund: Buy tab / Sell tab — each side is its own independent strategy
  if (feature === 'autoFund') {
    var afCfg = _autoCfgs.autoFund || cfg || {};
    var durOpts = { buy: [['5','5 min'],['10','10 min'],['15','15 min'],['30','30 min'],['60','1 hour'],['120','2 hours']], sell: [['30','30 min'],['60','1 hour'],['120','2 hours']] };
    function afSideVal(side, key, fallbackKey) {
      var s = afCfg[side];
      var v = (s && s[key] !== undefined && s[key] !== '') ? s[key] : afCfg[fallbackKey];
      return (v === undefined || v === '') ? '' : String(v);
    }
    function afSideEnabled(side) {
      var s = afCfg[side];
      if (s && s.enabled !== undefined) return !!s.enabled;
      return side === 'buy' ? afCfg.buyEnabled !== false : afCfg.sellEnabled !== false;
    }
    function afSideBool(side, key) {
      var s = afCfg[side];
      var v = (s && s[key] !== undefined && s[key] !== '') ? s[key] : afCfg[key];
      if (v === undefined || v === '') return true;
      return v === true || v === 'true' || v === 1 || v === '1';
    }
    function durSelect(side) {
      var cur = afSideVal(side, 'paymentDuration', side + 'PaymentDuration');
      var s = '<select data-feat="autoFund" data-key="' + side + '.paymentDuration" onchange="_cfgChange(this)" style="padding:7px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;width:100%;max-width:260px;margin-bottom:10px;">';
      durOpts[side].forEach(function(o) { s += '<option value="' + o[0] + '"' + (cur === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; });
      s += '</select>';
      return s;
    }
    function numInput(side, key, label, ph) {
      return '<div style="padding:4px 0;"><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">' + label + '</label><input type="number" data-feat="autoFund" data-key="' + side + '.' + key + '" value="' + esc(afSideVal(side, key, key)) + '" placeholder="' + ph + '" onchange="_cfgChange(this)" style="width:100%;max-width:260px;padding:7px 10px;border-radius:6px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);font-size:12px;outline:none;"></div>';
    }
    // Tab bar
    h += '<div style="display:flex;gap:4px;margin-bottom:10px;">';
    ['buy','sell'].forEach(function(s) {
      var active = _autoFundTabSide === s;
      h += '<span id="af-tab-' + s + '" style="cursor:pointer;padding:5px 16px;border-radius:4px;font-size:12px;font-weight:600;background:' + (active ? 'rgba(68,138,255,0.2)' : 'rgba(0,0,0,0.15)') + ';border:1px solid ' + (active ? 'rgba(68,138,255,0.4)' : '#1e1e2e') + ';" onclick="window._autoFundTab(\'' + s + '\')">' + (s === 'buy' ? '📥 Buy' : '📤 Sell') + '</span>';
    });
    h += '</div>';
    // Panels
    ['buy','sell'].forEach(function(s) {
      h += '<div id="auto-fund-panel-' + s + '" class="card" style="padding:14px;border-color:' + (s === 'buy' ? 'rgba(68,138,255,0.25)' : 'rgba(76,175,80,0.25)') + ';display:' + (_autoFundTabSide === s ? 'block' : 'none') + ';">';
      h += '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;">';
      h += '<span style="font-size:13px;font-weight:700;color:' + (s === 'buy' ? '#4a9eff' : '#4caf50') + ';">' + (s === 'buy' ? '📥 Buy' : '📤 Sell') + ' strategy</span>';
      var afLoop = (statusData && statusData.autoFund && statusData.autoFund[s]) || {};
      h += '<span id="auto-fund-' + s + '-status" style="font-size:11px;font-weight:600;color:' + (afLoop.running ? '#4caf50' : '#f44336') + ';">' + (afLoop.running ? '▶ Running' : '⏹ Stopped') + '</span>';
      h += '</div>';
      h += '<div id="auto-fund-' + s + '-loop" style="font-size:10px;color:var(--text-quaternary);margin-top:2px;">' + _afLoopInfo(afLoop) + '</div>';
      h += '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:8px;">';
      h += numInput(s, 'targetBalance', 'Target balance (USDT)', '600');
      h += numInput(s, 'intervalMin', 'Check every (min)', '5');
      h += numInput(s, 'minFundingBalance', 'Min funding reserve', '100');
      h += '</div>';
      h += '<label style="font-size:12px;color:var(--text-tertiary);display:block;margin-bottom:4px;">Payment duration (minutes)</label>';
      h += durSelect(s);
      h += '<div id="auto-fund-' + s + '-ads" style="font-size:12px;">Loading ' + s + ' ads...</div>';
      h += '<label style="display:flex;align-items:center;gap:8px;margin-top:10px;font-size:12px;color:var(--text-secondary);cursor:pointer;"><input type="checkbox" data-feat="autoFund" data-key="' + s + '.fallbackToActiveAds"' + (afSideBool(s, 'fallbackToActiveAds') ? ' checked' : '') + ' onchange="_cfgChange(this)"> Fallback: if my selected ' + s + ' ad is lost, top up the active ' + s + ' ads instead</label>';
      h += '<div style="font-size:10px;color:var(--text-quaternary);margin-top:6px;">Selecting ads auto-starts this side; unchecking all ads stops it.</div>';
      h += '<div style="display:flex;gap:6px;align-items:center;margin-top:10px;">';
      h += '<button class="btn btn-sm btn-danger" onclick="_autoFundToggle(\'' + s + '\', false)">⏹ Stop</button>';
      h += '<button class="btn btn-sm btn-success" onclick="_autoFundToggle(\'' + s + '\', true)">▶ Start</button>';
      h += '</div>';
      h += '<div id="auto-fund-' + s + '-saved" style="font-size:11px;min-height:16px;margin-top:4px;"></div>';
      h += '</div>';
    });
    h += '<div style="font-size:10px;color:var(--text-quaternary);margin-top:6px;">Each tab is an independent strategy — own target, interval, funding reserve, payment duration and ad selection — running its own standalone engine loop with its own timer, last-run and error isolation.</div>';
  }

  if (feature === 'report') {
    h += '<div style="margin-top:12px;"><button class="btn btn-sm btn-primary" onclick="_generateReportNow()" style="font-size:12px;">📊 Generate Report Now</button> <span id="report-gen-status" style="font-size:11px;color:var(--text-quaternary);margin-left:8px;"></span></div>';
  }

  // Log section
  if (feature === 'schedule') {
    h += '<div id="schedule-edit-area"></div>';
  }
  h += '<div style="margin-top:16px;border-top:1px solid #1e1e2e;padding-top:12px;">';
  h += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">';
  h += '<span style="font-size:13px;font-weight:600;">Activity Log</span>';
  h += '<button class="btn btn-sm btn-ghost" style="font-size:10px;" onclick="_clearV2Logs()">Clear</button></div>';
  h += '<div id="v2-log-' + feature + '" style="max-height:250px;overflow-y:auto;font-size:11px;font-family:monospace;line-height:1.7;"></div>';
  h += '</div></div>';

  if (feature === 'report') {
    h += '<div id="report-history-section" style="margin-top:20px;"><div class="card" style="max-width:780px;margin:0 auto;"><h3 style="margin-bottom:12px;">📊 Report History</h3><div id="report-history-list" style="color:var(--text-tertiary);font-size:13px;">Loading reports...</div></div></div>';
  }

  inner.innerHTML = h;
  if (feature === 'schedule') { _initScheduleEditor(inner, cfg); }
  if (feature === 'copyStrategy') { _loadCopyStrategyMerchants(inner, cfg); }
  if (feature === 'autoFund') { _loadAutoFundSideAds('buy'); _loadAutoFundSideAds('sell'); }
  if (feature === 'report') { _loadReportHistory(); }
  _refreshV2Logs(feature);
  _autoTimers[feature] = setInterval(function() { if (!document.hidden) _refreshV2Logs(feature); }, 30000);
  if (feature === 'autoFund') {
    if (_autoTimers['autoFund-loop']) clearInterval(_autoTimers['autoFund-loop']);
    _autoTimers['autoFund-loop'] = setInterval(function() { if (!document.hidden) _afRefreshLoopStatus(); }, 10000);
  }
}

// ===== Copy Strategy: merchant selection with buy/sell tabs =====
async function _loadCopyStrategyMerchants(container, cfg) {
  var area = document.getElementById('cs-merchant-area');
  if (!area) return;
  var selectedMids = cfg.merchantIds || [];
  if (!Array.isArray(selectedMids)) selectedMids = [];
  var selectedSide = cfg.side || 'both';

  // Fetch marketplace merchants
  try {
    var [buyRes, sellRes] = await Promise.all([
      API.get('/api/p2p/marketplace-list?side=buy&cryptoCurrency=USDT&fiatCurrency=KES&limit=30'),
      API.get('/api/p2p/marketplace-list?side=sell&cryptoCurrency=USDT&fiatCurrency=KES&limit=30')
    ]);
    var buyData = Array.isArray(buyRes.data) ? buyRes.data : [];
    var buyAds = buyData.length > 0 && Array.isArray(buyData[0].buyAds) ? buyData[0].buyAds : buyData;
    var sellData = Array.isArray(sellRes.data) ? sellRes.data : [];
    var sellAds = sellData.length > 0 && Array.isArray(sellData[0].sellAds) ? sellData[0].sellAds : sellData;
    var allAds = buyAds.concat(sellAds);
    var seen = {};
    var merchants = [];
    allAds.forEach(function(ad) {
      var cr = ad.creator || {};
      var mid = cr.userId || cr.user_id || '';
      if (mid && !seen[mid]) { seen[mid] = true; merchants.push({ id: mid, name: cr.nickName || cr.nick_name || mid.slice(-8), rating: cr.userRating || cr.rating || '' }); }
    });
    merchants.sort(function(a, b) { return a.name.localeCompare(b.name); });

    var h = '';
    // Side tabs
    h += '<div style="display:flex;gap:4px;margin-bottom:10px;">';
    ['both','buy','sell'].forEach(function(s) {
      h += '<span style="cursor:pointer;padding:4px 14px;border-radius:4px;font-size:12px;font-weight:600;background:' + (selectedSide === s ? 'rgba(68,138,255,0.2)' : 'rgba(0,0,0,0.15)') + ';border:1px solid ' + (selectedSide === s ? 'rgba(68,138,255,0.4)' : '#1e1e2e') + ';" onclick="window._csSetSide(\'' + s + '\')" class="cs-side-' + s + '">' + s.charAt(0).toUpperCase() + s.slice(1) + '</span>';
    });
    h += '<button class="btn btn-sm btn-ghost" style="font-size:10px;margin-left:auto;" onclick="window._csRefreshMerchants()">↻ Refresh</button>';
    h += '</div>';

    // Merchant count
    h += '<div style="font-size:11px;color:var(--text-tertiary);margin-bottom:6px;">' + merchants.length + ' merchants found — click to select for copying</div>';

    // Selected merchants tags
    h += '<div id="cs-selected-tags" style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:8px;">';
    if (selectedMids.length === 0) {
      h += '<span style="font-size:11px;color:var(--text-quaternary);">No merchants selected</span>';
    } else {
      selectedMids.forEach(function(mid) {
        var m = merchants.find(function(mm) { return mm.id === mid; });
        var label = m ? m.name : mid.slice(-8);
        h += '<span style="display:inline-flex;align-items:center;gap:4px;background:rgba(68,138,255,0.15);border:1px solid rgba(68,138,255,0.3);border-radius:4px;padding:2px 6px;font-size:11px;"><span>' + esc(label) + '</span><span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" onclick="window._csRemoveMerchant(\'' + esc(mid) + '\')">×</span></span>';
      });
    }
    h += '</div>';

    // Merchant list (scrollable, checkbox style)
    h += '<div style="max-height:260px;overflow-y:auto;border:1px solid var(--border-primary);border-radius:6px;padding:4px;">';
    merchants.forEach(function(m) {
      var checked = selectedMids.indexOf(m.id) !== -1 ? ' checked' : '';
      h += '<label style="display:flex;align-items:center;gap:8px;padding:5px 8px;border-radius:4px;cursor:pointer;font-size:12px;' + (checked ? 'background:rgba(68,138,255,0.08);' : '') + '">';
      h += '<input type="checkbox" value="' + esc(m.id) + '"' + checked + ' onchange="window._csToggleMerchant(this)">';
      h += '<span>' + esc(m.name) + '</span>';
      if (m.rating) h += '<span style="font-size:10px;color:#8888aa;margin-left:auto;">⭐ ' + esc(m.rating) + '</span>';
      h += '</label>';
    });
    h += '</div>';

    area.innerHTML = h;
  } catch (err) {
    area.innerHTML = '<div style="padding:12px;color:#f44336;font-size:12px;">Failed to load merchants: ' + esc(err.message) + ' <button class="btn btn-sm btn-ghost" style="margin-left:8px;" onclick="window._csRefreshMerchants()">Retry</button></div>';
  }
}

// Copy strategy helper functions
window._csToggleMerchant = function(el) {
  var mid = el.value;
  var checked = el.checked;
  _loadCfg('copyStrategy').then(function(cfg) {
    var mids = cfg.merchantIds || [];
    if (!Array.isArray(mids)) mids = [];
    if (checked) { if (mids.indexOf(mid) === -1) mids.push(mid); }
    else { mids = mids.filter(function(m) { return m !== mid; }); }
    cfg.merchantIds = mids;
    _saveCfg('copyStrategy', cfg);
    // Update tags
    var tagsEl = document.getElementById('cs-selected-tags');
    if (tagsEl) {
      var h = '';
      if (mids.length === 0) { h = '<span style="font-size:11px;color:var(--text-quaternary);">No merchants selected</span>'; }
      else { mids.forEach(function(m) {
        h += '<span style="display:inline-flex;align-items:center;gap:4px;background:rgba(68,138,255,0.15);border:1px solid rgba(68,138,255,0.3);border-radius:4px;padding:2px 6px;font-size:11px;"><span>' + esc(m.slice(-8)) + '</span><span style="cursor:pointer;color:#f44336;font-size:13px;line-height:1;" onclick="window._csRemoveMerchant(\'' + esc(m) + '\')">×</span></span>';
      }); }
      tagsEl.innerHTML = h;
    }
  });
};
window._csRemoveMerchant = function(mid) {
  _loadCfg('copyStrategy').then(function(cfg) {
    var mids = cfg.merchantIds || [];
    if (!Array.isArray(mids)) mids = [];
    cfg.merchantIds = mids.filter(function(m) { return m !== mid; });
    _saveCfg('copyStrategy', cfg);
    _loadCopyStrategyMerchants(null, cfg);
  });
};
window._csSetSide = function(side) {
  _loadCfg('copyStrategy').then(function(cfg) {
    cfg.side = side;
    _saveCfg('copyStrategy', cfg);
    ['both','buy','sell'].forEach(function(s) {
      var el = document.querySelector('.cs-side-' + s);
      if (el) {
        el.style.background = s === side ? 'rgba(68,138,255,0.2)' : 'rgba(0,0,0,0.15)';
        el.style.borderColor = s === side ? 'rgba(68,138,255,0.4)' : '#1e1e2e';
      }
    });
  });
};
window._csRefreshMerchants = function() {
  var area = document.getElementById('cs-merchant-area');
  if (area) area.innerHTML = 'Loading merchants...';
  _loadCfg('copyStrategy').then(function(cfg) { _loadCopyStrategyMerchants(null, cfg); });
};

function _renderScheduleProfiles(cfg) {
  var profiles = cfg.profiles || [];
  var daysLabel = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var h = '';
  h += '<div style="margin-bottom:8px;"><strong style="font-size:13px;">📅 Profiles</strong>';
  h += ' <span style="font-size:11px;color:var(--text-tertiary);">(' + profiles.length + ' configured)</span></div>';
  if (profiles.length === 0) {
    h += '<div style="padding:20px 0;text-align:center;color:var(--text-quaternary);font-size:13px;">No profiles yet. Add one below.</div>';
  }
  profiles.forEach(function(p, i) {
    var dayStr = (p.days || []).map(function(d) { return daysLabel[d] || d; }).join(', ') || 'None';
    h += '<div style="display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:6px;background:rgba(0,0,0,0.1);margin-bottom:4px;border:1px solid var(--border-primary);">';
    h += '<span style="font-size:14px;">' + esc(p.name || 'Unnamed') + '</span>';
    h += '<span style="font-size:10px;color:var(--text-quaternary);">' + dayStr + '</span>';
    h += '<span style="font-size:10px;color:#8888aa;">' + esc(p.timeStart || '--') + ' → ' + esc(p.timeEnd || '--') + '</span>';
    h += '<span class="badge badge-' + (p.side || 'buy') + '" style="font-size:9px;text-transform:uppercase;">' + (p.side || 'buy') + '</span>';
    h += '<button class="btn btn-sm btn-ghost" style="font-size:10px;color:#f44336;margin-left:auto;" onclick="_deleteScheduleProfile(' + i + ')">✕</button>';
    h += '</div>';
  });
  return h;
}
function _initScheduleEditor(container, cfg) {
  var area = document.getElementById('schedule-edit-area');
  if (!area) return;
  var pcount = (cfg.profiles || []).length;
  area.innerHTML = '\
    <div style="border-top:1px solid #1e1e2e;padding:12px 0 4px;">\
      <strong style="font-size:13px;">➕ Add Profile</strong>\
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:8px;font-size:12px;">\
        <div><label style="display:block;color:var(--text-tertiary);margin-bottom:2px;">Profile Name</label>\
          <input id="sp-name" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;" placeholder="Night mode"></div>\
        <div><label style="display:block;color:var(--text-tertiary);margin-bottom:2px;">Side</label>\
          <select id="sp-side" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;">\
            <option value="buy">Buy</option><option value="sell">Sell</option></select></div>\
      </div>\
      <div style="margin-top:6px;"><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:2px;">Days</label>\
        <div style="display:flex;gap:4px;flex-wrap:wrap;">' +
        ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(function(d, i) {
          return '<label style="display:flex;align-items:center;gap:3px;font-size:11px;padding:3px 6px;border-radius:4px;background:rgba(0,0,0,0.1);cursor:pointer;"><input type="checkbox" class="sp-day" value="' + i + '" checked> ' + d + '</label>';
        }).join('') +
      '</div></div>\
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:6px;">\
        <div><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:2px;">Start Time</label><input type="time" id="sp-start" value="00:00" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;"></div>\
        <div><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:2px;">End Time</label><input type="time" id="sp-end" value="23:59" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;"></div>\
      </div>\
      <div style="margin-top:6px;"><label style="display:block;font-size:12px;color:var(--text-tertiary);margin-bottom:2px;">Trailing Config Override (leave blank = no change)</label></div>\
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-top:4px;">\
        <div><input id="sp-margin" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;font-size:11px;" placeholder="Margin (e.g. 0.01)"></div>\
        <div><select id="sp-marginType" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;font-size:11px;"><option value="">—</option><option value="fixed">Fixed KES</option><option value="percent">Percent</option></select></div>\
        <div><select id="sp-trailMode" style="width:100%;padding:6px 8px;border-radius:5px;border:1px solid var(--border-primary);background:var(--bg-primary);color:var(--text-primary);outline:none;font-size:11px;"><option value="">—</option><option value="price">Price target</option><option value="market">Market optimal</option></select></div>\
      </div>\
      <button class="btn btn-primary btn-sm" style="margin-top:8px;" onclick="_addScheduleProfile()">➕ Add Profile</button>\
      <div id="sp-error" style="color:#f44336;font-size:11px;margin-top:4px;"></div>\
    </div>';
}

// ===== Auto-Fund: per-side ad selection (Buy card / Sell card) =====
// Client-side cache for active ads (30s TTL) to avoid repeated OKX calls
var _autoFundAdsCache = { buy: null, sell: null, expires: 0 };
var _AUTO_FUND_ADS_TTL = 30000;
async function _loadAutoFundSideAds(side) {
  var area = document.getElementById('auto-fund-' + side + '-ads');
  if (!area) return;
  try {
    var now = Date.now();
    // Serve from cache if fresh
    if (_autoFundAdsCache[side] && now < _autoFundAdsCache.expires) {
      var ads = _autoFundAdsCache[side];
      var cfg = _autoCfgs.autoFund || {};
      var sideObj = cfg[side];
      var selected = (sideObj && Array.isArray(sideObj.adIds)) ? sideObj.adIds : (Array.isArray(cfg.adIds) ? cfg.adIds : []);
      var h = '<div style="display:flex;flex-direction:column;gap:6px;">';
      ads.forEach(function(ad) {
        var aid = ad.adId || ad.id || '';
        var checked = selected.indexOf(aid) > -1;
        var price = ad.unitPrice || ad.price || '?';
        var remaining = ad.availableAmount || ad.quantity || '?';
        h += '<label style="display:flex;align-items:center;gap:8px;padding:6px 10px;border-radius:6px;background:rgba(0,0,0,0.1);cursor:pointer;border:1px solid ' + (checked ? 'rgba(68,138,255,0.4)' : 'transparent') + ';">';
        h += '<input type="checkbox" class="af-ad-cb" value="' + aid + '" ' + (checked ? 'checked' : '') + ' onchange="_onAutoFundAdToggle(this, \'' + side + '\')">';
        h += '<span style="font-size:12px;"><strong>Ad ' + aid.slice(-10) + '</strong>  KES ' + price + '  ' + remaining + ' USDT</span>';
        h += '</label>';
      });
      h += '</div>';
      area.innerHTML = h;
      return;
    }
    var res = await API.get('/api/okx/p2p/active-ads?side=' + side);
    var ads = (res && res.code === 0 && Array.isArray(res.data)) ? res.data : [];
    _autoFundAdsCache[side] = ads;
    _autoFundAdsCache.expires = now + _AUTO_FUND_ADS_TTL;
    if (ads.length === 0) {
      area.innerHTML = '<div style="color:var(--text-quaternary);padding:8px 0;">No active ' + side + ' ads. Create one first.</div>';
      return;
    }
    var cfg = _autoCfgs.autoFund || {};
    var sideObj = cfg[side];
    var selected = (sideObj && Array.isArray(sideObj.adIds)) ? sideObj.adIds : (Array.isArray(cfg.adIds) ? cfg.adIds : []);
    var h = '<div style="display:flex;flex-direction:column;gap:6px;">';
    ads.forEach(function(ad) {
      var aid = ad.adId || ad.id || '';
      var checked = selected.indexOf(aid) > -1;
      var price = ad.unitPrice || ad.price || '?';
      var remaining = ad.availableAmount || ad.quantity || '?';
      h += '<label style="display:flex;align-items:center;gap:8px;padding:6px 10px;border-radius:6px;background:rgba(0,0,0,0.1);cursor:pointer;border:1px solid ' + (checked ? 'rgba(68,138,255,0.4)' : 'transparent') + ';">';
      h += '<input type="checkbox" class="af-ad-cb" value="' + aid + '" ' + (checked ? 'checked' : '') + ' onchange="_onAutoFundAdToggle(this, \'' + side + '\')">';
      h += '<span style="font-size:12px;"><strong>Ad ' + aid.slice(-10) + '</strong>  KES ' + price + '  ' + remaining + ' USDT</span>';
      h += '</label>';
    });
    h += '</div>';
    area.innerHTML = h;
  } catch (e) {
    area.innerHTML = '<div style="color:#f44336;font-size:12px;">Failed to load ' + side + ' ads: ' + e.message + '</div>';
  }
}
function _onAutoFundAdToggle(el, side) {
  var cfg = _autoCfgs.autoFund || {};
  if (!side) side = 'buy';
  if (!cfg[side] || typeof cfg[side] !== 'object') cfg[side] = {};
  var selected = cfg[side].adIds || [];
  if (!Array.isArray(selected)) selected = [];
  if (el.checked) {
    if (selected.indexOf(el.value) === -1) selected.push(el.value);
  } else {
    selected = selected.filter(function(id) { return id !== el.value; });
  }
  cfg[side].adIds = selected;
  _autoCfgs.autoFund = cfg;
  var patch = {};
  patch[side] = { adIds: selected };
  _saveCfgDebounced('autoFund', patch, function(ok, msg) { _autoFundSaveHint(side, ok, msg); }, true);
  // Ads selection drives the engine: selecting ads starts this side,
  // clearing them stops it. The per-side Start/Stop buttons still work too.
  _autoFundSetSide(side, selected.length > 0).then(function() {
    _afRefreshLoopStatus();
  }).catch(function() {});
}
var _autoFundTabSide = 'buy';
window._afSaveTest = function() {
  var el = document.getElementById('af-save-test-out');
  if (!el) return;
  el.textContent = 'Sending…';
  API.post('/api/automation/v2/config/autoFund', { _saveTest: String(Date.now()) })
    .then(function(res) {
      el.textContent = 'Server replied code=' + (res && res.code !== undefined ? res.code : '?');
    })
    .catch(function(e) {
      el.textContent = 'FAILED: ' + ((e && e.message) || 'network error');
    });
};
window.addEventListener('error', function(ev) {
  var el = document.getElementById('js-err-box');
  if (!el) {
    el = document.createElement('div');
    el.id = 'js-err-box';
    el.style.cssText = 'position:fixed;top:8px;left:8px;right:8px;z-index:99999;background:#3d0b0b;color:#ffb3b3;padding:8px 12px;border:1px solid #f44336;border-radius:6px;font-size:12px;font-family:monospace;display:none;';
    document.body.appendChild(el);
  }
  el.style.display = 'block';
  el.textContent = 'JS ERROR: ' + (ev.message || 'unknown') + ' (' + String(ev.filename || '').split('/').pop() + ':' + ev.lineno + ')';
});
window.addEventListener('unhandledrejection', function(ev) {
  var el = document.getElementById('js-err-box');
  if (!el) {
    el = document.createElement('div');
    el.id = 'js-err-box';
    el.style.cssText = 'position:fixed;top:8px;left:8px;right:8px;z-index:99999;background:#3d0b0b;color:#ffb3b3;padding:8px 12px;border:1px solid #f44336;border-radius:6px;font-size:12px;font-family:monospace;display:none;';
    document.body.appendChild(el);
  }
  el.style.display = 'block';
  el.textContent = 'JS PROMISE ERROR: ' + ((ev && ev.reason && (ev.reason.message || ev.reason)) || 'unknown');
});
window._autoFundTab = function(side) {
  _autoFundTabSide = side;
  var b = document.getElementById('auto-fund-panel-buy');
  var s = document.getElementById('auto-fund-panel-sell');
  if (b) b.style.display = side === 'buy' ? 'block' : 'none';
  if (s) s.style.display = side === 'sell' ? 'block' : 'none';
  function mark(el, active) {
    if (!el) return;
    el.style.background = active ? 'rgba(68,138,255,0.2)' : 'rgba(0,0,0,0.15)';
    el.style.borderColor = active ? 'rgba(68,138,255,0.4)' : '#1e1e2e';
  }
  mark(document.getElementById('af-tab-buy'), side === 'buy');
  mark(document.getElementById('af-tab-sell'), side === 'sell');
};
function _autoFundSetSide(side, on) {
  // Start/stop the standalone engine for this side (server persists enabled)
  return API.post('/api/automation/v2/autofund/' + side + '/' + (on ? 'start' : 'stop')).then(function(res) {
    var cfg = _autoCfgs.autoFund || {};
    if (!cfg[side] || typeof cfg[side] !== 'object') cfg[side] = {};
    cfg[side].enabled = on;
    _autoCfgs.autoFund = cfg;
    return res;
  });
}
async function _autoFundToggle(side, on) {
  try {
    await _autoFundSetSide(side, on);
    // Re-render the whole feature page so the status change is unmistakable
    await _renderFeature(document.getElementById('auto-page-content'), 'autoFund');
    _autoFundSaveHint(side, true);
  } catch (e) {
    _autoFundSaveHint(side, false, e.message || 'request failed');
  }
}
function _afLoopInfo(l) {
  if (!l || !l.lastRun) return 'engine idle — no run yet';
  var mins = Math.floor((Date.now() - l.lastRun) / 60000);
  var ago = mins >= 60 ? Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm' : mins + 'm';
  return 'last run ' + ago + ' ago · ' + new Date(l.lastRun).toLocaleTimeString();
}
async function _afRefreshLoopStatus() {
  var statusData = await _loadStatus();
  if (!statusData || !statusData.autoFund) return;
  ['buy', 'sell'].forEach(function(s) {
    var l = statusData.autoFund[s] || {};
    var st = document.getElementById('auto-fund-' + s + '-status');
    if (st) {
      st.textContent = l.running ? '▶ Running' : '⏹ Stopped';
      st.style.color = l.running ? '#4caf50' : '#f44336';
    }
    var li = document.getElementById('auto-fund-' + s + '-loop');
    if (li) li.textContent = _afLoopInfo(l);
  });
}

var _autoCfgLoadFailed = {};
async function _loadCfg(feature) {
  if (_autoCfgs[feature]) return _autoCfgs[feature];
  try {
    var res = await API.get('/api/automation/v2/config/' + feature);
    if (res.code === 0 && res.data) {
      _autoCfgs[feature] = res.data;
      _autoCfgLoadFailed[feature] = false;
      return res.data;
    }
  } catch (e) {}
  // Load failed — mark it so we never save a partial/empty config over the
  // real one stored server-side (that would silently wipe the feature config).
  _autoCfgLoadFailed[feature] = true;
  return {};
}

async function _loadStatus() {
  try {
    var res = await API.get('/api/automation/v2/status');
    if (res.code === 0) return res.data;
  } catch (e) {}
  return null;
}

function _cfgChange(el) {
  var feature = el.getAttribute('data-feat');
  var key = el.getAttribute('data-key');
  var cfg = _autoCfgs[feature] || {};
  var val = el.type === 'checkbox' ? el.checked : (el.type === 'number' ? parseFloat(el.value) || 0 : el.value);
  var patch = {};
  // Handle nested keys (e.g., "sell.targetBalance", "events.orderCompleted")
  if (key.indexOf('.') > -1) {
    var parts = key.split('.');
    if (!cfg[parts[0]] || typeof cfg[parts[0]] !== 'object') cfg[parts[0]] = {};
    cfg[parts[0]][parts.slice(1).join('.')] = val;
    patch[parts[0]] = {};
    patch[parts[0]][parts.slice(1).join('.')] = val;
  } else {
    cfg[key] = val;
    patch[key] = val;
  }
  _autoCfgs[feature] = cfg;
  _saveCfgDebounced(feature, patch);
}

function _saveCfg(feature, cfg) {
  _autoCfgs[feature] = cfg;
  _saveCfgDebounced(feature, cfg);
}

var _savePending = {};
var _saveTimers = {};
function _saveCfgDebounced(feature, patch, onResult, immediate) {
  if (!_savePending[feature]) _savePending[feature] = {};
  _mergePatch(_savePending[feature], patch);
  if (_saveTimers[feature]) clearTimeout(_saveTimers[feature]);
  _saveTimers[feature] = setTimeout(function() {
    _saveTimers[feature] = null;
    var p = _savePending[feature];
    _savePending[feature] = {};
    API.post('/api/automation/v2/config/' + feature, p).then(function() {
      if (typeof onResult === 'function') onResult(true, null);
    }).catch(function(e) {
      console.error('config save failed:', feature, e);
      if (typeof onResult === 'function') onResult(false, e.message || 'save failed');
    });
  }, immediate ? 0 : 500);
}
function _mergePatch(target, patch) {
  Object.keys(patch).forEach(function(k) {
    var pv = patch[k];
    var tv = target[k];
    if (pv && typeof pv === 'object' && !Array.isArray(pv) && tv && typeof tv === 'object' && !Array.isArray(tv)) {
      target[k] = Object.assign({}, tv, pv);
    } else {
      target[k] = pv;
    }
  });
}
function _autoFundSaveHint(side, ok, msg) {
  var el = document.getElementById('auto-fund-' + side + '-saved');
  if (!el) return;
  el.textContent = ok ? '✓ Saved' : '✗ Save failed: ' + (msg || 'unknown error');
  el.style.color = ok ? '#4caf50' : '#f44336';
  clearTimeout(_autoFundSaveHint.tm);
  _autoFundSaveHint.tm = setTimeout(function() { el.textContent = ''; }, 4000);
}

function _refreshV2Logs(feature) {
  var el = document.getElementById('v2-log-' + feature);
  if (!el) return;
  API.get('/api/automation/v2/logs').then(function(res) {
    if (res.code !== 0 || !res.data) return;
    var lowerMsg = '';
    var logs = res.data.filter(function(l) {
      lowerMsg = l.msg.toLowerCase();
      if (lowerMsg.indexOf(feature.toLowerCase()) > -1) return true;
      if (lowerMsg.indexOf('engine') > -1) return true;
      if (lowerMsg.indexOf('automation') > -1) return true;
      if (lowerMsg.indexOf('started') > -1 || lowerMsg.indexOf('stopped') > -1) return true;
      if (lowerMsg.indexOf('[notif]') > -1) return true;
      return false;
    });
    if (logs.length === 0) { el.innerHTML = '<div style="color:var(--text-quaternary);padding:20px 0;text-align:center;">No activity yet</div>'; return; }
    var h = '';
    logs.slice(0, 50).forEach(function(l) {
      var c = l.type === 'error' ? '#f44336' : l.type === 'success' ? '#4caf50' : l.type === 'warning' ? '#ff9800' : '#8888aa';
      var t = new Date(l.ts).toLocaleTimeString();
      h += '<div style="color:' + c + ';"><span style="color:var(--text-quaternary);">[' + t + ']</span> ' + esc(l.msg) + '</div>';
    });
    el.innerHTML = h;
  }).catch(function() {});
}

async function _toggleFeature(feature, enabled) {
  var cfg = _autoCfgs[feature] || {};
  cfg.enabled = enabled;
  _autoCfgs[feature] = cfg;
  try {
    await API.post('/api/automation/v2/config/' + feature, { enabled: enabled });
    // AutoFund engines are controlled only by the per-side Start/Stop buttons
    // and by ad selection — the master switch just persists the flag.
  } catch (e) {
    console.error('feature toggle error', e);
  }
  _renderFeature(document.getElementById('auto-page-content'), feature);
}

function _clearV2Logs() {
  API.post('/api/automation/v2/clear-logs').catch(function() {});
}

var _v2EngineRunning = false;
async function _toggleV2Engine() {
  try {
    var statusData = await _loadStatus();
    if (statusData && statusData.running) {
      await API.post('/api/automation/v2/stop');
    } else {
      await API.post('/api/automation/v2/start');
    }
  } catch (e) {
    console.error('engine toggle error', e);
  }
  // Always re-render so the status bar reflects the real engine state
  _renderFeature(document.getElementById('auto-page-content'), _autoTab);
}

function _addScheduleProfile() {
  var name = document.getElementById('sp-name');
  var side = document.getElementById('sp-side');
  var start = document.getElementById('sp-start');
  var end = document.getElementById('sp-end');
  var margin = document.getElementById('sp-margin');
  var marginType = document.getElementById('sp-marginType');
  var trailMode = document.getElementById('sp-trailMode');
  var err = document.getElementById('sp-error');
  if (!name || !side || !start || !end) return;
  if (!name.value.trim()) { if (err) err.textContent = 'Enter a profile name'; return; }
  if (start.value >= end.value) { if (err) err.textContent = 'End time must be after start time'; return; }
  var dayEls = document.querySelectorAll('.sp-day:checked');
  if (dayEls.length === 0) { if (err) err.textContent = 'Select at least one day'; return; }
  var days = Array.from(dayEls).map(function(el) { return parseInt(el.value); });
  var config = {};
  if (margin.value) config.trailMargin = parseFloat(margin.value);
  if (marginType.value) config.marginType = marginType.value;
  if (trailMode.value) config.trailMode = trailMode.value;
  var profile = { name: name.value.trim(), days: days, timeStart: start.value, timeEnd: end.value, side: side.value, config: config };
  var cfg = _autoCfgs.schedule || {};
  if (!cfg.profiles) cfg.profiles = [];
  cfg.profiles.push(profile);
  _autoCfgs.schedule = cfg;
  API.post('/api/automation/v2/config/schedule', cfg).then(function() {
    if (err) err.textContent = '';
    _renderFeature(document.getElementById('auto-page-content'), 'schedule');
  }).catch(function(e) { if (err) err.textContent = 'Save failed: ' + e.message; });
}
function _deleteScheduleProfile(index) {
  var cfg = _autoCfgs.schedule || {};
  if (!cfg.profiles) cfg.profiles = [];
  cfg.profiles.splice(index, 1);
  _autoCfgs.schedule = cfg;
  API.post('/api/automation/v2/config/schedule', cfg).then(function() {
    _renderFeature(document.getElementById('auto-page-content'), 'schedule');
  });
}
window.__autoModLoaded = true;
_clearJsErrBox();

async function _loadReportHistory() {
  var el = document.getElementById('report-history-list');
  if (!el) return;
  try {
    var res = await API.get('/api/automation/v2/reports');
    var reports = (res && res.code === 0) ? (res.data || []) : [];
    if (!reports.length) {
      el.innerHTML = '<div style="padding:20px 0;text-align:center;color:var(--text-quaternary);"><div style="font-size:32px;margin-bottom:8px;">📊</div>No reports generated yet. Enable the feature and make sure the engine is running.</div>';
      return;
    }
    var html = '';
    reports.forEach(function(r) {
      var date = new Date(r.date).toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
      var time = new Date(r.date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
      var netColor = r.netFiatFlow >= 0 ? '#4caf50' : '#f44336';
      var netSign = r.netFiatFlow >= 0 ? '+' : '';
      html += '<div style="border:1px solid #1e1e2e;border-radius:10px;padding:14px 16px;margin-bottom:10px;background:rgba(0,0,0,0.08);">';
      html += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">';
      html += '<div><strong style="font-size:14px;">' + date + '</strong> <span style="font-size:11px;color:var(--text-quaternary);">' + time + '</span></div>';
      html += '<span style="font-size:11px;padding:3px 8px;border-radius:4px;background:rgba(68,138,255,0.12);color:#448aff;">' + r.frequency + '</span>';
      html += '</div>';
      html += '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:8px;font-size:12px;">';
      html += '<div><span style="color:var(--text-quaternary);">Orders</span><div style="font-size:16px;font-weight:700;margin-top:2px;">' + r.completedOrders + '</div></div>';
      html += '<div><span style="color:var(--text-quaternary);">Total Volume</span><div style="font-size:16px;font-weight:700;margin-top:2px;">' + (r.totalVolume || 0).toLocaleString(undefined, {maximumFractionDigits:0}) + ' <span style="font-size:11px;color:var(--text-tertiary);">KES</span></div></div>';
      html += '<div><span style="color:var(--text-quaternary);">Net Flow</span><div style="font-size:16px;font-weight:700;margin-top:2px;color:' + netColor + ';">' + netSign + (r.netFiatFlow || 0).toLocaleString(undefined, {maximumFractionDigits:0}) + ' <span style="font-size:11px;">KES</span></div></div>';
      html += '<div><span style="color:var(--text-quaternary);">Buy / Sell</span><div style="font-size:14px;font-weight:600;margin-top:2px;"><span style="color:#448aff;">📥 ' + r.buyCount + '</span> / <span style="color:#4caf50;">📤 ' + r.sellCount + '</span></div></div>';
      html += '</div>';
      if (r.buyFiat || r.sellFiat) {
        html += '<div style="margin-top:8px;padding-top:8px;border-top:1px solid #1e1e2e;font-size:11px;color:var(--text-tertiary);display:flex;gap:16px;">';
        html += '<span>Buy: ' + (r.buyFiat || 0).toLocaleString(undefined, {maximumFractionDigits:0}) + ' KES (' + (r.buyCrypto || 0).toFixed(2) + ' USDT)</span>';
        html += '<span>Sell: ' + (r.sellFiat || 0).toLocaleString(undefined, {maximumFractionDigits:0}) + ' KES (' + (r.sellCrypto || 0).toFixed(2) + ' USDT)</span>';
        html += '</div>';
      }
      html += '</div>';
    });
    el.innerHTML = html;
  } catch (e) {
    el.innerHTML = '<div style="padding:12px;color:#f44336;">Failed to load reports: ' + e.message + '</div>';
  }
}

async function _generateReportNow() {
  var status = document.getElementById('report-gen-status');
  if (status) status.textContent = 'Generating...';
  try {
    var res = await API.post('/api/automation/v2/reports/generate');
    if (res && res.code === 0) {
      if (status) status.textContent = '✅ Report generated! Check your notifications.';
    } else {
      if (status) status.textContent = '❌ ' + (res.msg || 'Failed');
    }
    setTimeout(function() { _loadReportHistory(); }, 1500);
  } catch (e) {
    if (status) status.textContent = '❌ ' + e.message;
  }
}
/* ==== js/modules/okx/aiChat.js ==== */
// ===== AI Chat Responder panel (serves sell-order chats automatically) =====
var _aiChatTimer = null;

async function renderAiChatRoot() {
  var el = document.getElementById('ai-chat-dashboard');
  if (!el) return;
  try {
    var [cfgRes, pendingRes, logRes] = await Promise.all([
      API.get('/api/okx/p2p/ai-chat/config'),
      API.get('/api/okx/p2p/ai-chat/pending'),
      API.get('/api/okx/p2p/ai-chat/log?limit=25')
    ]);
    var cfg = cfgRes.data || {};
    var pending = Array.isArray(pendingRes.data) ? pendingRes.data : [];
    var logs = Array.isArray(logRes.data) ? logRes.data : [];
    var html = '<div style="display:flex;flex-wrap:wrap;gap:14px;align-items:flex-end;margin-bottom:10px;">';
    html += '<div><label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:6px;margin-bottom:6px;cursor:pointer;"><input type="checkbox" id="ai-chat-enabled" ' + (cfg.enabled ? 'checked' : '') + '> <span>Auto-respond to sell-order chats</span></label>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);">Watches your active SELL orders, answers greetings, "can I proceed" and similar. Learning grows from your replies.</div></div>';
    html += '<div><label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:6px;cursor:pointer;"><input type="checkbox" id="ai-chat-autoreply" ' + (cfg.autoReply ? 'checked' : '') + '> <span>Reply automatically</span></label>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);">Off = still analyse & flag, never send.</div></div>';
    html += '<div><div style="font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">Reply delay (sec)</div><input id="ai-chat-delay" type="number" min="2" max="120" value="' + (cfg.replyDelaySec || 12) + '" style="width:90px;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);"></div>';
    html += '<div><div style="font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">Max auto-replies / order / day</div><input id="ai-chat-cap" type="number" min="1" max="50" value="' + (cfg.maxPerOrderPerDay || 3) + '" style="width:90px;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);"></div>';
    html += '<div><button class="btn btn-sm btn-primary" data-on-click="saveAiChatConfig()">💾 Save</button></div>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);">🤖 AI brain: free Cloudflare worker · 🔔 anything it can\'t answer safely flags you here + Telegram.</div></div>';

    if (pending.length) {
      html += '<div style="margin-bottom:10px;"><div style="font-size:12px;color:var(--text-secondary);margin-bottom:6px;">⚠️ Needs you — ' + pending.length + ' message' + (pending.length > 1 ? 's' : '') + ' the AI won\'t auto-answer:</div>';
      pending.forEach(function(p) {
        var st = p.status === 'sensitive' ? 'payment/release/dispute topic' : 'AI unsure';
        html += '<div style="background:rgba(255,152,0,0.06);border:1px solid rgba(255,152,0,0.25);border-radius:8px;padding:8px;margin-bottom:6px;">';
        html += '<div style="font-size:11px;color:var(--text-quaternary);">Order <code>' + esc(p.order_id) + '</code> · ' + esc(st) + '</div>';
        html += '<div style="font-size:12px;color:var(--text-primary);margin:4px 0;">"<span style="color:#ffb74d;">' + esc(p.msg) + '</span>"</div>';
        if (p.reply) html += '<div style="font-size:11px;color:var(--text-quaternary);margin-bottom:4px;">AI suggested draft (not sent): "' + esc(p.reply) + '"</div>';
        html += '<textarea id="ai-chat-resolve-' + p.id + '" rows="2" placeholder="Type your reply, then Send + Teach so the AI can answer this next time..." style="width:100%;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:6px;color:var(--text-primary);font-size:12px;padding:6px;"></textarea>';
        html += '<div style="display:flex;gap:6px;margin-top:6px;"><button class="btn btn-sm btn-success" data-on-click="sendAiChatReply(' + p.id + ')">📨 Send + Teach AI</button><button class="btn btn-sm btn-outline" data-on-click="skipAiChatFlag(' + p.id + ')">Done (no reply)</button></div>';
        html += '</div>';
      });
      html += '</div>';
    }

    html += '<div style="font-size:12px;color:var(--text-secondary);margin-bottom:6px;">📜 Activity</div>';
    html += '<div id="ai-chat-log" style="background:var(--bg-primary);border-radius:6px;padding:8px;font-size:11px;font-family:monospace;max-height:240px;overflow-y:auto;">';
    if (!logs.length) html += '<div style="color:var(--text-quaternary);">No activity yet — enable the responder and it will start handling sell chats.</div>';
    else logs.forEach(function(l) {
      var tagMap = { sent: ['✔ replied', '#4caf50'], human: ['⚠ flagged', '#ff9800'], skipped: ['– skipped', '#607d8b'], error: ['✖ error', '#ef5350'] };
      var tag = tagMap[l.status] || [l.status, '#90a4ae'];
      var sideLabel = l.source === 'human' ? 'taught' : l.source;
      html += '<div style="padding:3px 0;border-bottom:1px solid #14141e;color:#90a4ae;">'
        + '<span style="color:' + tag[1] + ';font-weight:600;">' + tag[0] + '</span>&nbsp; <span style="color:var(--text-quaternary);">[' + esc(l.order_id) + ']</span> '
        + '"' + esc(String(l.msg).replace(/\s+/g, ' ').slice(0, 90)) + '"'
        + (l.reply ? ' → <span style="color:#90a4ae;">"' + esc(String(l.reply).replace(/\s+/g, ' ').slice(0, 90)) + '"</span>' : '')
        + ' <span style="color:var(--text-quaternary);">(' + esc(sideLabel) + ')</span>'
        + '</div>';
    });
    html += '</div>';
    el.innerHTML = html;
    startAiChatPoll();
  } catch (err) {
    el.innerHTML = '<p style="color:#f44336;font-size:12px;">Failed to load AI responder: ' + esc(err.message) + '</p>';
  }
}

window.saveAiChatConfig = async function() {
  try {
    var body = {
      enabled: !!(document.getElementById('ai-chat-enabled') || {}).checked,
      autoReply: !!(document.getElementById('ai-chat-autoreply') || {}).checked,
      replyDelaySec: parseInt((document.getElementById('ai-chat-delay') || {}).value) || 12,
      maxPerOrderPerDay: parseInt((document.getElementById('ai-chat-cap') || {}).value) || 3
    };
    await API.post('/api/okx/p2p/ai-chat/config', body);
    showToast('AI responder saved', 'success');
    renderAiChatRoot();
  } catch (err) { showToast(err.message, 'error'); }
};

window.sendAiChatReply = async function(logId) {
  var tx = document.getElementById('ai-chat-resolve-' + logId);
  var reply = tx ? tx.value.trim() : '';
  if (!reply) { showToast('Type a reply first', 'error'); return; }
  try {
    var res = await API.post('/api/okx/p2p/ai-chat/resolve', { logId: logId, reply: reply, sendNow: true });
    showToast(res.data && res.data.sent ? 'Reply sent to customer + AI taught' : 'Reply taught to AI', 'success');
    renderAiChatRoot();
  } catch (err) { showToast(err.message, 'error'); }
};

window.skipAiChatFlag = async function(logId) {
  try {
    await API.post('/api/okx/p2p/ai-chat/resolve', { logId: logId, reply: '', sendNow: false });
    showToast('Flag marked done', 'success');
    renderAiChatRoot();
  } catch (err) { showToast(err.message, 'error'); }
};

function startAiChatPoll() {
  if (_aiChatTimer) clearInterval(_aiChatTimer);
  _aiChatTimer = setInterval(function() {
    var el = document.getElementById('ai-chat-dashboard');
    if (!el) { clearInterval(_aiChatTimer); _aiChatTimer = null; return; }
    if (document.hidden) return;
    API.get('/api/okx/p2p/ai-chat/pending').then(function(res) {
      if (!document.getElementById('ai-chat-dashboard')) return;
      var pending = Array.isArray(res.data) ? res.data.length : 0;
      var badge = document.getElementById('ai-chat-pending-badge');
      if (badge) badge.textContent = pending ? String(pending) : '';
    }).catch(function() {});
  }, 20000);
}
/* ==== js/modules/okx/fraudShield.js ==== */
// ===== Fraud Shield panel (buyer risk-scoring + blacklist manager) =====
var _fraudTimer = null;

function _fraudLevelMeta(l) {
  if (l === 'critical') return ['🚨 Critical', '#ef5350'];
  if (l === 'high') return ['⚠ High', '#ff9800'];
  if (l === 'watch') return ['👀 Watch', '#ffb74d'];
  return ['✔ Low', '#4caf50'];
}

async function renderFraudShieldRoot() {
  var el = document.getElementById('fraud-shield-dashboard');
  if (!el) return;
  try {
    var [cfgRes, blRes, asRes] = await Promise.all([
      API.get('/api/okx/p2p/fraud/config'),
      API.get('/api/okx/p2p/fraud/blacklist'),
      API.get('/api/okx/p2p/fraud/assessments?limit=20')
    ]);
    var cfg = cfgRes.data || {};
    var blacklist = Array.isArray(blRes.data) ? blRes.data : [];
    var assessments = Array.isArray(asRes.data) ? asRes.data : [];
    var html = '<div style="display:flex;flex-wrap:wrap;gap:14px;align-items:flex-end;margin-bottom:10px;">';
    html += '<div><label style="font-size:12px;color:var(--text-tertiary);display:flex;align-items:center;gap:6px;margin-bottom:6px;cursor:pointer;"><input type="checkbox" id="fraud-shield-enabled" ' + (cfg.enabled ? 'checked' : '') + '> <span>Enable Fraud Shield</span></label>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);">Scores every SELL order&#39;s buyer and blocks auto-release above the threshold.</div></div>';
    html += '<div><div style="font-size:12px;color:var(--text-tertiary);margin-bottom:4px;">Block auto-release at score ≥</div><input id="fraud-block-at" type="number" min="0" max="100" value="' + (cfg.blockAt || 60) + '" style="width:90px;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);"></div>';
    html += '<div><button class="btn btn-sm btn-primary" data-on-click="saveFraudConfig()">💾 Save</button></div>';
    html += '<div style="font-size:11px;color:var(--text-quaternary);">🏷 Levels: <span style="color:#4caf50;">Low &lt;30</span> · <span style="color:#ffb74d;">Watch 30–59</span> · <span style="color:#ff9800;">High 60–84</span> · <span style="color:#ef5350;">Critical ≥85</span> · 🤝 shared pay number +40, missing SMS +20, fast paid +15, first order +20, velocity +15, disputes +30, blacklist → CRITICAL.</div></div>';

    html += '<div style="display:flex;gap:14px;align-items:center;flex-wrap:wrap;margin-bottom:10px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:8px;padding:8px;">';
    html += '<div style="font-size:12px;color:var(--text-secondary);font-weight:600;">🚫 Blacklist</div>';
    html += '<select id="fraud-bl-type" style="padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:12px;"><option value="nickname">Nickname</option><option value="phone">Phone number</option><option value="account">Account number</option><option value="ref">SMS ref (prefix)</option></select>';
    html += '<input id="fraud-bl-value" placeholder="value (skip leading +/0)" style="width:170px;padding:4px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:4px;color:var(--text-primary);font-size:12px;">';
    html += '<button class="btn btn-sm btn-success" data-on-click="addFraudBlacklistEntry()">➕ Block</button>';
    html += '<span style="font-size:11px;color:var(--text-quaternary);">Blacklisted counterparty ⇒ auto CRITICAL.</span></div>';

    if (blacklist.length) {
      html += '<div style="margin-bottom:10px;"><div style="font-size:12px;color:var(--text-secondary);margin-bottom:6px;">Blocked (' + blacklist.length + '):</div><div style="display:flex;flex-wrap:wrap;gap:6px;">';
      blacklist.forEach(function(b) {
        var typeKey = { nickname: 'nick', phone: 'tel', account: 'acct', ref: 'ref' }[b.type] || b.type;
        html += '<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(239,83,80,0.1);border:1px solid rgba(239,83,80,0.3);border-radius:14px;padding:3px 8px;font-size:11px;color:var(--text-primary);">' + esc(typeKey) + ' <b>' + esc(b.value) + '</b><a href="javascript:void(0)" data-on-click="deleteFraudBlacklistEntry(\'' + b.id + '\')" style="color:#ef5350;text-decoration:none;font-size:12px;">✕</a></span>';
      });
      html += '</div></div>';
    }

    html += '<div style="font-size:12px;color:var(--text-secondary);margin-bottom:6px;">🔎 Recent assessments</div>';
    if (!assessments.length) {
      html += '<div style="color:var(--text-quaternary);font-size:11px;">No orders scored yet — scores are recorded the moment an order is marked paid or an SMS is received.</div>';
    } else {
      assessments.forEach(function(a) {
        var meta = _fraudLevelMeta(a.level);
        var factors = [];
        try { factors = JSON.parse(a.factors || '[]'); } catch (e) {}
        html += '<div style="background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:8px;padding:8px;margin-bottom:6px;">';
        html += '<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;flex-wrap:wrap;">';
        html += '<div style="font-size:11px;">Order <code>' + esc(a.order_id) + '</code> · <span style="color:' + meta[1] + ';font-weight:600;">' + meta[0] + '</span> · <b>' + a.score + '/100</b>' + (a.released ? ' · <span style="color:#4caf50;">released</span>' : '') + '</div>';
        html += '<div style="font-size:11px;color:var(--text-quaternary);">' + esc(a.decision || 'flagged') + ' · ' + String(a.created_at || '').replace('T', ' ').slice(0, 16) + '</div></div>';
        if (factors.length) html += '<div style="font-size:11px;color:var(--text-tertiary);margin-top:4px;">' + factors.slice(0, 4).map(function(f) { return '• ' + esc(f.label); }).join(' ') + '</div>';
        html += '</div>';
      });
    }
    el.innerHTML = html;
    if (_fraudTimer) { clearTimeout(_fraudTimer); _fraudTimer = null; }
    _fraudTimer = setTimeout(renderFraudShieldRoot, 20000);
  } catch (err) {
    // Transient failures (server restart blips, brief network drops) used to
    // stick forever — the auto-refresh timer only armed in the success branch.
    // Show a Retry link and self-heal on a short timer.
    el.innerHTML = '<p style="font-size:12px;">Fraud Shield unavailable: ' + esc(err.message) + '</p>' +
      ' <a href="javascript:void(0)" data-on-click="renderFraudShieldRoot()" style="color:var(--accent-blue);text-decoration:underline;">Retry</a>';
    if (_fraudTimer) { clearTimeout(_fraudTimer); _fraudTimer = null; }
    _fraudTimer = setTimeout(renderFraudShieldRoot, 15000);
  }
}

async function saveFraudConfig() {
  var enabled = !!document.getElementById('fraud-shield-enabled').checked;
  var blockAt = parseInt(document.getElementById('fraud-block-at').value) || 60;
  try {
    var res = await API.post('/api/okx/p2p/fraud/config', { enabled: enabled, blockAt: blockAt });
    if (res.code === 0) { showToast('Fraud Shield settings saved', 'success'); renderFraudShieldRoot(); }
    else showToast(res.msg || 'Save failed', 'error');
  } catch (e) { showToast(e.message || 'Save failed', 'error'); }
}

async function addFraudBlacklistEntry() {
  var type = document.getElementById('fraud-bl-type').value;
  var value = (document.getElementById('fraud-bl-value').value || '').trim();
  if (!value) { showToast('Enter a value to block', 'error'); return; }
  try {
    var res = await API.post('/api/okx/p2p/fraud/blacklist', { type: type, value: value });
    if (res.code === 0) { document.getElementById('fraud-bl-value').value = ''; showToast('Added to blacklist', 'success'); renderFraudShieldRoot(); }
    else showToast(res.msg || 'Add failed', 'error');
  } catch (e) { showToast(e.message || 'Add failed', 'error'); }
}

async function deleteFraudBlacklistEntry(id) {
  try {
    var res = await API.del('/api/okx/p2p/fraud/blacklist/' + id);
    if (res.code === 0) { showToast('Removed from blacklist', 'success'); renderFraudShieldRoot(); }
    else showToast(res.msg || 'Remove failed', 'error');
  } catch (e) { showToast(e.message || 'Remove failed', 'error'); }
}
/* ==== js/modules/okx/market.js ==== */
// Market hub — live P2P prices, marketplace browser, swap calculator.
async function renderMarket(container) {
  if (!currentUser) return;
  var FIAT = 'KES', CRYPTO = 'USDT';
  container.innerHTML = '<div class="page-header"><div><h2>📈 Market</h2><div class="subtitle">Live P2P market — ' + CRYPTO + '/' + FIAT + '</div></div>' +
    '<div style="display:flex;gap:8px;align-items:center;"><span id="mkt-ticker" style="font-size:20px;font-weight:700;color:#448aff;">…</span><span style="font-size:10px;color:var(--text-quaternary);" id="mkt-tick-time"></span></div></div>' +
    '<div style="display:flex;gap:8px;margin-bottom:14px;">' +
    '<button class="btn btn-sm btn-primary" data-mkt-tab="prices">Prices</button>' +
    '<button class="btn btn-sm btn-outline" data-mkt-tab="book">Marketplace</button>' +
    '<button class="btn btn-sm btn-outline" data-mkt-tab="swap">Swap Calc</button></div>' +
    '<div id="mkt-body"><p style="color:var(--text-quaternary);text-align:center;padding:30px;">Loading market…</p></div>';
  var body = document.getElementById('mkt-body');
  var tabs = container.querySelectorAll('[data-mkt-tab]');
  tabs.forEach(function(b) { b.onclick = function() {
    tabs.forEach(function(x) { x.className = 'btn btn-sm btn-outline'; });
    b.className = 'btn btn-sm btn-primary';
    _mktTab(b.getAttribute('data-mkt-tab'), body, FIAT, CRYPTO);
  }; });

  async function tick() {
    try {
      var r = await API.get('/api/okx/p2p/tickers?fiat=' + FIAT);
      var d = ((r.data || [])[0] || {}).prices || {};
      var p = d[CRYPTO.toLowerCase()] || d[CRYPTO] || d['usdt'];
      if (p) {
        document.getElementById('mkt-ticker').textContent = 'KES ' + Number(p).toLocaleString(undefined, { maximumFractionDigits: 2 });
        document.getElementById('mkt-tick-time').textContent = new Date().toLocaleTimeString();
      }
      return d;
    } catch (e) { return null; }
  }
  await tick();
  if (window._mktTickTimer) clearInterval(window._mktTickTimer);
  window._mktTickTimer = setInterval(function() { if (!document.hidden) tick(); }, 30000);

  _mktTab('prices', body, FIAT, CRYPTO, true);
}

async function _mktTab(tab, body, FIAT, CRYPTO, skipTick) {
  if (tab === 'prices') {
    body.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:30px;">Loading…</p>';
    var r = await API.get('/api/okx/p2p/tickers?fiat=' + FIAT).catch(function() { return { data: [] }; });
    var prices = ((r.data || [])[0] || {}).prices || {};
    var rows = Object.keys(prices).map(function(k) {
      return '<tr><td style="padding:8px;font-weight:600;text-transform:uppercase;">' + esc(k) + '</td><td style="padding:8px;color:#4caf50;">KES ' + Number(prices[k]).toLocaleString() + '</td></tr>';
    }).join('');
    body.innerHTML = '<div class="card"><table style="width:100%;border-collapse:collapse;font-size:13px;"><thead><tr><th style="text-align:left;padding:8px;color:var(--text-tertiary);">Coin</th><th style="text-align:left;padding:8px;color:var(--text-tertiary);">P2P Price (' + FIAT + ')</th></tr></thead><tbody>' + rows + '</tbody></table></div>';

  } else if (tab === 'book') {
    body.innerHTML = '<div style="display:flex;gap:8px;margin-bottom:10px;"><button class="btn btn-sm btn-primary" id="mkt-side-s">Sell Ads</button><button class="btn btn-sm btn-outline" id="mkt-side-b">Buy Ads</button></div><div id="mkt-book-body"><p style="color:var(--text-quaternary);text-align:center;padding:20px;">Loading…</p></div>';
    var sideBtns = body.querySelectorAll('#mkt-side-s,#mkt-side-b');
    function loadBook(side) {
      sideBtns.forEach(function(x) { x.className = 'btn btn-sm btn-outline'; });
      document.getElementById('mkt-side-' + side[0]).className = 'btn btn-sm btn-primary';
      var bb = document.getElementById('mkt-book-body');
      bb.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:20px;">Loading…</p>';
      API.get('/api/okx/p2p/market?side=' + side + '&crypto=USDT&fiat=' + FIAT).then(function(res) {
        var ads = (res.data || []).slice(0, 25);
        if (!ads.length) { bb.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:20px;">No tradable ads found.</p>'; return; }
        bb.innerHTML = '<div class="card" style="overflow-x:auto;"><table style="width:100%;border-collapse:collapse;font-size:12px;"><thead><tr><th style="text-align:left;padding:6px;color:var(--text-tertiary);">Price</th><th style="text-align:left;padding:6px;color:var(--text-tertiary);">Merchant</th><th style="text-align:left;padding:6px;color:var(--text-tertiary);">Available</th><th style="text-align:left;padding:6px;color:var(--text-tertiary);">Limits</th><th style="text-align:left;padding:6px;color:var(--text-tertiary);">Orders / Rate</th></tr></thead><tbody>' +
          ads.map(function(a) {
            var cr = a.creator || {};
            return '<tr><td style="padding:6px;font-weight:700;color:#4caf50;">' + a.unitPrice + '</td>' +
              '<td style="padding:6px;">' + esc(cr.nickName || cr.userId || '-') + '<br><span style="font-size:10px;color:var(--text-quaternary);">' + esc(cr.type || '') + '</span></td>' +
              '<td style="padding:6px;">' + a.availableAmount + ' ' + (a.cryptoCurrency || '').toUpperCase() + '</td>' +
              '<td style="padding:6px;">' + a.minOrderSize + ' – ' + a.maxOrderSize + '</td>' +
              '<td style="padding:6px;color:var(--text-tertiary);">' + (cr.completedOrders || '0') + ' · ' + Math.round(parseFloat(cr.completionRate || 0) * 100) + '%</td></tr>';
          }).join('') + '</tbody></table></div>';
      }).catch(function(e) { bb.innerHTML = '<p style="color:#f44336;text-align:center;padding:20px;">' + esc(e.message || 'Failed to load') + '</p>'; });
    }
    sideBtns.forEach(function(b) { b.onclick = function() { loadBook(b.id === 'mkt-side-s' ? 'sell' : 'buy'); }; });
    loadBook('sell');

  } else if (tab === 'swap') {
    body.innerHTML = '<div class="card" style="max-width:420px;margin:0 auto;">' +
      '<label style="font-size:12px;color:var(--text-tertiary);">USDT amount</label>' +
      '<input id="swap-amt" type="number" value="100" min="1" class="form-input" style="width:100%;padding:10px;margin:6px 0 12px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:8px;color:var(--text-primary);">' +
      '<button class="btn btn-primary" id="swap-go" style="width:100%;padding:10px;">Convert → ' + FIAT + '</button>' +
      '<div id="swap-out" style="text-align:center;padding:16px 0 0;font-size:22px;font-weight:700;color:#4caf50;"></div></div>';
    document.getElementById('swap-go').onclick = async function() {
      var amt = parseFloat(document.getElementById('swap-amt').value);
      if (!(amt > 0)) return;
      var out = document.getElementById('swap-out');
      out.textContent = '…';
      try {
        var r = await API.get('/api/okx/p2p/swap?crypto=' + CRYPTO + '&fiat=' + FIAT + '&amount=' + amt);
        var d = (r.data || [])[0] || {};
        out.textContent = 'KES ' + Number(d.swapAmount || d.price * amt || 0).toLocaleString();
      } catch (e) { out.textContent = '—'; showToast(e.message || 'Failed', 'error'); }
    };
  }
}
window.renderMarket = renderMarket;

/* ==== js/modules/okx/contacts.js ==== */
// Contacts hub — followed merchants watchlist, OKX blacklist, UID lookup.
async function renderContacts(container) {
  if (!currentUser) return;
  container.innerHTML = '<div class="page-header"><div><h2>🤝 Contacts</h2><div class="subtitle">People you trade with — watchlist, blacklist, lookups</div></div></div>' +
    '<div style="display:flex;gap:8px;margin-bottom:14px;">' +
    '<button class="btn btn-sm btn-primary" data-ct-tab="watchlist">Watchlist</button>' +
    '<button class="btn btn-sm btn-outline" data-ct-tab="blacklist">Blacklist</button>' +
    '<button class="btn btn-sm btn-outline" data-ct-tab="lookup">UID Lookup</button></div>' +
    '<div id="ct-body"><p style="color:var(--text-quaternary);text-align:center;padding:30px;">Loading…</p></div>';
  var body = document.getElementById('ct-body');
  var tabs = container.querySelectorAll('[data-ct-tab]');
  tabs.forEach(function(b) { b.onclick = function() {
    tabs.forEach(function(x) { x.className = 'btn btn-sm btn-outline'; });
    b.className = 'btn btn-sm btn-primary';
    _ctTab(b.getAttribute('data-ct-tab'), body);
  }; });
  _ctTab('watchlist', body);
}

async function _ctTab(tab, body) {
  if (tab === 'watchlist') {
    body.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:30px;">Loading followings…</p>';
    try {
      var r = await API.get('/api/okx/p2p/followings?page=1');
      var arr = ((r.data || [])[0] || {}).followings || (r.data || [])[0] || [];
      if (!Array.isArray(arr) || !arr.length) { body.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:30px;">You are not following any merchants yet. Follow merchants inside OKX and they appear here.</p>'; return; }
      body.innerHTML = '<div class="card">' + arr.map(function(m) {
        return '<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 4px;border-bottom:1px solid #1e1e2e;">' +
          '<div><b style="font-size:13px;">' + esc(m.nickname || m.nickName || m.userId || '-') + '</b>' +
          '<span style="margin-left:8px;font-size:10px;padding:1px 6px;border-radius:3px;background:' + (m.userType === 'diamond' ? '#ffd54f22;color:#ffd54f;' : m.userType === 'certified' ? '#448aff22;color:#448aff;' : '#55556a33;color:var(--text-tertiary);') + '">' + esc(m.userType || 'common') + '</span>' +
          '<br><span style="font-size:11px;color:var(--text-tertiary);">KYC L' + esc(m.kycLevel || '-') + ' · ' + (m.hasAlreadyTraded ? '<span style="color:#4caf50;">traded before</span>' : 'no history') + '</span></div>' +
          '<div style="text-align:right;"><div style="font-size:12px;font-weight:700;color:' + (m.hasOnlineAd ? '#4caf50;' : '#55556a;') + '">' + (m.hasOnlineAd ? '🟢 Ad online' : '⚪ Offline') + '</div></div></div>';
      }).join('') + '</div>';
    } catch (e) { body.innerHTML = '<p style="color:#f44336;text-align:center;padding:30px;">' + esc(e.message || 'Failed to load') + '</p>'; }

  } else if (tab === 'blacklist') {
    body.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:30px;">Loading blacklist…</p>';
    try {
      var r2 = await API.get('/api/okx/p2p/blacklist?currency=USDT');
      var list = Array.isArray(r2.data) ? r2.data : [];
      if (!list.length) { body.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;padding:30px;">Your OKX blacklist is empty.</p>'; return; }
      body.innerHTML = '<div class="card">' + list.map(function(u) {
        return '<div style="padding:10px 4px;border-bottom:1px solid #1e1e2e;display:flex;justify-content:space-between;"><div><b>' + esc(u.userName || u.userId) + '</b><br><span style="font-size:11px;color:var(--text-tertiary);">' + (u.orders || '?') + ' orders · rate ' + (u.completionRate || '-') + '</span></div><div style="font-size:10px;color:#f44336;">🚫 blacklisted<br>' + fmtDate(u.createdTimestamp, 'date') + '</div></div>';
      }).join('') + '</div>';
    } catch (e) { body.innerHTML = '<p style="color:#f44336;text-align:center;padding:30px;">' + esc(e.message || 'Failed to load') + '</p>'; }

  } else if (tab === 'lookup') {
    body.innerHTML = '<div class="card" style="max-width:480px;margin:0 auto;">' +
      '<label style="font-size:12px;color:var(--text-tertiary);">OKX UID (numeric, from their profile)</label>' +
      '<input id="uid-in" inputmode="numeric" placeholder="e.g. 25223301" style="width:100%;padding:10px;margin:6px 0 12px;background:var(--bg-primary);border:1px solid var(--border-primary);border-radius:8px;color:var(--text-primary);">' +
      '<button class="btn btn-primary" id="uid-go" style="width:100%;padding:10px;">Look up trader</button>' +
      '<div id="uid-out" style="padding-top:14px;"></div></div>';
    document.getElementById('uid-go').onclick = async function() {
      var uid = document.getElementById('uid-in').value.trim();
      var out = document.getElementById('uid-out');
      if (!/^\d{1,12}$/.test(uid)) { showToast('Enter a numeric UID', 'error'); return; }
      out.innerHTML = '<p style="color:var(--text-quaternary);text-align:center;">Looking up…</p>';
      try {
        var r = await API.post('/api/okx/p2p/uid-lookup', { uid: uid });
        var d = ((r.data || [])[0]) || {};
        out.innerHTML = '<div style="border:1px solid var(--border-primary);border-radius:8px;padding:12px;background:var(--bg-primary);">' +
          '<div style="font-size:15px;font-weight:700;">' + esc(d.nickName || d.realName || 'Trader') + '</div>' +
          '<div style="font-size:11px;color:var(--text-tertiary);margin-top:4px;">User ID: <span style="user-select:all;">' + esc(d.userId || '?') + '</span></div></div>';
      } catch (e) { out.innerHTML = '<p style="color:#f44336;">' + esc(e.message || 'Lookup failed') + '</p>'; }
    };
  }
}
window.renderContacts = renderContacts;

/* ==== js/modules/okx/okx-extras.js ==== */
// OKX order extras — trust stats + dispute center panels (callable from order views).
window.showOrderTrust = async function(orderId) {
  try {
    var o = (window._ordersMap || {})[orderId] || {};
    var uid = (o.counterpartyDetail || {}).id || (o.counterpartyDetail || {}).userId || '';
    if (!uid) { showToast('No counterparty ID on this order', 'error'); return; }
    var r = await API.get('/api/okx/p2p/trade-info/' + encodeURIComponent(uid));
    var arr = Array.isArray(r.data) ? r.data : [];
    var rows = arr.map(function(t) {
      return '<div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #1e1e2e;font-size:13px;">' +
        '<span>' + (t.side === 'buy' ? '🟢 You bought' : t.side === 'sell' ? '🔵 You sold' : esc(t.side)) + '</span>' +
        '<span><b>' + Number(t.tradeCount || 0) + '</b> trades · <b>' + Number(t.tradeAmount || 0).toLocaleString() + '</b> USDT</span></div>';
    }).join('') || '<p style="color:var(--text-quaternary);padding:10px;">No trade history with this counterparty yet.</p>';
    var cpName = (o.counterpartyDetail || {}).nickName || uid;
    document.body.insertAdjacentHTML('beforeend', '<div class="modal-overlay"><div class="modal-content" style="max-width:420px;"><h3>🛡 Trade History — ' + esc(cpName) + '</h3>' +
      '<div style="font-size:11px;color:var(--text-tertiary);margin-bottom:8px;">User ID: ' + esc(uid) + '</div>' + rows +
      '<button class="btn btn-outline" style="width:100%;margin-top:12px;" onclick="this.closest(\'.modal-overlay\').remove()">Close</button></div></div>');
  } catch (e) { showToast(e.message || 'Failed to load trust info', 'error'); }
};

window.showOrderDispute = async function(orderId) {
  try {
    var d = await API.get('/api/okx/p2p/dispute-details/' + encodeURIComponent(orderId)).catch(function() { return { data: [] }; });
    var info = (Array.isArray(d.data) ? d.data : [])[0] || null;
    var msgsHtml = '';
    if (info && info.messages) {
      msgsHtml = info.messages.slice(0, 30).map(function(m) {
        var who = m.sender === '0' ? 'You' : m.sender === '1' ? '⚖️ Support' : '👤 Counterparty';
        var color = m.sender === '1' ? '#ffd54f' : m.sender === '0' ? '#448aff' : '#4caf50';
        return '<div style="padding:6px 8px;border-left:3px solid ' + color + ';margin-bottom:6px;background:var(--bg-primary);border-radius:4px;">' +
          '<div style="font-size:10px;color:' + color + ';">' + who + ' · ' + fmtDate(m.timestamp) + '</div>' +
          '<div style="font-size:12px;color:var(--text-primary);">' + esc(m.message || '') + '</div></div>';
      }).join('');
    }
    var reason = info ? '<div style="font-size:12px;margin-bottom:8px;"><b>Reason:</b> ' + esc(info.disputeReason || '-') + (info.disputeSubReason ? ' — ' + esc(info.disputeSubReason) : '') + '</div>' : '<p style="font-size:12px;color:var(--text-tertiary);">No open dispute on this order yet. Create one from the OKX app if needed, or send a message below.</p>';
    document.body.insertAdjacentHTML('beforeend', '<div class="modal-overlay"><div class="modal-content" style="max-width:480px;"><h3>⚖️ Dispute Center</h3>' + reason +
      '<div style="max-height:260px;overflow-y:auto;margin-bottom:10px;">' + (msgsHtml || '') + '</div>' +
      '<input id="dsp-msg" placeholder="Message support/counterparty…" class="form-input" style="width:100%;padding:9px;background:var(--bg-primary);color:var(--text-primary);border:1px solid var(--border-primary);border-radius:8px;">' +
      '<div style="display:flex;gap:8px;margin-top:10px;"><button class="btn btn-primary" id="dsp-send">Send</button><button class="btn btn-outline" onclick="this.closest(\'.modal-overlay\').remove()">Close</button></div></div></div>');
    document.getElementById('dsp-send').onclick = async function() {
      var msg = document.getElementById('dsp-msg').value.trim();
      if (!msg) return;
      try { await API.post('/api/okx/p2p/dispute-message', { orderId: orderId, message: msg }); showToast('Sent', 'success'); document.querySelector('.modal-overlay').remove(); window.showOrderDispute(orderId); }
      catch (e) { showToast(e.message, 'error'); }
    };
  } catch (e) { showToast(e.message || 'Failed to load dispute', 'error'); }
};

/* ==== js/modules/okx/money-view.js ==== */
// Money View strip — self-injects at top of Dashboard: releases owed, payments due, live rate.
(function() {
  var BUSY = false;
  function tile(icon, num, label, color) {
    return '<div style="flex:1;min-width:100px;background:#12121f;border:1px solid #23233a;border-radius:12px;padding:10px 12px;">' +
      '<div style="font-size:18px;font-weight:800;color:' + color + ';">' + icon + ' ' + num + '</div>' +
      '<div style="font-size:10px;color:var(--text-tertiary);margin-top:2px;">' + label + '</div></div>';
  }
  async function refresh() {
    var pc = document.getElementById('page-content');
    if (!pc || BUSY) return;
    var mv = document.getElementById('money-view');
    var header = pc.querySelector('.page-header');
    if (!header || !header.textContent.toLowerCase().includes('overview') || document.hidden) { if (mv) mv.remove(); return; }
    BUSY = true;
    try {
      var r = await API.get('/api/okx/p2p/order-list?pageIndex=1&pageSize=50&completionStatus=pending').catch(function(){return{data:[]};});
      var orders = ((r.data || {}).data) || r.data || [];
      if (!Array.isArray(orders)) orders = [];
      var relOwed = 0, payDue = 0;
      orders.forEach(function(o) {
        if (!o || o.orderStatus !== 'new') return;
        if (o.side === 'sell' && o.paymentStatus === 'paid') relOwed++;
        if (o.side === 'buy' && o.paymentStatus === 'unpaid') payDue++;
      });
      var html = '<div id="money-view" style="display:flex;gap:10px;margin:0 0 14px;">';
      html += tile('🔓', relOwed, 'Releases owed to buyers', relOwed ? '#ff9100' : '#4caf50');
      html += tile('💳', payDue, 'Payments you must send', payDue ? '#ff5252' : '#4caf50');
      try {
        var t = await API.get('/api/okx/p2p/tickers?fiat=KES');
        var px = (((t.data || [])[0] || {}).prices || {}).usdt;
        if (px) html += tile('📈', 'KES ' + Number(px).toLocaleString(undefined, { maximumFractionDigits: 1 }), 'Live USDT/KES', '#448aff');
      } catch (e) {}
      html += '</div>';
      if (mv) mv.outerHTML = html;
      else header.insertAdjacentHTML('afterend', html);
    } catch (e) {} finally { BUSY = false; }
  }
  if (window._moneyViewTimer) clearInterval(window._moneyViewTimer);
  window._moneyViewTimer = setInterval(refresh, 45000);
  setTimeout(refresh, 1200);
  setTimeout(refresh, 1500);
})();
